
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || dest.hasOwnProperty(key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $73048c6b859c8a02$var$n, $73048c6b859c8a02$export$41c562ebe57d11e2, $73048c6b859c8a02$var$u, $73048c6b859c8a02$export$a8257692ac88316c, $73048c6b859c8a02$var$i, $73048c6b859c8a02$var$o, $73048c6b859c8a02$var$r, $73048c6b859c8a02$var$f, $73048c6b859c8a02$var$e, $73048c6b859c8a02$var$c = {}, $73048c6b859c8a02$var$s = [], $73048c6b859c8a02$var$a = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i, $73048c6b859c8a02$var$h = Array.isArray;
function $73048c6b859c8a02$var$v(n, l) {
    for(var u in l)n[u] = l[u];
    return n;
}
function $73048c6b859c8a02$var$p(n) {
    var l = n.parentNode;
    l && l.removeChild(n);
}
function $73048c6b859c8a02$export$c8a8987d4410bf2d(l, u, t) {
    var i, o, r, f = {};
    for(r in u)"key" == r ? i = u[r] : "ref" == r ? o = u[r] : f[r] = u[r];
    if (arguments.length > 2 && (f.children = arguments.length > 3 ? $73048c6b859c8a02$var$n.call(arguments, 2) : t), "function" == typeof l && null != l.defaultProps) for(r in l.defaultProps)void 0 === f[r] && (f[r] = l.defaultProps[r]);
    return $73048c6b859c8a02$var$d(l, f, i, o, null);
}
function $73048c6b859c8a02$var$d(n, t, i, o, r) {
    var f = {
        type: n,
        props: t,
        key: i,
        ref: o,
        __k: null,
        __: null,
        __b: 0,
        __e: null,
        __d: void 0,
        __c: null,
        __h: null,
        constructor: void 0,
        __v: null == r ? ++$73048c6b859c8a02$var$u : r
    };
    return null == r && null != $73048c6b859c8a02$export$41c562ebe57d11e2.vnode && $73048c6b859c8a02$export$41c562ebe57d11e2.vnode(f), f;
}
function $73048c6b859c8a02$export$7d1e3a5e95ceca43() {
    return {
        current: null
    };
}
function $73048c6b859c8a02$export$ffb0004e005737fa(n) {
    return n.children;
}
function $73048c6b859c8a02$export$16fa2f45be04daa8(n, l) {
    this.props = n, this.context = l;
}
function $73048c6b859c8a02$var$g(n, l) {
    if (null == l) return n.__ ? $73048c6b859c8a02$var$g(n.__, n.__.__k.indexOf(n) + 1) : null;
    for(var u; l < n.__k.length; l++)if (null != (u = n.__k[l]) && null != u.__e) return u.__e;
    return "function" == typeof n.type ? $73048c6b859c8a02$var$g(n) : null;
}
function $73048c6b859c8a02$var$m(n) {
    var l, u;
    if (null != (n = n.__) && null != n.__c) {
        for(n.__e = n.__c.base = null, l = 0; l < n.__k.length; l++)if (null != (u = n.__k[l]) && null != u.__e) {
            n.__e = n.__c.base = u.__e;
            break;
        }
        return $73048c6b859c8a02$var$m(n);
    }
}
function $73048c6b859c8a02$var$w(n) {
    (!n.__d && (n.__d = !0) && $73048c6b859c8a02$var$i.push(n) && !$73048c6b859c8a02$var$x.__r++ || $73048c6b859c8a02$var$o !== $73048c6b859c8a02$export$41c562ebe57d11e2.debounceRendering) && (($73048c6b859c8a02$var$o = $73048c6b859c8a02$export$41c562ebe57d11e2.debounceRendering) || $73048c6b859c8a02$var$r)($73048c6b859c8a02$var$x);
}
function $73048c6b859c8a02$var$x() {
    var n, l, u, t, o, r, e, c, s;
    for($73048c6b859c8a02$var$i.sort($73048c6b859c8a02$var$f); n = $73048c6b859c8a02$var$i.shift();)n.__d && (l = $73048c6b859c8a02$var$i.length, t = void 0, o = void 0, r = void 0, c = (e = (u = n).__v).__e, (s = u.__P) && (t = [], o = [], (r = $73048c6b859c8a02$var$v({}, e)).__v = e.__v + 1, $73048c6b859c8a02$var$L(s, e, r, u.__n, void 0 !== s.ownerSVGElement, null != e.__h ? [
        c
    ] : null, t, null == c ? $73048c6b859c8a02$var$g(e) : c, e.__h, o), $73048c6b859c8a02$var$M(t, e, o), e.__e != c && $73048c6b859c8a02$var$m(e)), $73048c6b859c8a02$var$i.length > l && $73048c6b859c8a02$var$i.sort($73048c6b859c8a02$var$f));
    $73048c6b859c8a02$var$x.__r = 0;
}
function $73048c6b859c8a02$var$P(n, l, u, t, i, o, r, f, e, a, v) {
    var p, y, _, b, m, w, x, P, C, H = 0, I = t && t.__k || $73048c6b859c8a02$var$s, T = I.length, j = T, z = l.length;
    for(u.__k = [], p = 0; p < z; p++)null != (b = u.__k[p] = null == (b = l[p]) || "boolean" == typeof b || "function" == typeof b ? null : "string" == typeof b || "number" == typeof b || "bigint" == typeof b ? $73048c6b859c8a02$var$d(null, b, null, null, b) : $73048c6b859c8a02$var$h(b) ? $73048c6b859c8a02$var$d($73048c6b859c8a02$export$ffb0004e005737fa, {
        children: b
    }, null, null, null) : b.__b > 0 ? $73048c6b859c8a02$var$d(b.type, b.props, b.key, b.ref ? b.ref : null, b.__v) : b) ? (b.__ = u, b.__b = u.__b + 1, -1 === (P = $73048c6b859c8a02$var$A(b, I, x = p + H, j)) ? _ = $73048c6b859c8a02$var$c : (_ = I[P] || $73048c6b859c8a02$var$c, I[P] = void 0, j--), $73048c6b859c8a02$var$L(n, b, _, i, o, r, f, e, a, v), m = b.__e, (y = b.ref) && _.ref != y && (_.ref && $73048c6b859c8a02$var$O(_.ref, null, b), v.push(y, b.__c || m, b)), null != m && (null == w && (w = m), (C = _ === $73048c6b859c8a02$var$c || null === _.__v) ? -1 == P && H-- : P !== x && (P === x + 1 ? H++ : P > x ? j > z - x ? H += P - x : H-- : H = P < x && P == x - 1 ? P - x : 0), x = p + H, "function" != typeof b.type || P === x && _.__k !== b.__k ? "function" == typeof b.type || P === x && !C ? void 0 !== b.__d ? (e = b.__d, b.__d = void 0) : e = m.nextSibling : e = $73048c6b859c8a02$var$S(n, m, e) : e = $73048c6b859c8a02$var$$(b, e, n), "function" == typeof u.type && (u.__d = e))) : (_ = I[p]) && null == _.key && _.__e && (_.__e == e && (e = $73048c6b859c8a02$var$g(_)), $73048c6b859c8a02$var$q(_, _, !1), I[p] = null);
    for(u.__e = w, p = T; p--;)null != I[p] && ("function" == typeof u.type && null != I[p].__e && I[p].__e == u.__d && (u.__d = I[p].__e.nextSibling), $73048c6b859c8a02$var$q(I[p], I[p]));
}
function $73048c6b859c8a02$var$$(n, l, u) {
    for(var t, i = n.__k, o = 0; i && o < i.length; o++)(t = i[o]) && (t.__ = n, l = "function" == typeof t.type ? $73048c6b859c8a02$var$$(t, l, u) : $73048c6b859c8a02$var$S(u, t.__e, l));
    return l;
}
function $73048c6b859c8a02$export$47e4c5b300681277(n, l) {
    return l = l || [], null == n || "boolean" == typeof n || ($73048c6b859c8a02$var$h(n) ? n.some(function(n) {
        $73048c6b859c8a02$export$47e4c5b300681277(n, l);
    }) : l.push(n)), l;
}
function $73048c6b859c8a02$var$S(n, l, u) {
    return null == u || u.parentNode !== n ? n.insertBefore(l, null) : l == u && null != l.parentNode || n.insertBefore(l, u), l.nextSibling;
}
function $73048c6b859c8a02$var$A(n, l, u, t) {
    var i = n.key, o = n.type, r = u - 1, f = u + 1, e = l[u];
    if (null === e || e && i == e.key && o === e.type) return u;
    if (t > (null != e ? 1 : 0)) for(; r >= 0 || f < l.length;){
        if (r >= 0) {
            if ((e = l[r]) && i == e.key && o === e.type) return r;
            r--;
        }
        if (f < l.length) {
            if ((e = l[f]) && i == e.key && o === e.type) return f;
            f++;
        }
    }
    return -1;
}
function $73048c6b859c8a02$var$H(n, l, u, t, i) {
    var o;
    for(o in u)"children" === o || "key" === o || o in l || $73048c6b859c8a02$var$T(n, o, null, u[o], t);
    for(o in l)i && "function" != typeof l[o] || "children" === o || "key" === o || "value" === o || "checked" === o || u[o] === l[o] || $73048c6b859c8a02$var$T(n, o, l[o], u[o], t);
}
function $73048c6b859c8a02$var$I(n, l, u) {
    "-" === l[0] ? n.setProperty(l, null == u ? "" : u) : n[l] = null == u ? "" : "number" != typeof u || $73048c6b859c8a02$var$a.test(l) ? u : u + "px";
}
function $73048c6b859c8a02$var$T(n, l, u, t, i) {
    var o;
    n: if ("style" === l) {
        if ("string" == typeof u) n.style.cssText = u;
        else {
            if ("string" == typeof t && (n.style.cssText = t = ""), t) for(l in t)u && l in u || $73048c6b859c8a02$var$I(n.style, l, "");
            if (u) for(l in u)t && u[l] === t[l] || $73048c6b859c8a02$var$I(n.style, l, u[l]);
        }
    } else if ("o" === l[0] && "n" === l[1]) o = l !== (l = l.replace(/(PointerCapture)$|Capture$/, "$1")), l = l.toLowerCase() in n ? l.toLowerCase().slice(2) : l.slice(2), n.l || (n.l = {}), n.l[l + o] = u, u ? t || n.addEventListener(l, o ? $73048c6b859c8a02$var$z : $73048c6b859c8a02$var$j, o) : n.removeEventListener(l, o ? $73048c6b859c8a02$var$z : $73048c6b859c8a02$var$j, o);
    else if ("dangerouslySetInnerHTML" !== l) {
        if (i) l = l.replace(/xlink(H|:h)/, "h").replace(/sName$/, "s");
        else if ("width" !== l && "height" !== l && "href" !== l && "list" !== l && "form" !== l && "tabIndex" !== l && "download" !== l && "rowSpan" !== l && "colSpan" !== l && l in n) try {
            n[l] = null == u ? "" : u;
            break n;
        } catch (n) {}
        "function" == typeof u || (null == u || !1 === u && "-" !== l[4] ? n.removeAttribute(l) : n.setAttribute(l, u));
    }
}
function $73048c6b859c8a02$var$j(n) {
    return this.l[n.type + !1]($73048c6b859c8a02$export$41c562ebe57d11e2.event ? $73048c6b859c8a02$export$41c562ebe57d11e2.event(n) : n);
}
function $73048c6b859c8a02$var$z(n) {
    return this.l[n.type + !0]($73048c6b859c8a02$export$41c562ebe57d11e2.event ? $73048c6b859c8a02$export$41c562ebe57d11e2.event(n) : n);
}
function $73048c6b859c8a02$var$L(n, u, t, i, o, r, f, e, c, s) {
    var a, p, y, d, _, g, m, w, x, $, C, S, A, H, I, T = u.type;
    if (void 0 !== u.constructor) return null;
    null != t.__h && (c = t.__h, e = u.__e = t.__e, u.__h = null, r = [
        e
    ]), (a = $73048c6b859c8a02$export$41c562ebe57d11e2.__b) && a(u);
    n: if ("function" == typeof T) try {
        if (w = u.props, x = (a = T.contextType) && i[a.__c], $ = a ? x ? x.props.value : a.__ : i, t.__c ? m = (p = u.__c = t.__c).__ = p.__E : ("prototype" in T && T.prototype.render ? u.__c = p = new T(w, $) : (u.__c = p = new $73048c6b859c8a02$export$16fa2f45be04daa8(w, $), p.constructor = T, p.render = $73048c6b859c8a02$var$B), x && x.sub(p), p.props = w, p.state || (p.state = {}), p.context = $, p.__n = i, y = p.__d = !0, p.__h = [], p._sb = []), null == p.__s && (p.__s = p.state), null != T.getDerivedStateFromProps && (p.__s == p.state && (p.__s = $73048c6b859c8a02$var$v({}, p.__s)), $73048c6b859c8a02$var$v(p.__s, T.getDerivedStateFromProps(w, p.__s))), d = p.props, _ = p.state, p.__v = u, y) null == T.getDerivedStateFromProps && null != p.componentWillMount && p.componentWillMount(), null != p.componentDidMount && p.__h.push(p.componentDidMount);
        else {
            if (null == T.getDerivedStateFromProps && w !== d && null != p.componentWillReceiveProps && p.componentWillReceiveProps(w, $), !p.__e && (null != p.shouldComponentUpdate && !1 === p.shouldComponentUpdate(w, p.__s, $) || u.__v === t.__v)) {
                for(u.__v !== t.__v && (p.props = w, p.state = p.__s, p.__d = !1), u.__e = t.__e, u.__k = t.__k, u.__k.forEach(function(n) {
                    n && (n.__ = u);
                }), C = 0; C < p._sb.length; C++)p.__h.push(p._sb[C]);
                p._sb = [], p.__h.length && f.push(p);
                break n;
            }
            null != p.componentWillUpdate && p.componentWillUpdate(w, p.__s, $), null != p.componentDidUpdate && p.__h.push(function() {
                p.componentDidUpdate(d, _, g);
            });
        }
        if (p.context = $, p.props = w, p.__P = n, p.__e = !1, S = $73048c6b859c8a02$export$41c562ebe57d11e2.__r, A = 0, "prototype" in T && T.prototype.render) {
            for(p.state = p.__s, p.__d = !1, S && S(u), a = p.render(p.props, p.state, p.context), H = 0; H < p._sb.length; H++)p.__h.push(p._sb[H]);
            p._sb = [];
        } else do p.__d = !1, S && S(u), a = p.render(p.props, p.state, p.context), p.state = p.__s;
        while (p.__d && ++A < 25);
        p.state = p.__s, null != p.getChildContext && (i = $73048c6b859c8a02$var$v($73048c6b859c8a02$var$v({}, i), p.getChildContext())), y || null == p.getSnapshotBeforeUpdate || (g = p.getSnapshotBeforeUpdate(d, _)), $73048c6b859c8a02$var$P(n, $73048c6b859c8a02$var$h(I = null != a && a.type === $73048c6b859c8a02$export$ffb0004e005737fa && null == a.key ? a.props.children : a) ? I : [
            I
        ], u, t, i, o, r, f, e, c, s), p.base = u.__e, u.__h = null, p.__h.length && f.push(p), m && (p.__E = p.__ = null);
    } catch (n) {
        u.__v = null, (c || null != r) && (u.__e = e, u.__h = !!c, r[r.indexOf(e)] = null), $73048c6b859c8a02$export$41c562ebe57d11e2.__e(n, u, t);
    }
    else null == r && u.__v === t.__v ? (u.__k = t.__k, u.__e = t.__e) : u.__e = $73048c6b859c8a02$var$N(t.__e, u, t, i, o, r, f, c, s);
    (a = $73048c6b859c8a02$export$41c562ebe57d11e2.diffed) && a(u);
}
function $73048c6b859c8a02$var$M(n, u, t) {
    for(var i = 0; i < t.length; i++)$73048c6b859c8a02$var$O(t[i], t[++i], t[++i]);
    $73048c6b859c8a02$export$41c562ebe57d11e2.__c && $73048c6b859c8a02$export$41c562ebe57d11e2.__c(u, n), n.some(function(u) {
        try {
            n = u.__h, u.__h = [], n.some(function(n) {
                n.call(u);
            });
        } catch (n) {
            $73048c6b859c8a02$export$41c562ebe57d11e2.__e(n, u.__v);
        }
    });
}
function $73048c6b859c8a02$var$N(l, u, t, i, o, r, f, e, s) {
    var a, v, y, d = t.props, _ = u.props, k = u.type, b = 0;
    if ("svg" === k && (o = !0), null != r) {
        for(; b < r.length; b++)if ((a = r[b]) && "setAttribute" in a == !!k && (k ? a.localName === k : 3 === a.nodeType)) {
            l = a, r[b] = null;
            break;
        }
    }
    if (null == l) {
        if (null === k) return document.createTextNode(_);
        l = o ? document.createElementNS("http://www.w3.org/2000/svg", k) : document.createElement(k, _.is && _), r = null, e = !1;
    }
    if (null === k) d === _ || e && l.data === _ || (l.data = _);
    else {
        if (r = r && $73048c6b859c8a02$var$n.call(l.childNodes), v = (d = t.props || $73048c6b859c8a02$var$c).dangerouslySetInnerHTML, y = _.dangerouslySetInnerHTML, !e) {
            if (null != r) for(d = {}, b = 0; b < l.attributes.length; b++)d[l.attributes[b].name] = l.attributes[b].value;
            (y || v) && (y && (v && y.__html == v.__html || y.__html === l.innerHTML) || (l.innerHTML = y && y.__html || ""));
        }
        if ($73048c6b859c8a02$var$H(l, _, d, o, e), y) u.__k = [];
        else if ($73048c6b859c8a02$var$P(l, $73048c6b859c8a02$var$h(b = u.props.children) ? b : [
            b
        ], u, t, i, o && "foreignObject" !== k, r, f, r ? r[0] : t.__k && $73048c6b859c8a02$var$g(t, 0), e, s), null != r) for(b = r.length; b--;)null != r[b] && $73048c6b859c8a02$var$p(r[b]);
        e || ("value" in _ && void 0 !== (b = _.value) && (b !== l.value || "progress" === k && !b || "option" === k && b !== d.value) && $73048c6b859c8a02$var$T(l, "value", b, d.value, !1), "checked" in _ && void 0 !== (b = _.checked) && b !== l.checked && $73048c6b859c8a02$var$T(l, "checked", b, d.checked, !1));
    }
    return l;
}
function $73048c6b859c8a02$var$O(n, u, t) {
    try {
        "function" == typeof n ? n(u) : n.current = u;
    } catch (n) {
        $73048c6b859c8a02$export$41c562ebe57d11e2.__e(n, t);
    }
}
function $73048c6b859c8a02$var$q(n, u, t) {
    var i, o;
    if ($73048c6b859c8a02$export$41c562ebe57d11e2.unmount && $73048c6b859c8a02$export$41c562ebe57d11e2.unmount(n), (i = n.ref) && (i.current && i.current !== n.__e || $73048c6b859c8a02$var$O(i, null, u)), null != (i = n.__c)) {
        if (i.componentWillUnmount) try {
            i.componentWillUnmount();
        } catch (n) {
            $73048c6b859c8a02$export$41c562ebe57d11e2.__e(n, u);
        }
        i.base = i.__P = null, n.__c = void 0;
    }
    if (i = n.__k) for(o = 0; o < i.length; o++)i[o] && $73048c6b859c8a02$var$q(i[o], u, t || "function" != typeof n.type);
    t || null == n.__e || $73048c6b859c8a02$var$p(n.__e), n.__ = n.__e = n.__d = void 0;
}
function $73048c6b859c8a02$var$B(n, l, u) {
    return this.constructor(n, u);
}
function $73048c6b859c8a02$export$b3890eb0ae9dca99(u, t, i) {
    var o, r, f, e;
    $73048c6b859c8a02$export$41c562ebe57d11e2.__ && $73048c6b859c8a02$export$41c562ebe57d11e2.__(u, t), r = (o = "function" == typeof i) ? null : i && i.__k || t.__k, f = [], e = [], $73048c6b859c8a02$var$L(t, u = (!o && i || t).__k = $73048c6b859c8a02$export$c8a8987d4410bf2d($73048c6b859c8a02$export$ffb0004e005737fa, null, [
        u
    ]), r || $73048c6b859c8a02$var$c, $73048c6b859c8a02$var$c, void 0 !== t.ownerSVGElement, !o && i ? [
        i
    ] : r ? null : t.firstChild ? $73048c6b859c8a02$var$n.call(t.childNodes) : null, f, !o && i ? i : r ? r.__e : t.firstChild, o, e), $73048c6b859c8a02$var$M(f, u, e);
}
function $73048c6b859c8a02$export$fa8d919ba61d84db(n, l) {
    $73048c6b859c8a02$export$b3890eb0ae9dca99(n, l, $73048c6b859c8a02$export$fa8d919ba61d84db);
}
function $73048c6b859c8a02$export$e530037191fcd5d7(l, u, t) {
    var i, o, r, f, e = $73048c6b859c8a02$var$v({}, l.props);
    for(r in l.type && l.type.defaultProps && (f = l.type.defaultProps), u)"key" == r ? i = u[r] : "ref" == r ? o = u[r] : e[r] = void 0 === u[r] && void 0 !== f ? f[r] : u[r];
    return arguments.length > 2 && (e.children = arguments.length > 3 ? $73048c6b859c8a02$var$n.call(arguments, 2) : t), $73048c6b859c8a02$var$d(l.type, e, i || l.key, o || l.ref, null);
}
function $73048c6b859c8a02$export$fd42f52fd3ae1109(n, l) {
    var u = {
        __c: l = "__cC" + $73048c6b859c8a02$var$e++,
        __: n,
        Consumer: function(n, l) {
            return n.children(l);
        },
        Provider: function(n) {
            var u, t;
            return this.getChildContext || (u = [], (t = {})[l] = this, this.getChildContext = function() {
                return t;
            }, this.shouldComponentUpdate = function(n) {
                this.props.value !== n.value && u.some(function(n) {
                    n.__e = !0, $73048c6b859c8a02$var$w(n);
                });
            }, this.sub = function(n) {
                u.push(n);
                var l = n.componentWillUnmount;
                n.componentWillUnmount = function() {
                    u.splice(u.indexOf(n), 1), l && l.call(n);
                };
            }), n.children;
        }
    };
    return u.Provider.__ = u.Consumer.contextType = u;
}
$73048c6b859c8a02$var$n = $73048c6b859c8a02$var$s.slice, $73048c6b859c8a02$export$41c562ebe57d11e2 = {
    __e: function(n, l, u, t) {
        for(var i, o, r; l = l.__;)if ((i = l.__c) && !i.__) try {
            if ((o = i.constructor) && null != o.getDerivedStateFromError && (i.setState(o.getDerivedStateFromError(n)), r = i.__d), null != i.componentDidCatch && (i.componentDidCatch(n, t || {}), r = i.__d), r) return i.__E = i;
        } catch (l) {
            n = l;
        }
        throw n;
    }
}, $73048c6b859c8a02$var$u = 0, $73048c6b859c8a02$export$a8257692ac88316c = function(n) {
    return null != n && void 0 === n.constructor;
}, $73048c6b859c8a02$export$16fa2f45be04daa8.prototype.setState = function(n, l) {
    var u;
    u = null != this.__s && this.__s !== this.state ? this.__s : this.__s = $73048c6b859c8a02$var$v({}, this.state), "function" == typeof n && (n = n($73048c6b859c8a02$var$v({}, u), this.props)), n && $73048c6b859c8a02$var$v(u, n), null != n && this.__v && (l && this._sb.push(l), $73048c6b859c8a02$var$w(this));
}, $73048c6b859c8a02$export$16fa2f45be04daa8.prototype.forceUpdate = function(n) {
    this.__v && (this.__e = !0, n && this.__h.push(n), $73048c6b859c8a02$var$w(this));
}, $73048c6b859c8a02$export$16fa2f45be04daa8.prototype.render = $73048c6b859c8a02$export$ffb0004e005737fa, $73048c6b859c8a02$var$i = [], $73048c6b859c8a02$var$r = "function" == typeof Promise ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, $73048c6b859c8a02$var$f = function(n, l) {
    return n.__v.__b - l.__v.__b;
}, $73048c6b859c8a02$var$x.__r = 0, $73048c6b859c8a02$var$e = 0;



const $7e84e1a08353bb30$var$alert = {
    remove: (id)=>document.getElementById(id).outerHTML = "",
    add: (text, alertStyle = "alert-success", countdown = 5000)=>{
        if (!text) return;
        let alertNode = document.createElement("DIV");
        alertNode.id = $7e84e1a08353bb30$var$alert.hash(text);
        alertNode.innerHTML = text;
        alertNode.classList.add("global-alert", "alert", alertStyle);
        document.body.appendChild(alertNode);
        setTimeout(()=>$7e84e1a08353bb30$var$alert.remove(alertNode.id), countdown);
    },
    hash: (str)=>{
        let hash = 0;
        if (str.length == 0) return hash;
        for(let i = 0; i < str.length; i++){
            let char = str.charCodeAt(i);
            hash = (hash << 5) - hash + char;
            hash = hash & hash; // Convert to 32bit integer
        }
        return hash;
    }
};
var $7e84e1a08353bb30$export$2e2bcd8739ae039 = $7e84e1a08353bb30$var$alert;



const $a43f12068c4c782d$var$storage = {
    usage: ()=>{
        let total = 0;
        let k;
        for(k in localStorage)if (Object.prototype.hasOwnProperty.call(localStorage, k)) total += (localStorage[k].length + k.length) * 2;
        return total;
    },
    createStorageBox: (data, metadata = null)=>({
            data: data,
            createdAt: Date.now(),
            metadata: metadata
        }),
    remove: (id)=>localStorage.removeItem(id),
    set: (id, data, metadata = null)=>{
        localStorage.setItem(id, JSON.stringify($a43f12068c4c782d$var$storage.createStorageBox(data, metadata)));
        return Promise.resolve(id);
    },
    get: (id)=>{
        let data = localStorage.getItem(id);
        if (data != null) {
            data = JSON.parse(data);
            if (Object.prototype.hasOwnProperty.call(data, "data")) return new Promise((r)=>r(data.data));
        }
        return new Promise((r)=>r(null));
    },
    reset: ()=>localStorage.clear() && window.dispatchEvent(new CustomEvent("resetStorage"))
};
var $a43f12068c4c782d$export$2e2bcd8739ae039 = $a43f12068c4c782d$var$storage;




let $085ef619554b5411$export$5f80af4e66cab974 = (modules)=>{
    let events = {};
    let state = {};
    let store = {
        dispatch (event, data) {
            if (event !== "@dispatch") store.dispatch("@dispatch", [
                event,
                data,
                events[event]
            ]);
            if (events[event]) {
                let changes;
                events[event].forEach((i)=>{
                    let diff = events[event].includes(i) && i(state, data, store);
                    if (diff && typeof diff.then !== "function") {
                        state = {
                            ...state,
                            ...diff
                        };
                        changes = {
                            ...changes,
                            ...diff
                        };
                    }
                });
                if (changes) store.dispatch("@changed", changes);
            }
        },
        get: ()=>state,
        on (event, cb) {
            (events[event] || (events[event] = [])).push(cb);
            return ()=>{
                events[event] = events[event].filter((i)=>i !== cb);
            };
        }
    };
    modules.forEach((i)=>{
        if (i) i(store);
    });
    store.dispatch("@init");
    return store;
};


//import { http } from "/src/core";
const $5332018adf75499b$export$bd17ce0bf3001bf8 = (store)=>{
    store.on("@init", ()=>({
            me: {}
        }));
    store.on("me/update", (state, me)=>{
        return {
            me: me
        };
    });
};


const $b8ff5357b6cef316$export$10417fa5fd48c90a = (store)=>{
    store.on("@init", ()=>({
            api: {}
        }));
    store.on("api/update", (state, api)=>{
        return {
            api: api
        };
    });
};


const $e44fcdfc78a2fa42$export$1a062524560abcaa = (store)=>{
    store.on("@init", ()=>({
            route: "",
            id: "",
            action: "",
            backUrl: "",
            entityType: "",
            search: "",
            entity: {}
        }));
    store.on("router/update", (_, newState)=>{
        return {
            entity: newState.entity,
            backUrl: newState.backUrl
        };
    });
};


const $b49847e1ffb70926$export$21b66e234e71aa95 = (store)=>{
    store.on("@init", ()=>({
            notifications: []
        }));
    store.on("notifications/update", (state, notifications = [])=>{
        return {
            notifications: notifications
        };
    });
    store.on("notifications/remove", (state, notification)=>{
        return {
            notifications: state.notifications.filter((n)=>n.id != notification.id)
        };
    });
    store.on("notifications/read", (state, notification)=>{
        return {
            notifications: state.notifications.map((n)=>n.id === notification.id ? Object.assign(n, {
                    read: true
                }) : n)
        };
    });
};



const $1648cda18d60f785$export$336a589663e3f2e0 = (store)=>{
    store.on("@init", ()=>({
            bookmarks: []
        }));
    store.on("bookmarks/update", (state, bookmarks = [])=>{
        return {
            bookmarks: bookmarks
        };
    });
    store.on("bookmark/remove", (state, bookmark)=>{
        (0, $cd2f6546c5cf5c32$export$7d6f1c8842f9f527).delete(`/api/bookmarks/${bookmark.id}`);
        return {
            bookmarks: state.bookmarks.filter((b)=>b.id != bookmark.id)
        };
    });
    store.on("bookmark/add", (state, message_id)=>{
        (0, $cd2f6546c5cf5c32$export$7d6f1c8842f9f527).post("/api/bookmarks", {
            message_id: message_id
        }).then((bookmark)=>{
            store.dispatch("bookmarks/update", [
                ...state.bookmarks,
                bookmark
            ]);
        });
    });
};


const $b7ae12cde431bd4b$var$store = (0, $085ef619554b5411$export$5f80af4e66cab974)([
    (0, $b8ff5357b6cef316$export$10417fa5fd48c90a),
    (0, $5332018adf75499b$export$bd17ce0bf3001bf8),
    (0, $e44fcdfc78a2fa42$export$1a062524560abcaa),
    (0, $b49847e1ffb70926$export$21b66e234e71aa95),
    (0, $1648cda18d60f785$export$336a589663e3f2e0)
]);
var $b7ae12cde431bd4b$export$2e2bcd8739ae039 = $b7ae12cde431bd4b$var$store;


const $cb95bcae1947788f$var$consoleLogger = {
    type: "logger",
    log (args) {
        this.output("log", args);
    },
    warn (args) {
        this.output("warn", args);
    },
    error (args) {
        this.output("error", args);
    },
    output (type, args) {
        if (console && console[type]) console[type].apply(console, args);
    }
};
class $cb95bcae1947788f$var$Logger {
    constructor(concreteLogger){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this.init(concreteLogger, options);
    }
    init(concreteLogger) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this.prefix = options.prefix || "i18next:";
        this.logger = concreteLogger || $cb95bcae1947788f$var$consoleLogger;
        this.options = options;
        this.debug = options.debug;
    }
    log() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return this.forward(args, "log", "", true);
    }
    warn() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return this.forward(args, "warn", "", true);
    }
    error() {
        for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
        return this.forward(args, "error", "");
    }
    deprecate() {
        for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
        return this.forward(args, "warn", "WARNING DEPRECATED: ", true);
    }
    forward(args, lvl, prefix, debugOnly) {
        if (debugOnly && !this.debug) return null;
        if (typeof args[0] === "string") args[0] = `${prefix}${this.prefix} ${args[0]}`;
        return this.logger[lvl](args);
    }
    create(moduleName) {
        return new $cb95bcae1947788f$var$Logger(this.logger, {
            prefix: `${this.prefix}:${moduleName}:`,
            ...this.options
        });
    }
    clone(options) {
        options = options || this.options;
        options.prefix = options.prefix || this.prefix;
        return new $cb95bcae1947788f$var$Logger(this.logger, options);
    }
}
var $cb95bcae1947788f$var$baseLogger = new $cb95bcae1947788f$var$Logger();
class $cb95bcae1947788f$var$EventEmitter {
    constructor(){
        this.observers = {};
    }
    on(events, listener) {
        events.split(" ").forEach((event)=>{
            this.observers[event] = this.observers[event] || [];
            this.observers[event].push(listener);
        });
        return this;
    }
    off(event, listener) {
        if (!this.observers[event]) return;
        if (!listener) {
            delete this.observers[event];
            return;
        }
        this.observers[event] = this.observers[event].filter((l)=>l !== listener);
    }
    emit(event) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        if (this.observers[event]) {
            const cloned = [].concat(this.observers[event]);
            cloned.forEach((observer)=>{
                observer(...args);
            });
        }
        if (this.observers["*"]) {
            const cloned = [].concat(this.observers["*"]);
            cloned.forEach((observer)=>{
                observer.apply(observer, [
                    event,
                    ...args
                ]);
            });
        }
    }
}
function $cb95bcae1947788f$var$defer() {
    let res;
    let rej;
    const promise = new Promise((resolve, reject)=>{
        res = resolve;
        rej = reject;
    });
    promise.resolve = res;
    promise.reject = rej;
    return promise;
}
function $cb95bcae1947788f$var$makeString(object) {
    if (object == null) return "";
    return "" + object;
}
function $cb95bcae1947788f$var$copy(a, s, t) {
    a.forEach((m)=>{
        if (s[m]) t[m] = s[m];
    });
}
function $cb95bcae1947788f$var$getLastOfPath(object, path, Empty) {
    function cleanKey(key) {
        return key && key.indexOf("###") > -1 ? key.replace(/###/g, ".") : key;
    }
    function canNotTraverseDeeper() {
        return !object || typeof object === "string";
    }
    const stack = typeof path !== "string" ? [].concat(path) : path.split(".");
    while(stack.length > 1){
        if (canNotTraverseDeeper()) return {};
        const key = cleanKey(stack.shift());
        if (!object[key] && Empty) object[key] = new Empty();
        if (Object.prototype.hasOwnProperty.call(object, key)) object = object[key];
        else object = {};
    }
    if (canNotTraverseDeeper()) return {};
    return {
        obj: object,
        k: cleanKey(stack.shift())
    };
}
function $cb95bcae1947788f$var$setPath(object, path, newValue) {
    const { obj: obj, k: k } = $cb95bcae1947788f$var$getLastOfPath(object, path, Object);
    obj[k] = newValue;
}
function $cb95bcae1947788f$var$pushPath(object, path, newValue, concat) {
    const { obj: obj, k: k } = $cb95bcae1947788f$var$getLastOfPath(object, path, Object);
    obj[k] = obj[k] || [];
    if (concat) obj[k] = obj[k].concat(newValue);
    if (!concat) obj[k].push(newValue);
}
function $cb95bcae1947788f$var$getPath(object, path) {
    const { obj: obj, k: k } = $cb95bcae1947788f$var$getLastOfPath(object, path);
    if (!obj) return undefined;
    return obj[k];
}
function $cb95bcae1947788f$var$getPathWithDefaults(data, defaultData, key) {
    const value = $cb95bcae1947788f$var$getPath(data, key);
    if (value !== undefined) return value;
    return $cb95bcae1947788f$var$getPath(defaultData, key);
}
function $cb95bcae1947788f$var$deepExtend(target, source, overwrite) {
    for(const prop in source)if (prop !== "__proto__" && prop !== "constructor") {
        if (prop in target) {
            if (typeof target[prop] === "string" || target[prop] instanceof String || typeof source[prop] === "string" || source[prop] instanceof String) {
                if (overwrite) target[prop] = source[prop];
            } else $cb95bcae1947788f$var$deepExtend(target[prop], source[prop], overwrite);
        } else target[prop] = source[prop];
    }
    return target;
}
function $cb95bcae1947788f$var$regexEscape(str) {
    return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
}
var $cb95bcae1947788f$var$_entityMap = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#39;",
    "/": "&#x2F;"
};
function $cb95bcae1947788f$var$escape(data) {
    if (typeof data === "string") return data.replace(/[&<>"'\/]/g, (s)=>$cb95bcae1947788f$var$_entityMap[s]);
    return data;
}
const $cb95bcae1947788f$var$chars = [
    " ",
    ",",
    "?",
    "!",
    ";"
];
function $cb95bcae1947788f$var$looksLikeObjectPath(key, nsSeparator, keySeparator) {
    nsSeparator = nsSeparator || "";
    keySeparator = keySeparator || "";
    const possibleChars = $cb95bcae1947788f$var$chars.filter((c)=>nsSeparator.indexOf(c) < 0 && keySeparator.indexOf(c) < 0);
    if (possibleChars.length === 0) return true;
    const r = new RegExp(`(${possibleChars.map((c)=>c === "?" ? "\\?" : c).join("|")})`);
    let matched = !r.test(key);
    if (!matched) {
        const ki = key.indexOf(keySeparator);
        if (ki > 0 && !r.test(key.substring(0, ki))) matched = true;
    }
    return matched;
}
function $cb95bcae1947788f$var$deepFind(obj, path) {
    let keySeparator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ".";
    if (!obj) return undefined;
    if (obj[path]) return obj[path];
    const paths = path.split(keySeparator);
    let current = obj;
    for(let i = 0; i < paths.length; ++i){
        if (!current) return undefined;
        if (typeof current[paths[i]] === "string" && i + 1 < paths.length) return undefined;
        if (current[paths[i]] === undefined) {
            let j = 2;
            let p = paths.slice(i, i + j).join(keySeparator);
            let mix = current[p];
            while(mix === undefined && paths.length > i + j){
                j++;
                p = paths.slice(i, i + j).join(keySeparator);
                mix = current[p];
            }
            if (mix === undefined) return undefined;
            if (mix === null) return null;
            if (path.endsWith(p)) {
                if (typeof mix === "string") return mix;
                if (p && typeof mix[p] === "string") return mix[p];
            }
            const joinedPath = paths.slice(i + j).join(keySeparator);
            if (joinedPath) return $cb95bcae1947788f$var$deepFind(mix, joinedPath, keySeparator);
            return undefined;
        }
        current = current[paths[i]];
    }
    return current;
}
function $cb95bcae1947788f$var$getCleanedCode(code) {
    if (code && code.indexOf("_") > 0) return code.replace("_", "-");
    return code;
}
class $cb95bcae1947788f$var$ResourceStore extends $cb95bcae1947788f$var$EventEmitter {
    constructor(data){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
            ns: [
                "translation"
            ],
            defaultNS: "translation"
        };
        super();
        this.data = data || {};
        this.options = options;
        if (this.options.keySeparator === undefined) this.options.keySeparator = ".";
        if (this.options.ignoreJSONStructure === undefined) this.options.ignoreJSONStructure = true;
    }
    addNamespaces(ns) {
        if (this.options.ns.indexOf(ns) < 0) this.options.ns.push(ns);
    }
    removeNamespaces(ns) {
        const index = this.options.ns.indexOf(ns);
        if (index > -1) this.options.ns.splice(index, 1);
    }
    getResource(lng, ns, key) {
        let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
        const ignoreJSONStructure = options.ignoreJSONStructure !== undefined ? options.ignoreJSONStructure : this.options.ignoreJSONStructure;
        let path = [
            lng,
            ns
        ];
        if (key && typeof key !== "string") path = path.concat(key);
        if (key && typeof key === "string") path = path.concat(keySeparator ? key.split(keySeparator) : key);
        if (lng.indexOf(".") > -1) path = lng.split(".");
        const result = $cb95bcae1947788f$var$getPath(this.data, path);
        if (result || !ignoreJSONStructure || typeof key !== "string") return result;
        return $cb95bcae1947788f$var$deepFind(this.data && this.data[lng] && this.data[lng][ns], key, keySeparator);
    }
    addResource(lng, ns, key, value) {
        let options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
            silent: false
        };
        const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
        let path = [
            lng,
            ns
        ];
        if (key) path = path.concat(keySeparator ? key.split(keySeparator) : key);
        if (lng.indexOf(".") > -1) {
            path = lng.split(".");
            value = ns;
            ns = path[1];
        }
        this.addNamespaces(ns);
        $cb95bcae1947788f$var$setPath(this.data, path, value);
        if (!options.silent) this.emit("added", lng, ns, key, value);
    }
    addResources(lng, ns, resources) {
        let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
            silent: false
        };
        for(const m in resources)if (typeof resources[m] === "string" || Object.prototype.toString.apply(resources[m]) === "[object Array]") this.addResource(lng, ns, m, resources[m], {
            silent: true
        });
        if (!options.silent) this.emit("added", lng, ns, resources);
    }
    addResourceBundle(lng, ns, resources, deep, overwrite) {
        let options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {
            silent: false
        };
        let path = [
            lng,
            ns
        ];
        if (lng.indexOf(".") > -1) {
            path = lng.split(".");
            deep = resources;
            resources = ns;
            ns = path[1];
        }
        this.addNamespaces(ns);
        let pack = $cb95bcae1947788f$var$getPath(this.data, path) || {};
        if (deep) $cb95bcae1947788f$var$deepExtend(pack, resources, overwrite);
        else pack = {
            ...pack,
            ...resources
        };
        $cb95bcae1947788f$var$setPath(this.data, path, pack);
        if (!options.silent) this.emit("added", lng, ns, resources);
    }
    removeResourceBundle(lng, ns) {
        if (this.hasResourceBundle(lng, ns)) delete this.data[lng][ns];
        this.removeNamespaces(ns);
        this.emit("removed", lng, ns);
    }
    hasResourceBundle(lng, ns) {
        return this.getResource(lng, ns) !== undefined;
    }
    getResourceBundle(lng, ns) {
        if (!ns) ns = this.options.defaultNS;
        if (this.options.compatibilityAPI === "v1") return {
            ...this.getResource(lng, ns)
        };
        return this.getResource(lng, ns);
    }
    getDataByLanguage(lng) {
        return this.data[lng];
    }
    hasLanguageSomeTranslations(lng) {
        const data = this.getDataByLanguage(lng);
        const n = data && Object.keys(data) || [];
        return !!n.find((v)=>data[v] && Object.keys(data[v]).length > 0);
    }
    toJSON() {
        return this.data;
    }
}
var $cb95bcae1947788f$var$postProcessor = {
    processors: {},
    addPostProcessor (module) {
        this.processors[module.name] = module;
    },
    handle (processors, value, key, options, translator) {
        processors.forEach((processor)=>{
            if (this.processors[processor]) value = this.processors[processor].process(value, key, options, translator);
        });
        return value;
    }
};
const $cb95bcae1947788f$var$checkedLoadedFor = {};
class $cb95bcae1947788f$var$Translator extends $cb95bcae1947788f$var$EventEmitter {
    constructor(services){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        super();
        $cb95bcae1947788f$var$copy([
            "resourceStore",
            "languageUtils",
            "pluralResolver",
            "interpolator",
            "backendConnector",
            "i18nFormat",
            "utils"
        ], services, this);
        this.options = options;
        if (this.options.keySeparator === undefined) this.options.keySeparator = ".";
        this.logger = $cb95bcae1947788f$var$baseLogger.create("translator");
    }
    changeLanguage(lng) {
        if (lng) this.language = lng;
    }
    exists(key) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
            interpolation: {}
        };
        if (key === undefined || key === null) return false;
        const resolved = this.resolve(key, options);
        return resolved && resolved.res !== undefined;
    }
    extractFromKey(key, options) {
        let nsSeparator = options.nsSeparator !== undefined ? options.nsSeparator : this.options.nsSeparator;
        if (nsSeparator === undefined) nsSeparator = ":";
        const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
        let namespaces = options.ns || this.options.defaultNS || [];
        const wouldCheckForNsInKey = nsSeparator && key.indexOf(nsSeparator) > -1;
        const seemsNaturalLanguage = !this.options.userDefinedKeySeparator && !options.keySeparator && !this.options.userDefinedNsSeparator && !options.nsSeparator && !$cb95bcae1947788f$var$looksLikeObjectPath(key, nsSeparator, keySeparator);
        if (wouldCheckForNsInKey && !seemsNaturalLanguage) {
            const m = key.match(this.interpolator.nestingRegexp);
            if (m && m.length > 0) return {
                key: key,
                namespaces: namespaces
            };
            const parts = key.split(nsSeparator);
            if (nsSeparator !== keySeparator || nsSeparator === keySeparator && this.options.ns.indexOf(parts[0]) > -1) namespaces = parts.shift();
            key = parts.join(keySeparator);
        }
        if (typeof namespaces === "string") namespaces = [
            namespaces
        ];
        return {
            key: key,
            namespaces: namespaces
        };
    }
    translate(keys, options, lastKey) {
        if (typeof options !== "object" && this.options.overloadTranslationOptionHandler) options = this.options.overloadTranslationOptionHandler(arguments);
        if (typeof options === "object") options = {
            ...options
        };
        if (!options) options = {};
        if (keys === undefined || keys === null) return "";
        if (!Array.isArray(keys)) keys = [
            String(keys)
        ];
        const returnDetails = options.returnDetails !== undefined ? options.returnDetails : this.options.returnDetails;
        const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
        const { key: key, namespaces: namespaces } = this.extractFromKey(keys[keys.length - 1], options);
        const namespace = namespaces[namespaces.length - 1];
        const lng = options.lng || this.language;
        const appendNamespaceToCIMode = options.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
        if (lng && lng.toLowerCase() === "cimode") {
            if (appendNamespaceToCIMode) {
                const nsSeparator = options.nsSeparator || this.options.nsSeparator;
                if (returnDetails) return {
                    res: `${namespace}${nsSeparator}${key}`,
                    usedKey: key,
                    exactUsedKey: key,
                    usedLng: lng,
                    usedNS: namespace,
                    usedParams: this.getUsedParamsDetails(options)
                };
                return `${namespace}${nsSeparator}${key}`;
            }
            if (returnDetails) return {
                res: key,
                usedKey: key,
                exactUsedKey: key,
                usedLng: lng,
                usedNS: namespace,
                usedParams: this.getUsedParamsDetails(options)
            };
            return key;
        }
        const resolved = this.resolve(keys, options);
        let res = resolved && resolved.res;
        const resUsedKey = resolved && resolved.usedKey || key;
        const resExactUsedKey = resolved && resolved.exactUsedKey || key;
        const resType = Object.prototype.toString.apply(res);
        const noObject = [
            "[object Number]",
            "[object Function]",
            "[object RegExp]"
        ];
        const joinArrays = options.joinArrays !== undefined ? options.joinArrays : this.options.joinArrays;
        const handleAsObjectInI18nFormat = !this.i18nFormat || this.i18nFormat.handleAsObject;
        const handleAsObject = typeof res !== "string" && typeof res !== "boolean" && typeof res !== "number";
        if (handleAsObjectInI18nFormat && res && handleAsObject && noObject.indexOf(resType) < 0 && !(typeof joinArrays === "string" && resType === "[object Array]")) {
            if (!options.returnObjects && !this.options.returnObjects) {
                if (!this.options.returnedObjectHandler) this.logger.warn("accessing an object - but returnObjects options is not enabled!");
                const r = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(resUsedKey, res, {
                    ...options,
                    ns: namespaces
                }) : `key '${key} (${this.language})' returned an object instead of string.`;
                if (returnDetails) {
                    resolved.res = r;
                    resolved.usedParams = this.getUsedParamsDetails(options);
                    return resolved;
                }
                return r;
            }
            if (keySeparator) {
                const resTypeIsArray = resType === "[object Array]";
                const copy = resTypeIsArray ? [] : {};
                const newKeyToUse = resTypeIsArray ? resExactUsedKey : resUsedKey;
                for(const m in res)if (Object.prototype.hasOwnProperty.call(res, m)) {
                    const deepKey = `${newKeyToUse}${keySeparator}${m}`;
                    copy[m] = this.translate(deepKey, {
                        ...options,
                        joinArrays: false,
                        ns: namespaces
                    });
                    if (copy[m] === deepKey) copy[m] = res[m];
                }
                res = copy;
            }
        } else if (handleAsObjectInI18nFormat && typeof joinArrays === "string" && resType === "[object Array]") {
            res = res.join(joinArrays);
            if (res) res = this.extendTranslation(res, keys, options, lastKey);
        } else {
            let usedDefault = false;
            let usedKey = false;
            const needsPluralHandling = options.count !== undefined && typeof options.count !== "string";
            const hasDefaultValue = $cb95bcae1947788f$var$Translator.hasDefaultValue(options);
            const defaultValueSuffix = needsPluralHandling ? this.pluralResolver.getSuffix(lng, options.count, options) : "";
            const defaultValueSuffixOrdinalFallback = options.ordinal && needsPluralHandling ? this.pluralResolver.getSuffix(lng, options.count, {
                ordinal: false
            }) : "";
            const defaultValue = options[`defaultValue${defaultValueSuffix}`] || options[`defaultValue${defaultValueSuffixOrdinalFallback}`] || options.defaultValue;
            if (!this.isValidLookup(res) && hasDefaultValue) {
                usedDefault = true;
                res = defaultValue;
            }
            if (!this.isValidLookup(res)) {
                usedKey = true;
                res = key;
            }
            const missingKeyNoValueFallbackToKey = options.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey;
            const resForMissing = missingKeyNoValueFallbackToKey && usedKey ? undefined : res;
            const updateMissing = hasDefaultValue && defaultValue !== res && this.options.updateMissing;
            if (usedKey || usedDefault || updateMissing) {
                this.logger.log(updateMissing ? "updateKey" : "missingKey", lng, namespace, key, updateMissing ? defaultValue : res);
                if (keySeparator) {
                    const fk = this.resolve(key, {
                        ...options,
                        keySeparator: false
                    });
                    if (fk && fk.res) this.logger.warn("Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.");
                }
                let lngs = [];
                const fallbackLngs = this.languageUtils.getFallbackCodes(this.options.fallbackLng, options.lng || this.language);
                if (this.options.saveMissingTo === "fallback" && fallbackLngs && fallbackLngs[0]) for(let i = 0; i < fallbackLngs.length; i++)lngs.push(fallbackLngs[i]);
                else if (this.options.saveMissingTo === "all") lngs = this.languageUtils.toResolveHierarchy(options.lng || this.language);
                else lngs.push(options.lng || this.language);
                const send = (l, k, specificDefaultValue)=>{
                    const defaultForMissing = hasDefaultValue && specificDefaultValue !== res ? specificDefaultValue : resForMissing;
                    if (this.options.missingKeyHandler) this.options.missingKeyHandler(l, namespace, k, defaultForMissing, updateMissing, options);
                    else if (this.backendConnector && this.backendConnector.saveMissing) this.backendConnector.saveMissing(l, namespace, k, defaultForMissing, updateMissing, options);
                    this.emit("missingKey", l, namespace, k, res);
                };
                if (this.options.saveMissing) {
                    if (this.options.saveMissingPlurals && needsPluralHandling) lngs.forEach((language)=>{
                        this.pluralResolver.getSuffixes(language, options).forEach((suffix)=>{
                            send([
                                language
                            ], key + suffix, options[`defaultValue${suffix}`] || defaultValue);
                        });
                    });
                    else send(lngs, key, defaultValue);
                }
            }
            res = this.extendTranslation(res, keys, options, resolved, lastKey);
            if (usedKey && res === key && this.options.appendNamespaceToMissingKey) res = `${namespace}:${key}`;
            if ((usedKey || usedDefault) && this.options.parseMissingKeyHandler) {
                if (this.options.compatibilityAPI !== "v1") res = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? `${namespace}:${key}` : key, usedDefault ? res : undefined);
                else res = this.options.parseMissingKeyHandler(res);
            }
        }
        if (returnDetails) {
            resolved.res = res;
            resolved.usedParams = this.getUsedParamsDetails(options);
            return resolved;
        }
        return res;
    }
    extendTranslation(res, key, options, resolved, lastKey) {
        var _this = this;
        if (this.i18nFormat && this.i18nFormat.parse) res = this.i18nFormat.parse(res, {
            ...this.options.interpolation.defaultVariables,
            ...options
        }, options.lng || this.language || resolved.usedLng, resolved.usedNS, resolved.usedKey, {
            resolved: resolved
        });
        else if (!options.skipInterpolation) {
            if (options.interpolation) this.interpolator.init({
                ...options,
                interpolation: {
                    ...this.options.interpolation,
                    ...options.interpolation
                }
            });
            const skipOnVariables = typeof res === "string" && (options && options.interpolation && options.interpolation.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
            let nestBef;
            if (skipOnVariables) {
                const nb = res.match(this.interpolator.nestingRegexp);
                nestBef = nb && nb.length;
            }
            let data = options.replace && typeof options.replace !== "string" ? options.replace : options;
            if (this.options.interpolation.defaultVariables) data = {
                ...this.options.interpolation.defaultVariables,
                ...data
            };
            res = this.interpolator.interpolate(res, data, options.lng || this.language, options);
            if (skipOnVariables) {
                const na = res.match(this.interpolator.nestingRegexp);
                const nestAft = na && na.length;
                if (nestBef < nestAft) options.nest = false;
            }
            if (!options.lng && this.options.compatibilityAPI !== "v1" && resolved && resolved.res) options.lng = resolved.usedLng;
            if (options.nest !== false) res = this.interpolator.nest(res, function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                if (lastKey && lastKey[0] === args[0] && !options.context) {
                    _this.logger.warn(`It seems you are nesting recursively key: ${args[0]} in key: ${key[0]}`);
                    return null;
                }
                return _this.translate(...args, key);
            }, options);
            if (options.interpolation) this.interpolator.reset();
        }
        const postProcess = options.postProcess || this.options.postProcess;
        const postProcessorNames = typeof postProcess === "string" ? [
            postProcess
        ] : postProcess;
        if (res !== undefined && res !== null && postProcessorNames && postProcessorNames.length && options.applyPostProcessor !== false) res = $cb95bcae1947788f$var$postProcessor.handle(postProcessorNames, res, key, this.options && this.options.postProcessPassResolved ? {
            i18nResolved: resolved,
            ...options
        } : options, this);
        return res;
    }
    resolve(keys) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        let found;
        let usedKey;
        let exactUsedKey;
        let usedLng;
        let usedNS;
        if (typeof keys === "string") keys = [
            keys
        ];
        keys.forEach((k)=>{
            if (this.isValidLookup(found)) return;
            const extracted = this.extractFromKey(k, options);
            const key = extracted.key;
            usedKey = key;
            let namespaces = extracted.namespaces;
            if (this.options.fallbackNS) namespaces = namespaces.concat(this.options.fallbackNS);
            const needsPluralHandling = options.count !== undefined && typeof options.count !== "string";
            const needsZeroSuffixLookup = needsPluralHandling && !options.ordinal && options.count === 0 && this.pluralResolver.shouldUseIntlApi();
            const needsContextHandling = options.context !== undefined && (typeof options.context === "string" || typeof options.context === "number") && options.context !== "";
            const codes = options.lngs ? options.lngs : this.languageUtils.toResolveHierarchy(options.lng || this.language, options.fallbackLng);
            namespaces.forEach((ns)=>{
                if (this.isValidLookup(found)) return;
                usedNS = ns;
                if (!$cb95bcae1947788f$var$checkedLoadedFor[`${codes[0]}-${ns}`] && this.utils && this.utils.hasLoadedNamespace && !this.utils.hasLoadedNamespace(usedNS)) {
                    $cb95bcae1947788f$var$checkedLoadedFor[`${codes[0]}-${ns}`] = true;
                    this.logger.warn(`key "${usedKey}" for languages "${codes.join(", ")}" won't get resolved as namespace "${usedNS}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
                }
                codes.forEach((code)=>{
                    if (this.isValidLookup(found)) return;
                    usedLng = code;
                    const finalKeys = [
                        key
                    ];
                    if (this.i18nFormat && this.i18nFormat.addLookupKeys) this.i18nFormat.addLookupKeys(finalKeys, key, code, ns, options);
                    else {
                        let pluralSuffix;
                        if (needsPluralHandling) pluralSuffix = this.pluralResolver.getSuffix(code, options.count, options);
                        const zeroSuffix = `${this.options.pluralSeparator}zero`;
                        const ordinalPrefix = `${this.options.pluralSeparator}ordinal${this.options.pluralSeparator}`;
                        if (needsPluralHandling) {
                            finalKeys.push(key + pluralSuffix);
                            if (options.ordinal && pluralSuffix.indexOf(ordinalPrefix) === 0) finalKeys.push(key + pluralSuffix.replace(ordinalPrefix, this.options.pluralSeparator));
                            if (needsZeroSuffixLookup) finalKeys.push(key + zeroSuffix);
                        }
                        if (needsContextHandling) {
                            const contextKey = `${key}${this.options.contextSeparator}${options.context}`;
                            finalKeys.push(contextKey);
                            if (needsPluralHandling) {
                                finalKeys.push(contextKey + pluralSuffix);
                                if (options.ordinal && pluralSuffix.indexOf(ordinalPrefix) === 0) finalKeys.push(contextKey + pluralSuffix.replace(ordinalPrefix, this.options.pluralSeparator));
                                if (needsZeroSuffixLookup) finalKeys.push(contextKey + zeroSuffix);
                            }
                        }
                    }
                    let possibleKey;
                    while(possibleKey = finalKeys.pop())if (!this.isValidLookup(found)) {
                        exactUsedKey = possibleKey;
                        found = this.getResource(code, ns, possibleKey, options);
                    }
                });
            });
        });
        return {
            res: found,
            usedKey: usedKey,
            exactUsedKey: exactUsedKey,
            usedLng: usedLng,
            usedNS: usedNS
        };
    }
    isValidLookup(res) {
        return res !== undefined && !(!this.options.returnNull && res === null) && !(!this.options.returnEmptyString && res === "");
    }
    getResource(code, ns, key) {
        let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        if (this.i18nFormat && this.i18nFormat.getResource) return this.i18nFormat.getResource(code, ns, key, options);
        return this.resourceStore.getResource(code, ns, key, options);
    }
    getUsedParamsDetails() {
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        const optionsKeys = [
            "defaultValue",
            "ordinal",
            "context",
            "replace",
            "lng",
            "lngs",
            "fallbackLng",
            "ns",
            "keySeparator",
            "nsSeparator",
            "returnObjects",
            "returnDetails",
            "joinArrays",
            "postProcess",
            "interpolation"
        ];
        const useOptionsReplaceForData = options.replace && typeof options.replace !== "string";
        let data = useOptionsReplaceForData ? options.replace : options;
        if (useOptionsReplaceForData && typeof options.count !== "undefined") data.count = options.count;
        if (this.options.interpolation.defaultVariables) data = {
            ...this.options.interpolation.defaultVariables,
            ...data
        };
        if (!useOptionsReplaceForData) {
            data = {
                ...data
            };
            for (const key of optionsKeys)delete data[key];
        }
        return data;
    }
    static hasDefaultValue(options) {
        const prefix = "defaultValue";
        for(const option in options){
            if (Object.prototype.hasOwnProperty.call(options, option) && prefix === option.substring(0, prefix.length) && undefined !== options[option]) return true;
        }
        return false;
    }
}
function $cb95bcae1947788f$var$capitalize(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}
class $cb95bcae1947788f$var$LanguageUtil {
    constructor(options){
        this.options = options;
        this.supportedLngs = this.options.supportedLngs || false;
        this.logger = $cb95bcae1947788f$var$baseLogger.create("languageUtils");
    }
    getScriptPartFromCode(code) {
        code = $cb95bcae1947788f$var$getCleanedCode(code);
        if (!code || code.indexOf("-") < 0) return null;
        const p = code.split("-");
        if (p.length === 2) return null;
        p.pop();
        if (p[p.length - 1].toLowerCase() === "x") return null;
        return this.formatLanguageCode(p.join("-"));
    }
    getLanguagePartFromCode(code) {
        code = $cb95bcae1947788f$var$getCleanedCode(code);
        if (!code || code.indexOf("-") < 0) return code;
        const p = code.split("-");
        return this.formatLanguageCode(p[0]);
    }
    formatLanguageCode(code) {
        if (typeof code === "string" && code.indexOf("-") > -1) {
            const specialCases = [
                "hans",
                "hant",
                "latn",
                "cyrl",
                "cans",
                "mong",
                "arab"
            ];
            let p = code.split("-");
            if (this.options.lowerCaseLng) p = p.map((part)=>part.toLowerCase());
            else if (p.length === 2) {
                p[0] = p[0].toLowerCase();
                p[1] = p[1].toUpperCase();
                if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = $cb95bcae1947788f$var$capitalize(p[1].toLowerCase());
            } else if (p.length === 3) {
                p[0] = p[0].toLowerCase();
                if (p[1].length === 2) p[1] = p[1].toUpperCase();
                if (p[0] !== "sgn" && p[2].length === 2) p[2] = p[2].toUpperCase();
                if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = $cb95bcae1947788f$var$capitalize(p[1].toLowerCase());
                if (specialCases.indexOf(p[2].toLowerCase()) > -1) p[2] = $cb95bcae1947788f$var$capitalize(p[2].toLowerCase());
            }
            return p.join("-");
        }
        return this.options.cleanCode || this.options.lowerCaseLng ? code.toLowerCase() : code;
    }
    isSupportedCode(code) {
        if (this.options.load === "languageOnly" || this.options.nonExplicitSupportedLngs) code = this.getLanguagePartFromCode(code);
        return !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(code) > -1;
    }
    getBestMatchFromCodes(codes) {
        if (!codes) return null;
        let found;
        codes.forEach((code)=>{
            if (found) return;
            const cleanedLng = this.formatLanguageCode(code);
            if (!this.options.supportedLngs || this.isSupportedCode(cleanedLng)) found = cleanedLng;
        });
        if (!found && this.options.supportedLngs) codes.forEach((code)=>{
            if (found) return;
            const lngOnly = this.getLanguagePartFromCode(code);
            if (this.isSupportedCode(lngOnly)) return found = lngOnly;
            found = this.options.supportedLngs.find((supportedLng)=>{
                if (supportedLng === lngOnly) return supportedLng;
                if (supportedLng.indexOf("-") < 0 && lngOnly.indexOf("-") < 0) return;
                if (supportedLng.indexOf(lngOnly) === 0) return supportedLng;
            });
        });
        if (!found) found = this.getFallbackCodes(this.options.fallbackLng)[0];
        return found;
    }
    getFallbackCodes(fallbacks, code) {
        if (!fallbacks) return [];
        if (typeof fallbacks === "function") fallbacks = fallbacks(code);
        if (typeof fallbacks === "string") fallbacks = [
            fallbacks
        ];
        if (Object.prototype.toString.apply(fallbacks) === "[object Array]") return fallbacks;
        if (!code) return fallbacks.default || [];
        let found = fallbacks[code];
        if (!found) found = fallbacks[this.getScriptPartFromCode(code)];
        if (!found) found = fallbacks[this.formatLanguageCode(code)];
        if (!found) found = fallbacks[this.getLanguagePartFromCode(code)];
        if (!found) found = fallbacks.default;
        return found || [];
    }
    toResolveHierarchy(code, fallbackCode) {
        const fallbackCodes = this.getFallbackCodes(fallbackCode || this.options.fallbackLng || [], code);
        const codes = [];
        const addCode = (c)=>{
            if (!c) return;
            if (this.isSupportedCode(c)) codes.push(c);
            else this.logger.warn(`rejecting language code not found in supportedLngs: ${c}`);
        };
        if (typeof code === "string" && (code.indexOf("-") > -1 || code.indexOf("_") > -1)) {
            if (this.options.load !== "languageOnly") addCode(this.formatLanguageCode(code));
            if (this.options.load !== "languageOnly" && this.options.load !== "currentOnly") addCode(this.getScriptPartFromCode(code));
            if (this.options.load !== "currentOnly") addCode(this.getLanguagePartFromCode(code));
        } else if (typeof code === "string") addCode(this.formatLanguageCode(code));
        fallbackCodes.forEach((fc)=>{
            if (codes.indexOf(fc) < 0) addCode(this.formatLanguageCode(fc));
        });
        return codes;
    }
}
let $cb95bcae1947788f$var$sets = [
    {
        lngs: [
            "ach",
            "ak",
            "am",
            "arn",
            "br",
            "fil",
            "gun",
            "ln",
            "mfe",
            "mg",
            "mi",
            "oc",
            "pt",
            "pt-BR",
            "tg",
            "tl",
            "ti",
            "tr",
            "uz",
            "wa"
        ],
        nr: [
            1,
            2
        ],
        fc: 1
    },
    {
        lngs: [
            "af",
            "an",
            "ast",
            "az",
            "bg",
            "bn",
            "ca",
            "da",
            "de",
            "dev",
            "el",
            "en",
            "eo",
            "es",
            "et",
            "eu",
            "fi",
            "fo",
            "fur",
            "fy",
            "gl",
            "gu",
            "ha",
            "hi",
            "hu",
            "hy",
            "ia",
            "it",
            "kk",
            "kn",
            "ku",
            "lb",
            "mai",
            "ml",
            "mn",
            "mr",
            "nah",
            "nap",
            "nb",
            "ne",
            "nl",
            "nn",
            "no",
            "nso",
            "pa",
            "pap",
            "pms",
            "ps",
            "pt-PT",
            "rm",
            "sco",
            "se",
            "si",
            "so",
            "son",
            "sq",
            "sv",
            "sw",
            "ta",
            "te",
            "tk",
            "ur",
            "yo"
        ],
        nr: [
            1,
            2
        ],
        fc: 2
    },
    {
        lngs: [
            "ay",
            "bo",
            "cgg",
            "fa",
            "ht",
            "id",
            "ja",
            "jbo",
            "ka",
            "km",
            "ko",
            "ky",
            "lo",
            "ms",
            "sah",
            "su",
            "th",
            "tt",
            "ug",
            "vi",
            "wo",
            "zh"
        ],
        nr: [
            1
        ],
        fc: 3
    },
    {
        lngs: [
            "be",
            "bs",
            "cnr",
            "dz",
            "hr",
            "ru",
            "sr",
            "uk"
        ],
        nr: [
            1,
            2,
            5
        ],
        fc: 4
    },
    {
        lngs: [
            "ar"
        ],
        nr: [
            0,
            1,
            2,
            3,
            11,
            100
        ],
        fc: 5
    },
    {
        lngs: [
            "cs",
            "sk"
        ],
        nr: [
            1,
            2,
            5
        ],
        fc: 6
    },
    {
        lngs: [
            "csb",
            "pl"
        ],
        nr: [
            1,
            2,
            5
        ],
        fc: 7
    },
    {
        lngs: [
            "cy"
        ],
        nr: [
            1,
            2,
            3,
            8
        ],
        fc: 8
    },
    {
        lngs: [
            "fr"
        ],
        nr: [
            1,
            2
        ],
        fc: 9
    },
    {
        lngs: [
            "ga"
        ],
        nr: [
            1,
            2,
            3,
            7,
            11
        ],
        fc: 10
    },
    {
        lngs: [
            "gd"
        ],
        nr: [
            1,
            2,
            3,
            20
        ],
        fc: 11
    },
    {
        lngs: [
            "is"
        ],
        nr: [
            1,
            2
        ],
        fc: 12
    },
    {
        lngs: [
            "jv"
        ],
        nr: [
            0,
            1
        ],
        fc: 13
    },
    {
        lngs: [
            "kw"
        ],
        nr: [
            1,
            2,
            3,
            4
        ],
        fc: 14
    },
    {
        lngs: [
            "lt"
        ],
        nr: [
            1,
            2,
            10
        ],
        fc: 15
    },
    {
        lngs: [
            "lv"
        ],
        nr: [
            1,
            2,
            0
        ],
        fc: 16
    },
    {
        lngs: [
            "mk"
        ],
        nr: [
            1,
            2
        ],
        fc: 17
    },
    {
        lngs: [
            "mnk"
        ],
        nr: [
            0,
            1,
            2
        ],
        fc: 18
    },
    {
        lngs: [
            "mt"
        ],
        nr: [
            1,
            2,
            11,
            20
        ],
        fc: 19
    },
    {
        lngs: [
            "or"
        ],
        nr: [
            2,
            1
        ],
        fc: 2
    },
    {
        lngs: [
            "ro"
        ],
        nr: [
            1,
            2,
            20
        ],
        fc: 20
    },
    {
        lngs: [
            "sl"
        ],
        nr: [
            5,
            1,
            2,
            3
        ],
        fc: 21
    },
    {
        lngs: [
            "he",
            "iw"
        ],
        nr: [
            1,
            2,
            20,
            21
        ],
        fc: 22
    }
];
let $cb95bcae1947788f$var$_rulesPluralsTypes = {
    1: function(n) {
        return Number(n > 1);
    },
    2: function(n) {
        return Number(n != 1);
    },
    3: function(n) {
        return 0;
    },
    4: function(n) {
        return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
    },
    5: function(n) {
        return Number(n == 0 ? 0 : n == 1 ? 1 : n == 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5);
    },
    6: function(n) {
        return Number(n == 1 ? 0 : n >= 2 && n <= 4 ? 1 : 2);
    },
    7: function(n) {
        return Number(n == 1 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
    },
    8: function(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : n != 8 && n != 11 ? 2 : 3);
    },
    9: function(n) {
        return Number(n >= 2);
    },
    10: function(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : n < 7 ? 2 : n < 11 ? 3 : 4);
    },
    11: function(n) {
        return Number(n == 1 || n == 11 ? 0 : n == 2 || n == 12 ? 1 : n > 2 && n < 20 ? 2 : 3);
    },
    12: function(n) {
        return Number(n % 10 != 1 || n % 100 == 11);
    },
    13: function(n) {
        return Number(n !== 0);
    },
    14: function(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : n == 3 ? 2 : 3);
    },
    15: function(n) {
        return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
    },
    16: function(n) {
        return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n !== 0 ? 1 : 2);
    },
    17: function(n) {
        return Number(n == 1 || n % 10 == 1 && n % 100 != 11 ? 0 : 1);
    },
    18: function(n) {
        return Number(n == 0 ? 0 : n == 1 ? 1 : 2);
    },
    19: function(n) {
        return Number(n == 1 ? 0 : n == 0 || n % 100 > 1 && n % 100 < 11 ? 1 : n % 100 > 10 && n % 100 < 20 ? 2 : 3);
    },
    20: function(n) {
        return Number(n == 1 ? 0 : n == 0 || n % 100 > 0 && n % 100 < 20 ? 1 : 2);
    },
    21: function(n) {
        return Number(n % 100 == 1 ? 1 : n % 100 == 2 ? 2 : n % 100 == 3 || n % 100 == 4 ? 3 : 0);
    },
    22: function(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : (n < 0 || n > 10) && n % 10 == 0 ? 2 : 3);
    }
};
const $cb95bcae1947788f$var$nonIntlVersions = [
    "v1",
    "v2",
    "v3"
];
const $cb95bcae1947788f$var$intlVersions = [
    "v4"
];
const $cb95bcae1947788f$var$suffixesOrder = {
    zero: 0,
    one: 1,
    two: 2,
    few: 3,
    many: 4,
    other: 5
};
function $cb95bcae1947788f$var$createRules() {
    const rules = {};
    $cb95bcae1947788f$var$sets.forEach((set)=>{
        set.lngs.forEach((l)=>{
            rules[l] = {
                numbers: set.nr,
                plurals: $cb95bcae1947788f$var$_rulesPluralsTypes[set.fc]
            };
        });
    });
    return rules;
}
class $cb95bcae1947788f$var$PluralResolver {
    constructor(languageUtils){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this.languageUtils = languageUtils;
        this.options = options;
        this.logger = $cb95bcae1947788f$var$baseLogger.create("pluralResolver");
        if ((!this.options.compatibilityJSON || $cb95bcae1947788f$var$intlVersions.includes(this.options.compatibilityJSON)) && (typeof Intl === "undefined" || !Intl.PluralRules)) {
            this.options.compatibilityJSON = "v3";
            this.logger.error("Your environment seems not to be Intl API compatible, use an Intl.PluralRules polyfill. Will fallback to the compatibilityJSON v3 format handling.");
        }
        this.rules = $cb95bcae1947788f$var$createRules();
    }
    addRule(lng, obj) {
        this.rules[lng] = obj;
    }
    getRule(code) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        if (this.shouldUseIntlApi()) try {
            return new Intl.PluralRules($cb95bcae1947788f$var$getCleanedCode(code), {
                type: options.ordinal ? "ordinal" : "cardinal"
            });
        } catch  {
            return;
        }
        return this.rules[code] || this.rules[this.languageUtils.getLanguagePartFromCode(code)];
    }
    needsPlural(code) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        const rule = this.getRule(code, options);
        if (this.shouldUseIntlApi()) return rule && rule.resolvedOptions().pluralCategories.length > 1;
        return rule && rule.numbers.length > 1;
    }
    getPluralFormsOfKey(code, key) {
        let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        return this.getSuffixes(code, options).map((suffix)=>`${key}${suffix}`);
    }
    getSuffixes(code) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        const rule = this.getRule(code, options);
        if (!rule) return [];
        if (this.shouldUseIntlApi()) return rule.resolvedOptions().pluralCategories.sort((pluralCategory1, pluralCategory2)=>$cb95bcae1947788f$var$suffixesOrder[pluralCategory1] - $cb95bcae1947788f$var$suffixesOrder[pluralCategory2]).map((pluralCategory)=>`${this.options.prepend}${options.ordinal ? `ordinal${this.options.prepend}` : ""}${pluralCategory}`);
        return rule.numbers.map((number)=>this.getSuffix(code, number, options));
    }
    getSuffix(code, count) {
        let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        const rule = this.getRule(code, options);
        if (rule) {
            if (this.shouldUseIntlApi()) return `${this.options.prepend}${options.ordinal ? `ordinal${this.options.prepend}` : ""}${rule.select(count)}`;
            return this.getSuffixRetroCompatible(rule, count);
        }
        this.logger.warn(`no plural rule found for: ${code}`);
        return "";
    }
    getSuffixRetroCompatible(rule, count) {
        const idx = rule.noAbs ? rule.plurals(count) : rule.plurals(Math.abs(count));
        let suffix = rule.numbers[idx];
        if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
            if (suffix === 2) suffix = "plural";
            else if (suffix === 1) suffix = "";
        }
        const returnSuffix = ()=>this.options.prepend && suffix.toString() ? this.options.prepend + suffix.toString() : suffix.toString();
        if (this.options.compatibilityJSON === "v1") {
            if (suffix === 1) return "";
            if (typeof suffix === "number") return `_plural_${suffix.toString()}`;
            return returnSuffix();
        } else if (this.options.compatibilityJSON === "v2") return returnSuffix();
        else if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) return returnSuffix();
        return this.options.prepend && idx.toString() ? this.options.prepend + idx.toString() : idx.toString();
    }
    shouldUseIntlApi() {
        return !$cb95bcae1947788f$var$nonIntlVersions.includes(this.options.compatibilityJSON);
    }
}
function $cb95bcae1947788f$var$deepFindWithDefaults(data, defaultData, key) {
    let keySeparator = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : ".";
    let ignoreJSONStructure = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
    let path = $cb95bcae1947788f$var$getPathWithDefaults(data, defaultData, key);
    if (!path && ignoreJSONStructure && typeof key === "string") {
        path = $cb95bcae1947788f$var$deepFind(data, key, keySeparator);
        if (path === undefined) path = $cb95bcae1947788f$var$deepFind(defaultData, key, keySeparator);
    }
    return path;
}
class $cb95bcae1947788f$var$Interpolator {
    constructor(){
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        this.logger = $cb95bcae1947788f$var$baseLogger.create("interpolator");
        this.options = options;
        this.format = options.interpolation && options.interpolation.format || ((value)=>value);
        this.init(options);
    }
    init() {
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        if (!options.interpolation) options.interpolation = {
            escapeValue: true
        };
        const iOpts = options.interpolation;
        this.escape = iOpts.escape !== undefined ? iOpts.escape : $cb95bcae1947788f$var$escape;
        this.escapeValue = iOpts.escapeValue !== undefined ? iOpts.escapeValue : true;
        this.useRawValueToEscape = iOpts.useRawValueToEscape !== undefined ? iOpts.useRawValueToEscape : false;
        this.prefix = iOpts.prefix ? $cb95bcae1947788f$var$regexEscape(iOpts.prefix) : iOpts.prefixEscaped || "{{";
        this.suffix = iOpts.suffix ? $cb95bcae1947788f$var$regexEscape(iOpts.suffix) : iOpts.suffixEscaped || "}}";
        this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ",";
        this.unescapePrefix = iOpts.unescapeSuffix ? "" : iOpts.unescapePrefix || "-";
        this.unescapeSuffix = this.unescapePrefix ? "" : iOpts.unescapeSuffix || "";
        this.nestingPrefix = iOpts.nestingPrefix ? $cb95bcae1947788f$var$regexEscape(iOpts.nestingPrefix) : iOpts.nestingPrefixEscaped || $cb95bcae1947788f$var$regexEscape("$t(");
        this.nestingSuffix = iOpts.nestingSuffix ? $cb95bcae1947788f$var$regexEscape(iOpts.nestingSuffix) : iOpts.nestingSuffixEscaped || $cb95bcae1947788f$var$regexEscape(")");
        this.nestingOptionsSeparator = iOpts.nestingOptionsSeparator ? iOpts.nestingOptionsSeparator : iOpts.nestingOptionsSeparator || ",";
        this.maxReplaces = iOpts.maxReplaces ? iOpts.maxReplaces : 1000;
        this.alwaysFormat = iOpts.alwaysFormat !== undefined ? iOpts.alwaysFormat : false;
        this.resetRegExp();
    }
    reset() {
        if (this.options) this.init(this.options);
    }
    resetRegExp() {
        const regexpStr = `${this.prefix}(.+?)${this.suffix}`;
        this.regexp = new RegExp(regexpStr, "g");
        const regexpUnescapeStr = `${this.prefix}${this.unescapePrefix}(.+?)${this.unescapeSuffix}${this.suffix}`;
        this.regexpUnescape = new RegExp(regexpUnescapeStr, "g");
        const nestingRegexpStr = `${this.nestingPrefix}(.+?)${this.nestingSuffix}`;
        this.nestingRegexp = new RegExp(nestingRegexpStr, "g");
    }
    interpolate(str, data, lng, options) {
        let match;
        let value;
        let replaces;
        const defaultData = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {};
        function regexSafe(val) {
            return val.replace(/\$/g, "$$$$");
        }
        const handleFormat = (key)=>{
            if (key.indexOf(this.formatSeparator) < 0) {
                const path = $cb95bcae1947788f$var$deepFindWithDefaults(data, defaultData, key, this.options.keySeparator, this.options.ignoreJSONStructure);
                return this.alwaysFormat ? this.format(path, undefined, lng, {
                    ...options,
                    ...data,
                    interpolationkey: key
                }) : path;
            }
            const p = key.split(this.formatSeparator);
            const k = p.shift().trim();
            const f = p.join(this.formatSeparator).trim();
            return this.format($cb95bcae1947788f$var$deepFindWithDefaults(data, defaultData, k, this.options.keySeparator, this.options.ignoreJSONStructure), f, lng, {
                ...options,
                ...data,
                interpolationkey: k
            });
        };
        this.resetRegExp();
        const missingInterpolationHandler = options && options.missingInterpolationHandler || this.options.missingInterpolationHandler;
        const skipOnVariables = options && options.interpolation && options.interpolation.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
        const todos = [
            {
                regex: this.regexpUnescape,
                safeValue: (val)=>regexSafe(val)
            },
            {
                regex: this.regexp,
                safeValue: (val)=>this.escapeValue ? regexSafe(this.escape(val)) : regexSafe(val)
            }
        ];
        todos.forEach((todo)=>{
            replaces = 0;
            while(match = todo.regex.exec(str)){
                const matchedVar = match[1].trim();
                value = handleFormat(matchedVar);
                if (value === undefined) {
                    if (typeof missingInterpolationHandler === "function") {
                        const temp = missingInterpolationHandler(str, match, options);
                        value = typeof temp === "string" ? temp : "";
                    } else if (options && Object.prototype.hasOwnProperty.call(options, matchedVar)) value = "";
                    else if (skipOnVariables) {
                        value = match[0];
                        continue;
                    } else {
                        this.logger.warn(`missed to pass in variable ${matchedVar} for interpolating ${str}`);
                        value = "";
                    }
                } else if (typeof value !== "string" && !this.useRawValueToEscape) value = $cb95bcae1947788f$var$makeString(value);
                const safeValue = todo.safeValue(value);
                str = str.replace(match[0], safeValue);
                if (skipOnVariables) {
                    todo.regex.lastIndex += value.length;
                    todo.regex.lastIndex -= match[0].length;
                } else todo.regex.lastIndex = 0;
                replaces++;
                if (replaces >= this.maxReplaces) break;
            }
        });
        return str;
    }
    nest(str, fc) {
        let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        let match;
        let value;
        let clonedOptions;
        function handleHasOptions(key, inheritedOptions) {
            const sep = this.nestingOptionsSeparator;
            if (key.indexOf(sep) < 0) return key;
            const c = key.split(new RegExp(`${sep}[ ]*{`));
            let optionsString = `{${c[1]}`;
            key = c[0];
            optionsString = this.interpolate(optionsString, clonedOptions);
            const matchedSingleQuotes = optionsString.match(/'/g);
            const matchedDoubleQuotes = optionsString.match(/"/g);
            if (matchedSingleQuotes && matchedSingleQuotes.length % 2 === 0 && !matchedDoubleQuotes || matchedDoubleQuotes.length % 2 !== 0) optionsString = optionsString.replace(/'/g, '"');
            try {
                clonedOptions = JSON.parse(optionsString);
                if (inheritedOptions) clonedOptions = {
                    ...inheritedOptions,
                    ...clonedOptions
                };
            } catch (e) {
                this.logger.warn(`failed parsing options string in nesting for key ${key}`, e);
                return `${key}${sep}${optionsString}`;
            }
            delete clonedOptions.defaultValue;
            return key;
        }
        while(match = this.nestingRegexp.exec(str)){
            let formatters = [];
            clonedOptions = {
                ...options
            };
            clonedOptions = clonedOptions.replace && typeof clonedOptions.replace !== "string" ? clonedOptions.replace : clonedOptions;
            clonedOptions.applyPostProcessor = false;
            delete clonedOptions.defaultValue;
            let doReduce = false;
            if (match[0].indexOf(this.formatSeparator) !== -1 && !/{.*}/.test(match[1])) {
                const r = match[1].split(this.formatSeparator).map((elem)=>elem.trim());
                match[1] = r.shift();
                formatters = r;
                doReduce = true;
            }
            value = fc(handleHasOptions.call(this, match[1].trim(), clonedOptions), clonedOptions);
            if (value && match[0] === str && typeof value !== "string") return value;
            if (typeof value !== "string") value = $cb95bcae1947788f$var$makeString(value);
            if (!value) {
                this.logger.warn(`missed to resolve ${match[1]} for nesting ${str}`);
                value = "";
            }
            if (doReduce) value = formatters.reduce((v, f)=>this.format(v, f, options.lng, {
                    ...options,
                    interpolationkey: match[1].trim()
                }), value.trim());
            str = str.replace(match[0], value);
            this.regexp.lastIndex = 0;
        }
        return str;
    }
}
function $cb95bcae1947788f$var$parseFormatStr(formatStr) {
    let formatName = formatStr.toLowerCase().trim();
    const formatOptions = {};
    if (formatStr.indexOf("(") > -1) {
        const p = formatStr.split("(");
        formatName = p[0].toLowerCase().trim();
        const optStr = p[1].substring(0, p[1].length - 1);
        if (formatName === "currency" && optStr.indexOf(":") < 0) {
            if (!formatOptions.currency) formatOptions.currency = optStr.trim();
        } else if (formatName === "relativetime" && optStr.indexOf(":") < 0) {
            if (!formatOptions.range) formatOptions.range = optStr.trim();
        } else {
            const opts = optStr.split(";");
            opts.forEach((opt)=>{
                if (!opt) return;
                const [key, ...rest] = opt.split(":");
                const val = rest.join(":").trim().replace(/^'+|'+$/g, "");
                if (!formatOptions[key.trim()]) formatOptions[key.trim()] = val;
                if (val === "false") formatOptions[key.trim()] = false;
                if (val === "true") formatOptions[key.trim()] = true;
                if (!isNaN(val)) formatOptions[key.trim()] = parseInt(val, 10);
            });
        }
    }
    return {
        formatName: formatName,
        formatOptions: formatOptions
    };
}
function $cb95bcae1947788f$var$createCachedFormatter(fn) {
    const cache = {};
    return function invokeFormatter(val, lng, options) {
        const key = lng + JSON.stringify(options);
        let formatter = cache[key];
        if (!formatter) {
            formatter = fn($cb95bcae1947788f$var$getCleanedCode(lng), options);
            cache[key] = formatter;
        }
        return formatter(val);
    };
}
class $cb95bcae1947788f$var$Formatter {
    constructor(){
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        this.logger = $cb95bcae1947788f$var$baseLogger.create("formatter");
        this.options = options;
        this.formats = {
            number: $cb95bcae1947788f$var$createCachedFormatter((lng, opt)=>{
                const formatter = new Intl.NumberFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val);
            }),
            currency: $cb95bcae1947788f$var$createCachedFormatter((lng, opt)=>{
                const formatter = new Intl.NumberFormat(lng, {
                    ...opt,
                    style: "currency"
                });
                return (val)=>formatter.format(val);
            }),
            datetime: $cb95bcae1947788f$var$createCachedFormatter((lng, opt)=>{
                const formatter = new Intl.DateTimeFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val);
            }),
            relativetime: $cb95bcae1947788f$var$createCachedFormatter((lng, opt)=>{
                const formatter = new Intl.RelativeTimeFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val, opt.range || "day");
            }),
            list: $cb95bcae1947788f$var$createCachedFormatter((lng, opt)=>{
                const formatter = new Intl.ListFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val);
            })
        };
        this.init(options);
    }
    init(services) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
            interpolation: {}
        };
        const iOpts = options.interpolation;
        this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ",";
    }
    add(name, fc) {
        this.formats[name.toLowerCase().trim()] = fc;
    }
    addCached(name, fc) {
        this.formats[name.toLowerCase().trim()] = $cb95bcae1947788f$var$createCachedFormatter(fc);
    }
    format(value, format, lng) {
        let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        const formats = format.split(this.formatSeparator);
        const result = formats.reduce((mem, f)=>{
            const { formatName: formatName, formatOptions: formatOptions } = $cb95bcae1947788f$var$parseFormatStr(f);
            if (this.formats[formatName]) {
                let formatted = mem;
                try {
                    const valOptions = options && options.formatParams && options.formatParams[options.interpolationkey] || {};
                    const l = valOptions.locale || valOptions.lng || options.locale || options.lng || lng;
                    formatted = this.formats[formatName](mem, l, {
                        ...formatOptions,
                        ...options,
                        ...valOptions
                    });
                } catch (error) {
                    this.logger.warn(error);
                }
                return formatted;
            } else this.logger.warn(`there was no format function for ${formatName}`);
            return mem;
        }, value);
        return result;
    }
}
function $cb95bcae1947788f$var$removePending(q, name) {
    if (q.pending[name] !== undefined) {
        delete q.pending[name];
        q.pendingCount--;
    }
}
class $cb95bcae1947788f$var$Connector extends $cb95bcae1947788f$var$EventEmitter {
    constructor(backend, store, services){
        let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        super();
        this.backend = backend;
        this.store = store;
        this.services = services;
        this.languageUtils = services.languageUtils;
        this.options = options;
        this.logger = $cb95bcae1947788f$var$baseLogger.create("backendConnector");
        this.waitingReads = [];
        this.maxParallelReads = options.maxParallelReads || 10;
        this.readingCalls = 0;
        this.maxRetries = options.maxRetries >= 0 ? options.maxRetries : 5;
        this.retryTimeout = options.retryTimeout >= 1 ? options.retryTimeout : 350;
        this.state = {};
        this.queue = [];
        if (this.backend && this.backend.init) this.backend.init(services, options.backend, options);
    }
    queueLoad(languages, namespaces, options, callback) {
        const toLoad = {};
        const pending = {};
        const toLoadLanguages = {};
        const toLoadNamespaces = {};
        languages.forEach((lng)=>{
            let hasAllNamespaces = true;
            namespaces.forEach((ns)=>{
                const name = `${lng}|${ns}`;
                if (!options.reload && this.store.hasResourceBundle(lng, ns)) this.state[name] = 2;
                else if (this.state[name] < 0) ;
                else if (this.state[name] === 1) {
                    if (pending[name] === undefined) pending[name] = true;
                } else {
                    this.state[name] = 1;
                    hasAllNamespaces = false;
                    if (pending[name] === undefined) pending[name] = true;
                    if (toLoad[name] === undefined) toLoad[name] = true;
                    if (toLoadNamespaces[ns] === undefined) toLoadNamespaces[ns] = true;
                }
            });
            if (!hasAllNamespaces) toLoadLanguages[lng] = true;
        });
        if (Object.keys(toLoad).length || Object.keys(pending).length) this.queue.push({
            pending: pending,
            pendingCount: Object.keys(pending).length,
            loaded: {},
            errors: [],
            callback: callback
        });
        return {
            toLoad: Object.keys(toLoad),
            pending: Object.keys(pending),
            toLoadLanguages: Object.keys(toLoadLanguages),
            toLoadNamespaces: Object.keys(toLoadNamespaces)
        };
    }
    loaded(name, err, data) {
        const s = name.split("|");
        const lng = s[0];
        const ns = s[1];
        if (err) this.emit("failedLoading", lng, ns, err);
        if (data) this.store.addResourceBundle(lng, ns, data);
        this.state[name] = err ? -1 : 2;
        const loaded = {};
        this.queue.forEach((q)=>{
            $cb95bcae1947788f$var$pushPath(q.loaded, [
                lng
            ], ns);
            $cb95bcae1947788f$var$removePending(q, name);
            if (err) q.errors.push(err);
            if (q.pendingCount === 0 && !q.done) {
                Object.keys(q.loaded).forEach((l)=>{
                    if (!loaded[l]) loaded[l] = {};
                    const loadedKeys = q.loaded[l];
                    if (loadedKeys.length) loadedKeys.forEach((n)=>{
                        if (loaded[l][n] === undefined) loaded[l][n] = true;
                    });
                });
                q.done = true;
                if (q.errors.length) q.callback(q.errors);
                else q.callback();
            }
        });
        this.emit("loaded", loaded);
        this.queue = this.queue.filter((q)=>!q.done);
    }
    read(lng, ns, fcName) {
        let tried = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
        let wait = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : this.retryTimeout;
        let callback = arguments.length > 5 ? arguments[5] : undefined;
        if (!lng.length) return callback(null, {});
        if (this.readingCalls >= this.maxParallelReads) {
            this.waitingReads.push({
                lng: lng,
                ns: ns,
                fcName: fcName,
                tried: tried,
                wait: wait,
                callback: callback
            });
            return;
        }
        this.readingCalls++;
        const resolver = (err, data)=>{
            this.readingCalls--;
            if (this.waitingReads.length > 0) {
                const next = this.waitingReads.shift();
                this.read(next.lng, next.ns, next.fcName, next.tried, next.wait, next.callback);
            }
            if (err && data && tried < this.maxRetries) {
                setTimeout(()=>{
                    this.read.call(this, lng, ns, fcName, tried + 1, wait * 2, callback);
                }, wait);
                return;
            }
            callback(err, data);
        };
        const fc = this.backend[fcName].bind(this.backend);
        if (fc.length === 2) {
            try {
                const r = fc(lng, ns);
                if (r && typeof r.then === "function") r.then((data)=>resolver(null, data)).catch(resolver);
                else resolver(null, r);
            } catch (err) {
                resolver(err);
            }
            return;
        }
        return fc(lng, ns, resolver);
    }
    prepareLoading(languages, namespaces) {
        let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        let callback = arguments.length > 3 ? arguments[3] : undefined;
        if (!this.backend) {
            this.logger.warn("No backend was added via i18next.use. Will not load resources.");
            return callback && callback();
        }
        if (typeof languages === "string") languages = this.languageUtils.toResolveHierarchy(languages);
        if (typeof namespaces === "string") namespaces = [
            namespaces
        ];
        const toLoad = this.queueLoad(languages, namespaces, options, callback);
        if (!toLoad.toLoad.length) {
            if (!toLoad.pending.length) callback();
            return null;
        }
        toLoad.toLoad.forEach((name)=>{
            this.loadOne(name);
        });
    }
    load(languages, namespaces, callback) {
        this.prepareLoading(languages, namespaces, {}, callback);
    }
    reload(languages, namespaces, callback) {
        this.prepareLoading(languages, namespaces, {
            reload: true
        }, callback);
    }
    loadOne(name) {
        let prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
        const s = name.split("|");
        const lng = s[0];
        const ns = s[1];
        this.read(lng, ns, "read", undefined, undefined, (err, data)=>{
            if (err) this.logger.warn(`${prefix}loading namespace ${ns} for language ${lng} failed`, err);
            if (!err && data) this.logger.log(`${prefix}loaded namespace ${ns} for language ${lng}`, data);
            this.loaded(name, err, data);
        });
    }
    saveMissing(languages, namespace, key, fallbackValue, isUpdate) {
        let options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
        let clb = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : ()=>{};
        if (this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(namespace)) {
            this.logger.warn(`did not save key "${key}" as the namespace "${namespace}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
            return;
        }
        if (key === undefined || key === null || key === "") return;
        if (this.backend && this.backend.create) {
            const opts = {
                ...options,
                isUpdate: isUpdate
            };
            const fc = this.backend.create.bind(this.backend);
            if (fc.length < 6) try {
                let r;
                if (fc.length === 5) r = fc(languages, namespace, key, fallbackValue, opts);
                else r = fc(languages, namespace, key, fallbackValue);
                if (r && typeof r.then === "function") r.then((data)=>clb(null, data)).catch(clb);
                else clb(null, r);
            } catch (err) {
                clb(err);
            }
            else fc(languages, namespace, key, fallbackValue, clb, opts);
        }
        if (!languages || !languages[0]) return;
        this.store.addResource(languages[0], namespace, key, fallbackValue);
    }
}
function $cb95bcae1947788f$var$get() {
    return {
        debug: false,
        initImmediate: true,
        ns: [
            "translation"
        ],
        defaultNS: [
            "translation"
        ],
        fallbackLng: [
            "dev"
        ],
        fallbackNS: false,
        supportedLngs: false,
        nonExplicitSupportedLngs: false,
        load: "all",
        preload: false,
        simplifyPluralSuffix: true,
        keySeparator: ".",
        nsSeparator: ":",
        pluralSeparator: "_",
        contextSeparator: "_",
        partialBundledLanguages: false,
        saveMissing: false,
        updateMissing: false,
        saveMissingTo: "fallback",
        saveMissingPlurals: true,
        missingKeyHandler: false,
        missingInterpolationHandler: false,
        postProcess: false,
        postProcessPassResolved: false,
        returnNull: false,
        returnEmptyString: true,
        returnObjects: false,
        joinArrays: false,
        returnedObjectHandler: false,
        parseMissingKeyHandler: false,
        appendNamespaceToMissingKey: false,
        appendNamespaceToCIMode: false,
        overloadTranslationOptionHandler: function handle(args) {
            let ret = {};
            if (typeof args[1] === "object") ret = args[1];
            if (typeof args[1] === "string") ret.defaultValue = args[1];
            if (typeof args[2] === "string") ret.tDescription = args[2];
            if (typeof args[2] === "object" || typeof args[3] === "object") {
                const options = args[3] || args[2];
                Object.keys(options).forEach((key)=>{
                    ret[key] = options[key];
                });
            }
            return ret;
        },
        interpolation: {
            escapeValue: true,
            format: (value, format, lng, options)=>value,
            prefix: "{{",
            suffix: "}}",
            formatSeparator: ",",
            unescapePrefix: "-",
            nestingPrefix: "$t(",
            nestingSuffix: ")",
            nestingOptionsSeparator: ",",
            maxReplaces: 1000,
            skipOnVariables: true
        }
    };
}
function $cb95bcae1947788f$var$transformOptions(options) {
    if (typeof options.ns === "string") options.ns = [
        options.ns
    ];
    if (typeof options.fallbackLng === "string") options.fallbackLng = [
        options.fallbackLng
    ];
    if (typeof options.fallbackNS === "string") options.fallbackNS = [
        options.fallbackNS
    ];
    if (options.supportedLngs && options.supportedLngs.indexOf("cimode") < 0) options.supportedLngs = options.supportedLngs.concat([
        "cimode"
    ]);
    return options;
}
function $cb95bcae1947788f$var$noop() {}
function $cb95bcae1947788f$var$bindMemberFunctions(inst) {
    const mems = Object.getOwnPropertyNames(Object.getPrototypeOf(inst));
    mems.forEach((mem)=>{
        if (typeof inst[mem] === "function") inst[mem] = inst[mem].bind(inst);
    });
}
class $cb95bcae1947788f$var$I18n extends $cb95bcae1947788f$var$EventEmitter {
    constructor(){
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        let callback = arguments.length > 1 ? arguments[1] : undefined;
        super();
        this.options = $cb95bcae1947788f$var$transformOptions(options);
        this.services = {};
        this.logger = $cb95bcae1947788f$var$baseLogger;
        this.modules = {
            external: []
        };
        $cb95bcae1947788f$var$bindMemberFunctions(this);
        if (callback && !this.isInitialized && !options.isClone) {
            if (!this.options.initImmediate) {
                this.init(options, callback);
                return this;
            }
            setTimeout(()=>{
                this.init(options, callback);
            }, 0);
        }
    }
    init() {
        var _this = this;
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        let callback = arguments.length > 1 ? arguments[1] : undefined;
        if (typeof options === "function") {
            callback = options;
            options = {};
        }
        if (!options.defaultNS && options.defaultNS !== false && options.ns) {
            if (typeof options.ns === "string") options.defaultNS = options.ns;
            else if (options.ns.indexOf("translation") < 0) options.defaultNS = options.ns[0];
        }
        const defOpts = $cb95bcae1947788f$var$get();
        this.options = {
            ...defOpts,
            ...this.options,
            ...$cb95bcae1947788f$var$transformOptions(options)
        };
        if (this.options.compatibilityAPI !== "v1") this.options.interpolation = {
            ...defOpts.interpolation,
            ...this.options.interpolation
        };
        if (options.keySeparator !== undefined) this.options.userDefinedKeySeparator = options.keySeparator;
        if (options.nsSeparator !== undefined) this.options.userDefinedNsSeparator = options.nsSeparator;
        function createClassOnDemand(ClassOrObject) {
            if (!ClassOrObject) return null;
            if (typeof ClassOrObject === "function") return new ClassOrObject();
            return ClassOrObject;
        }
        if (!this.options.isClone) {
            if (this.modules.logger) $cb95bcae1947788f$var$baseLogger.init(createClassOnDemand(this.modules.logger), this.options);
            else $cb95bcae1947788f$var$baseLogger.init(null, this.options);
            let formatter;
            if (this.modules.formatter) formatter = this.modules.formatter;
            else if (typeof Intl !== "undefined") formatter = $cb95bcae1947788f$var$Formatter;
            const lu = new $cb95bcae1947788f$var$LanguageUtil(this.options);
            this.store = new $cb95bcae1947788f$var$ResourceStore(this.options.resources, this.options);
            const s = this.services;
            s.logger = $cb95bcae1947788f$var$baseLogger;
            s.resourceStore = this.store;
            s.languageUtils = lu;
            s.pluralResolver = new $cb95bcae1947788f$var$PluralResolver(lu, {
                prepend: this.options.pluralSeparator,
                compatibilityJSON: this.options.compatibilityJSON,
                simplifyPluralSuffix: this.options.simplifyPluralSuffix
            });
            if (formatter && (!this.options.interpolation.format || this.options.interpolation.format === defOpts.interpolation.format)) {
                s.formatter = createClassOnDemand(formatter);
                s.formatter.init(s, this.options);
                this.options.interpolation.format = s.formatter.format.bind(s.formatter);
            }
            s.interpolator = new $cb95bcae1947788f$var$Interpolator(this.options);
            s.utils = {
                hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
            };
            s.backendConnector = new $cb95bcae1947788f$var$Connector(createClassOnDemand(this.modules.backend), s.resourceStore, s, this.options);
            s.backendConnector.on("*", function(event) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
                _this.emit(event, ...args);
            });
            if (this.modules.languageDetector) {
                s.languageDetector = createClassOnDemand(this.modules.languageDetector);
                if (s.languageDetector.init) s.languageDetector.init(s, this.options.detection, this.options);
            }
            if (this.modules.i18nFormat) {
                s.i18nFormat = createClassOnDemand(this.modules.i18nFormat);
                if (s.i18nFormat.init) s.i18nFormat.init(this);
            }
            this.translator = new $cb95bcae1947788f$var$Translator(this.services, this.options);
            this.translator.on("*", function(event) {
                for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
                _this.emit(event, ...args);
            });
            this.modules.external.forEach((m)=>{
                if (m.init) m.init(this);
            });
        }
        this.format = this.options.interpolation.format;
        if (!callback) callback = $cb95bcae1947788f$var$noop;
        if (this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
            const codes = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
            if (codes.length > 0 && codes[0] !== "dev") this.options.lng = codes[0];
        }
        if (!this.services.languageDetector && !this.options.lng) this.logger.warn("init: no languageDetector is used and no lng is defined");
        const storeApi = [
            "getResource",
            "hasResourceBundle",
            "getResourceBundle",
            "getDataByLanguage"
        ];
        storeApi.forEach((fcName)=>{
            this[fcName] = function() {
                return _this.store[fcName](...arguments);
            };
        });
        const storeApiChained = [
            "addResource",
            "addResources",
            "addResourceBundle",
            "removeResourceBundle"
        ];
        storeApiChained.forEach((fcName)=>{
            this[fcName] = function() {
                _this.store[fcName](...arguments);
                return _this;
            };
        });
        const deferred = $cb95bcae1947788f$var$defer();
        const load = ()=>{
            const finish = (err, t)=>{
                if (this.isInitialized && !this.initializedStoreOnce) this.logger.warn("init: i18next is already initialized. You should call init just once!");
                this.isInitialized = true;
                if (!this.options.isClone) this.logger.log("initialized", this.options);
                this.emit("initialized", this.options);
                deferred.resolve(t);
                callback(err, t);
            };
            if (this.languages && this.options.compatibilityAPI !== "v1" && !this.isInitialized) return finish(null, this.t.bind(this));
            this.changeLanguage(this.options.lng, finish);
        };
        if (this.options.resources || !this.options.initImmediate) load();
        else setTimeout(load, 0);
        return deferred;
    }
    loadResources(language) {
        let callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $cb95bcae1947788f$var$noop;
        let usedCallback = callback;
        const usedLng = typeof language === "string" ? language : this.language;
        if (typeof language === "function") usedCallback = language;
        if (!this.options.resources || this.options.partialBundledLanguages) {
            if (usedLng && usedLng.toLowerCase() === "cimode" && (!this.options.preload || this.options.preload.length === 0)) return usedCallback();
            const toLoad = [];
            const append = (lng)=>{
                if (!lng) return;
                if (lng === "cimode") return;
                const lngs = this.services.languageUtils.toResolveHierarchy(lng);
                lngs.forEach((l)=>{
                    if (l === "cimode") return;
                    if (toLoad.indexOf(l) < 0) toLoad.push(l);
                });
            };
            if (!usedLng) {
                const fallbacks = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
                fallbacks.forEach((l)=>append(l));
            } else append(usedLng);
            if (this.options.preload) this.options.preload.forEach((l)=>append(l));
            this.services.backendConnector.load(toLoad, this.options.ns, (e)=>{
                if (!e && !this.resolvedLanguage && this.language) this.setResolvedLanguage(this.language);
                usedCallback(e);
            });
        } else usedCallback(null);
    }
    reloadResources(lngs, ns, callback) {
        const deferred = $cb95bcae1947788f$var$defer();
        if (!lngs) lngs = this.languages;
        if (!ns) ns = this.options.ns;
        if (!callback) callback = $cb95bcae1947788f$var$noop;
        this.services.backendConnector.reload(lngs, ns, (err)=>{
            deferred.resolve();
            callback(err);
        });
        return deferred;
    }
    use(module) {
        if (!module) throw new Error("You are passing an undefined module! Please check the object you are passing to i18next.use()");
        if (!module.type) throw new Error("You are passing a wrong module! Please check the object you are passing to i18next.use()");
        if (module.type === "backend") this.modules.backend = module;
        if (module.type === "logger" || module.log && module.warn && module.error) this.modules.logger = module;
        if (module.type === "languageDetector") this.modules.languageDetector = module;
        if (module.type === "i18nFormat") this.modules.i18nFormat = module;
        if (module.type === "postProcessor") $cb95bcae1947788f$var$postProcessor.addPostProcessor(module);
        if (module.type === "formatter") this.modules.formatter = module;
        if (module.type === "3rdParty") this.modules.external.push(module);
        return this;
    }
    setResolvedLanguage(l) {
        if (!l || !this.languages) return;
        if ([
            "cimode",
            "dev"
        ].indexOf(l) > -1) return;
        for(let li = 0; li < this.languages.length; li++){
            const lngInLngs = this.languages[li];
            if ([
                "cimode",
                "dev"
            ].indexOf(lngInLngs) > -1) continue;
            if (this.store.hasLanguageSomeTranslations(lngInLngs)) {
                this.resolvedLanguage = lngInLngs;
                break;
            }
        }
    }
    changeLanguage(lng, callback) {
        var _this2 = this;
        this.isLanguageChangingTo = lng;
        const deferred = $cb95bcae1947788f$var$defer();
        this.emit("languageChanging", lng);
        const setLngProps = (l)=>{
            this.language = l;
            this.languages = this.services.languageUtils.toResolveHierarchy(l);
            this.resolvedLanguage = undefined;
            this.setResolvedLanguage(l);
        };
        const done = (err, l)=>{
            if (l) {
                setLngProps(l);
                this.translator.changeLanguage(l);
                this.isLanguageChangingTo = undefined;
                this.emit("languageChanged", l);
                this.logger.log("languageChanged", l);
            } else this.isLanguageChangingTo = undefined;
            deferred.resolve(function() {
                return _this2.t(...arguments);
            });
            if (callback) callback(err, function() {
                return _this2.t(...arguments);
            });
        };
        const setLng = (lngs)=>{
            if (!lng && !lngs && this.services.languageDetector) lngs = [];
            const l = typeof lngs === "string" ? lngs : this.services.languageUtils.getBestMatchFromCodes(lngs);
            if (l) {
                if (!this.language) setLngProps(l);
                if (!this.translator.language) this.translator.changeLanguage(l);
                if (this.services.languageDetector && this.services.languageDetector.cacheUserLanguage) this.services.languageDetector.cacheUserLanguage(l);
            }
            this.loadResources(l, (err)=>{
                done(err, l);
            });
        };
        if (!lng && this.services.languageDetector && !this.services.languageDetector.async) setLng(this.services.languageDetector.detect());
        else if (!lng && this.services.languageDetector && this.services.languageDetector.async) {
            if (this.services.languageDetector.detect.length === 0) this.services.languageDetector.detect().then(setLng);
            else this.services.languageDetector.detect(setLng);
        } else setLng(lng);
        return deferred;
    }
    getFixedT(lng, ns, keyPrefix) {
        var _this3 = this;
        const fixedT = function(key, opts) {
            let options;
            if (typeof opts !== "object") {
                for(var _len3 = arguments.length, rest = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++)rest[_key3 - 2] = arguments[_key3];
                options = _this3.options.overloadTranslationOptionHandler([
                    key,
                    opts
                ].concat(rest));
            } else options = {
                ...opts
            };
            options.lng = options.lng || fixedT.lng;
            options.lngs = options.lngs || fixedT.lngs;
            options.ns = options.ns || fixedT.ns;
            options.keyPrefix = options.keyPrefix || keyPrefix || fixedT.keyPrefix;
            const keySeparator = _this3.options.keySeparator || ".";
            let resultKey;
            if (options.keyPrefix && Array.isArray(key)) resultKey = key.map((k)=>`${options.keyPrefix}${keySeparator}${k}`);
            else resultKey = options.keyPrefix ? `${options.keyPrefix}${keySeparator}${key}` : key;
            return _this3.t(resultKey, options);
        };
        if (typeof lng === "string") fixedT.lng = lng;
        else fixedT.lngs = lng;
        fixedT.ns = ns;
        fixedT.keyPrefix = keyPrefix;
        return fixedT;
    }
    t() {
        return this.translator && this.translator.translate(...arguments);
    }
    exists() {
        return this.translator && this.translator.exists(...arguments);
    }
    setDefaultNamespace(ns) {
        this.options.defaultNS = ns;
    }
    hasLoadedNamespace(ns) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        if (!this.isInitialized) {
            this.logger.warn("hasLoadedNamespace: i18next was not initialized", this.languages);
            return false;
        }
        if (!this.languages || !this.languages.length) {
            this.logger.warn("hasLoadedNamespace: i18n.languages were undefined or empty", this.languages);
            return false;
        }
        const lng = options.lng || this.resolvedLanguage || this.languages[0];
        const fallbackLng = this.options ? this.options.fallbackLng : false;
        const lastLng = this.languages[this.languages.length - 1];
        if (lng.toLowerCase() === "cimode") return true;
        const loadNotPending = (l, n)=>{
            const loadState = this.services.backendConnector.state[`${l}|${n}`];
            return loadState === -1 || loadState === 2;
        };
        if (options.precheck) {
            const preResult = options.precheck(this, loadNotPending);
            if (preResult !== undefined) return preResult;
        }
        if (this.hasResourceBundle(lng, ns)) return true;
        if (!this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages) return true;
        if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
        return false;
    }
    loadNamespaces(ns, callback) {
        const deferred = $cb95bcae1947788f$var$defer();
        if (!this.options.ns) {
            if (callback) callback();
            return Promise.resolve();
        }
        if (typeof ns === "string") ns = [
            ns
        ];
        ns.forEach((n)=>{
            if (this.options.ns.indexOf(n) < 0) this.options.ns.push(n);
        });
        this.loadResources((err)=>{
            deferred.resolve();
            if (callback) callback(err);
        });
        return deferred;
    }
    loadLanguages(lngs, callback) {
        const deferred = $cb95bcae1947788f$var$defer();
        if (typeof lngs === "string") lngs = [
            lngs
        ];
        const preloaded = this.options.preload || [];
        const newLngs = lngs.filter((lng)=>preloaded.indexOf(lng) < 0);
        if (!newLngs.length) {
            if (callback) callback();
            return Promise.resolve();
        }
        this.options.preload = preloaded.concat(newLngs);
        this.loadResources((err)=>{
            deferred.resolve();
            if (callback) callback(err);
        });
        return deferred;
    }
    dir(lng) {
        if (!lng) lng = this.resolvedLanguage || (this.languages && this.languages.length > 0 ? this.languages[0] : this.language);
        if (!lng) return "rtl";
        const rtlLngs = [
            "ar",
            "shu",
            "sqr",
            "ssh",
            "xaa",
            "yhd",
            "yud",
            "aao",
            "abh",
            "abv",
            "acm",
            "acq",
            "acw",
            "acx",
            "acy",
            "adf",
            "ads",
            "aeb",
            "aec",
            "afb",
            "ajp",
            "apc",
            "apd",
            "arb",
            "arq",
            "ars",
            "ary",
            "arz",
            "auz",
            "avl",
            "ayh",
            "ayl",
            "ayn",
            "ayp",
            "bbz",
            "pga",
            "he",
            "iw",
            "ps",
            "pbt",
            "pbu",
            "pst",
            "prp",
            "prd",
            "ug",
            "ur",
            "ydd",
            "yds",
            "yih",
            "ji",
            "yi",
            "hbo",
            "men",
            "xmn",
            "fa",
            "jpr",
            "peo",
            "pes",
            "prs",
            "dv",
            "sam",
            "ckb"
        ];
        const languageUtils = this.services && this.services.languageUtils || new $cb95bcae1947788f$var$LanguageUtil($cb95bcae1947788f$var$get());
        return rtlLngs.indexOf(languageUtils.getLanguagePartFromCode(lng)) > -1 || lng.toLowerCase().indexOf("-arab") > 1 ? "rtl" : "ltr";
    }
    static createInstance() {
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        let callback = arguments.length > 1 ? arguments[1] : undefined;
        return new $cb95bcae1947788f$var$I18n(options, callback);
    }
    cloneInstance() {
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        let callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $cb95bcae1947788f$var$noop;
        const forkResourceStore = options.forkResourceStore;
        if (forkResourceStore) delete options.forkResourceStore;
        const mergedOptions = {
            ...this.options,
            ...options,
            isClone: true
        };
        const clone = new $cb95bcae1947788f$var$I18n(mergedOptions);
        if (options.debug !== undefined || options.prefix !== undefined) clone.logger = clone.logger.clone(options);
        const membersToCopy = [
            "store",
            "services",
            "language"
        ];
        membersToCopy.forEach((m)=>{
            clone[m] = this[m];
        });
        clone.services = {
            ...this.services
        };
        clone.services.utils = {
            hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
        };
        if (forkResourceStore) {
            clone.store = new $cb95bcae1947788f$var$ResourceStore(this.store.data, mergedOptions);
            clone.services.resourceStore = clone.store;
        }
        clone.translator = new $cb95bcae1947788f$var$Translator(clone.services, mergedOptions);
        clone.translator.on("*", function(event) {
            for(var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++)args[_key4 - 1] = arguments[_key4];
            clone.emit(event, ...args);
        });
        clone.init(mergedOptions, callback);
        clone.translator.options = mergedOptions;
        clone.translator.backendConnector.services.utils = {
            hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
        };
        return clone;
    }
    toJSON() {
        return {
            options: this.options,
            store: this.store,
            language: this.language,
            languages: this.languages,
            resolvedLanguage: this.resolvedLanguage
        };
    }
}
const $cb95bcae1947788f$export$2e2bcd8739ae039 = $cb95bcae1947788f$var$I18n.createInstance();
$cb95bcae1947788f$export$2e2bcd8739ae039.createInstance = $cb95bcae1947788f$var$I18n.createInstance;
const $cb95bcae1947788f$export$99152e8d49ca4e7d = $cb95bcae1947788f$export$2e2bcd8739ae039.createInstance;
const $cb95bcae1947788f$export$147ec2801e896265 = $cb95bcae1947788f$export$2e2bcd8739ae039.dir;
const $cb95bcae1947788f$export$2cd8252107eb640b = $cb95bcae1947788f$export$2e2bcd8739ae039.init;
const $cb95bcae1947788f$export$d3d08d944062d7e = $cb95bcae1947788f$export$2e2bcd8739ae039.loadResources;
const $cb95bcae1947788f$export$a5d9bf5d83fcab09 = $cb95bcae1947788f$export$2e2bcd8739ae039.reloadResources;
const $cb95bcae1947788f$export$1f96ae73734a86cc = $cb95bcae1947788f$export$2e2bcd8739ae039.use;
const $cb95bcae1947788f$export$61465194746e7fd2 = $cb95bcae1947788f$export$2e2bcd8739ae039.changeLanguage;
const $cb95bcae1947788f$export$f90d180fc7da3b3b = $cb95bcae1947788f$export$2e2bcd8739ae039.getFixedT;
const $cb95bcae1947788f$export$625550452a3fa3ec = $cb95bcae1947788f$export$2e2bcd8739ae039.t;
const $cb95bcae1947788f$export$f7e9f41ea797a17 = $cb95bcae1947788f$export$2e2bcd8739ae039.exists;
const $cb95bcae1947788f$export$2b4b218e406d2d00 = $cb95bcae1947788f$export$2e2bcd8739ae039.setDefaultNamespace;
const $cb95bcae1947788f$export$93d9ee97c1ad3f31 = $cb95bcae1947788f$export$2e2bcd8739ae039.hasLoadedNamespace;
const $cb95bcae1947788f$export$83be934b53fff43b = $cb95bcae1947788f$export$2e2bcd8739ae039.loadNamespaces;
const $cb95bcae1947788f$export$8cd7e7a54fa865bc = $cb95bcae1947788f$export$2e2bcd8739ae039.loadLanguages;


const $c6f88c2c6ea3c4b1$var$me = {
    get () {
        return (0, $b7ae12cde431bd4b$export$2e2bcd8739ae039).get()?.me;
    },
    get data () {
        return (0, $b7ae12cde431bd4b$export$2e2bcd8739ae039).get()?.me?.data;
    },
    get lang () {
        return (0, $b7ae12cde431bd4b$export$2e2bcd8739ae039).get()?.me?.data?.lang;
    },
    get groups () {
        return (0, $b7ae12cde431bd4b$export$2e2bcd8739ae039).get()?.me?.groups;
    },
    get id () {
        return (0, $b7ae12cde431bd4b$export$2e2bcd8739ae039).get()?.me?.id;
    },
    get avatar () {
        return (0, $b7ae12cde431bd4b$export$2e2bcd8739ae039).get()?.me?.avatar;
    },
    getGroupName (id) {
        let group = (0, $b7ae12cde431bd4b$export$2e2bcd8739ae039).get()["groups"]?.find((g)=>g["id"] == id);
        return group ? group["name"] : "";
    },
    update () {
        return (0, $dcc08ede0b85ca51$export$2e2bcd8739ae039).get("/api/me", true).then((r)=>{
            if (!r || !r?.id) {
                (0, $b7ae12cde431bd4b$export$2e2bcd8739ae039).dispatch("update", {});
                return;
            }
            Promise.all(r.groups.map((g)=>(0, $dcc08ede0b85ca51$export$2e2bcd8739ae039).get(`/api/groups/${g.id}`).then((group)=>group))).then((groups)=>{
                r.groups = groups;
                (0, $b7ae12cde431bd4b$export$2e2bcd8739ae039).dispatch("me/update", Object.assign({
                    loaded: true
                }, r));
            });
            (0, $cb95bcae1947788f$export$2e2bcd8739ae039).changeLanguage(r?.data?.lang);
            return r;
        });
    },
    fetch () {
        if ((0, $b7ae12cde431bd4b$export$2e2bcd8739ae039).get()["loaded"]) return new Promise((r)=>r((0, $b7ae12cde431bd4b$export$2e2bcd8739ae039).get()));
        return $c6f88c2c6ea3c4b1$var$me.update();
    },
    reset () {
        (0, $b7ae12cde431bd4b$export$2e2bcd8739ae039).dispatch("@init");
    },
    logout () {
        (0, $a43f12068c4c782d$export$2e2bcd8739ae039).reset();
    }
};
var $c6f88c2c6ea3c4b1$export$2e2bcd8739ae039 = $c6f88c2c6ea3c4b1$var$me;



var $d51ff6fbc6548743$exports = {};

$parcel$defineInteropFlag($d51ff6fbc6548743$exports);

$parcel$export($d51ff6fbc6548743$exports, "PureComponent", () => $d51ff6fbc6548743$export$221d75b3f55bb0bd);
$parcel$export($d51ff6fbc6548743$exports, "memo", () => $d51ff6fbc6548743$export$7c73462e0d25e514);
$parcel$export($d51ff6fbc6548743$exports, "forwardRef", () => $d51ff6fbc6548743$export$257a8862b851cb5b);
$parcel$export($d51ff6fbc6548743$exports, "Children", () => $d51ff6fbc6548743$export$dca3b0875bd9a954);
$parcel$export($d51ff6fbc6548743$exports, "Suspense", () => $d51ff6fbc6548743$export$74bf444e3cd11ea5);
$parcel$export($d51ff6fbc6548743$exports, "lazy", () => $d51ff6fbc6548743$export$488013bae63b21da);
$parcel$export($d51ff6fbc6548743$exports, "SuspenseList", () => $d51ff6fbc6548743$export$998bcd577473dd93);
$parcel$export($d51ff6fbc6548743$exports, "createPortal", () => $d51ff6fbc6548743$export$d39a5bbd09211389);
$parcel$export($d51ff6fbc6548743$exports, "render", () => $d51ff6fbc6548743$export$b3890eb0ae9dca99);
$parcel$export($d51ff6fbc6548743$exports, "hydrate", () => $d51ff6fbc6548743$export$fa8d919ba61d84db);
$parcel$export($d51ff6fbc6548743$exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $d51ff6fbc6548743$export$ae55be85d98224ed);
$parcel$export($d51ff6fbc6548743$exports, "version", () => $d51ff6fbc6548743$export$83d89fbfd8236492);
$parcel$export($d51ff6fbc6548743$exports, "createFactory", () => $d51ff6fbc6548743$export$d38cd72104c1f0e9);
$parcel$export($d51ff6fbc6548743$exports, "isValidElement", () => $d51ff6fbc6548743$export$a8257692ac88316c);
$parcel$export($d51ff6fbc6548743$exports, "isFragment", () => $d51ff6fbc6548743$export$9522e17588c12572);
$parcel$export($d51ff6fbc6548743$exports, "cloneElement", () => $d51ff6fbc6548743$export$e530037191fcd5d7);
$parcel$export($d51ff6fbc6548743$exports, "unmountComponentAtNode", () => $d51ff6fbc6548743$export$502457920280e6be);
$parcel$export($d51ff6fbc6548743$exports, "findDOMNode", () => $d51ff6fbc6548743$export$466bfc07425424d5);
$parcel$export($d51ff6fbc6548743$exports, "unstable_batchedUpdates", () => $d51ff6fbc6548743$export$c78a37762a8d58e1);
$parcel$export($d51ff6fbc6548743$exports, "flushSync", () => $d51ff6fbc6548743$export$cd75ccfd720a3cd4);
$parcel$export($d51ff6fbc6548743$exports, "StrictMode", () => $d51ff6fbc6548743$export$5f8d39834fd61797);
$parcel$export($d51ff6fbc6548743$exports, "startTransition", () => $d51ff6fbc6548743$export$7568632d0d33d16d);
$parcel$export($d51ff6fbc6548743$exports, "useDeferredValue", () => $d51ff6fbc6548743$export$6a7bc4e911dc01cf);
$parcel$export($d51ff6fbc6548743$exports, "useTransition", () => $d51ff6fbc6548743$export$7b286972b8d8ccbf);
$parcel$export($d51ff6fbc6548743$exports, "useInsertionEffect", () => $d51ff6fbc6548743$export$aaabe4eda9ed9969);
$parcel$export($d51ff6fbc6548743$exports, "isElement", () => $d51ff6fbc6548743$export$45a5e7f76e0caa8d);
$parcel$export($d51ff6fbc6548743$exports, "useSyncExternalStore", () => $d51ff6fbc6548743$export$306c0aa65ff9ec16);
$parcel$export($d51ff6fbc6548743$exports, "default", () => $d51ff6fbc6548743$export$2e2bcd8739ae039);
$parcel$export($d51ff6fbc6548743$exports, "Component", () => $73048c6b859c8a02$export$16fa2f45be04daa8);
$parcel$export($d51ff6fbc6548743$exports, "Fragment", () => $73048c6b859c8a02$export$ffb0004e005737fa);
$parcel$export($d51ff6fbc6548743$exports, "createContext", () => $73048c6b859c8a02$export$fd42f52fd3ae1109);
$parcel$export($d51ff6fbc6548743$exports, "createElement", () => $73048c6b859c8a02$export$c8a8987d4410bf2d);
$parcel$export($d51ff6fbc6548743$exports, "createRef", () => $73048c6b859c8a02$export$7d1e3a5e95ceca43);

var $88a9540d1aad6464$exports = {};

$parcel$export($88a9540d1aad6464$exports, "useState", () => $88a9540d1aad6464$export$60241385465d0a34);
$parcel$export($88a9540d1aad6464$exports, "useReducer", () => $88a9540d1aad6464$export$13e3392192263954);
$parcel$export($88a9540d1aad6464$exports, "useEffect", () => $88a9540d1aad6464$export$6d9c69b0de29b591);
$parcel$export($88a9540d1aad6464$exports, "useLayoutEffect", () => $88a9540d1aad6464$export$e5c5a5f917a5871c);
$parcel$export($88a9540d1aad6464$exports, "useRef", () => $88a9540d1aad6464$export$b8f5890fc79d6aca);
$parcel$export($88a9540d1aad6464$exports, "useMemo", () => $88a9540d1aad6464$export$1538c33de8887b59);
$parcel$export($88a9540d1aad6464$exports, "useImperativeHandle", () => $88a9540d1aad6464$export$d5a552a76deda3c2);
$parcel$export($88a9540d1aad6464$exports, "useCallback", () => $88a9540d1aad6464$export$35808ee640e87ca7);
$parcel$export($88a9540d1aad6464$exports, "useContext", () => $88a9540d1aad6464$export$fae74005e78b1a27);
$parcel$export($88a9540d1aad6464$exports, "useDebugValue", () => $88a9540d1aad6464$export$dc8fbce3eb94dc1e);
$parcel$export($88a9540d1aad6464$exports, "useErrorBoundary", () => $88a9540d1aad6464$export$c052f6604b7d51fe);
$parcel$export($88a9540d1aad6464$exports, "useId", () => $88a9540d1aad6464$export$f680877a34711e37);

var $88a9540d1aad6464$var$t, $88a9540d1aad6464$var$r, $88a9540d1aad6464$var$u, $88a9540d1aad6464$var$i, $88a9540d1aad6464$var$o = 0, $88a9540d1aad6464$var$f = [], $88a9540d1aad6464$var$c = [], $88a9540d1aad6464$var$e = (0, $73048c6b859c8a02$export$41c562ebe57d11e2).__b, $88a9540d1aad6464$var$a = (0, $73048c6b859c8a02$export$41c562ebe57d11e2).__r, $88a9540d1aad6464$var$v = (0, $73048c6b859c8a02$export$41c562ebe57d11e2).diffed, $88a9540d1aad6464$var$l = (0, $73048c6b859c8a02$export$41c562ebe57d11e2).__c, $88a9540d1aad6464$var$m = (0, $73048c6b859c8a02$export$41c562ebe57d11e2).unmount;
function $88a9540d1aad6464$var$d(t, u) {
    (0, $73048c6b859c8a02$export$41c562ebe57d11e2).__h && (0, $73048c6b859c8a02$export$41c562ebe57d11e2).__h($88a9540d1aad6464$var$r, t, $88a9540d1aad6464$var$o || u), $88a9540d1aad6464$var$o = 0;
    var i = $88a9540d1aad6464$var$r.__H || ($88a9540d1aad6464$var$r.__H = {
        __: [],
        __h: []
    });
    return t >= i.__.length && i.__.push({
        __V: $88a9540d1aad6464$var$c
    }), i.__[t];
}
function $88a9540d1aad6464$export$60241385465d0a34(n) {
    return $88a9540d1aad6464$var$o = 1, $88a9540d1aad6464$export$13e3392192263954($88a9540d1aad6464$var$B, n);
}
function $88a9540d1aad6464$export$13e3392192263954(n, u, i) {
    var o = $88a9540d1aad6464$var$d($88a9540d1aad6464$var$t++, 2);
    if (o.t = n, !o.__c && (o.__ = [
        i ? i(u) : $88a9540d1aad6464$var$B(void 0, u),
        function(n) {
            var t = o.__N ? o.__N[0] : o.__[0], r = o.t(t, n);
            t !== r && (o.__N = [
                r,
                o.__[1]
            ], o.__c.setState({}));
        }
    ], o.__c = $88a9540d1aad6464$var$r, !$88a9540d1aad6464$var$r.u)) {
        var f = function(n, t, r) {
            if (!o.__c.__H) return !0;
            var u = o.__c.__H.__.filter(function(n) {
                return n.__c;
            });
            if (u.every(function(n) {
                return !n.__N;
            })) return !c || c.call(this, n, t, r);
            var i = !1;
            return u.forEach(function(n) {
                if (n.__N) {
                    var t = n.__[0];
                    n.__ = n.__N, n.__N = void 0, t !== n.__[0] && (i = !0);
                }
            }), !(!i && o.__c.props === n) && (!c || c.call(this, n, t, r));
        };
        $88a9540d1aad6464$var$r.u = !0;
        var c = $88a9540d1aad6464$var$r.shouldComponentUpdate, e = $88a9540d1aad6464$var$r.componentWillUpdate;
        $88a9540d1aad6464$var$r.componentWillUpdate = function(n, t, r) {
            if (this.__e) {
                var u = c;
                c = void 0, f(n, t, r), c = u;
            }
            e && e.call(this, n, t, r);
        }, $88a9540d1aad6464$var$r.shouldComponentUpdate = f;
    }
    return o.__N || o.__;
}
function $88a9540d1aad6464$export$6d9c69b0de29b591(u, i) {
    var o = $88a9540d1aad6464$var$d($88a9540d1aad6464$var$t++, 3);
    !(0, $73048c6b859c8a02$export$41c562ebe57d11e2).__s && $88a9540d1aad6464$var$z(o.__H, i) && (o.__ = u, o.i = i, $88a9540d1aad6464$var$r.__H.__h.push(o));
}
function $88a9540d1aad6464$export$e5c5a5f917a5871c(u, i) {
    var o = $88a9540d1aad6464$var$d($88a9540d1aad6464$var$t++, 4);
    !(0, $73048c6b859c8a02$export$41c562ebe57d11e2).__s && $88a9540d1aad6464$var$z(o.__H, i) && (o.__ = u, o.i = i, $88a9540d1aad6464$var$r.__h.push(o));
}
function $88a9540d1aad6464$export$b8f5890fc79d6aca(n) {
    return $88a9540d1aad6464$var$o = 5, $88a9540d1aad6464$export$1538c33de8887b59(function() {
        return {
            current: n
        };
    }, []);
}
function $88a9540d1aad6464$export$d5a552a76deda3c2(n, t, r) {
    $88a9540d1aad6464$var$o = 6, $88a9540d1aad6464$export$e5c5a5f917a5871c(function() {
        return "function" == typeof n ? (n(t()), function() {
            return n(null);
        }) : n ? (n.current = t(), function() {
            return n.current = null;
        }) : void 0;
    }, null == r ? r : r.concat(n));
}
function $88a9540d1aad6464$export$1538c33de8887b59(n, r) {
    var u = $88a9540d1aad6464$var$d($88a9540d1aad6464$var$t++, 7);
    return $88a9540d1aad6464$var$z(u.__H, r) ? (u.__V = n(), u.i = r, u.__h = n, u.__V) : u.__;
}
function $88a9540d1aad6464$export$35808ee640e87ca7(n, t) {
    return $88a9540d1aad6464$var$o = 8, $88a9540d1aad6464$export$1538c33de8887b59(function() {
        return n;
    }, t);
}
function $88a9540d1aad6464$export$fae74005e78b1a27(n) {
    var u = $88a9540d1aad6464$var$r.context[n.__c], i = $88a9540d1aad6464$var$d($88a9540d1aad6464$var$t++, 9);
    return i.c = n, u ? (null == i.__ && (i.__ = !0, u.sub($88a9540d1aad6464$var$r)), u.props.value) : n.__;
}
function $88a9540d1aad6464$export$dc8fbce3eb94dc1e(t, r) {
    (0, $73048c6b859c8a02$export$41c562ebe57d11e2).useDebugValue && (0, $73048c6b859c8a02$export$41c562ebe57d11e2).useDebugValue(r ? r(t) : t);
}
function $88a9540d1aad6464$export$c052f6604b7d51fe(n) {
    var u = $88a9540d1aad6464$var$d($88a9540d1aad6464$var$t++, 10), i = $88a9540d1aad6464$export$60241385465d0a34();
    return u.__ = n, $88a9540d1aad6464$var$r.componentDidCatch || ($88a9540d1aad6464$var$r.componentDidCatch = function(n, t) {
        u.__ && u.__(n, t), i[1](n);
    }), [
        i[0],
        function() {
            i[1](void 0);
        }
    ];
}
function $88a9540d1aad6464$export$f680877a34711e37() {
    var n = $88a9540d1aad6464$var$d($88a9540d1aad6464$var$t++, 11);
    if (!n.__) {
        for(var u = $88a9540d1aad6464$var$r.__v; null !== u && !u.__m && null !== u.__;)u = u.__;
        var i = u.__m || (u.__m = [
            0,
            0
        ]);
        n.__ = "P" + i[0] + "-" + i[1]++;
    }
    return n.__;
}
function $88a9540d1aad6464$var$b() {
    for(var t; t = $88a9540d1aad6464$var$f.shift();)if (t.__P && t.__H) try {
        t.__H.__h.forEach($88a9540d1aad6464$var$k), t.__H.__h.forEach($88a9540d1aad6464$var$w), t.__H.__h = [];
    } catch (r) {
        t.__H.__h = [], (0, $73048c6b859c8a02$export$41c562ebe57d11e2).__e(r, t.__v);
    }
}
(0, $73048c6b859c8a02$export$41c562ebe57d11e2).__b = function(n) {
    $88a9540d1aad6464$var$r = null, $88a9540d1aad6464$var$e && $88a9540d1aad6464$var$e(n);
}, (0, $73048c6b859c8a02$export$41c562ebe57d11e2).__r = function(n) {
    $88a9540d1aad6464$var$a && $88a9540d1aad6464$var$a(n), $88a9540d1aad6464$var$t = 0;
    var i = ($88a9540d1aad6464$var$r = n.__c).__H;
    i && ($88a9540d1aad6464$var$u === $88a9540d1aad6464$var$r ? (i.__h = [], $88a9540d1aad6464$var$r.__h = [], i.__.forEach(function(n) {
        n.__N && (n.__ = n.__N), n.__V = $88a9540d1aad6464$var$c, n.__N = n.i = void 0;
    })) : (i.__h.forEach($88a9540d1aad6464$var$k), i.__h.forEach($88a9540d1aad6464$var$w), i.__h = [], $88a9540d1aad6464$var$t = 0)), $88a9540d1aad6464$var$u = $88a9540d1aad6464$var$r;
}, (0, $73048c6b859c8a02$export$41c562ebe57d11e2).diffed = function(t) {
    $88a9540d1aad6464$var$v && $88a9540d1aad6464$var$v(t);
    var o = t.__c;
    o && o.__H && (o.__H.__h.length && (1 !== $88a9540d1aad6464$var$f.push(o) && $88a9540d1aad6464$var$i === (0, $73048c6b859c8a02$export$41c562ebe57d11e2).requestAnimationFrame || (($88a9540d1aad6464$var$i = (0, $73048c6b859c8a02$export$41c562ebe57d11e2).requestAnimationFrame) || $88a9540d1aad6464$var$j)($88a9540d1aad6464$var$b)), o.__H.__.forEach(function(n) {
        n.i && (n.__H = n.i), n.__V !== $88a9540d1aad6464$var$c && (n.__ = n.__V), n.i = void 0, n.__V = $88a9540d1aad6464$var$c;
    })), $88a9540d1aad6464$var$u = $88a9540d1aad6464$var$r = null;
}, (0, $73048c6b859c8a02$export$41c562ebe57d11e2).__c = function(t, r) {
    r.some(function(t) {
        try {
            t.__h.forEach($88a9540d1aad6464$var$k), t.__h = t.__h.filter(function(n) {
                return !n.__ || $88a9540d1aad6464$var$w(n);
            });
        } catch (u) {
            r.some(function(n) {
                n.__h && (n.__h = []);
            }), r = [], (0, $73048c6b859c8a02$export$41c562ebe57d11e2).__e(u, t.__v);
        }
    }), $88a9540d1aad6464$var$l && $88a9540d1aad6464$var$l(t, r);
}, (0, $73048c6b859c8a02$export$41c562ebe57d11e2).unmount = function(t) {
    $88a9540d1aad6464$var$m && $88a9540d1aad6464$var$m(t);
    var r, u = t.__c;
    u && u.__H && (u.__H.__.forEach(function(n) {
        try {
            $88a9540d1aad6464$var$k(n);
        } catch (n) {
            r = n;
        }
    }), u.__H = void 0, r && (0, $73048c6b859c8a02$export$41c562ebe57d11e2).__e(r, u.__v));
};
var $88a9540d1aad6464$var$g = "function" == typeof requestAnimationFrame;
function $88a9540d1aad6464$var$j(n) {
    var t, r = function() {
        clearTimeout(u), $88a9540d1aad6464$var$g && cancelAnimationFrame(t), setTimeout(n);
    }, u = setTimeout(r, 100);
    $88a9540d1aad6464$var$g && (t = requestAnimationFrame(r));
}
function $88a9540d1aad6464$var$k(n) {
    var t = $88a9540d1aad6464$var$r, u = n.__c;
    "function" == typeof u && (n.__c = void 0, u()), $88a9540d1aad6464$var$r = t;
}
function $88a9540d1aad6464$var$w(n) {
    var t = $88a9540d1aad6464$var$r;
    n.__c = n.__(), $88a9540d1aad6464$var$r = t;
}
function $88a9540d1aad6464$var$z(n, t) {
    return !n || n.length !== t.length || t.some(function(t, r) {
        return t !== n[r];
    });
}
function $88a9540d1aad6464$var$B(n, t) {
    return "function" == typeof t ? t(n) : t;
}


function $d51ff6fbc6548743$var$g(n, t) {
    for(var e in t)n[e] = t[e];
    return n;
}
function $d51ff6fbc6548743$var$C(n, t) {
    for(var e in n)if ("__source" !== e && !(e in t)) return !0;
    for(var r in t)if ("__source" !== r && n[r] !== t[r]) return !0;
    return !1;
}
function $d51ff6fbc6548743$var$E(n, t) {
    return n === t && (0 !== n || 1 / n == 1 / t) || n != n && t != t;
}
function $d51ff6fbc6548743$export$221d75b3f55bb0bd(n) {
    this.props = n;
}
function $d51ff6fbc6548743$export$7c73462e0d25e514(n, e) {
    function r(n) {
        var t = this.props.ref, r = t == n.ref;
        return !r && t && (t.call ? t(null) : t.current = null), e ? !e(this.props, n) || !r : $d51ff6fbc6548743$var$C(this.props, n);
    }
    function u(e) {
        return this.shouldComponentUpdate = r, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)(n, e);
    }
    return u.displayName = "Memo(" + (n.displayName || n.name) + ")", u.prototype.isReactComponent = !0, u.__f = !0, u;
}
($d51ff6fbc6548743$export$221d75b3f55bb0bd.prototype = new (0, $73048c6b859c8a02$export$16fa2f45be04daa8)).isPureReactComponent = !0, $d51ff6fbc6548743$export$221d75b3f55bb0bd.prototype.shouldComponentUpdate = function(n, t) {
    return $d51ff6fbc6548743$var$C(this.props, n) || $d51ff6fbc6548743$var$C(this.state, t);
};
var $d51ff6fbc6548743$var$R = (0, $73048c6b859c8a02$export$41c562ebe57d11e2).__b;
(0, $73048c6b859c8a02$export$41c562ebe57d11e2).__b = function(n) {
    n.type && n.type.__f && n.ref && (n.props.ref = n.ref, n.ref = null), $d51ff6fbc6548743$var$R && $d51ff6fbc6548743$var$R(n);
};
var $d51ff6fbc6548743$var$N = "undefined" != typeof Symbol && Symbol.for && Symbol.for("react.forward_ref") || 3911;
function $d51ff6fbc6548743$export$257a8862b851cb5b(n) {
    function t(t) {
        var e = $d51ff6fbc6548743$var$g({}, t);
        return delete e.ref, n(e, t.ref || null);
    }
    return t.$$typeof = $d51ff6fbc6548743$var$N, t.render = t, t.prototype.isReactComponent = t.__f = !0, t.displayName = "ForwardRef(" + (n.displayName || n.name) + ")", t;
}
var $d51ff6fbc6548743$var$A = function(n, t) {
    return null == n ? null : (0, $73048c6b859c8a02$export$47e4c5b300681277)((0, $73048c6b859c8a02$export$47e4c5b300681277)(n).map(t));
}, $d51ff6fbc6548743$export$dca3b0875bd9a954 = {
    map: $d51ff6fbc6548743$var$A,
    forEach: $d51ff6fbc6548743$var$A,
    count: function(n) {
        return n ? (0, $73048c6b859c8a02$export$47e4c5b300681277)(n).length : 0;
    },
    only: function(n) {
        var t = (0, $73048c6b859c8a02$export$47e4c5b300681277)(n);
        if (1 !== t.length) throw "Children.only";
        return t[0];
    },
    toArray: (0, $73048c6b859c8a02$export$47e4c5b300681277)
}, $d51ff6fbc6548743$var$T = (0, $73048c6b859c8a02$export$41c562ebe57d11e2).__e;
(0, $73048c6b859c8a02$export$41c562ebe57d11e2).__e = function(n, t, e, r) {
    if (n.then) {
        for(var u, o = t; o = o.__;)if ((u = o.__c) && u.__c) return null == t.__e && (t.__e = e.__e, t.__k = e.__k), u.__c(n, t);
    }
    $d51ff6fbc6548743$var$T(n, t, e, r);
};
var $d51ff6fbc6548743$var$F = (0, $73048c6b859c8a02$export$41c562ebe57d11e2).unmount;
function $d51ff6fbc6548743$var$I(n, t, e) {
    return n && (n.__c && n.__c.__H && (n.__c.__H.__.forEach(function(n) {
        "function" == typeof n.__c && n.__c();
    }), n.__c.__H = null), null != (n = $d51ff6fbc6548743$var$g({}, n)).__c && (n.__c.__P === e && (n.__c.__P = t), n.__c = null), n.__k = n.__k && n.__k.map(function(n) {
        return $d51ff6fbc6548743$var$I(n, t, e);
    })), n;
}
function $d51ff6fbc6548743$var$L(n, t, e) {
    return n && (n.__v = null, n.__k = n.__k && n.__k.map(function(n) {
        return $d51ff6fbc6548743$var$L(n, t, e);
    }), n.__c && n.__c.__P === t && (n.__e && e.insertBefore(n.__e, n.__d), n.__c.__e = !0, n.__c.__P = e)), n;
}
function $d51ff6fbc6548743$export$74bf444e3cd11ea5() {
    this.__u = 0, this.t = null, this.__b = null;
}
function $d51ff6fbc6548743$var$D(n) {
    var t = n.__.__c;
    return t && t.__a && t.__a(n);
}
function $d51ff6fbc6548743$export$488013bae63b21da(n) {
    var e, r, u;
    function o(o) {
        if (e || (e = n()).then(function(n) {
            r = n.default || n;
        }, function(n) {
            u = n;
        }), u) throw u;
        if (!r) throw e;
        return (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)(r, o);
    }
    return o.displayName = "Lazy", o.__f = !0, o;
}
function $d51ff6fbc6548743$export$998bcd577473dd93() {
    this.u = null, this.o = null;
}
(0, $73048c6b859c8a02$export$41c562ebe57d11e2).unmount = function(n) {
    var t = n.__c;
    t && t.__R && t.__R(), t && !0 === n.__h && (n.type = null), $d51ff6fbc6548743$var$F && $d51ff6fbc6548743$var$F(n);
}, ($d51ff6fbc6548743$export$74bf444e3cd11ea5.prototype = new (0, $73048c6b859c8a02$export$16fa2f45be04daa8)).__c = function(n, t) {
    var e = t.__c, r = this;
    null == r.t && (r.t = []), r.t.push(e);
    var u = $d51ff6fbc6548743$var$D(r.__v), o = !1, i = function() {
        o || (o = !0, e.__R = null, u ? u(l) : l());
    };
    e.__R = i;
    var l = function() {
        if (!--r.__u) {
            if (r.state.__a) {
                var n = r.state.__a;
                r.__v.__k[0] = $d51ff6fbc6548743$var$L(n, n.__c.__P, n.__c.__O);
            }
            var t;
            for(r.setState({
                __a: r.__b = null
            }); t = r.t.pop();)t.forceUpdate();
        }
    }, c = !0 === t.__h;
    r.__u++ || c || r.setState({
        __a: r.__b = r.__v.__k[0]
    }), n.then(i, i);
}, $d51ff6fbc6548743$export$74bf444e3cd11ea5.prototype.componentWillUnmount = function() {
    this.t = [];
}, $d51ff6fbc6548743$export$74bf444e3cd11ea5.prototype.render = function(n, e) {
    if (this.__b) {
        if (this.__v.__k) {
            var r = document.createElement("div"), o = this.__v.__k[0].__c;
            this.__v.__k[0] = $d51ff6fbc6548743$var$I(this.__b, r, o.__O = o.__P);
        }
        this.__b = null;
    }
    var i = e.__a && (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)((0, $73048c6b859c8a02$export$ffb0004e005737fa), null, n.fallback);
    return i && (i.__h = null), [
        (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)((0, $73048c6b859c8a02$export$ffb0004e005737fa), null, e.__a ? null : n.children),
        i
    ];
};
var $d51ff6fbc6548743$var$W = function(n, t, e) {
    if (++e[1] === e[0] && n.o.delete(t), n.props.revealOrder && ("t" !== n.props.revealOrder[0] || !n.o.size)) for(e = n.u; e;){
        for(; e.length > 3;)e.pop()();
        if (e[1] < e[0]) break;
        n.u = e = e[2];
    }
};
function $d51ff6fbc6548743$var$P(n) {
    return this.getChildContext = function() {
        return n.context;
    }, n.children;
}
function $d51ff6fbc6548743$var$j(n) {
    var e = this, r = n.i;
    e.componentWillUnmount = function() {
        (0, $73048c6b859c8a02$export$b3890eb0ae9dca99)(null, e.l), e.l = null, e.i = null;
    }, e.i && e.i !== r && e.componentWillUnmount(), e.l || (e.i = r, e.l = {
        nodeType: 1,
        parentNode: r,
        childNodes: [],
        appendChild: function(n) {
            this.childNodes.push(n), e.i.appendChild(n);
        },
        insertBefore: function(n, t) {
            this.childNodes.push(n), e.i.appendChild(n);
        },
        removeChild: function(n) {
            this.childNodes.splice(this.childNodes.indexOf(n) >>> 1, 1), e.i.removeChild(n);
        }
    }), (0, $73048c6b859c8a02$export$b3890eb0ae9dca99)((0, $73048c6b859c8a02$export$c8a8987d4410bf2d)($d51ff6fbc6548743$var$P, {
        context: e.context
    }, n.__v), e.l);
}
function $d51ff6fbc6548743$export$d39a5bbd09211389(n, e) {
    var r = (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)($d51ff6fbc6548743$var$j, {
        __v: n,
        i: e
    });
    return r.containerInfo = e, r;
}
($d51ff6fbc6548743$export$998bcd577473dd93.prototype = new (0, $73048c6b859c8a02$export$16fa2f45be04daa8)).__a = function(n) {
    var t = this, e = $d51ff6fbc6548743$var$D(t.__v), r = t.o.get(n);
    return r[0]++, function(u) {
        var o = function() {
            t.props.revealOrder ? (r.push(u), $d51ff6fbc6548743$var$W(t, n, r)) : u();
        };
        e ? e(o) : o();
    };
}, $d51ff6fbc6548743$export$998bcd577473dd93.prototype.render = function(n) {
    this.u = null, this.o = new Map;
    var t = (0, $73048c6b859c8a02$export$47e4c5b300681277)(n.children);
    n.revealOrder && "b" === n.revealOrder[0] && t.reverse();
    for(var e = t.length; e--;)this.o.set(t[e], this.u = [
        1,
        0,
        this.u
    ]);
    return n.children;
}, $d51ff6fbc6548743$export$998bcd577473dd93.prototype.componentDidUpdate = $d51ff6fbc6548743$export$998bcd577473dd93.prototype.componentDidMount = function() {
    var n = this;
    this.o.forEach(function(t, e) {
        $d51ff6fbc6548743$var$W(n, e, t);
    });
};
var $d51ff6fbc6548743$var$B = "undefined" != typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103, $d51ff6fbc6548743$var$H = /^(?:accent|alignment|arabic|baseline|cap|clip(?!PathU)|color|dominant|fill|flood|font|glyph(?!R)|horiz|image(!S)|letter|lighting|marker(?!H|W|U)|overline|paint|pointer|shape|stop|strikethrough|stroke|text(?!L)|transform|underline|unicode|units|v|vector|vert|word|writing|x(?!C))[A-Z]/, $d51ff6fbc6548743$var$Z = /^on(Ani|Tra|Tou|BeforeInp|Compo)/, $d51ff6fbc6548743$var$Y = /[A-Z0-9]/g, $d51ff6fbc6548743$var$$ = "undefined" != typeof document, $d51ff6fbc6548743$var$q = function(n) {
    return ("undefined" != typeof Symbol && "symbol" == typeof Symbol() ? /fil|che|rad/ : /fil|che|ra/).test(n);
};
function $d51ff6fbc6548743$export$b3890eb0ae9dca99(n, t, e) {
    return null == t.__k && (t.textContent = ""), (0, $73048c6b859c8a02$export$b3890eb0ae9dca99)(n, t), "function" == typeof e && e(), n ? n.__c : null;
}
function $d51ff6fbc6548743$export$fa8d919ba61d84db(n, t, e) {
    return (0, $73048c6b859c8a02$export$fa8d919ba61d84db)(n, t), "function" == typeof e && e(), n ? n.__c : null;
}
(0, $73048c6b859c8a02$export$16fa2f45be04daa8).prototype.isReactComponent = {}, [
    "componentWillMount",
    "componentWillReceiveProps",
    "componentWillUpdate"
].forEach(function(t) {
    Object.defineProperty((0, $73048c6b859c8a02$export$16fa2f45be04daa8).prototype, t, {
        configurable: !0,
        get: function() {
            return this["UNSAFE_" + t];
        },
        set: function(n) {
            Object.defineProperty(this, t, {
                configurable: !0,
                writable: !0,
                value: n
            });
        }
    });
});
var $d51ff6fbc6548743$var$K = (0, $73048c6b859c8a02$export$41c562ebe57d11e2).event;
function $d51ff6fbc6548743$var$Q() {}
function $d51ff6fbc6548743$var$X() {
    return this.cancelBubble;
}
function $d51ff6fbc6548743$var$nn() {
    return this.defaultPrevented;
}
(0, $73048c6b859c8a02$export$41c562ebe57d11e2).event = function(n) {
    return $d51ff6fbc6548743$var$K && (n = $d51ff6fbc6548743$var$K(n)), n.persist = $d51ff6fbc6548743$var$Q, n.isPropagationStopped = $d51ff6fbc6548743$var$X, n.isDefaultPrevented = $d51ff6fbc6548743$var$nn, n.nativeEvent = n;
};
var $d51ff6fbc6548743$var$tn, $d51ff6fbc6548743$var$en = {
    enumerable: !1,
    configurable: !0,
    get: function() {
        return this.class;
    }
}, $d51ff6fbc6548743$var$rn = (0, $73048c6b859c8a02$export$41c562ebe57d11e2).vnode;
(0, $73048c6b859c8a02$export$41c562ebe57d11e2).vnode = function(n) {
    "string" == typeof n.type && function(n) {
        var t = n.props, e = n.type, u = {};
        for(var o in t){
            var i = t[o];
            if (!("value" === o && "defaultValue" in t && null == i || $d51ff6fbc6548743$var$$ && "children" === o && "noscript" === e || "class" === o || "className" === o)) {
                var l = o.toLowerCase();
                "defaultValue" === o && "value" in t && null == t.value ? o = "value" : "download" === o && !0 === i ? i = "" : "ondoubleclick" === l ? o = "ondblclick" : "onchange" !== l || "input" !== e && "textarea" !== e || $d51ff6fbc6548743$var$q(t.type) ? "onfocus" === l ? o = "onfocusin" : "onblur" === l ? o = "onfocusout" : $d51ff6fbc6548743$var$Z.test(o) ? o = l : -1 === e.indexOf("-") && $d51ff6fbc6548743$var$H.test(o) ? o = o.replace($d51ff6fbc6548743$var$Y, "-$&").toLowerCase() : null === i && (i = void 0) : l = o = "oninput", "oninput" === l && u[o = l] && (o = "oninputCapture"), u[o] = i;
            }
        }
        "select" == e && u.multiple && Array.isArray(u.value) && (u.value = (0, $73048c6b859c8a02$export$47e4c5b300681277)(t.children).forEach(function(n) {
            n.props.selected = -1 != u.value.indexOf(n.props.value);
        })), "select" == e && null != u.defaultValue && (u.value = (0, $73048c6b859c8a02$export$47e4c5b300681277)(t.children).forEach(function(n) {
            n.props.selected = u.multiple ? -1 != u.defaultValue.indexOf(n.props.value) : u.defaultValue == n.props.value;
        })), t.class && !t.className ? (u.class = t.class, Object.defineProperty(u, "className", $d51ff6fbc6548743$var$en)) : (t.className && !t.class || t.class && t.className) && (u.class = u.className = t.className), n.props = u;
    }(n), n.$$typeof = $d51ff6fbc6548743$var$B, $d51ff6fbc6548743$var$rn && $d51ff6fbc6548743$var$rn(n);
};
var $d51ff6fbc6548743$var$un = (0, $73048c6b859c8a02$export$41c562ebe57d11e2).__r;
(0, $73048c6b859c8a02$export$41c562ebe57d11e2).__r = function(n) {
    $d51ff6fbc6548743$var$un && $d51ff6fbc6548743$var$un(n), $d51ff6fbc6548743$var$tn = n.__c;
};
var $d51ff6fbc6548743$var$on = (0, $73048c6b859c8a02$export$41c562ebe57d11e2).diffed;
(0, $73048c6b859c8a02$export$41c562ebe57d11e2).diffed = function(n) {
    $d51ff6fbc6548743$var$on && $d51ff6fbc6548743$var$on(n);
    var t = n.props, e = n.__e;
    null != e && "textarea" === n.type && "value" in t && t.value !== e.value && (e.value = null == t.value ? "" : t.value), $d51ff6fbc6548743$var$tn = null;
};
var $d51ff6fbc6548743$export$ae55be85d98224ed = {
    ReactCurrentDispatcher: {
        current: {
            readContext: function(n) {
                return $d51ff6fbc6548743$var$tn.__n[n.__c].props.value;
            }
        }
    }
}, $d51ff6fbc6548743$export$83d89fbfd8236492 = "17.0.2";
function $d51ff6fbc6548743$export$d38cd72104c1f0e9(n) {
    return (0, $73048c6b859c8a02$export$c8a8987d4410bf2d).bind(null, n);
}
function $d51ff6fbc6548743$export$a8257692ac88316c(n) {
    return !!n && n.$$typeof === $d51ff6fbc6548743$var$B;
}
function $d51ff6fbc6548743$export$9522e17588c12572(n) {
    return $d51ff6fbc6548743$export$a8257692ac88316c(n) && n.type === (0, $73048c6b859c8a02$export$ffb0004e005737fa);
}
function $d51ff6fbc6548743$export$e530037191fcd5d7(n) {
    return $d51ff6fbc6548743$export$a8257692ac88316c(n) ? (0, $73048c6b859c8a02$export$e530037191fcd5d7).apply(null, arguments) : n;
}
function $d51ff6fbc6548743$export$502457920280e6be(n) {
    return !!n.__k && ((0, $73048c6b859c8a02$export$b3890eb0ae9dca99)(null, n), !0);
}
function $d51ff6fbc6548743$export$466bfc07425424d5(n) {
    return n && (n.base || 1 === n.nodeType && n) || null;
}
var $d51ff6fbc6548743$export$c78a37762a8d58e1 = function(n, t) {
    return n(t);
}, $d51ff6fbc6548743$export$cd75ccfd720a3cd4 = function(n, t) {
    return n(t);
}, $d51ff6fbc6548743$export$5f8d39834fd61797 = (0, $73048c6b859c8a02$export$ffb0004e005737fa);
function $d51ff6fbc6548743$export$7568632d0d33d16d(n) {
    n();
}
function $d51ff6fbc6548743$export$6a7bc4e911dc01cf(n) {
    return n;
}
function $d51ff6fbc6548743$export$7b286972b8d8ccbf() {
    return [
        !1,
        $d51ff6fbc6548743$export$7568632d0d33d16d
    ];
}
var $d51ff6fbc6548743$export$aaabe4eda9ed9969 = (0, $88a9540d1aad6464$export$e5c5a5f917a5871c), $d51ff6fbc6548743$export$45a5e7f76e0caa8d = $d51ff6fbc6548743$export$a8257692ac88316c;
function $d51ff6fbc6548743$export$306c0aa65ff9ec16(n, t) {
    var e = t(), r = (0, $88a9540d1aad6464$export$60241385465d0a34)({
        h: {
            __: e,
            v: t
        }
    }), u = r[0].h, o = r[1];
    return (0, $88a9540d1aad6464$export$e5c5a5f917a5871c)(function() {
        u.__ = e, u.v = t, $d51ff6fbc6548743$var$E(u.__, t()) || o({
            h: u
        });
    }, [
        n,
        e,
        t
    ]), (0, $88a9540d1aad6464$export$6d9c69b0de29b591)(function() {
        return $d51ff6fbc6548743$var$E(u.__, u.v()) || o({
            h: u
        }), n(function() {
            $d51ff6fbc6548743$var$E(u.__, u.v()) || o({
                h: u
            });
        });
    }, [
        n
    ]), e;
}
var $d51ff6fbc6548743$export$2e2bcd8739ae039 = {
    useState: (0, $88a9540d1aad6464$export$60241385465d0a34),
    useId: (0, $88a9540d1aad6464$export$f680877a34711e37),
    useReducer: (0, $88a9540d1aad6464$export$13e3392192263954),
    useEffect: (0, $88a9540d1aad6464$export$6d9c69b0de29b591),
    useLayoutEffect: (0, $88a9540d1aad6464$export$e5c5a5f917a5871c),
    useInsertionEffect: $d51ff6fbc6548743$export$aaabe4eda9ed9969,
    useTransition: $d51ff6fbc6548743$export$7b286972b8d8ccbf,
    useDeferredValue: $d51ff6fbc6548743$export$6a7bc4e911dc01cf,
    useSyncExternalStore: $d51ff6fbc6548743$export$306c0aa65ff9ec16,
    startTransition: $d51ff6fbc6548743$export$7568632d0d33d16d,
    useRef: (0, $88a9540d1aad6464$export$b8f5890fc79d6aca),
    useImperativeHandle: (0, $88a9540d1aad6464$export$d5a552a76deda3c2),
    useMemo: (0, $88a9540d1aad6464$export$1538c33de8887b59),
    useCallback: (0, $88a9540d1aad6464$export$35808ee640e87ca7),
    useContext: (0, $88a9540d1aad6464$export$fae74005e78b1a27),
    useDebugValue: (0, $88a9540d1aad6464$export$dc8fbce3eb94dc1e),
    version: "17.0.2",
    Children: $d51ff6fbc6548743$export$dca3b0875bd9a954,
    render: $d51ff6fbc6548743$export$b3890eb0ae9dca99,
    hydrate: $d51ff6fbc6548743$export$fa8d919ba61d84db,
    unmountComponentAtNode: $d51ff6fbc6548743$export$502457920280e6be,
    createPortal: $d51ff6fbc6548743$export$d39a5bbd09211389,
    createElement: (0, $73048c6b859c8a02$export$c8a8987d4410bf2d),
    createContext: (0, $73048c6b859c8a02$export$fd42f52fd3ae1109),
    createFactory: $d51ff6fbc6548743$export$d38cd72104c1f0e9,
    cloneElement: $d51ff6fbc6548743$export$e530037191fcd5d7,
    createRef: (0, $73048c6b859c8a02$export$7d1e3a5e95ceca43),
    Fragment: (0, $73048c6b859c8a02$export$ffb0004e005737fa),
    isValidElement: $d51ff6fbc6548743$export$a8257692ac88316c,
    isElement: $d51ff6fbc6548743$export$45a5e7f76e0caa8d,
    isFragment: $d51ff6fbc6548743$export$9522e17588c12572,
    findDOMNode: $d51ff6fbc6548743$export$466bfc07425424d5,
    Component: (0, $73048c6b859c8a02$export$16fa2f45be04daa8),
    PureComponent: $d51ff6fbc6548743$export$221d75b3f55bb0bd,
    memo: $d51ff6fbc6548743$export$7c73462e0d25e514,
    forwardRef: $d51ff6fbc6548743$export$257a8862b851cb5b,
    flushSync: $d51ff6fbc6548743$export$cd75ccfd720a3cd4,
    unstable_batchedUpdates: $d51ff6fbc6548743$export$c78a37762a8d58e1,
    StrictMode: $d51ff6fbc6548743$export$5f8d39834fd61797,
    Suspense: $d51ff6fbc6548743$export$74bf444e3cd11ea5,
    SuspenseList: $d51ff6fbc6548743$export$998bcd577473dd93,
    lazy: $d51ff6fbc6548743$export$488013bae63b21da,
    __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED: $d51ff6fbc6548743$export$ae55be85d98224ed
};
$parcel$exportWildcard($d51ff6fbc6548743$exports, $88a9540d1aad6464$exports);


var $de454a4ed9de8e76$exports = {};
function $de454a4ed9de8e76$var$_extends() {
    $de454a4ed9de8e76$exports = $de454a4ed9de8e76$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    }, $de454a4ed9de8e76$exports.__esModule = true, $de454a4ed9de8e76$exports["default"] = $de454a4ed9de8e76$exports;
    return $de454a4ed9de8e76$var$_extends.apply(this, arguments);
}
$de454a4ed9de8e76$exports = $de454a4ed9de8e76$var$_extends, $de454a4ed9de8e76$exports.__esModule = true, $de454a4ed9de8e76$exports["default"] = $de454a4ed9de8e76$exports;



var $a99e0b75acbdb5bf$exports = {};
/**
 * This file automatically generated from `pre-publish.js`.
 * Do not manually edit.
 */ $a99e0b75acbdb5bf$exports = {
    "area": true,
    "base": true,
    "br": true,
    "col": true,
    "embed": true,
    "hr": true,
    "img": true,
    "input": true,
    "link": true,
    "meta": true,
    "param": true,
    "source": true,
    "track": true,
    "wbr": true
};


var $98b8487e681fd7c4$var$t = /\s([^'"/\s><]+?)[\s/>]|([^\s=]+)=\s?(".*?"|'.*?')/g;
function $98b8487e681fd7c4$var$n(n) {
    var r = {
        type: "tag",
        name: "",
        voidElement: !1,
        attrs: {},
        children: []
    }, i = n.match(/<\/?([^\s]+?)[/\s>]/);
    if (i && (r.name = i[1], ((0, (/*@__PURE__*/$parcel$interopDefault($a99e0b75acbdb5bf$exports)))[i[1]] || "/" === n.charAt(n.length - 2)) && (r.voidElement = !0), r.name.startsWith("!--"))) {
        var s = n.indexOf("-->");
        return {
            type: "comment",
            comment: -1 !== s ? n.slice(4, s) : ""
        };
    }
    for(var a = new RegExp($98b8487e681fd7c4$var$t), c = null; null !== (c = a.exec(n));)if (c[0].trim()) {
        if (c[1]) {
            var o = c[1].trim(), l = [
                o,
                ""
            ];
            o.indexOf("=") > -1 && (l = o.split("=")), r.attrs[l[0]] = l[1], a.lastIndex--;
        } else c[2] && (r.attrs[c[2]] = c[3].trim().substring(1, c[3].length - 1));
    }
    return r;
}
var $98b8487e681fd7c4$var$r = /<[a-zA-Z0-9\-\!\/](?:"[^"]*"|'[^']*'|[^'">])*>/g, $98b8487e681fd7c4$var$i = /^\s*$/, $98b8487e681fd7c4$var$s = Object.create(null);
function $98b8487e681fd7c4$var$a(e, t) {
    switch(t.type){
        case "text":
            return e + t.content;
        case "tag":
            return e += "<" + t.name + (t.attrs ? function(e) {
                var t = [];
                for(var n in e)t.push(n + '="' + e[n] + '"');
                return t.length ? " " + t.join(" ") : "";
            }(t.attrs) : "") + (t.voidElement ? "/>" : ">"), t.voidElement ? e : e + t.children.reduce($98b8487e681fd7c4$var$a, "") + "</" + t.name + ">";
        case "comment":
            return e + "<!--" + t.comment + "-->";
    }
}
var $98b8487e681fd7c4$var$c = {
    parse: function(e, t) {
        t || (t = {}), t.components || (t.components = $98b8487e681fd7c4$var$s);
        var a, c = [], o = [], l = -1, m = !1;
        if (0 !== e.indexOf("<")) {
            var u = e.indexOf("<");
            c.push({
                type: "text",
                content: -1 === u ? e : e.substring(0, u)
            });
        }
        return e.replace($98b8487e681fd7c4$var$r, function(r, s) {
            if (m) {
                if (r !== "</" + a.name + ">") return;
                m = !1;
            }
            var u, f = "/" !== r.charAt(1), h = r.startsWith("<!--"), p = s + r.length, d = e.charAt(p);
            if (h) {
                var v = $98b8487e681fd7c4$var$n(r);
                return l < 0 ? (c.push(v), c) : ((u = o[l]).children.push(v), c);
            }
            if (f && (l++, "tag" === (a = $98b8487e681fd7c4$var$n(r)).type && t.components[a.name] && (a.type = "component", m = !0), a.voidElement || m || !d || "<" === d || a.children.push({
                type: "text",
                content: e.slice(p, e.indexOf("<", p))
            }), 0 === l && c.push(a), (u = o[l - 1]) && u.children.push(a), o[l] = a), (!f || a.voidElement) && (l > -1 && (a.voidElement || a.name === r.slice(2, -1)) && (l--, a = -1 === l ? c : o[l]), !m && "<" !== d && d)) {
                u = -1 === l ? c : o[l].children;
                var x = e.indexOf("<", p), g = e.slice(p, -1 === x ? void 0 : x);
                $98b8487e681fd7c4$var$i.test(g) && (g = " "), (x > -1 && l + u.length >= 0 || " " !== g) && u.push({
                    type: "text",
                    content: g
                });
            }
        }), c;
    },
    stringify: function(e) {
        return e.reduce(function(e, t) {
            return e + $98b8487e681fd7c4$var$a("", t);
        }, "");
    }
};
var $98b8487e681fd7c4$export$2e2bcd8739ae039 = $98b8487e681fd7c4$var$c;


function $8948bff4a00b46d7$export$c106dd0671a0fc2d() {
    if (console && console.warn) {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (typeof args[0] === "string") args[0] = `react-i18next:: ${args[0]}`;
        console.warn(...args);
    }
}
const $8948bff4a00b46d7$var$alreadyWarned = {};
function $8948bff4a00b46d7$export$5b28268982f175ba() {
    for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
    if (typeof args[0] === "string" && $8948bff4a00b46d7$var$alreadyWarned[args[0]]) return;
    if (typeof args[0] === "string") $8948bff4a00b46d7$var$alreadyWarned[args[0]] = new Date();
    $8948bff4a00b46d7$export$c106dd0671a0fc2d(...args);
}
const $8948bff4a00b46d7$var$loadedClb = (i18n, cb)=>()=>{
        if (i18n.isInitialized) cb();
        else {
            const initialized = ()=>{
                setTimeout(()=>{
                    i18n.off("initialized", initialized);
                }, 0);
                cb();
            };
            i18n.on("initialized", initialized);
        }
    };
function $8948bff4a00b46d7$export$83be934b53fff43b(i18n, ns, cb) {
    i18n.loadNamespaces(ns, $8948bff4a00b46d7$var$loadedClb(i18n, cb));
}
function $8948bff4a00b46d7$export$8cd7e7a54fa865bc(i18n, lng, ns, cb) {
    if (typeof ns === "string") ns = [
        ns
    ];
    ns.forEach((n)=>{
        if (i18n.options.ns.indexOf(n) < 0) i18n.options.ns.push(n);
    });
    i18n.loadLanguages(lng, $8948bff4a00b46d7$var$loadedClb(i18n, cb));
}
function $8948bff4a00b46d7$var$oldI18nextHasLoadedNamespace(ns, i18n) {
    let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    const lng = i18n.languages[0];
    const fallbackLng = i18n.options ? i18n.options.fallbackLng : false;
    const lastLng = i18n.languages[i18n.languages.length - 1];
    if (lng.toLowerCase() === "cimode") return true;
    const loadNotPending = (l, n)=>{
        const loadState = i18n.services.backendConnector.state[`${l}|${n}`];
        return loadState === -1 || loadState === 2;
    };
    if (options.bindI18n && options.bindI18n.indexOf("languageChanging") > -1 && i18n.services.backendConnector.backend && i18n.isLanguageChangingTo && !loadNotPending(i18n.isLanguageChangingTo, ns)) return false;
    if (i18n.hasResourceBundle(lng, ns)) return true;
    if (!i18n.services.backendConnector.backend || i18n.options.resources && !i18n.options.partialBundledLanguages) return true;
    if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
    return false;
}
function $8948bff4a00b46d7$export$93d9ee97c1ad3f31(ns, i18n) {
    let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    if (!i18n.languages || !i18n.languages.length) {
        $8948bff4a00b46d7$export$5b28268982f175ba("i18n.languages were undefined or empty", i18n.languages);
        return true;
    }
    const isNewerI18next = i18n.options.ignoreJSONStructure !== undefined;
    if (!isNewerI18next) return $8948bff4a00b46d7$var$oldI18nextHasLoadedNamespace(ns, i18n, options);
    return i18n.hasLoadedNamespace(ns, {
        lng: options.lng,
        precheck: (i18nInstance, loadNotPending)=>{
            if (options.bindI18n && options.bindI18n.indexOf("languageChanging") > -1 && i18nInstance.services.backendConnector.backend && i18nInstance.isLanguageChangingTo && !loadNotPending(i18nInstance.isLanguageChangingTo, ns)) return false;
        }
    });
}
function $8948bff4a00b46d7$export$be63e0664592e141(Component) {
    return Component.displayName || Component.name || (typeof Component === "string" && Component.length > 0 ? Component : "Unknown");
}


const $41e77d45d3c057fa$var$matchHtmlEntity = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g;
const $41e77d45d3c057fa$var$htmlEntities = {
    "&amp;": "&",
    "&#38;": "&",
    "&lt;": "<",
    "&#60;": "<",
    "&gt;": ">",
    "&#62;": ">",
    "&apos;": "'",
    "&#39;": "'",
    "&quot;": '"',
    "&#34;": '"',
    "&nbsp;": " ",
    "&#160;": " ",
    "&copy;": "\xa9",
    "&#169;": "\xa9",
    "&reg;": "\xae",
    "&#174;": "\xae",
    "&hellip;": "\u2026",
    "&#8230;": "\u2026",
    "&#x2F;": "/",
    "&#47;": "/"
};
const $41e77d45d3c057fa$var$unescapeHtmlEntity = (m)=>$41e77d45d3c057fa$var$htmlEntities[m];
const $41e77d45d3c057fa$export$e8bacd2802a88316 = (text)=>text.replace($41e77d45d3c057fa$var$matchHtmlEntity, $41e77d45d3c057fa$var$unescapeHtmlEntity);


let $be3a1ef505afdca5$var$defaultOptions = {
    bindI18n: "languageChanged",
    bindI18nStore: "",
    transEmptyNodeValue: "",
    transSupportBasicHtmlNodes: true,
    transWrapTextNodes: "",
    transKeepBasicHtmlNodesFor: [
        "br",
        "strong",
        "i",
        "p"
    ],
    useSuspense: true,
    unescape: $41e77d45d3c057fa$export$e8bacd2802a88316
};
function $be3a1ef505afdca5$export$2e2366488d12e20d() {
    let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    $be3a1ef505afdca5$var$defaultOptions = {
        ...$be3a1ef505afdca5$var$defaultOptions,
        ...options
    };
}
function $be3a1ef505afdca5$export$212bb2fc580a90a8() {
    return $be3a1ef505afdca5$var$defaultOptions;
}


let $fb1664200764ca4e$var$i18nInstance;
function $fb1664200764ca4e$export$a039134f2fc7e0(instance) {
    $fb1664200764ca4e$var$i18nInstance = instance;
}
function $fb1664200764ca4e$export$64af334f494c2f47() {
    return $fb1664200764ca4e$var$i18nInstance;
}


function $c1087cd88d2287b5$var$hasChildren(node, checkLength) {
    if (!node) return false;
    const base = node.props ? node.props.children : node.children;
    if (checkLength) return base.length > 0;
    return !!base;
}
function $c1087cd88d2287b5$var$getChildren(node) {
    if (!node) return [];
    const children = node.props ? node.props.children : node.children;
    return node.props && node.props.i18nIsDynamicList ? $c1087cd88d2287b5$var$getAsArray(children) : children;
}
function $c1087cd88d2287b5$var$hasValidReactChildren(children) {
    if (Object.prototype.toString.call(children) !== "[object Array]") return false;
    return children.every((child)=>(0, $d51ff6fbc6548743$export$a8257692ac88316c)(child));
}
function $c1087cd88d2287b5$var$getAsArray(data) {
    return Array.isArray(data) ? data : [
        data
    ];
}
function $c1087cd88d2287b5$var$mergeProps(source, target) {
    const newTarget = {
        ...target
    };
    newTarget.props = Object.assign(source.props, target.props);
    return newTarget;
}
function $c1087cd88d2287b5$export$4f7a36dd898f1267(children, i18nOptions) {
    if (!children) return "";
    let stringNode = "";
    const childrenArray = $c1087cd88d2287b5$var$getAsArray(children);
    const keepArray = i18nOptions.transSupportBasicHtmlNodes && i18nOptions.transKeepBasicHtmlNodesFor ? i18nOptions.transKeepBasicHtmlNodesFor : [];
    childrenArray.forEach((child, childIndex)=>{
        if (typeof child === "string") stringNode += `${child}`;
        else if ((0, $d51ff6fbc6548743$export$a8257692ac88316c)(child)) {
            const childPropsCount = Object.keys(child.props).length;
            const shouldKeepChild = keepArray.indexOf(child.type) > -1;
            const childChildren = child.props.children;
            if (!childChildren && shouldKeepChild && childPropsCount === 0) stringNode += `<${child.type}/>`;
            else if (!childChildren && (!shouldKeepChild || childPropsCount !== 0)) stringNode += `<${childIndex}></${childIndex}>`;
            else if (child.props.i18nIsDynamicList) stringNode += `<${childIndex}></${childIndex}>`;
            else if (shouldKeepChild && childPropsCount === 1 && typeof childChildren === "string") stringNode += `<${child.type}>${childChildren}</${child.type}>`;
            else {
                const content = $c1087cd88d2287b5$export$4f7a36dd898f1267(childChildren, i18nOptions);
                stringNode += `<${childIndex}>${content}</${childIndex}>`;
            }
        } else if (child === null) (0, $8948bff4a00b46d7$export$c106dd0671a0fc2d)(`Trans: the passed in value is invalid - seems you passed in a null child.`);
        else if (typeof child === "object") {
            const { format: format, ...clone } = child;
            const keys = Object.keys(clone);
            if (keys.length === 1) {
                const value = format ? `${keys[0]}, ${format}` : keys[0];
                stringNode += `{{${value}}}`;
            } else (0, $8948bff4a00b46d7$export$c106dd0671a0fc2d)(`react-i18next: the passed in object contained more than one variable - the object should look like {{ value, format }} where format is optional.`, child);
        } else (0, $8948bff4a00b46d7$export$c106dd0671a0fc2d)(`Trans: the passed in value is invalid - seems you passed in a variable like {number} - please pass in variables for interpolation as full objects like {{number}}.`, child);
    });
    return stringNode;
}
function $c1087cd88d2287b5$var$renderNodes(children, targetString, i18n, i18nOptions, combinedTOpts, shouldUnescape) {
    if (targetString === "") return [];
    const keepArray = i18nOptions.transKeepBasicHtmlNodesFor || [];
    const emptyChildrenButNeedsHandling = targetString && new RegExp(keepArray.map((keep)=>`<${keep}`).join("|")).test(targetString);
    if (!children && !emptyChildrenButNeedsHandling && !shouldUnescape) return [
        targetString
    ];
    const data = {};
    function getData(childs) {
        const childrenArray = $c1087cd88d2287b5$var$getAsArray(childs);
        childrenArray.forEach((child)=>{
            if (typeof child === "string") return;
            if ($c1087cd88d2287b5$var$hasChildren(child)) getData($c1087cd88d2287b5$var$getChildren(child));
            else if (typeof child === "object" && !(0, $d51ff6fbc6548743$export$a8257692ac88316c)(child)) Object.assign(data, child);
        });
    }
    getData(children);
    const ast = (0, $98b8487e681fd7c4$export$2e2bcd8739ae039).parse(`<0>${targetString}</0>`);
    const opts = {
        ...data,
        ...combinedTOpts
    };
    function renderInner(child, node, rootReactNode) {
        const childs = $c1087cd88d2287b5$var$getChildren(child);
        const mappedChildren = mapAST(childs, node.children, rootReactNode);
        return $c1087cd88d2287b5$var$hasValidReactChildren(childs) && mappedChildren.length === 0 || child.props && child.props.i18nIsDynamicList ? childs : mappedChildren;
    }
    function pushTranslatedJSX(child, inner, mem, i, isVoid) {
        if (child.dummy) {
            child.children = inner;
            mem.push((0, $d51ff6fbc6548743$export$e530037191fcd5d7)(child, {
                key: i
            }, isVoid ? undefined : inner));
        } else mem.push(...(0, $d51ff6fbc6548743$export$dca3b0875bd9a954).map([
            child
        ], (c)=>{
            const props = {
                ...c.props
            };
            delete props.i18nIsDynamicList;
            return (0, $d51ff6fbc6548743$export$2e2bcd8739ae039).createElement(c.type, (0, (/*@__PURE__*/$parcel$interopDefault($de454a4ed9de8e76$exports)))({}, props, {
                key: i,
                ref: c.ref
            }, isVoid ? {} : {
                children: inner
            }));
        }));
    }
    function mapAST(reactNode, astNode, rootReactNode) {
        const reactNodes = $c1087cd88d2287b5$var$getAsArray(reactNode);
        const astNodes = $c1087cd88d2287b5$var$getAsArray(astNode);
        return astNodes.reduce((mem, node, i)=>{
            const translationContent = node.children && node.children[0] && node.children[0].content && i18n.services.interpolator.interpolate(node.children[0].content, opts, i18n.language);
            if (node.type === "tag") {
                let tmp = reactNodes[parseInt(node.name, 10)];
                if (rootReactNode.length === 1 && !tmp) tmp = rootReactNode[0][node.name];
                if (!tmp) tmp = {};
                const child = Object.keys(node.attrs).length !== 0 ? $c1087cd88d2287b5$var$mergeProps({
                    props: node.attrs
                }, tmp) : tmp;
                const isElement = (0, $d51ff6fbc6548743$export$a8257692ac88316c)(child);
                const isValidTranslationWithChildren = isElement && $c1087cd88d2287b5$var$hasChildren(node, true) && !node.voidElement;
                const isEmptyTransWithHTML = emptyChildrenButNeedsHandling && typeof child === "object" && child.dummy && !isElement;
                const isKnownComponent = typeof children === "object" && children !== null && Object.hasOwnProperty.call(children, node.name);
                if (typeof child === "string") {
                    const value = i18n.services.interpolator.interpolate(child, opts, i18n.language);
                    mem.push(value);
                } else if ($c1087cd88d2287b5$var$hasChildren(child) || isValidTranslationWithChildren) {
                    const inner = renderInner(child, node, rootReactNode);
                    pushTranslatedJSX(child, inner, mem, i);
                } else if (isEmptyTransWithHTML) {
                    const inner = mapAST(reactNodes, node.children, rootReactNode);
                    pushTranslatedJSX(child, inner, mem, i);
                } else if (Number.isNaN(parseFloat(node.name))) {
                    if (isKnownComponent) {
                        const inner = renderInner(child, node, rootReactNode);
                        pushTranslatedJSX(child, inner, mem, i, node.voidElement);
                    } else if (i18nOptions.transSupportBasicHtmlNodes && keepArray.indexOf(node.name) > -1) {
                        if (node.voidElement) mem.push((0, $73048c6b859c8a02$export$c8a8987d4410bf2d)(node.name, {
                            key: `${node.name}-${i}`
                        }));
                        else {
                            const inner = mapAST(reactNodes, node.children, rootReactNode);
                            mem.push((0, $73048c6b859c8a02$export$c8a8987d4410bf2d)(node.name, {
                                key: `${node.name}-${i}`
                            }, inner));
                        }
                    } else if (node.voidElement) mem.push(`<${node.name} />`);
                    else {
                        const inner = mapAST(reactNodes, node.children, rootReactNode);
                        mem.push(`<${node.name}>${inner}</${node.name}>`);
                    }
                } else if (typeof child === "object" && !isElement) {
                    const content = node.children[0] ? translationContent : null;
                    if (content) mem.push(content);
                } else pushTranslatedJSX(child, translationContent, mem, i, node.children.length !== 1 || !translationContent);
            } else if (node.type === "text") {
                const wrapTextNodes = i18nOptions.transWrapTextNodes;
                const content = shouldUnescape ? i18nOptions.unescape(i18n.services.interpolator.interpolate(node.content, opts, i18n.language)) : i18n.services.interpolator.interpolate(node.content, opts, i18n.language);
                if (wrapTextNodes) mem.push((0, $73048c6b859c8a02$export$c8a8987d4410bf2d)(wrapTextNodes, {
                    key: `${node.name}-${i}`
                }, content));
                else mem.push(content);
            }
            return mem;
        }, []);
    }
    const result = mapAST([
        {
            dummy: true,
            children: children || []
        }
    ], ast, $c1087cd88d2287b5$var$getAsArray(children || []));
    return $c1087cd88d2287b5$var$getChildren(result[0]);
}
function $c1087cd88d2287b5$export$8d6a9236f2e3f2ce(_ref) {
    let { children: children, count: count, parent: parent, i18nKey: i18nKey, context: context, tOptions: tOptions = {}, values: values, defaults: defaults, components: components, ns: ns, i18n: i18nFromProps, t: tFromProps, shouldUnescape: shouldUnescape, ...additionalProps } = _ref;
    const i18n = i18nFromProps || (0, $fb1664200764ca4e$export$64af334f494c2f47)();
    if (!i18n) {
        (0, $8948bff4a00b46d7$export$5b28268982f175ba)("You will need to pass in an i18next instance by using i18nextReactModule");
        return children;
    }
    const t = tFromProps || i18n.t.bind(i18n) || ((k)=>k);
    if (context) tOptions.context = context;
    const reactI18nextOptions = {
        ...(0, $be3a1ef505afdca5$export$212bb2fc580a90a8)(),
        ...i18n.options && i18n.options.react
    };
    let namespaces = ns || t.ns || i18n.options && i18n.options.defaultNS;
    namespaces = typeof namespaces === "string" ? [
        namespaces
    ] : namespaces || [
        "translation"
    ];
    const nodeAsString = $c1087cd88d2287b5$export$4f7a36dd898f1267(children, reactI18nextOptions);
    const defaultValue = defaults || nodeAsString || reactI18nextOptions.transEmptyNodeValue || i18nKey;
    const { hashTransKey: hashTransKey } = reactI18nextOptions;
    const key = i18nKey || (hashTransKey ? hashTransKey(nodeAsString || defaultValue) : nodeAsString || defaultValue);
    if (i18n.options && i18n.options.interpolation && i18n.options.interpolation.defaultVariables) values = values && Object.keys(values).length > 0 ? {
        ...values,
        ...i18n.options.interpolation.defaultVariables
    } : {
        ...i18n.options.interpolation.defaultVariables
    };
    const interpolationOverride = values ? tOptions.interpolation : {
        interpolation: {
            ...tOptions.interpolation,
            prefix: "#$?",
            suffix: "?$#"
        }
    };
    const combinedTOpts = {
        ...tOptions,
        count: count,
        ...values,
        ...interpolationOverride,
        defaultValue: defaultValue,
        ns: namespaces
    };
    const translation = key ? t(key, combinedTOpts) : defaultValue;
    const content = $c1087cd88d2287b5$var$renderNodes(components || children, translation, i18n, reactI18nextOptions, combinedTOpts, shouldUnescape);
    const useAsParent = parent !== undefined ? parent : reactI18nextOptions.defaultTransParent;
    return useAsParent ? (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)(useAsParent, additionalProps, content) : content;
}







const $f4663bfcfe4ffd82$export$ae7e14d40d89f296 = {
    type: "3rdParty",
    init (instance) {
        (0, $be3a1ef505afdca5$export$2e2366488d12e20d)(instance.options.react);
        (0, $fb1664200764ca4e$export$a039134f2fc7e0)(instance);
    }
};


const $7769fa9636e2bfa3$export$5603ab5ced17ce64 = (0, $73048c6b859c8a02$export$fd42f52fd3ae1109)();
class $7769fa9636e2bfa3$export$ea171b67e3820290 {
    constructor(){
        this.usedNamespaces = {};
    }
    addUsedNamespaces(namespaces) {
        namespaces.forEach((ns)=>{
            if (!this.usedNamespaces[ns]) this.usedNamespaces[ns] = true;
        });
    }
    getUsedNamespaces() {
        return Object.keys(this.usedNamespaces);
    }
}
function $7769fa9636e2bfa3$export$30ff0342ccf735a(ForComponent) {
    return (ctx)=>new Promise((resolve)=>{
            const i18nInitialProps = $7769fa9636e2bfa3$export$704200e5d0b9e8f();
            if (ForComponent.getInitialProps) ForComponent.getInitialProps(ctx).then((componentsInitialProps)=>{
                resolve({
                    ...componentsInitialProps,
                    ...i18nInitialProps
                });
            });
            else resolve(i18nInitialProps);
        });
}
function $7769fa9636e2bfa3$export$704200e5d0b9e8f() {
    const i18n = (0, $fb1664200764ca4e$export$64af334f494c2f47)();
    const namespaces = i18n.reportNamespaces ? i18n.reportNamespaces.getUsedNamespaces() : [];
    const ret = {};
    const initialI18nStore = {};
    i18n.languages.forEach((l)=>{
        initialI18nStore[l] = {};
        namespaces.forEach((ns)=>{
            initialI18nStore[l][ns] = i18n.getResourceBundle(l, ns) || {};
        });
    });
    ret.initialI18nStore = initialI18nStore;
    ret.initialLanguage = i18n.language;
    return ret;
}


function $8c71aa9aa535d5cc$export$8d6a9236f2e3f2ce(_ref) {
    let { children: children, count: count, parent: parent, i18nKey: i18nKey, context: context, tOptions: tOptions = {}, values: values, defaults: defaults, components: components, ns: ns, i18n: i18nFromProps, t: tFromProps, shouldUnescape: shouldUnescape, ...additionalProps } = _ref;
    const { i18n: i18nFromContext, defaultNS: defaultNSFromContext } = (0, $88a9540d1aad6464$export$fae74005e78b1a27)((0, $7769fa9636e2bfa3$export$5603ab5ced17ce64)) || {};
    const i18n = i18nFromProps || i18nFromContext || (0, $fb1664200764ca4e$export$64af334f494c2f47)();
    const t = tFromProps || i18n && i18n.t.bind(i18n);
    return (0, $c1087cd88d2287b5$export$8d6a9236f2e3f2ce)({
        children: children,
        count: count,
        parent: parent,
        i18nKey: i18nKey,
        context: context,
        tOptions: tOptions,
        values: values,
        defaults: defaults,
        components: components,
        ns: ns || t && t.ns || defaultNSFromContext || i18n && i18n.options && i18n.options.defaultNS,
        i18n: i18n,
        t: tFromProps,
        shouldUnescape: shouldUnescape,
        ...additionalProps
    });
}






const $23287d5819478a30$var$usePrevious = (value, ignore)=>{
    const ref = (0, $88a9540d1aad6464$export$b8f5890fc79d6aca)();
    (0, $88a9540d1aad6464$export$6d9c69b0de29b591)(()=>{
        ref.current = ignore ? ref.current : value;
    }, [
        value,
        ignore
    ]);
    return ref.current;
};
function $23287d5819478a30$export$9fc83ad70ead8663(ns) {
    let props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const { i18n: i18nFromProps } = props;
    const { i18n: i18nFromContext, defaultNS: defaultNSFromContext } = (0, $88a9540d1aad6464$export$fae74005e78b1a27)((0, $7769fa9636e2bfa3$export$5603ab5ced17ce64)) || {};
    const i18n = i18nFromProps || i18nFromContext || (0, $fb1664200764ca4e$export$64af334f494c2f47)();
    if (i18n && !i18n.reportNamespaces) i18n.reportNamespaces = new (0, $7769fa9636e2bfa3$export$ea171b67e3820290)();
    if (!i18n) {
        (0, $8948bff4a00b46d7$export$5b28268982f175ba)("You will need to pass in an i18next instance by using initReactI18next");
        const notReadyT = (k, optsOrDefaultValue)=>{
            if (typeof optsOrDefaultValue === "string") return optsOrDefaultValue;
            if (optsOrDefaultValue && typeof optsOrDefaultValue === "object" && typeof optsOrDefaultValue.defaultValue === "string") return optsOrDefaultValue.defaultValue;
            return Array.isArray(k) ? k[k.length - 1] : k;
        };
        const retNotReady = [
            notReadyT,
            {},
            false
        ];
        retNotReady.t = notReadyT;
        retNotReady.i18n = {};
        retNotReady.ready = false;
        return retNotReady;
    }
    if (i18n.options.react && i18n.options.react.wait !== undefined) (0, $8948bff4a00b46d7$export$5b28268982f175ba)("It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.");
    const i18nOptions = {
        ...(0, $be3a1ef505afdca5$export$212bb2fc580a90a8)(),
        ...i18n.options.react,
        ...props
    };
    const { useSuspense: useSuspense, keyPrefix: keyPrefix } = i18nOptions;
    let namespaces = ns || defaultNSFromContext || i18n.options && i18n.options.defaultNS;
    namespaces = typeof namespaces === "string" ? [
        namespaces
    ] : namespaces || [
        "translation"
    ];
    if (i18n.reportNamespaces.addUsedNamespaces) i18n.reportNamespaces.addUsedNamespaces(namespaces);
    const ready = (i18n.isInitialized || i18n.initializedStoreOnce) && namespaces.every((n)=>(0, $8948bff4a00b46d7$export$93d9ee97c1ad3f31)(n, i18n, i18nOptions));
    function getT() {
        return i18n.getFixedT(props.lng || null, i18nOptions.nsMode === "fallback" ? namespaces : namespaces[0], keyPrefix);
    }
    const [t, setT] = (0, $88a9540d1aad6464$export$60241385465d0a34)(getT);
    let joinedNS = namespaces.join();
    if (props.lng) joinedNS = `${props.lng}${joinedNS}`;
    const previousJoinedNS = $23287d5819478a30$var$usePrevious(joinedNS);
    const isMounted = (0, $88a9540d1aad6464$export$b8f5890fc79d6aca)(true);
    (0, $88a9540d1aad6464$export$6d9c69b0de29b591)(()=>{
        const { bindI18n: bindI18n, bindI18nStore: bindI18nStore } = i18nOptions;
        isMounted.current = true;
        if (!ready && !useSuspense) {
            if (props.lng) (0, $8948bff4a00b46d7$export$8cd7e7a54fa865bc)(i18n, props.lng, namespaces, ()=>{
                if (isMounted.current) setT(getT);
            });
            else (0, $8948bff4a00b46d7$export$83be934b53fff43b)(i18n, namespaces, ()=>{
                if (isMounted.current) setT(getT);
            });
        }
        if (ready && previousJoinedNS && previousJoinedNS !== joinedNS && isMounted.current) setT(getT);
        function boundReset() {
            if (isMounted.current) setT(getT);
        }
        if (bindI18n && i18n) i18n.on(bindI18n, boundReset);
        if (bindI18nStore && i18n) i18n.store.on(bindI18nStore, boundReset);
        return ()=>{
            isMounted.current = false;
            if (bindI18n && i18n) bindI18n.split(" ").forEach((e)=>i18n.off(e, boundReset));
            if (bindI18nStore && i18n) bindI18nStore.split(" ").forEach((e)=>i18n.store.off(e, boundReset));
        };
    }, [
        i18n,
        joinedNS
    ]);
    const isInitial = (0, $88a9540d1aad6464$export$b8f5890fc79d6aca)(true);
    (0, $88a9540d1aad6464$export$6d9c69b0de29b591)(()=>{
        if (isMounted.current && !isInitial.current) setT(getT);
        isInitial.current = false;
    }, [
        i18n,
        keyPrefix
    ]);
    const ret = [
        t,
        i18n,
        ready
    ];
    ret.t = t;
    ret.i18n = i18n;
    ret.ready = ready;
    if (ready) return ret;
    if (!ready && !useSuspense) return ret;
    throw new Promise((resolve)=>{
        if (props.lng) (0, $8948bff4a00b46d7$export$8cd7e7a54fa865bc)(i18n, props.lng, namespaces, ()=>resolve());
        else (0, $8948bff4a00b46d7$export$83be934b53fff43b)(i18n, namespaces, ()=>resolve());
    });
}





function $ee5bb531210bb8d0$export$2dcb0053efd21124(ns) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return function Extend(WrappedComponent) {
        function I18nextWithTranslation(_ref) {
            let { forwardedRef: forwardedRef, ...rest } = _ref;
            const [t, i18n, ready] = (0, $23287d5819478a30$export$9fc83ad70ead8663)(ns, {
                ...rest,
                keyPrefix: options.keyPrefix
            });
            const passDownProps = {
                ...rest,
                t: t,
                i18n: i18n,
                tReady: ready
            };
            if (options.withRef && forwardedRef) passDownProps.ref = forwardedRef;
            else if (!options.withRef && forwardedRef) passDownProps.forwardedRef = forwardedRef;
            return (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)(WrappedComponent, passDownProps);
        }
        I18nextWithTranslation.displayName = `withI18nextTranslation(${(0, $8948bff4a00b46d7$export$be63e0664592e141)(WrappedComponent)})`;
        I18nextWithTranslation.WrappedComponent = WrappedComponent;
        const forwardRef = (props, ref)=>(0, $73048c6b859c8a02$export$c8a8987d4410bf2d)(I18nextWithTranslation, Object.assign({}, props, {
                forwardedRef: ref
            }));
        return options.withRef ? (0, $d51ff6fbc6548743$export$257a8862b851cb5b)(forwardRef) : I18nextWithTranslation;
    };
}



function $730c785d8f766145$export$b63289fbda65eed1(props) {
    const { ns: ns, children: children, ...options } = props;
    const [t, i18n, ready] = (0, $23287d5819478a30$export$9fc83ad70ead8663)(ns, options);
    return children(t, {
        i18n: i18n,
        lng: i18n.language
    }, ready);
}




function $416905e0717fbb75$export$1325e8699caa160f(_ref) {
    let { i18n: i18n, defaultNS: defaultNS, children: children } = _ref;
    const value = (0, $88a9540d1aad6464$export$1538c33de8887b59)(()=>({
            i18n: i18n,
            defaultNS: defaultNS
        }), [
        i18n,
        defaultNS
    ]);
    return (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)((0, $7769fa9636e2bfa3$export$5603ab5ced17ce64).Provider, {
        value: value
    }, children);
}





function $92a5e6fb63b23713$export$3526fb65ade8d8b7(initialI18nStore, initialLanguage) {
    let props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    const { i18n: i18nFromProps } = props;
    const { i18n: i18nFromContext } = (0, $88a9540d1aad6464$export$fae74005e78b1a27)((0, $7769fa9636e2bfa3$export$5603ab5ced17ce64)) || {};
    const i18n = i18nFromProps || i18nFromContext || (0, $fb1664200764ca4e$export$64af334f494c2f47)();
    if (i18n.options && i18n.options.isClone) return;
    if (initialI18nStore && !i18n.initializedStoreOnce) {
        i18n.services.resourceStore.data = initialI18nStore;
        i18n.options.ns = Object.values(initialI18nStore).reduce((mem, lngResources)=>{
            Object.keys(lngResources).forEach((ns)=>{
                if (mem.indexOf(ns) < 0) mem.push(ns);
            });
            return mem;
        }, i18n.options.ns);
        i18n.initializedStoreOnce = true;
        i18n.isInitialized = true;
    }
    if (initialLanguage && !i18n.initializedLanguageOnce) {
        i18n.changeLanguage(initialLanguage);
        i18n.initializedLanguageOnce = true;
    }
}




function $6a3a7999dcfd4802$export$80dfa519af1c8605() {
    return function Extend(WrappedComponent) {
        function I18nextWithSSR(_ref) {
            let { initialI18nStore: initialI18nStore, initialLanguage: initialLanguage, ...rest } = _ref;
            (0, $92a5e6fb63b23713$export$3526fb65ade8d8b7)(initialI18nStore, initialLanguage);
            return (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)(WrappedComponent, {
                ...rest
            });
        }
        I18nextWithSSR.getInitialProps = (0, $7769fa9636e2bfa3$export$30ff0342ccf735a)(WrappedComponent);
        I18nextWithSSR.displayName = `withI18nextSSR(${(0, $8948bff4a00b46d7$export$be63e0664592e141)(WrappedComponent)})`;
        I18nextWithSSR.WrappedComponent = WrappedComponent;
        return I18nextWithSSR;
    };
}







const $791ae55525c87072$export$324d90190a8b822a = ()=>"";
const $791ae55525c87072$export$2da9be4cfdb689b1 = ()=>"";
const $791ae55525c87072$export$98e628dec113755e = ()=>"";
const $791ae55525c87072$export$2e6c959c16ff56b8 = ()=>"";
const $791ae55525c87072$export$4e35d5c922a95490 = ()=>"";
const $791ae55525c87072$export$720a3b9db04b7a0f = ()=>"";


var $f4e9a5159a153fa2$exports = {};
$f4e9a5159a153fa2$exports = JSON.parse('{"hourly":"Hodinov\xe1","next_coms":"Shl\xe9dnout dal\u0161\xed koment\xe1\u0159e","ago":"p\u0159ed {{duration}}","login_placeholder":"e-mail","password_placeholder":"heslo","new_password_placeholder":"nov\xe9 heslo","confirm_password_placeholder":"potvrdit heslo","connect":"P\u0159ipojen\xed","submit":"Odeslat","title_placeholder":"Nadpis zpr\xe1vy (voliteln\u011B)","text_placeholder":"Zde napi\u0161te svou zpr\xe1vu","upload_pdf":"Nahr\xe1t pdf","upload_image":"Nahr\xe1t fotky","upload_video":"Nahr\xe1t video","upload_music":"Nahr\xe1t hudbu","add_date":"Zadat datum","logout":"Odhl\xe1sit","settings":"Nastaven\xed","name":"Jm\xe9no","name_input":"Vybrat jm\xe9no","login":"Login","login_input":"Vybrat login","email":"E-mail","email_input":"Vypl\u0148te sem sv\u016Fj e-mail","save_changes":"Ulo\u017Eit zm\u011Bny","password":"Heslo","password_input":"Vypl\u0148te sem nov\xe9 heslo","Invalid login/password":"Neplatn\xfd login a/nebo heslo","edit":"Upravit","delete":"Smazat","ask_delete_message":"Opravdu chcete smazat tuto zpr\xe1vu?","account":"\xda\u010Det","forgot_password":"Zapom\u011Bli jste sv\xe9 heslo?","password_reset_mail_sent":"E-mail pro obnovu hesla byl odesl\xe1n!","User not found":"U\u017Eivatel nenalezen","reset_password_title":"Resetovat heslo","error":"Do\u0161lo k chyb\u011B","passwords_dont_match":"Hesla se neshoduj\xed","invitation_link":"Odkaz s pozv\xe1nkou","reset_invitation_link":"Resetovat odkaz s pozv\xe1nkou","invitation_welcome":"V\xedtejte na Zusam! P\u0159ed vstupem do skupiny se p\u0159ihla\u0161te.","signup":"Zalo\u017Eit \xfa\u010Det","create_a_group":"Vytvo\u0159it skupinu","create_the_group":"Vytvo\u0159it tuto skupinu","quit_group":"Opustit skupinu","settings_updated":"Nastaven\xed byla aktualizov\xe1na","group_updated":"Skupina byla aktualizov\xe1na!","group_left":"Opustili jste tuto skupinu!","multiple_photos_upload":"Do\u0161lo k chyb\u011B. Zkuste nahr\xe1t obr\xe1zky jeden po druh\xe9m (toto se ob\u010Das v n\u011Bkter\xfdch prohl\xed\u017Ee\u010D\xedch stane).","error_new_message":"Do\u0161lo k chyb\u011B b\u011Bhem odes\xedl\xe1n\xed zpr\xe1vy.","error_upload":"Do\u0161lo k chyb\u011B b\u011Bhem nahr\xe1v\xe1n\xed","cancel_write":"Opravdu chcete ukon\u010Dit psan\xed nov\xe9 zpr\xe1vy?","empty_message":"Pr\xe1zdnou zpr\xe1vu nelze odeslat!","cancel":"Zru\u0161it","just_now":"Pr\xe1v\u011B te\u010F","notification_emails":"E-mailov\xe1 upozorn\u011Bn\xed","monthly":"M\u011Bs\xed\u010Dn\xed","notification_emails_stopped":"E-mailov\xe1 upozorn\u011Bn\xed zastavena!","group_share_choice":"Do kter\xe9 skupiny chcete poslat tuto zpr\xe1vu?","public_link":"ve\u0159ejn\xfd odkaz","default_group":"V\xfdchoz\xed skupina","destroy_account":"Smazat \xfa\u010Det","destroy_account_explain":"Smaz\xe1n\xed \xfa\u010Dtu nelze vr\xe1tit zp\u011Bt. Bu\u010Fte si opravdu jisti.","are_you_sure":"Jste si opravdu jisti?","share_message":"sd\xedlet zpr\xe1vu","previous_coms":"Shl\xe9dnout p\u0159edchoz\xed koment\xe1\u0159e","users":"u\u017Eivatel\xe9","has_posted_in":"zve\u0159ejnili v","has_commented_on":"komentovali v","has_joined":"vstoupili","has_left":"opustili","the_message_from":"zpr\xe1vu od","in":"v","lang":"jazyk","reply":"odpov\u011B\u010F","replies_one":"{{count}} odpov\u011B\u010F","replies_other":"{{count}} odpov\u011Bd\xed","publish_in_group":"zve\u0159ejnit ve skupin\u011B","search_in_group":"hledat ve skupin\u011B","changed_group_name":"zm\u011Bnili jm\xe9no skupiny","to":"na","notifications":"upozorn\u011Bn\xed","mark_all_as_read":"ozna\u010Dit v\u0161e jako p\u0159e\u010Dten\xe9","search_without_result":"Hled\xe1n\xed nevr\xe1tilo \u017Eadn\xe9 odpov\xeddaj\xedc\xed zpr\xe1vy.","add_bookmark":"P\u0159idat zpr\xe1vu do z\xe1lo\u017Eek","remove_bookmark":"Smazat zpr\xe1vu ze z\xe1lo\u017Eek","bookmarks":"z\xe1lo\u017Eky","api_key":"API kl\xed\u010D","reset_api_key":"Resetovat API kl\xed\u010D (budete odpojeni)","video_not_ready":"Video je\u0161t\u011B nen\xed p\u0159ipraveno.","bookmark_added":"Zpr\xe1va p\u0159id\xe1na do z\xe1lo\u017Eek!","bookmark_removed":"Zpr\xe1va odstran\u011Bna ze z\xe1lo\u017Eek!","parent_message":"Nad\u0159azen\xe1 zpr\xe1va","groups":"Skupiny","none":"\u017D\xe1dn\xe1","daily":"Denn\xed","weekly":"T\xfddenn\xed","upload_audio":"","audio_not_ready":""}');


var $d03e13a2cf004f69$exports = {};
$d03e13a2cf004f69$exports = JSON.parse('{"edit":"Bearbeiten","add_date":"Ein Datum hinzuf\xfcgen","save_changes":"\xc4nderungen speichern","password_input":"Gib hier ein neues Passwort ein","next_coms":"N\xe4chste Kommentare ansehen","previous_coms":"Vorherige Kommentare ansehen","ago":"Vor {{duration}}","submit":"Senden","groups":"Gruppen","password_placeholder":"Passwort","title_placeholder":"Titel deiner Nachricht (optional)","text_placeholder":"Schreibe deine Nachricht hier","upload_video":"Video hinzuf\xfcgen","login_placeholder":"E-Mail","new_password_placeholder":"Neues Passwort","upload_music":"Musik hinzuf\xfcgen","upload_pdf":"PDF hinzuf\xfcgen","confirm_password_placeholder":"Passwort best\xe4tigen","delete":"L\xf6schen","upload_image":"Fotos hinzuf\xfcgen","logout":"Abmelden","name":"Name","connect":"Anmelden","name_input":"W\xe4hle einen Namen","settings":"Einstellungen","login_input":"W\xe4hle einen Benutzername","email":"E-Mail","login":"Benutzername","email_input":"Gib hier deine E-Mail-Adresse ein","password":"Passwort","Invalid login/password":"Ung\xfcltiges Benutzername oder Passwort","forgot_password":"Hast du dein Passwort vergessen?","ask_delete_message":"Bist du sicher, dass du diese Nachricht l\xf6schen willst?","account":"Konto","password_reset_mail_sent":"Die E-Mail zum Zur\xfccksetzen des Passworts wurde gesendet!","create_a_group":"Eine Gruppe erstellen","users":"Benutzer","to":"zu","remove_bookmark":"Nachricht aus den Lesezeichnen entfernen","bookmarks":"Lesezeichen","multiple_photos_upload":"Ein Fehler ist aufgetreten. Versuche, die Bilder nacheinander hochzuladen (dies kann bei einigen Browsern vorkommen).","passwords_dont_match":"Passw\xf6rter stimmen nicht \xfcberein","User not found":"Benutzer nicht gefunden","reset_password_title":"Dein Passwort zur\xfccksetzen","error":"Ein Fehler ist aufgetreten","invitation_link":"Einladungslink","reset_invitation_link":"Einladungslink zur\xfccksetzen","invitation_welcome":"Willkommen bei Zusam! Bitte melde dich an, bevor du der Gruppe beitrittst.","notification_emails_stopped":"E-Mail-Benachrichtigungen gestoppt!","the_message_from":"die Nachricht von","signup":"Registrieren","group_updated":"Die Gruppe wurde aktualisiert!","group_left":"Du hast die Gruppe verlassen!","create_the_group":"Die Gruppe erstellen","quit_group":"Die Gruppe verlassen","settings_updated":"Deine Einstellungen wurden aktualisiert","monthly":"Monatlich","error_new_message":"Beim Senden deiner Nachricht ist ein Fehler aufgetreten.","just_now":"Gerade jetzt","none":"Keine","weekly":"W\xf6chentlich","are_you_sure":"Bist du sicher?","error_upload":"Beim Hochladen ist ein Fehler aufgetreten","cancel_write":"Willst du das Schreiben einer neuen Nachricht wirklich abbrechen?","empty_message":"Die Nachricht ist leer und kann nicht gesendet werden!","cancel":"Abbrechen","notification_emails":"E-Mail-Benachrichtigungen","hourly":"St\xfcndlich","daily":"T\xe4glich","group_share_choice":"An welche Gruppe m\xf6chtest du diese Nachricht senden?","destroy_account":"Dein Konto l\xf6schen","has_left":"hat verlassen","publish_in_group":"in der Gruppe ver\xf6ffentlichen","public_link":"\xf6ffentlicher Link","default_group":"Standard-Gruppe","has_posted_in":"hat ver\xf6ffentlicht in","has_joined":"ist beigetreten","lang":"Sprache","reply":"antworten","destroy_account_explain":"Wenn du dein Konto einmal gel\xf6scht hast, gibt es keinen Weg zur\xfcck. Bitte sei sicher.","share_message":"die Nachricht teilen","search_in_group":"in dieser Gruppe suchen","mark_all_as_read":"alle als gelesen markieren","has_commented_on":"hat kommentiert","in":"in","replies_one":"{{count}} Antwort","replies_other":"{{count}} Antworten","changed_group_name":"hat den Gruppenamen ge\xe4ndert","notifications":"Benachrichtigungen","reset_api_key":"Setze den API-Schl\xfcssel zur\xfcck (die Verbindung wird unterbrochen)","video_not_ready":"Das Video ist noch nicht fertig.","bookmark_added":"Nachricht zu den Lesezeichen hinzugef\xfcgt!","search_without_result":"Deine Suche hat zu keiner Nachricht gef\xfchrt.","add_bookmark":"Nachricht zu den Lesezeichnen hinzuf\xfcgen","api_key":"API-Schl\xfcssel","bookmark_removed":"Nachricht aus den Lesezeichen entfernt!","parent_message":"Quellenachricht","audio_not_ready":"Audio ist noch nicht fertig.","upload_audio":"Audio hinzuf\xfcgen."}');


var $fb625c47b8ebabfd$exports = {};
$fb625c47b8ebabfd$exports = JSON.parse('{"previous_coms":"See previous comments","next_coms":"See next comments","ago":"{{duration}} ago","groups":"Groups","login_placeholder":"email","password_placeholder":"password","new_password_placeholder":"new password","confirm_password_placeholder":"confirm password","connect":"Connection","submit":"Submit","title_placeholder":"Title of your message (optional)","text_placeholder":"Write your message here","upload_image":"Add photos","upload_video":"Add a video","upload_music":"Add musics","upload_pdf":"Add pdf","add_date":"Add a date","logout":"Logout","settings":"Settings","name":"Name","name_input":"Choose a name","login":"Login","login_input":"Choose a login","email":"Email","email_input":"Fill in your email here","save_changes":"Save changes","password":"Password","password_input":"Write a new password here","Invalid login/password":"Invalid login and/or password","edit":"Edit","delete":"Delete","ask_delete_message":"Are you sure to delete this message?","account":"Account","forgot_password":"Did you forget your password?","password_reset_mail_sent":"The password reset email was sent !","User not found":"User not found","reset_password_title":"Reset your password","error":"An error occurred","passwords_dont_match":"Passwords don\'t match","invitation_link":"Invitation link","reset_invitation_link":"Reset invitation link","invitation_welcome":"Welcome on Zusam ! Please sign up before joining the group.","signup":"Sign up","create_a_group":"Create a group","create_the_group":"Create the group","quit_group":"Leave the group","settings_updated":"Your settings were updated","group_updated":"The group was updated !","group_left":"You left the group !","multiple_photos_upload":"An error ocurred. Try uploading images one by one (this can happen in some browsers)","error_new_message":"An error occurred while sending your message.","error_upload":"An error occurred during the upload","cancel_write":"Do you really want to cancel writing a new message?","empty_message":"The message is empty and cannot be sent !","cancel":"Cancel","just_now":"Just now","notification_emails":"Email notifications","none":"None","hourly":"Hourly","daily":"Daily","weekly":"Weekly","monthly":"Monthly","notification_emails_stopped":"Email notifications stopped !","group_share_choice":"To which group do you want to send this message?","public_link":"public link","default_group":"Default group","destroy_account":"Delete your account","destroy_account_explain":"Once you delete your account, there is no going back. Please be certain.","are_you_sure":"Are you sure?","share_message":"share the message","users":"users","has_posted_in":"has posted in","has_commented_on":"has commented on","has_joined":"has joined","has_left":"has left","the_message_from":"the message from","in":"in","lang":"language","reply":"reply","replies_one":"{{count}} reply","replies_other":"{{count}} replies","publish_in_group":"publish in the group","search_in_group":"search in this group","changed_group_name":"changed the group\'s name","to":"to","notifications":"notifications","mark_all_as_read":"mark all as read","search_without_result":"Your search did not match any message.","add_bookmark":"Bookmark message","remove_bookmark":"Unbookmark message","bookmarks":"bookmarks","api_key":"API key","reset_api_key":"Reset the API key (you will be disconnected)","video_not_ready":"Video is not ready yet.","bookmark_added":"Message added to bookmarks !","bookmark_removed":"Message removed from bookmarks !","parent_message":"Parent message","audio_not_ready":"Audio is not ready yet.","upload_audio":"Add an audio file."}');


var $0d0d79d0d4f00eca$exports = {};
$0d0d79d0d4f00eca$exports = JSON.parse('{"previous_coms":"Ver los comentarios anteriores","next_coms":"Ver los siguientes comentarios","ago":"Hace {{duration}}","groups":"Grupos","login_placeholder":"correo","password_placeholder":"contrase\xf1a","new_password_placeholder":"nueva contrase\xf1a","confirm_password_placeholder":"confirmar contrase\xf1a","connect":"Conectarse","submit":"Enviar","title_placeholder":"Asunto (opcional)","text_placeholder":"Escribe tu mensaje aqu\xed","upload_image":"A\xf1adir fotos","upload_video":"A\xf1adir video","upload_music":"A\xf1adir m\xfasica","upload_pdf":"A\xf1adir pdf","add_date":"A\xf1adir una fecha","logout":"Desconectarse","settings":"Par\xe1metros","name":"Nombre","name_input":"Elige un nombre","login":"Usuario","login_input":"Elige un usuario","email":"Correo","email_input":"Indicar correo electr\xf3nico","save_changes":"Guardar los cambios","password":"Contrase\xf1a","password_input":"Indicar una nueva contrase\xf1a","Invalid login/password":"Usuario o contrase\xf1a incorrecto","edit":"Editar","delete":"Borrar","ask_delete_message":"\xbfQuieres borrar este mensaje?","account":"Cuenta","forgot_password":"\xbfOlvidaste tu contrase\xf1a?","password_reset_mail_sent":"El correo ha sido enviado!","User not found":"El usuario no existe","reset_password_title":"Cambia tu contrase\xf1a","error":"Se ha producido un error","passwords_dont_match":"Las contrase\xf1as no coinciden","invitation_link":"Enlace de invitaci\xf3n","reset_invitation_link":"Cambiar el enlace de invitaci\xf3n","invitation_welcome":"Bienvenido a Zusam ! Inscribete para conectarte con un grupo.","signup":"Inscribirse","create_a_group":"Crear un grupo","create_the_group":"Crear el grupo","quit_group":"Dejar el grupo","settings_updated":"Sus ajustes fueron actualizados","group_updated":"El grupo ha sido actualizado!","group_left":"\xa1Has dejado el grupo!","multiple_photos_upload":"Se ha producido un error. Intenta subir las im\xe1genes una a una (esto puede ocurrir en algunos navegadores)","error_new_message":"Se ha producido un error al enviar su mensaje.","error_upload":"Se ha producido un error durante la carga","cancel_write":"\xbfQuieres cancelar este nuevo mensaje?","empty_message":"No hay mensaje!","cancel":"Cancelar","just_now":"Ahora","notification_emails":"Correo de notificaci\xf3n","none":"Ninguno","hourly":"Cada hora","daily":"Diario","weekly":"Semanal","monthly":"Mensual","notification_emails_stopped":"Notificaciones de correo electr\xf3nico detenidas!","group_share_choice":"\xbfA qu\xe9 grupo desea enviar este mensaje?","public_link":"enlace p\xfablico","default_group":"Grupo predeterminado","destroy_account":"Borrar la cuenta","destroy_account_explain":"Una vez que elimines tu cuenta, no hay vuelta atr\xe1s.","are_you_sure":"Est\xe1s seguro ?","share_message":"comparte el mensaje","users":"usuarios","has_posted_in":"ha publicado en","has_commented_on":"ha comentado","has_joined":"se has unido","has_left":"ha dejado","the_message_from":"el mensaje de","in":"en","lang":"idioma","reply":"responder","replies_one":"{{count}} respuesta","replies_other":"{{count}} respuestas","publish_in_group":"publicar en el grupo","search_in_group":"buscar en este grupo","changed_group_name":"cambi\xf3 el nombre del grupo","to":"a","notifications":"notificaciones","mark_all_as_read":"marcar todo como leido","search_without_result":"Su b\xfasqueda no coincide con ning\xfan mensaje.","add_bookmark":"Marcar este mensaje","remove_bookmark":"Desmarcar este mensaje","bookmarks":"marcadores","api_key":"Clave API","reset_api_key":"Restablecer la clave API (se desconectar\xe1)","video_not_ready":"El v\xeddeo a\xfan no est\xe1 listo.","bookmark_added":"Mensaje agregado a marcadores !","bookmark_removed":"Mensaje eliminado de los marcadores !","parent_message":"Mensaje para padres","audio_not_ready":"El audio a\xfan no est\xe1 listo.","upload_audio":"A\xf1adir un archivo de audio."}');


var $56575d19017aef25$exports = {};
$56575d19017aef25$exports = JSON.parse('{"previous_coms":"Voir les commentaires pr\xe9c\xe9dents","next_coms":"Voir les commentaires suivants","ago":"Il y a {{duration}}","groups":"Groupes","login_placeholder":"courriel","password_placeholder":"mot de passe","new_password_placeholder":"nouveau mot de passe","confirm_password_placeholder":"confirmez le mot de passe","connect":"Connexion","submit":"Envoyer","title_placeholder":"Titre de votre message (optionnel)","text_placeholder":"\xc9crivez votre message ici","upload_image":"Ajouter des photos","upload_video":"Ajouter une vid\xe9o","upload_music":"Ajouter des musiques","upload_pdf":"Ajouter un pdf","add_date":"Pr\xe9ciser une date","logout":"Se d\xe9connecter","settings":"Param\xe8tres","name":"Nom","name_input":"Choisissez un nom","login":"Identifiant","login_input":"Choisissez un identifiant","email":"Courriel","email_input":"Saisissez votre adresse \xe9lectronique ici","save_changes":"Sauvegarder les changements","password":"Mot de passe","password_input":"Entrez un nouveau mot de passe","Invalid login/password":"Identifiant et/ou mot de passe invalide","edit":"Modifier","delete":"Supprimer","ask_delete_message":"\xcates-vous s\xfbr de vouloir supprimer ce message ?","account":"Compte","forgot_password":"Mot de passe oubli\xe9 ?","password_reset_mail_sent":"Le courriel de r\xe9initialisation a bien \xe9t\xe9 envoy\xe9\xa0!","User not found":"Utilisateur inexistant","reset_password_title":"R\xe9initialisation de votre mot de passe","error":"Une erreur s\'est produite","passwords_dont_match":"Les mots de passe ne correspondent pas","invitation_link":"Lien d\'invitation","reset_invitation_link":"R\xe9initialiser le lien d\'invitation","invitation_welcome":"Bienvenue sur Zusam ! Veuillez vous inscrire avant de rejoindre le groupe.","signup":"S\'inscrire","create_a_group":"Cr\xe9er un groupe","create_the_group":"Cr\xe9er le groupe","quit_group":"Quitter le groupe","settings_updated":"Vos param\xe8tres ont \xe9t\xe9 mis \xe0 jour","group_updated":"Le groupe a \xe9t\xe9 mis \xe0 jour !","group_left":"Vous avez quitt\xe9 le groupe !","multiple_photos_upload":"Une erreur s\'est produite. Essayez de t\xe9l\xe9charger les images une par une (cela peut se produire dans certains navigateurs).","error_new_message":"Une erreur s\u2019est produite lors de l\u2019envoi de votre message.","error_upload":"Une erreur s\'est produite pendant le t\xe9l\xe9versement","cancel_write":"Voulez-vous annuler l\'\xe9criture d\'un nouveau message\xa0?","empty_message":"Le message est vide et ne peut \xeatre envoy\xe9\xa0!","cancel":"Annuler","just_now":"\xc0 l\'instant","notification_emails":"Courriel de notification","none":"Aucun","hourly":"Une fois par heure","daily":"Journalier","weekly":"Hebdomadaire","monthly":"Mensuel","notification_emails_stopped":"Notifications par courriel d\xe9sactiv\xe9es\xa0!","group_share_choice":"A quel groupe voulez-vous envoyer ce message ?","public_link":"lien public","default_group":"Groupe par d\xe9faut","destroy_account":"Supprimer votre compte","destroy_account_explain":"Une fois votre compte supprim\xe9, il sera impossible d\'annuler l\'op\xe9ration.","are_you_sure":"\xcates-vous s\xfbr ?","share_message":"partager le message","users":"utilisateurs","has_posted_in":"a post\xe9 dans","has_commented_on":"a comment\xe9","has_joined":"a rejoint","has_left":"a quitt\xe9","the_message_from":"le message de","in":"dans","lang":"langue","reply":"r\xe9pondre","replies_one":"{{count}} r\xe9ponse","replies_other":"{{count}} r\xe9ponses","publish_in_group":"promouvoir le message","search_in_group":"rechercher dans le groupe","changed_group_name":"a chang\xe9 le nom du groupe","to":"en","notifications":"notifications","mark_all_as_read":"tout marquer comme lu","search_without_result":"Votre recherche ne correspond \xe0 aucun message.","add_bookmark":"Ajouter aux marque-pages","remove_bookmark":"Supprimer des marque-pages","bookmarks":"marque-pages","api_key":"Clef d\'API","reset_api_key":"Changer votre clef d\'API (vous allez \xeatre d\xe9connect\xe9)","video_not_ready":"La vid\xe9o n\'est pas encore pr\xeate.","bookmark_added":"Message ajout\xe9 aux marque-pages !","bookmark_removed":"Message supprim\xe9 des marque-pages !","parent_message":"Message parent","audio_not_ready":"Le fichier audio n\'est pas pr\xeat.","upload_audio":"Ajouter un fichier audio."}');


var $99d33bf86d13fec0$exports = {};
$99d33bf86d13fec0$exports = JSON.parse('{"next_coms":"K\xf6vetkez\u0151 hozz\xe1sz\xf3l\xe1sok","ago":"{{duration}} ezel\xf6tt","groups":"Csoportok","new_password_placeholder":"\xfaj jelsz\xf3","connect":"Kapcsolat","submit":"K\xfcld\xe9s","title_placeholder":"\xdczenet c\xedme (nem k\xf6telez\u0151)","login_placeholder":"email","previous_coms":"Kor\xe1bbi hozz\xe1sz\xf3l\xe1sok","password_placeholder":"jelsz\xf3","confirm_password_placeholder":"jelsz\xf3 meger\u0151s\xedt\xe9se","text_placeholder":"\xcdrd ide az \xfczenetet","upload_image":"Fot\xf3k hozz\xe1ad\xe1sa","upload_video":"Vide\xf3 hozz\xe1ad\xe1sa","upload_music":"Zen\xe9k hozz\xe1ad\xe1sa","upload_pdf":"Pdf hozz\xe1ad\xe1sa","add_date":"D\xe1tum hozz\xe1ad\xe1sa","logout":"Kijelentkez\xe9s","name_input":"V\xe1lassz egy nevet","login":"Bejelentkez\xe9s","login_input":"V\xe1lassz ki egy bejelentkez\xe9st","email":"Email","email_input":"\xcdrd az email c\xedmedet ide","save_changes":"V\xe1ltoz\xe1sok ment\xe9se","password":"Jelsz\xf3","Invalid login/password":"Hib\xe1s felhaszn\xe1l\xf3 \xe9s/vagy jelsz\xf3","delete":"T\xf6rl\xe9s","account":"Fi\xf3k","forgot_password":"Elfelejtetted a jelszavad?","password_reset_mail_sent":"A jelsz\xf3helyre\xe1ll\xedt\xf3 email el lett k\xfcldve!","User not found":"Felhaszn\xe1l\xf3 nem tal\xe1lhat\xf3","reset_password_title":"Jelsz\xf3 alaphelyzetbe \xe1ll\xedt\xe1s","error":"Hiba t\xf6rt\xe9nt","invitation_link":"Megh\xedv\xf3 link","invitation_welcome":"\xdcdv\xf6z\xf6l a Zusam ! Regisztr\xe1lj miel\xf6tt bel\xe9psz egy csoportba.","signup":"Regisztr\xe1ci\xf3","create_a_group":"Egy csoport l\xe9trehoz\xe1sa","create_the_group":"A csoport l\xe9trehoz\xe1sa","quit_group":"Kil\xe9p\xe9s a csoportb\xf3l","group_updated":"A csoport friss\xedtve !","group_left":"Elhagytad a csoportot !","error_new_message":"Hiba t\xf6rt\xe9nt az \xfczenet k\xfcld\xe9se k\xf6zben.","error_upload":"Hiba t\xf6rt\xe9nt a felt\xf6lt\xe9s k\xf6zben","empty_message":"Az \xfczenet \xfcres \xe9s \xedgy nem k\xfcldhet\u0151 el !","cancel":"M\xe9gsem","just_now":"Csak most","notification_emails":"Email \xe9rtes\xedt\xe9sek","none":"Egyik sem","hourly":"\xd3r\xe1nk\xe9nt","daily":"Napi","weekly":"Heti","monthly":"Havi","notification_emails_stopped":"Az e-mail \xe9rtes\xedt\xe9sek le\xe1lltak !","public_link":"nyilv\xe1nos link","default_group":"Alap\xe9rtelmezett csoport","destroy_account":"A fi\xf3k t\xf6rl\xe9se","are_you_sure":"Biztos vagy benne?","share_message":"Az \xfczenet megoszt\xe1sa","users":"felhaszn\xe1l\xf3k","has_posted_in":"k\xf6zz\xe9t\xe9ve","has_commented_on":"hozz\xe1szolt","has_joined":"csatlakozott","has_left":"kil\xe9pett","in":"ban","lang":"nyelv","reply":"v\xe1lasz","replies_other":"{{count}} v\xe1lasz","search_in_group":"keres\xe9s ebben a csoportban","changed_group_name":"megv\xe1ltoztatta a csoport nev\xe9t","mark_all_as_read":"\xf6sszes megjel\xf6l\xe9se olvasottk\xe9nt","search_without_result":"A keres\xe9s nem egyezett egyetlen \xfczenettel sem.","bookmarks":"k\xf6nyvjelz\u0151k","add_bookmark":"\xdczenet elrak\xe1sa a k\xf6nyvjelz\u0151kh\xf6z","api_key":"API kulcs","reset_api_key":"Az API-kulcs alaphelyzetbe \xe1ll\xedt\xe1sa (megszakad a kapcsolat)","video_not_ready":"A vide\xf3 m\xe9g nem \xe1ll k\xe9szen.","bookmark_added":"\xdczenet hozz\xe1adva a k\xf6nyvjelz\u0151kh\xf6z !","bookmark_removed":"Az \xfczenet elt\xe1vol\xedtva a k\xf6nyvjelz\u0151k k\xf6z\xfcl!","parent_message":"Sz\xfcl\u0151 \xfczenet","settings":"Be\xe1ll\xedt\xe1sok","name":"N\xe9v","password_input":"\xcdrd ide az \xfaj jelsz\xf3t","edit":"Szerkeszt\xe9s","ask_delete_message":"Biztos, hogy t\xf6rl\xf6d az \xfczenetet?","passwords_dont_match":"A jelszavak nem egyeznek","reset_invitation_link":"Megh\xedv\xf3 link alaphelyzetbe \xe1ll\xedt\xe1sa","settings_updated":"A be\xe1ll\xedt\xe1sok friss\xfcltek","multiple_photos_upload":"Hiba t\xf6rt\xe9nt. Pr\xf3b\xe1ld a k\xe9peket egyes\xe9vel felt\xf6lteni ( n\xe9h\xe1ny b\xf6ng\xe9sz\u0151ben ez t\xf6rt\xe9nhet ).","cancel_write":"Biztos, hogy megszak\xedt\xf3d az \xfaj \xfczeneted \xedr\xe1s\xe1t?","group_share_choice":"Melyik csoportnak szeretn\xe9 elk\xfcldeni ezt az \xfczenetet?","destroy_account_explain":"Miut\xe1n t\xf6r\xf6lte a fi\xf3kj\xe1t, nincs vissza\xfat. K\xe9rlek, l\xe9gy biztos.","notifications":"\xe9rtes\xedt\xe9sek","the_message_from":"az \xfczenet k\xfcld\u0151je","replies_one":"{{count}} v\xe1lasz","publish_in_group":"k\xf6zz\xe9t\xe9tel a csoportban","to":"hoz","remove_bookmark":"\xdczenet k\xf6nyvjelz\u0151j\xe9nek t\xf6rl\xe9se","upload_audio":"","audio_not_ready":""}');


var $c8ec0615535ae05c$exports = {};
$c8ec0615535ae05c$exports = JSON.parse('{"groups":"\uADF8\uB8F9","new_password_placeholder":"\uC0C8\uB85C\uC6B4 \uBE44\uBC00\uBC88\uD638","confirm_password_placeholder":"\uBE44\uBC00\uBC88\uD638 \uD655\uC778","title_placeholder":"\uBA54\uC2DC\uC9C0 \uC81C\uBAA9 (\uC120\uD0DD\uC0AC\uD56D)","upload_pdf":"PDF \uCD94\uAC00","password":"\uBE44\uBC00\uBC88\uD638","password_input":"\uC5EC\uAE30\uC5D0 \uC0C8\uB85C\uC6B4 \uBE44\uBC00\uBC88\uD638 \uC791\uC131","password_reset_mail_sent":"\uBE44\uBC00\uBC88\uD638 \uC7AC\uC124\uC815 \uC774\uBA54\uC77C\uC774 \uC804\uC1A1\uB418\uC5C8\uC2B5\uB2C8\uB2E4!","settings_updated":"\uC124\uC815 \uC5C5\uB370\uC774\uD2B8\uB428","notification_emails_stopped":"\uC774\uBA54\uC77C \uC54C\uB9BC\uC774 \uC911\uC9C0\uB418\uC5C8\uC2B5\uB2C8\uB2E4!","public_link":"\uACF5\uAC1C \uB9C1\uD06C","has_commented_on":"\uB313\uAE00 \uB4F1\uB85D\uB428","the_message_from":"\uBA54\uC138\uC9C0","previous_coms":"\uC774\uC804 \uB313\uAE00 \uBCF4\uAE30","next_coms":"\uB2E4\uC74C \uB313\uAE00 \uBCF4\uAE30","ago":"{{duration}} \uC804","name_input":"\uC774\uB984 \uC120\uD0DD","login_placeholder":"\uC774\uBA54\uC77C","submit":"\uC81C\uCD9C","add_date":"\uB0A0\uC9DC \uCD94\uAC00","name":"\uC774\uB984","password_placeholder":"\uBE44\uBC00\uBC88\uD638","upload_music":"\uC74C\uC545 \uCD94\uAC00","logout":"\uB85C\uADF8\uC544\uC6C3","connect":"\uC5F0\uACB0","text_placeholder":"\uC5EC\uAE30\uC5D0 \uBA54\uC2DC\uC9C0 \uC791\uC131","upload_video":"\uB3D9\uC601\uC0C1 \uCD94\uAC00","settings":"\uC124\uC815","login":"\uB85C\uADF8\uC778","login_input":"\uB85C\uADF8\uC778 \uC120\uD0DD","upload_image":"\uC0AC\uC9C4 \uCD94\uAC00","save_changes":"\uBCC0\uACBD \uC0AC\uD56D \uC800\uC7A5","email":"\uC774\uBA54\uC77C","email_input":"\uC5EC\uAE30\uC5D0 \uC774\uBA54\uC77C \uC785\uB825","Invalid login/password":"\uC798\uBABB\uB41C \uB85C\uADF8\uC778 \uBC0F/\uB610\uB294 \uBE44\uBC00\uBC88\uD638","edit":"\uD3B8\uC9D1","delete":"\uC0AD\uC81C","ask_delete_message":"\uC774 \uBA54\uC2DC\uC9C0\uB97C \uC0AD\uC81C\uD558\uACA0\uC2B5\uB2C8\uAE4C?","account":"\uACC4\uC815","forgot_password":"\uBE44\uBC00\uBC88\uD638\uB97C \uC78A\uC5C8\uB098\uC694?","signup":"\uAC00\uC785\uD558\uAE30","notification_emails":"\uC774\uBA54\uC77C \uC54C\uB9BC","none":"\uC5C6\uC74C","User not found":"\uC0AC\uC6A9\uC790\uB97C \uCC3E\uC744 \uC218 \uC5C6\uC74C","reset_password_title":"\uBE44\uBC00\uBC88\uD638 \uC7AC\uC124\uC815","invitation_link":"\uCD08\uB300 \uB9C1\uD06C","reset_invitation_link":"\uCD08\uB300 \uB9C1\uD06C \uC7AC\uC124\uC815","error":"\uC624\uB958 \uBC1C\uC0DD","passwords_dont_match":"\uBE44\uBC00\uBC88\uD638\uAC00 \uC77C\uCE58\uD558\uC9C0 \uC54A\uC74C","invitation_welcome":"Zusam\uC5D0 \uC624\uC2E0 \uAC83\uC744 \uD658\uC601\uD569\uB2C8\uB2E4! \uADF8\uB8F9\uC5D0 \uAC00\uC785\uD558\uAE30 \uC804\uC5D0 \uAC00\uC785\uD558\uC138\uC694.","create_a_group":"\uADF8\uB8F9 \uB9CC\uB4E4\uAE30","daily":"\uC77C\uAC04","create_the_group":"\uADF8\uB8F9 \uB9CC\uB4E4\uAE30","quit_group":"\uADF8\uB8F9 \uB098\uAC00\uAE30","group_updated":"\uADF8\uB8F9\uC774 \uC5C5\uB370\uC774\uD2B8\uB418\uC5C8\uC2B5\uB2C8\uB2E4!","multiple_photos_upload":"\uC624\uB958\uAC00 \uBC1C\uC0DD\uD588\uC2B5\uB2C8\uB2E4. \uC774\uBBF8\uC9C0\uB97C \uD558\uB098\uC529 \uC5C5\uB85C\uB4DC\uD574 \uBCF4\uC138\uC694 (\uC77C\uBD80 \uBE0C\uB77C\uC6B0\uC800\uC5D0\uC11C \uBC1C\uC0DD\uD560 \uC218 \uC788\uC74C).","group_left":"\uADF8\uB8F9\uC744 \uB098\uAC14\uC2B5\uB2C8\uB2E4!","error_new_message":"\uBA54\uC2DC\uC9C0\uB97C \uBCF4\uB0B4\uB294 \uB3D9\uC548 \uC624\uB958\uAC00 \uBC1C\uC0DD\uD588\uC2B5\uB2C8\uB2E4.","empty_message":"\uBA54\uC2DC\uC9C0\uAC00 \uBE44\uC5B4 \uC788\uC5B4 \uBCF4\uB0BC \uC218 \uC5C6\uC2B5\uB2C8\uB2E4!","default_group":"\uAE30\uBCF8 \uADF8\uB8F9","error_upload":"\uC5C5\uB85C\uB4DC \uC911 \uC624\uB958 \uBC1C\uC0DD","weekly":"\uC8FC\uAC04","monthly":"\uC6D4\uAC04","cancel_write":"\uC0C8\uB85C\uC6B4 \uBA54\uC2DC\uC9C0 \uC791\uC131\uC744 \uCDE8\uC18C\uD558\uACA0\uC2B5\uB2C8\uAE4C?","cancel":"\uCDE8\uC18C","group_share_choice":"\uC774 \uBA54\uC2DC\uC9C0\uB97C \uC5B4\uB290 \uADF8\uB8F9\uC5D0 \uBCF4\uB0B4\uACA0\uC2B5\uB2C8\uAE4C?","hourly":"\uB9E4 \uC2DC\uAC04","just_now":"\uC9C0\uAE08 \uB2F9\uC7A5","users":"\uC0AC\uC6A9\uC790","has_posted_in":"\uAC8C\uC2DC\uB428","destroy_account":"\uACC4\uC815 \uC0AD\uC81C","destroy_account_explain":"\uACC4\uC815\uC744 \uC0AD\uC81C\uD558\uBA74 \uB418\uB3CC\uB9B4 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4. \uD655\uC778 \uD574 \uC8FC\uC138\uC694.","are_you_sure":"\uD655\uC2E4\uD558\uB098\uC694?","share_message":"\uBA54\uC2DC\uC9C0 \uACF5\uC720","has_joined":"\uAC00\uC785\uB428","lang":"\uC5B8\uC5B4","reply":"\uB2F5\uAE00","replies_one":"{{count}} \uB2F5\uAE00","publish_in_group":"\uADF8\uB8F9\uC5D0 \uAC8C\uC2DC","search_in_group":"\uC774 \uADF8\uB8F9\uC5D0\uC11C \uAC80\uC0C9","to":"\uC5D0","search_without_result":"\uAC80\uC0C9\uC5B4\uC640 \uC77C\uCE58\uD558\uB294 \uBA54\uC2DC\uC9C0\uAC00 \uC5C6\uC2B5\uB2C8\uB2E4.","bookmarks":"\uBD81\uB9C8\uD06C","video_not_ready":"\uB3D9\uC601\uC0C1\uC774 \uC544\uC9C1 \uC900\uBE44\uB418\uC9C0 \uC54A\uC558\uC2B5\uB2C8\uB2E4.","parent_message":"\uC0C1\uC704 \uBA54\uC2DC\uC9C0","in":"\uC758","changed_group_name":"\uADF8\uB8F9 \uC774\uB984 \uBCC0\uACBD\uB428","notifications":"\uC54C\uB9BC","mark_all_as_read":"\uBAA8\uB450 \uC77D\uC740 \uAC83\uC73C\uB85C \uD45C\uC2DC","reset_api_key":"API \uD0A4 \uC7AC\uC124\uC815 (\uC5F0\uACB0\uC774 \uB04A\uC5B4\uC9D0)","has_left":"\uB098\uAC14\uC74C","replies_other":"{{count}} \uB2F5\uAE00","remove_bookmark":"\uBD81\uB9C8\uD06C \uD574\uC81C \uBA54\uC2DC\uC9C0","api_key":"API \uD0A4","bookmark_added":"\uBD81\uB9C8\uD06C\uC5D0 \uBA54\uC2DC\uC9C0\uAC00 \uCD94\uAC00\uB418\uC5C8\uC2B5\uB2C8\uB2E4!","bookmark_removed":"\uBD81\uB9C8\uD06C\uC5D0\uC11C \uBA54\uC2DC\uC9C0\uAC00 \uC81C\uAC70\uB418\uC5C8\uC2B5\uB2C8\uB2E4!","add_bookmark":"\uBD81\uB9C8\uD06C \uBA54\uC2DC\uC9C0","audio_not_ready":"\uC624\uB514\uC624\uAC00 \uC544\uC9C1 \uC900\uBE44\uB418\uC9C0 \uC54A\uC558\uC2B5\uB2C8\uB2E4.","upload_audio":"\uC624\uB514\uC624 \uD30C\uC77C\uC744 \uCD94\uAC00\uD569\uB2C8\uB2E4."}');


var $6d1e59a43645a5df$exports = {};
$6d1e59a43645a5df$exports = JSON.parse('{"previous_coms":"Zie vorige","next_coms":"Zie volgende","ago":"{{duration}} geleden","groups":"Groepen","login_placeholder":"email","password_placeholder":"wachtwoord","new_password_placeholder":"nieuw wachtwoord","confirm_password_placeholder":"bevestig wachtwoord","connect":"Verbind","submit":"Verstuur","title_placeholder":"Titel van jouw bericht (optioneel)","text_placeholder":"Schrijf jouw bericht hier","upload_image":"Voeg foto\'s toe","upload_video":"Voeg filmpje toe","upload_music":"Voeg muziek toe","upload_pdf":"Voeg PDF toe","add_date":"Voeg een datum toe","logout":"Afmelden","settings":"Instellingen","name":"Naam","name_input":"Kies een naam","login":"Aanmelden","login_input":"Kies een aanmeldingsnaam","email":"Email","email_input":"Voeg uw email adres hier in","save_changes":"Wijzigingen opslaan","password":"Wachtwoord","password_input":"Kies een nieuw wachtwoord","Invalid login/password":"Ongeldige aanmeldnaam/wachtwoord combinatie","edit":"Bewerken","delete":"Verwijderen","ask_delete_message":"Bent u zeker dat u dit bericht wil verwijderen?","account":"Account","forgot_password":"Wachtwoord vergeten?","password_reset_mail_sent":"De wachtwoord reset link is naar uw email adres verstuurd !","User not found":"Gebruiker niet gevonden","reset_password_title":"Reset uw wachtwoord","error":"Er is een fout opgetreden","passwords_dont_match":"Wachtwoorden komen niet overeen","invitation_link":"Uitnodigings link","reset_invitation_link":"Reset uitnodiging link","invitation_welcome":"Welkom op Zusam ! Gelieve aan te melden vooraleer in een groep in te schrijven.","signup":"Inschrijven","create_a_group":"Maak een groep","create_the_group":"Maak de groep","quit_group":"Verlaat de groep","settings_updated":"Uw instellingen werden aangepast","group_updated":"De groep werd aangepast !","group_left":"U heeft de groep verlaten !","multiple_photos_upload":"Er is een fout opgetreden. Probeer foto\'s 1 voor 1 op te laden","error_new_message":"Er is een fout opgetreden bij het doorsturen van uw bericht.","error_upload":"Er is een fout opgetreden bij het uploaden","cancel_write":"Bent u zeker dat u dit bericht wil annuleren?","empty_message":"Dit bericht is leeg en kan niet worden verzonden !","cancel":"Annuleren","just_now":"Net","notification_emails":"Email notificaties","none":"Niets","hourly":"Elk uur","daily":"Elke dag","weekly":"Elke week","monthly":"Elke maand","notification_emails_stopped":"Email notificaties zijn gestopt !","group_share_choice":"Naar welke groep wenst u dit bericht te sturen?","public_link":"publieke link","default_group":"Standaard groep","destroy_account":"Verwijder jouw account","destroy_account_explain":"Indien u uw account verwijdert, kan deze niet meer worden teruggehaald.","are_you_sure":"Bent u zeker?","share_message":"Deel bericht","users":"gebruikers","has_posted_in":"heeft gepost in","has_commented_on":"heeft commentaar gegeven op","has_joined":"is erbij gekomen","has_left":"is weggegaan","the_message_from":"het bericht van","in":"in","lang":"taal","reply":"antwoorden","replies_one":"{{count}} antwoord","replies_other":"{{count}} antwoorden","publish_in_group":"gepubliseerd in de groep","search_in_group":"zoek in deze groep","changed_group_name":"verandert de groepsnaam","to":"aan","notifications":"notificaties","mark_all_as_read":"markeer als gelezen","search_without_result":"Er werd geen enkel bericht gevonden met deze criteria.","add_bookmark":"Bookmark bericht","remove_bookmark":"Unbookmark bericht","bookmarks":"bookmarks","api_key":"API key","reset_api_key":"Reset the API key (you will be disconnected)","video_not_ready":"Video is nog niet klaar.","bookmark_added":"Bericht toegevoegd aan bookmarks !","bookmark_removed":"Bericht verwijderd uit bookmarks !","parent_message":"Parent bericht","upload_audio":"","audio_not_ready":""}');


var $ff7a0be7f7b1420f$exports = {};
$ff7a0be7f7b1420f$exports = JSON.parse('{"previous_coms":"Pozri predch\xe1dzaj\xface koment\xe1re","next_coms":"Pozri nasleduj\xface koment\xe1re","ago":"{{duration}} sp\xe4\u0165","groups":"Skupiny","login_placeholder":"email","password_placeholder":"heslo","new_password_placeholder":"nov\xe9 heslo","confirm_password_placeholder":"potvrdi\u0165 heslo","connect":"Pripojenie","submit":"Odosla\u0165","title_placeholder":"Nadpis v\xe1\u0161ho pr\xedspevku (nie je povinn\xe9)","text_placeholder":"Tu nap\xed\u0161 pr\xedspevok","upload_image":"Prida\u0165 fotografie","upload_video":"Pridajte video","upload_music":"Prida\u0165 hudbu","upload_pdf":"Prida\u0165 pdf","add_date":"Prida\u0165 d\xe1tum","logout":"Odhl\xe1si\u0165","settings":"Nastavenia","name":"Meno","name_input":"Zvo\u013E si nejak\xe9 meno","login":"Login","login_input":"Zvo\u013E si nejak\xe9 prihlasovacie meno","email":"Email","email_input":"Nap\xed\u0161 tvoj email sem","save_changes":"Ulo\u017Ei\u0165 zmeny","password":"Heslo","password_input":"Tu nap\xed\u0161 heslo","Invalid login/password":"Nespr\xe1vny login alebo heslo","edit":"Upravi\u0165","delete":"Zmaza\u0165","ask_delete_message":"Si si ist\xfd, \u017Ee chce\u0161 zmaza\u0165 tento pr\xedspevok?","account":"\xda\u010Det","forgot_password":"Zabudol si svoje heslo?","password_reset_mail_sent":"Email s inform\xe1ciami o nastaven\xed nov\xe9ho hesla bol odoslan\xfd!","User not found":"Neexistuj\xfaci u\u017E\xedvate\u013E","reset_password_title":"Zmena hesla","error":"Chyba","passwords_dont_match":"Hesl\xe1 sa nezhoduj\xfa","invitation_link":"Poz\xfdvac\xed odkaz","reset_invitation_link":"Obnovi\u0165 pozv\xe1nku odkaz","invitation_welcome":"Vitajte v Zusam ! Zaregistrujte sa pred pripojen\xedm sa ku skupine.","signup":"Prihl\xe1si\u0165","create_a_group":"Vytvori\u0165 skupinu","create_the_group":"Vytvori\u0165 skupinu","quit_group":"Opusti\u0165 skupinu","settings_updated":"Va\u0161e nastavenia boli zmenen\xe9","group_updated":"Nastavenia skupiny boli zmenen\xe9!","group_left":"Opustili ste skupinu!","multiple_photos_upload":"Objavila sa chyba. Sk\xfaste prilo\u017Ei\u0165 obr\xe1zky po jednom (t\xe1to chyba sa m\xf4\u017Ee objavova\u0165 v niektor\xfdch prehliada\u010Doch)","error_new_message":"Pri odosielan\xed va\u0161ej spr\xe1vy do\u0161lo k chybe.","error_upload":"Objavila sa chyba po\u010Das odosielania","cancel_write":"Chcete naozaj zru\u0161i\u0165 vytv\xe1ranie nov\xe9ho pr\xedspevku?","empty_message":"Spr\xe1va je pr\xe1zdna a nie je mo\u017En\xe1!","cancel":"Zru\u0161i\u0165","just_now":"Pr\xe1ve teraz","notification_emails":"Notifika\u010Dn\xfd email","none":"\u017Diadne","hourly":"Ka\u017Ed\xfa hodinu","daily":"Denne","weekly":"T\xfd\u017Edenne","monthly":"Mesa\u010Dne","notification_emails_stopped":"E-mailov\xe9 upozornenia sa zastavili!","group_share_choice":"Do ktorej skupiny chcete odosla\u0165 t\xfato spr\xe1vu ?","public_link":"verejn\xe9 spojenie","default_group":"Predvolen\xfa skupinu","destroy_account":"Odstr\xe1\u0148te svoj \xfa\u010Det","destroy_account_explain":"Potom, \u010Do vyma\u017Eete svoj \xfa\u010Det, nie je tam \u017Eiadny n\xe1vrat. Pros\xedm, uistite sa.","are_you_sure":"Si si ist\xfd ?","share_message":"zdie\u013Eajte spr\xe1vu","users":"u\u017E\xedvatelia","has_posted_in":"zverejnila v","has_commented_on":"komentoval","has_joined":"sa pripojil k","has_left":"opustil","the_message_from":"spr\xe1va od","in":"v","lang":"jazyk","reply":"odpove\u010F","replies_one":"{{count}} odpove\u010F","replies_other":"{{count}} odpoved\xed","publish_in_group":"publikova\u0165 v skupine","search_in_group":"h\u013Eada\u0165 v tejto skupine","changed_group_name":"zmenil n\xe1zov skupiny","to":"na","notifications":"ozn\xe1menia","mark_all_as_read":"ozna\u010Di\u0165 v\u0161etko ako pre\u010D\xedtan\xe9","search_without_result":"Va\u0161e vyh\u013Ead\xe1vanie nezhodla \u017Eiadne spr\xe1vy.","add_bookmark":"T\xfato spr\xe1vu ulo\u017Ei\u0165 medzi z\xe1lo\u017Eky","remove_bookmark":"Zru\u0161te ozna\u010Denie tejto spr\xe1vy","bookmarks":"z\xe1lo\u017Eky","api_key":"K\u013E\xfa\u010D API","reset_api_key":"Obnovte k\u013E\xfa\u010D rozhrania API (budete odpojen\xed)","video_not_ready":"Video e\u0161te nie je pripraven\xe9.","bookmark_added":"Spr\xe1va pridan\xe1 do z\xe1lo\u017Eiek !","bookmark_removed":"Spr\xe1va bola odstr\xe1nen\xe1 zo z\xe1lo\u017Eiek !","parent_message":"Spr\xe1va rodi\u010Da","audio_not_ready":"Audio e\u0161te nie je pripraven\xfd.","upload_audio":"Pridajte zvukov\xfd s\xfabor."}');


var $68505c5527d81c5f$exports = {};
$68505c5527d81c5f$exports = JSON.parse('{"save_changes":"\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u044F","add_date":"\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0434\u0430\u0442\u0443","are_you_sure":"\u0412\u044B \u0443\u0432\u0435\u0440\u0435\u043D\u044B?","text_placeholder":"\u041D\u0430\u043F\u0438\u0448\u0438\u0442\u0435 \u0441\u0432\u043E\u0435 \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435 \u0437\u0434\u0435\u0441\u044C","password":"\u041F\u0430\u0440\u043E\u043B\u044C","has_left":"\u0443\u0448\u0435\u043B","password_input":"\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u043D\u043E\u0432\u044B\u0439 \u043F\u0430\u0440\u043E\u043B\u044C \u0437\u0434\u0435\u0441\u044C","has_commented_on":"\u043F\u0440\u043E\u043A\u043E\u043C\u043C\u0435\u043D\u0442\u0438\u0440\u043E\u0432\u0430\u043B","video_not_ready":"\u0412\u0438\u0434\u0435\u043E \u0435\u0449\u0435 \u043D\u0435 \u0433\u043E\u0442\u043E\u0432\u043E.","group_left":"\u0422\u044B \u043F\u043E\u043A\u0438\u043D\u0443\u043B \u0433\u0440\u0443\u043F\u043F\u0443 !","api_key":"\u041A\u043B\u044E\u0447 API","ask_delete_message":"\u0412\u044B \u0443\u0432\u0435\u0440\u0435\u043D\u044B, \u0447\u0442\u043E \u0445\u043E\u0442\u0438\u0442\u0435 \u0443\u0434\u0430\u043B\u0438\u0442\u044C \u044D\u0442\u043E \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435?","the_message_from":"\u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435 \u043E\u0442","changed_group_name":"\u0438\u0437\u043C\u0435\u043D\u0438\u043B \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u0435 \u0433\u0440\u0443\u043F\u043F\u044B","has_joined":"\u043F\u0440\u0438\u0441\u043E\u0435\u0434\u0438\u043D\u0438\u043B\u0441\u044F","title_placeholder":"\u0417\u0430\u0433\u043E\u043B\u043E\u0432\u043E\u043A \u0432\u0430\u0448\u0435\u0433\u043E \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u044F (\u043E\u043F\u0446\u0438\u043E\u043D\u0430\u043B\u044C\u043D\u043E)","create_a_group":"\u0421\u043E\u0437\u0434\u0430\u0442\u044C \u0433\u0440\u0443\u043F\u043F\u0443","group_share_choice":"\u041A\u0430\u043A\u043E\u0439 \u0433\u0440\u0443\u043F\u043F\u0435 \u0432\u044B \u0445\u043E\u0442\u0438\u0442\u0435 \u043E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C \u044D\u0442\u043E \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435?","email":"\u042D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u0430\u044F \u043F\u043E\u0447\u0442\u0430","edit":"\u0420\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C","password_reset_mail_sent":"\u042D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0435 \u043F\u0438\u0441\u044C\u043C\u043E \u0441\u043E \u0441\u0431\u0440\u043E\u0441\u043E\u043C \u043F\u0430\u0440\u043E\u043B\u044F \u0431\u044B\u043B\u043E \u043E\u0442\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u043E !","search_in_group":"\u043F\u043E\u0438\u0441\u043A \u0432 \u044D\u0442\u043E\u0439 \u0433\u0440\u0443\u043F\u043F\u0435","upload_audio":"\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0430\u0443\u0434\u0438\u043E\u0444\u0430\u0439\u043B.","search_without_result":"\u0412\u0430\u0448 \u043F\u043E\u0438\u0441\u043A \u043D\u0435 \u0432\u044B\u044F\u0432\u0438\u043B \u043D\u0438 \u043E\u0434\u043D\u043E\u0433\u043E \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u044F.","invitation_link":"\u041F\u0440\u0438\u0433\u043B\u0430\u0441\u0438\u0442\u0435\u043B\u044C\u043D\u0430\u044F \u0441\u0441\u044B\u043B\u043A\u0430","passwords_dont_match":"\u041F\u0430\u0440\u043E\u043B\u0438 \u043D\u0435 \u0441\u043E\u0432\u043F\u0430\u0434\u0430\u044E\u0442","name":"\u0418\u043C\u044F","bookmark_removed":"\u0421\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435 \u0443\u0434\u0430\u043B\u0435\u043D\u043E \u0438\u0437 \u0437\u0430\u043A\u043B\u0430\u0434\u043E\u043A !","in":"\u0432","new_password_placeholder":"\u043D\u043E\u0432\u044B\u0439 \u043F\u0430\u0440\u043E\u043B\u044C","upload_image":"\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0444\u043E\u0442\u043E\u0433\u0440\u0430\u0444\u0438\u0438","User not found":"\u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D","password_placeholder":"\u043F\u0430\u0440\u043E\u043B\u044C","delete":"\u0423\u0434\u0430\u043B\u0438\u0442\u044C","to":"\u043A","publish_in_group":"\u043E\u043F\u0443\u0431\u043B\u0438\u043A\u043E\u0432\u0430\u0442\u044C \u0432 \u0433\u0440\u0443\u043F\u043F\u0435","remove_bookmark":"\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435 \u0438\u0437 \u0437\u0430\u043A\u043B\u0430\u0434\u043A\u0438","error_new_message":"\u041F\u0440\u0438 \u043E\u0442\u043F\u0440\u0430\u0432\u043A\u0435 \u0432\u0430\u0448\u0435\u0433\u043E \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u044F \u043F\u0440\u043E\u0438\u0437\u043E\u0448\u043B\u0430 \u043E\u0448\u0438\u0431\u043A\u0430.","reset_invitation_link":"\u0421\u0431\u0440\u043E\u0441\u0438\u0442\u044C \u0441\u0441\u044B\u043B\u043A\u0443 \u043D\u0430 \u043F\u0440\u0438\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u0435","notifications":"\u0443\u0432\u0435\u0434\u043E\u043C\u043B\u0435\u043D\u0438\u044F","reset_api_key":"\u0421\u0431\u0440\u043E\u0441\u044C\u0442\u0435 \u043A\u043B\u044E\u0447 API (\u0432\u044B \u0431\u0443\u0434\u0435\u0442\u0435 \u043E\u0442\u043A\u043B\u044E\u0447\u0435\u043D\u044B)","name_input":"\u0412\u044B\u0431\u0440\u0430\u0442\u044C \u0438\u043C\u044F","cancel_write":"\u0412\u044B \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0445\u043E\u0442\u0438\u0442\u0435 \u043E\u0442\u043C\u0435\u043D\u0438\u0442\u044C \u043E\u0442\u043F\u0440\u0430\u0432\u043A\u0443 \u043D\u043E\u0432\u043E\u0433\u043E \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u044F?","upload_pdf":"\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C pdf-\u0444\u0430\u0439\u043B","forgot_password":"\u0412\u044B \u0437\u0430\u0431\u044B\u043B\u0438 \u0441\u0432\u043E\u0439 \u043F\u0430\u0440\u043E\u043B\u044C?","bookmark_added":"\u0421\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435 \u0434\u043E\u0431\u0430\u0432\u043B\u0435\u043D\u043E \u0432 \u0437\u0430\u043A\u043B\u0430\u0434\u043A\u0438 !","error_upload":"\u0412\u043E \u0432\u0440\u0435\u043C\u044F \u0437\u0430\u0433\u0440\u0443\u0437\u043A\u0438 \u043F\u0440\u043E\u0438\u0437\u043E\u0448\u043B\u0430 \u043E\u0448\u0438\u0431\u043A\u0430","audio_not_ready":"\u0410\u0443\u0434\u0438\u043E \u0435\u0449\u0435 \u043D\u0435 \u0433\u043E\u0442\u043E\u0432\u043E.","upload_music":"\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u043C\u0443\u0437\u044B\u043A\u0443","invitation_welcome":"\u0414\u043E\u0431\u0440\u043E \u043F\u043E\u0436\u0430\u043B\u043E\u0432\u0430\u0442\u044C \u043D\u0430 Zusam! \u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u0437\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0438\u0440\u0443\u0439\u0442\u0435\u0441\u044C, \u043F\u0440\u0435\u0436\u0434\u0435 \u0447\u0435\u043C \u043F\u0440\u0438\u0441\u043E\u0435\u0434\u0438\u043D\u0438\u0442\u044C\u0441\u044F \u043A \u0433\u0440\u0443\u043F\u043F\u0435.","mark_all_as_read":"\u043E\u0442\u043C\u0435\u0442\u044C\u0442\u0435 \u0432\u0441\u0435 \u043A\u0430\u043A \u043F\u0440\u043E\u0447\u0438\u0442\u0430\u043D\u043D\u043E\u0435","lang":"\u044F\u0437\u044B\u043A","group_updated":"\u0413\u0440\u0443\u043F\u043F\u0430 \u0431\u044B\u043B\u0430 \u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u0430!","users":"\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0438","email_input":"\u0417\u0430\u043F\u043E\u043B\u043D\u0438\u0442\u0435 \u0441\u0432\u043E\u0439 \u0430\u0434\u0440\u0435\u0441 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0439 \u043F\u043E\u0447\u0442\u044B \u0437\u0434\u0435\u0441\u044C","error":"\u041F\u0440\u043E\u0438\u0437\u043E\u0448\u043B\u0430 \u043E\u0448\u0438\u0431\u043A\u0430","Invalid login/password":"\u041D\u0435\u0432\u0435\u0440\u043D\u044B\u0439 \u043B\u043E\u0433\u0438\u043D \u0438/\u0438\u043B\u0438 \u043F\u0430\u0440\u043E\u043B\u044C","logout":"\u0412\u044B\u0445\u043E\u0434 \u0438\u0437 \u0441\u0438\u0441\u0442\u0435\u043C\u044B","groups":"\u0413\u0440\u0443\u043F\u043F\u044B","login":"\u0410\u0432\u0442\u043E\u0440\u0438\u0437\u043E\u0432\u0430\u0442\u044C\u0441\u044F","destroy_account":"\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u0441\u0432\u043E\u0439 \u0430\u043A\u043A\u0430\u0443\u043D\u0442","confirm_password_placeholder":"\u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u0435 \u043F\u0430\u0440\u043E\u043B\u044C","default_group":"\u0413\u0440\u0443\u043F\u043F\u0430 \u043F\u043E \u0443\u043C\u043E\u043B\u0447\u0430\u043D\u0438\u044E","login_placeholder":"\u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u0430\u044F \u043F\u043E\u0447\u0442\u0430","upload_video":"\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0432\u0438\u0434\u0435\u043E","settings":"\u041D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0438","multiple_photos_upload":"\u041F\u0440\u043E\u0438\u0437\u043E\u0448\u043B\u0430 \u043E\u0448\u0438\u0431\u043A\u0430. \u041F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u0437\u0430\u0433\u0440\u0443\u0436\u0430\u0442\u044C \u0438\u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u044F \u043F\u043E \u043E\u0434\u043D\u043E\u043C\u0443 (\u044D\u0442\u043E \u043C\u043E\u0436\u0435\u0442 \u043F\u0440\u043E\u0438\u0437\u043E\u0439\u0442\u0438 \u0432 \u043D\u0435\u043A\u043E\u0442\u043E\u0440\u044B\u0445 \u0431\u0440\u0430\u0443\u0437\u0435\u0440\u0430\u0445)","notification_emails":"\u0423\u0432\u0435\u0434\u043E\u043C\u043B\u0435\u043D\u0438\u044F \u043F\u043E \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0439 \u043F\u043E\u0447\u0442\u0435","signup":"\u0412\u043E\u0439\u0442\u0438","notification_emails_stopped":"\u0423\u0432\u0435\u0434\u043E\u043C\u043B\u0435\u043D\u0438\u044F \u043F\u043E \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0439 \u043F\u043E\u0447\u0442\u0435 \u043E\u0441\u0442\u0430\u043D\u043E\u0432\u043B\u0435\u043D\u044B !","add_bookmark":"\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435 \u0432 \u0437\u0430\u043A\u043B\u0430\u0434\u043A\u0438","public_link":"\u043E\u0431\u0449\u0435\u0434\u043E\u0441\u0442\u0443\u043F\u043D\u0430\u044F \u0441\u0441\u044B\u043B\u043A\u0430","has_posted_in":"\u0440\u0430\u0437\u043C\u0435\u0441\u0442\u0438\u043B \u0432","quit_group":"\u041F\u043E\u043A\u0438\u043D\u0443\u0442\u044C \u0433\u0440\u0443\u043F\u043F\u0443","settings_updated":"\u0412\u0430\u0448\u0438 \u043D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0438 \u0431\u044B\u043B\u0438 \u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u044B","share_message":"\u043F\u043E\u0434\u0435\u043B\u0438\u0442\u044C\u0441\u044F \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435\u043C","empty_message":"\u0421\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435 \u043F\u0443\u0441\u0442\u043E\u0435 \u0438 \u043D\u0435 \u043C\u043E\u0436\u0435\u0442 \u0431\u044B\u0442\u044C \u043E\u0442\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u043E !","bookmarks":"\u0437\u0430\u043A\u043B\u0430\u0434\u043A\u0438"}');


var $8fff5098bed66940$exports = {};
$8fff5098bed66940$exports = JSON.parse('{"login":"\u2D30\u2D3D\u2D5B\u2D30\u2D4E","login_input":"\u2D59\u2D5C\u2D49 \u2D3D\u2D54\u2D30 \u2D4F \u2D53\u2D3D\u2D5B\u2D30\u2D4E","email":"\u2D49\u2D4E\u2D30\u2D62\u2D4D","email_input":"\u2D59\u2D59\u2D49\u2D37\u2D3C \u2D49\u2D4E\u2D30\u2D62\u2D4D \u2D4F\u2D4F\u2D3D \u2D37\u2D30","save_changes":"\u2D43\u2D39\u2D53 \u2D49\u2D59\u2D4F\u2D3C\u2D30\u2D4D\u2D4F","password":"\u2D49\u2D4F\u2D49\u2D33\u2D4D \u2D4F \u2D61\u2D30\u2D37\u2D30\u2D3C","password_input":"\u2D30\u2D54\u2D49 \u2D37\u2D30 \u2D49\u2D4F\u2D49\u2D33\u2D4D \u2D30\u2D4E\u2D30\u2D62\u2D4F\u2D53 \u2D4F \u2D61\u2D30\u2D37\u2D30\u2D3C","delete":"\u2D59\u2D59\u2D3C\u2D39","account":"\u2D30\u2D4E\u2D49\u2D39\u2D30\u2D4F","name":"\u2D49\u2D59\u2D4E","name_input":"\u2D59\u2D5C\u2D49 \u2D3D\u2D54\u2D30 \u2D4F \u2D62\u2D49\u2D59\u2D4E","next_coms":"\u2D65\u2D55 \u2D49\u2D45\u2D3C\u2D30\u2D61\u2D30\u2D4D\u2D4F \u2D49\u2D4E\u2D33\u2D33\u2D53\u2D54\u2D30","ago":"{{duration}} \u2D49\u2D63\u2D54\u2D49\u2D4F","previous_coms":"\u2D65\u2D55 \u2D49\u2D45\u2D3C\u2D30\u2D61\u2D30\u2D4D\u2D4F \u2D49\u2D4E\u2D63\u2D61\u2D53\u2D54\u2D30","groups":"\u2D5C\u2D49\u2D33\u2D54\u2D53\u2D4E\u2D4E\u2D30\u2D61\u2D49\u2D4F","login_placeholder":"\u2D49\u2D4E\u2D30\u2D62\u2D4D","password_placeholder":"\u2D49\u2D4F\u2D49\u2D33\u2D4D \u2D4F \u2D61\u2D30\u2D37\u2D30\u2D3C","submit":"\u2D30\u2D63\u2D4F","new_password_placeholder":"\u2D49\u2D4F\u2D49\u2D33\u2D4D \u2D30\u2D4E\u2D30\u2D62\u2D4F\u2D53 \u2D4F \u2D61\u2D30\u2D37\u2D30\u2D3C","confirm_password_placeholder":"\u2D59\u2D37\u2D37\u2D49\u2D37 \u2D49\u2D4F\u2D49\u2D33\u2D4D \u2D4F \u2D61\u2D30\u2D37\u2D30\u2D3C","text_placeholder":"\u2D30\u2D54\u2D49 \u2D37\u2D30 \u2D5C\u2D30\u2D31\u2D54\u2D30\u2D5C \u2D4F\u2D4F\u2D3D","upload_music":"\u2D54\u2D4F\u2D53 \u2D49\u2D65\u2D30\u2D61\u2D30\u2D4F\u2D4F","connect":"\u2D30\u2D61\u2D30\u2D39","title_placeholder":"\u2D30\u2D63\u2D61\u2D4D \u2D4F \u2D5C\u2D31\u2D54\u2D30\u2D5C \u2D4F\u2D4F\u2D3D (\u2D30\u2D54\u2D53\u2D5B\u2D5B\u2D49\u2D4D)","upload_image":"\u2D54\u2D4F\u2D53 \u2D5C\u2D49\u2D61\u2D4D\u2D30\u2D3C\u2D49\u2D4F","upload_video":"\u2D54\u2D4F\u2D53 \u2D49\u2D3C\u2D49\u2D37\u2D62\u2D53\u2D5C\u2D4F","upload_pdf":"\u2D54\u2D4F\u2D53 pdf","add_date":"\u2D54\u2D4F\u2D53 \u2D3D\u2D54\u2D30 \u2D4F \u2D53\u2D59\u2D30\u2D3D\u2D53\u2D37","logout":"\u2D3C\u2D3C\u2D56","settings":"\u2D5C\u2D49\u2D59\u2D56\u2D30\u2D4D","edit":"\u2D59\u2D33\u2D33\u2D37","lang":"\u2D5C\u2D53\u2D5C\u2D4D\u2D30\u2D62\u2D5C","ask_delete_message":"\u2D49\u2D59 \u2D5C\u2D43\u2D47\u2D47\u2D49\u2D37 \u2D30\u2D37 \u2D5C\u2D3D\u2D3D\u2D59\u2D37 \u2D5C\u2D30\u2D31\u2D54\u2D30\u2D5C \u2D30\u2D37?","Invalid login/password":"\u2D49\u2D5C\u2D5C\u2D30\u2D61\u2D63\u2D33\u2D4D \u2D53\u2D3D\u2D5B\u2D30\u2D4E \u2D37/\u2D4F\u2D49\u2D56 \u2D49\u2D4F\u2D49\u2D33\u2D4D \u2D4F \u2D61\u2D30\u2D37\u2D30\u2D3C","forgot_password":"\u2D49\u2D59 \u2D5C\u2D3B\u2D5C\u2D5C\u2D53\u2D37 \u2D49\u2D4F\u2D49\u2D33\u2D4D \u2D4F \u2D61\u2D30\u2D37\u2D30\u2D3C \u2D4F\u2D4F\u2D3D?","User not found":"\u2D30\u2D4F\u2D59\u2D59\u2D4E\u2D54\u2D59 \u2D53\u2D54 \u2D49\u2D4D\u2D4D\u2D49","group_left":"\u2D5C\u2D3C\u2D3C\u2D56\u2D37 \u2D59\u2D33 \u2D5C\u2D33\u2D54\u2D53\u2D4E\u2D4E\u2D30 !","api_key":"\u2D5C\u2D30\u2D59\u2D30\u2D54\u2D53\u2D5C \u2D4F API","replies_other":"{{count}} \u2D5C\u2D49\u2D4E\u2D54\u2D30\u2D54\u2D53\u2D5C\u2D49\u2D4F","notifications":"\u2D49\u2D59\u2D53\u2D3C\u2D54\u2D49\u2D5C\u2D4F","reset_password_title":"\u2D30\u2D4D\u2D59 \u2D30\u2D59\u2D4F\u2D53\u2D4E \u2D4F \u2D49\u2D4F\u2D49\u2D33\u2D4D \u2D4F \u2D61\u2D30\u2D37\u2D30\u2D3C \u2D4F\u2D4F\u2D3D","passwords_dont_match":"\u2D53\u2D54 \u2D49\u2D4E\u2D59\u2D30\u2D59\u2D30 \u2D49\u2D4F\u2D49\u2D33\u2D4D \u2D4F \u2D61\u2D30\u2D37\u2D30\u2D3C","invitation_link":"\u2D30\u2D59\u2D56\u2D53\u2D4F \u2D4F \u2D53\u2D59\u2D49\u2D33\u2D54","password_reset_mail_sent":"\u2D49\u2D5C\u2D5C\u2D61\u2D30\u2D59\u2D59\u2D49\u2D3C\u2D39 \u2D49\u2D4E\u2D30\u2D62\u2D4D \u2D45\u2D3C \u2D61\u2D30\u2D4D\u2D30\u2D59 \u2D4F \u2D53\u2D59\u2D54\u2D53\u2D59 \u2D4F \u2D49\u2D4F\u2D49\u2D33\u2D4D \u2D4F \u2D61\u2D30\u2D37\u2D30\u2D3C!","error":"\u2D5C\u2D4D\u2D4D\u2D30 \u2D49\u2D5B\u2D5C \u2D4F \u2D5C\u2D63\u2D33\u2D4D\u2D5C","reset_invitation_link":"\u2D30\u2D4D\u2D59 \u2D30\u2D59\u2D4F\u2D53\u2D4E \u2D4F \u2D53\u2D59\u2D56\u2D53\u2D4F \u2D4F \u2D53\u2D59\u2D49\u2D33\u2D54","invitation_welcome":"\u2D30\u2D4F\u2D59\u2D53\u2D3C \u2D49\u2D59\u2D3D \u2D33 Zusam ! \u2D49\u2D45\u2D5A\u2D5A\u2D30 \u2D30\u2D3D \u2D53\u2D63\u2D4E\u2D4E\u2D3B\u2D4E \u2D37\u2D30\u2D5C \u2D4F \u2D53\u2D3D\u2D5B\u2D30\u2D4E \u2D56\u2D54 \u2D5C\u2D33\u2D54\u2D53\u2D4E\u2D4E\u2D30.","signup":"\u2D30\u2D63\u2D4E\u2D4E\u2D3B\u2D4E","create_a_group":"\u2D59\u2D3D\u2D54 \u2D3D\u2D54\u2D30 \u2D4F \u2D5C\u2D33\u2D54\u2D53\u2D4E\u2D4E\u2D30","create_the_group":"\u2D59\u2D3D\u2D54 \u2D5C\u2D30\u2D33\u2D54\u2D53\u2D4E\u2D4E\u2D30","quit_group":"\u2D3C\u2D3C\u2D56 \u2D59\u2D33 \u2D5C\u2D33\u2D54\u2D53\u2D4E\u2D4E\u2D30","settings_updated":"\u2D5C\u2D5C\u2D53\u2D59\u2D4E\u2D30\u2D62\u2D4F\u2D53\u2D4F\u2D5C \u2D5C\u2D59\u2D56\u2D30\u2D4D \u2D4F\u2D4F\u2D3D","group_updated":"\u2D5C\u2D3B\u2D5C\u2D5C\u2D53\u2D59\u2D4E\u2D30\u2D62\u2D4F\u2D53 \u2D5C\u2D33\u2D54\u2D53\u2D4E\u2D4E\u2D30 \u2D4F\u2D4F\u2D3D !","publish_in_group":"\u2D3C\u2D59\u2D54 \u2D33 \u2D5C\u2D33\u2D54\u2D53\u2D4E\u2D4E\u2D30","search_in_group":"\u2D54\u2D63\u2D53 \u2D33 \u2D5C\u2D33\u2D54\u2D53\u2D4E\u2D4E\u2D30","changed_group_name":"\u2D5C\u2D59\u2D4F\u2D3C\u2D4D\u2D37 \u2D49\u2D59\u2D4E \u2D4F \u2D5C\u2D33\u2D54\u2D53\u2D4E\u2D4E\u2D30","to":"\u2D49","mark_all_as_read":"\u2D55\u2D5B\u2D4E \u2D4E\u2D30\u2D55\u2D55\u2D30 \u2D30\u2D4E \u2D49\u2D5C\u2D5C\u2D61\u2D30\u2D56\u2D54\u2D4F","cancel":"\u2D59\u2D59\u2D54","notification_emails":"\u2D49\u2D59\u2D53\u2D3C\u2D54\u2D49\u2D5C\u2D4F \u2D4F \u2D49\u2D4E\u2D30\u2D62\u2D4D","none":"\u2D53\u2D40\u2D53","hourly":"\u2D3D\u2D53 \u2D5C\u2D30\u2D59\u2D54\u2D30\u2D33\u2D5C","daily":"\u2D3D\u2D53 \u2D30\u2D59\u2D59","weekly":"\u2D3D\u2D53 \u2D49\u2D4E\u2D30\u2D4D\u2D30\u2D59\u2D59","monthly":"\u2D3D\u2D53 \u2D30\u2D62\u2D62\u2D53\u2D54","has_joined":"\u2D49\u2D3D\u2D5B\u2D4E","search_without_result":"\u2D53\u2D54 \u2D49\u2D4E\u2D59\u2D30\u2D59\u2D30 \u2D53\u2D54\u2D63\u2D53 \u2D4F\u2D4F\u2D3D \u2D30\u2D3D\u2D37 \u2D3D\u2D54\u2D30\u2D62\u2D33\u2D30\u2D5C\u2D5C \u2D5C\u2D30\u2D31\u2D54\u2D30\u2D5C.","just_now":"\u2D37\u2D56\u2D49 \u2D4F\u2D4F\u2D49\u2D5C","notification_emails_stopped":"\u2D31\u2D37\u2D37\u2D4F \u2D49\u2D59\u2D53\u2D3C\u2D54\u2D49\u2D5C\u2D4F \u2D4F \u2D49\u2D4E\u2D30\u2D62\u2D4D !","destroy_account":"\u2D3D\u2D3D\u2D59 \u2D30\u2D4E\u2D49\u2D39\u2D30\u2D4F \u2D4F\u2D4F\u2D3D","has_posted_in":"\u2D49\u2D5C\u2D5C\u2D61\u2D30\u2D3C\u2D59\u2D54 \u2D33","has_commented_on":"\u2D49\u2D59\u2D3D\u2D54 \u2D30\u2D45\u2D3C\u2D30\u2D61\u2D30\u2D4D \u2D45\u2D3C","has_left":"\u2D49\u2D3C\u2D3C\u2D56","the_message_from":"\u2D5C\u2D30\u2D31\u2D54\u2D30\u2D5C \u2D59\u2D33","in":"\u2D33","reply":"\u2D54\u2D30\u2D54","public_link":"\u2D30\u2D59\u2D56\u2D53\u2D4F \u2D30\u2D4E\u2D30\u2D5C\u2D30\u2D62","default_group":"\u2D5C\u2D30\u2D33\u2D54\u2D53\u2D4E\u2D4E\u2D30 \u2D5C\u2D30\u2D4E\u2D54\u2D37\u2D53\u2D5C","are_you_sure":"\u2D49\u2D59 \u2D5C\u2D43\u2D47\u2D47\u2D49\u2D37?","users":"\u2D49\u2D4F\u2D59\u2D59\u2D4E\u2D54\u2D30\u2D59","share_message":"\u2D31\u2D39\u2D53 \u2D5C\u2D30\u2D31\u2D54\u2D30\u2D5C \u2D30\u2D3C","multiple_photos_upload":"\u2D5C\u2D30\u2D63\u2D33\u2D4D\u2D5C. \u2D30\u2D4D\u2D59 \u2D30\u2D33\u2D30\u2D4E \u2D4F \u2D5C\u2D61\u2D4D\u2D30\u2D3C\u2D49\u2D4F \u2D49\u2D5B\u2D5C \u2D59 \u2D62\u2D49\u2D5B\u2D5C (\u2D49\u2D63\u2D4E\u2D54 \u2D30\u2D37 \u2D62\u2D49\u2D4D\u2D49 \u2D53\u2D62\u2D30\u2D37 \u2D37\u2D49 \u2D3D\u2D54\u2D30 \u2D4F \u2D49\u2D4E\u2D59\u2D59\u2D30\u2D54\u2D30\u2D5C\u2D4F).","error_new_message":"\u2D5C\u2D30\u2D63\u2D33\u2D4D\u2D5C \u2D33 \u2D53\u2D59\u2D49\u2D3C\u2D39 \u2D4F \u2D5C\u2D31\u2D54\u2D30\u2D5C \u2D4F\u2D4F\u2D3D.","cancel_write":"\u2D49\u2D59 \u2D5C\u2D43\u2D47\u2D47\u2D49\u2D37 \u2D53\u2D54 \u2D5C\u2D54\u2D49\u2D37 \u2D30\u2D37 \u2D5C\u2D30\u2D54\u2D49\u2D37 \u2D3D\u2D54\u2D30 \u2D4F \u2D5C\u2D31\u2D54\u2D30\u2D5C \u2D5C\u2D30\u2D4E\u2D30\u2D62\u2D4F\u2D53\u2D5C?","empty_message":"\u2D5C\u2D45\u2D61\u2D30 \u2D5C\u2D31\u2D54\u2D30\u2D5C \u2D53\u2D54 \u2D49\u2D63\u2D54\u2D49 \u2D53\u2D59\u2D49\u2D3C\u2D39 \u2D4F\u2D4F\u2D59 !","group_share_choice":"\u2D4E\u2D30\u2D5C\u2D5C\u2D30 \u2D5C\u2D33\u2D54\u2D53\u2D4E\u2D4E\u2D30 \u2D4F\u2D4F\u2D30 \u2D5C\u2D54\u2D49\u2D37 \u2D30\u2D37 \u2D30\u2D59 \u2D5C\u2D59\u2D59\u2D49\u2D3C\u2D39\u2D37 \u2D5C\u2D30\u2D31\u2D54\u2D30\u2D5C \u2D30\u2D37?","destroy_account_explain":"\u2D4E\u2D5B \u2D5C\u2D3D\u2D3D\u2D59\u2D37 \u2D30\u2D4E\u2D49\u2D39\u2D30\u2D4F \u2D4F\u2D4F\u2D3D, \u2D53\u2D59\u2D30\u2D54 \u2D30\u2D37 \u2D37 \u2D5C\u2D30\u2D56\u2D53\u2D4D\u2D37. \u2D43\u2D47\u2D47\u2D30 \u2D59 \u2D53\u2D62\u2D30\u2D37.","replies_one":"{{count}} \u2D49\u2D54\u2D30\u2D54","error_upload":"\u2D5C\u2D30\u2D63\u2D33\u2D4D\u2D5C \u2D33 \u2D61\u2D30\u2D33\u2D30\u2D4E","add_bookmark":"\u2D54\u2D4F\u2D53 \u2D33 \u2D5C\u2D59\u2D4F\u2D30 \u2D4F \u2D5C\u2D4E\u2D49\u2D5C\u2D30\u2D54","parent_message":"\u2D5C\u2D30\u2D31\u2D54\u2D30\u2D5C \u2D4F \u2D49\u2D4E\u2D30\u2D54\u2D30\u2D61\u2D4F","remove_bookmark":"\u2D3D\u2D3D\u2D59 \u2D5C\u2D30\u2D59\u2D4F\u2D30 \u2D4F \u2D5C\u2D4E\u2D49\u2D5C\u2D30\u2D54","bookmarks":"\u2D5C\u2D30\u2D59\u2D4F\u2D30 \u2D4F \u2D5C\u2D4E\u2D49\u2D5C\u2D30\u2D54","reset_api_key":"\u2D59\u2D4F\u2D3C\u2D4D \u2D5C\u2D30\u2D59\u2D30\u2D54\u2D53\u2D5C \u2D4F API (\u2D54\u2D30\u2D37 \u2D49\u2D5C\u2D5C\u2D61\u2D30\u2D3D\u2D3D\u2D59 \u2D53\u2D4E\u2D62\u2D30\u2D61\u2D30\u2D39 \u2D4F\u2D4F\u2D3D)","video_not_ready":"\u2D49\u2D59\u2D53\u2D4D \u2D53\u2D54 \u2D49\u2D61\u2D4A\u2D49\u2D37 \u2D53\u2D3C\u2D49\u2D37\u2D62\u2D53.","bookmark_added":"\u2D5C\u2D53\u2D37\u2D3C \u2D5C\u2D31\u2D54\u2D30\u2D5C \u2D56\u2D54 \u2D5C\u2D59\u2D4F\u2D30 \u2D4F \u2D5C\u2D4E\u2D49\u2D5C\u2D30\u2D54 !","bookmark_removed":"\u2D5C\u2D3B\u2D5C\u2D5C\u2D61\u2D30\u2D3D\u2D3D\u2D59 \u2D5C\u2D31\u2D54\u2D30\u2D5C \u2D59\u2D33 \u2D5C\u2D59\u2D4F\u2D30 \u2D4F \u2D5C\u2D4E\u2D49\u2D5C\u2D30\u2D54 !","upload_audio":"","audio_not_ready":""}');


var $0b8ec7cf8e82b81b$exports = {};
$0b8ec7cf8e82b81b$exports = JSON.parse('{"password_placeholder":"\u5BC6\u7801","title_placeholder":"\u60A8\u6D88\u606F\u7684\u6807\u9898(\u53EF\u9009)","upload_image":"\u6DFB\u52A0\u56FE\u7247","text_placeholder":"\u5728\u8FD9\u91CC\u8F93\u5165\u60A8\u7684\u6D88\u606F","upload_music":"\u6DFB\u52A0\u97F3\u4E50","upload_pdf":"\u6DFB\u52A0PDF\u6587\u4EF6","add_date":"\u6DFB\u52A0\u65E5\u671F","logout":"\u6CE8\u9500","settings":"\u8BBE\u7F6E","name":"\u59D3\u540D","name_input":"\u9009\u62E9\u4E00\u4E2A\u540D\u79F0","login":"\u767B\u5F55","login_input":"\u9009\u62E9\u4E00\u4E2A\u4EE5\u767B\u5F55","email":"\u7535\u5B50\u90AE\u7BB1","email_input":"\u5728\u8FD9\u91CC\u8F93\u5165\u60A8\u7684\u7535\u5B50\u90AE\u4EF6\u5730\u5740","passwords_dont_match":"\u5BC6\u7801\u4E0D\u4E00\u81F4","invitation_link":"\u9080\u8BF7\u94FE\u63A5","reset_invitation_link":"\u91CD\u8BBE\u9080\u8BF7\u94FE\u63A5","invitation_welcome":"\u6B22\u8FCE\u6765\u5230Zusam ! \u5728\u52A0\u5165\u4E00\u4E2A\u7EC4\u524D,\u8BF7\u5148\u6CE8\u518C\u3002","signup":"\u6CE8\u518C","create_a_group":"\u521B\u5EFA\u7FA4\u7EC4","create_the_group":"\u521B\u5EFA\u7FA4\u7EC4","quit_group":"\u79BB\u5F00\u7FA4\u7EC4","settings_updated":"\u4F60\u7684\u8BBE\u7F6E\u5DF2\u66F4\u65B0","group_left":"\u4F60\u79BB\u5F00\u4E86\u7FA4\u7EC4!","group_updated":"\u7FA4\u7EC4\u5DF2\u66F4\u65B0!","multiple_photos_upload":"\u53D1\u751F\u9519\u8BEF\u3002 \u8BF7\u5C1D\u8BD5\u9010\u4E2A\u4E0A\u4F20\u56FE\u50CF(\u5728\u67D0\u4E9B\u6D4F\u89C8\u5668\u4E2D\u53EF\u80FD\u4F1A\u53D1\u751F\u8FD9\u79CD\u60C5\u51B5)\u3002","error_new_message":"\u53D1\u9001\u6D88\u606F\u65F6\u51FA\u9519\u3002","error_upload":"\u4E0A\u4F20\u51FA\u9519","cancel_write":"\u662F\u5426\u786E\u5B9E\u8981\u53D6\u6D88\u7F16\u5199\u65B0\u6D88\u606F?","empty_message":"\u65E0\u6CD5\u53D1\u9001\u7A7A\u6D88\u606F!","notification_emails":"\u7535\u5B50\u90AE\u4EF6\u901A\u77E5","destroy_account_explain":"\u4E00\u65E6\u60A8\u5220\u9664\u4E86\u8D26\u6237,\u60A8\u5C06\u65E0\u6CD5\u64A4\u9500\u672C\u64CD\u4F5C! \u8BF7\u786E\u8BA4\u3002","replies_one":"{{count}}\u56DE\u590D","replies_other":"{{count}}\u56DE\u590D\u4E86","publish_in_group":"\u5728\u7FA4\u7EC4\u91CC\u53D1\u5E03","search_in_group":"\u5728\u6B64\u7FA4\u7EC4\u4E2D\u641C\u7D22","changed_group_name":"\u66F4\u6539\u4E86\u7EC4\u7684\u540D\u79F0","to":"\u5230","notifications":"\u901A\u77E5","mark_all_as_read":"\u5168\u90E8\u5DF2\u8BFB","search_without_result":"\u6CA1\u6709\u5339\u914D\u7684\u6D88\u606F\u3002","add_bookmark":"\u4E3A\u6D88\u606F\u6DFB\u52A0\u4E66\u7B7E","previous_coms":"\u67E5\u770B\u4EE5\u524D\u7684\u8BC4\u8BBA","next_coms":"\u67E5\u770B\u4E0B\u4E00\u4E2A\u8BC4\u8BBA","ago":"{{duration}}\u524D","groups":"\u7EC4","login_placeholder":"\u7535\u5B50\u90AE\u7BB1","new_password_placeholder":"\u65B0\u5BC6\u7801","confirm_password_placeholder":"\u786E\u8BA4\u5BC6\u7801","connect":"\u8FDE\u63A5","submit":"\u63D0\u4EA4","save_changes":"\u4FDD\u5B58\u66F4\u6539","password":"\u5BC6\u7801","password_input":"\u5728\u6B64\u8F93\u5165\u60A8\u7684\u7684\u5BC6\u7801","Invalid login/password":"\u7528\u6237\u540D\u6216\u5BC6\u7801\u9519\u8BEF","edit":"\u7F16\u8F91","delete":"\u5220\u9664","account":"\u8D26\u6237","forgot_password":"\u5FD8\u8BB0\u4F60\u7684\u5BC6\u7801\u4E86\u5417?","password_reset_mail_sent":"\u5BC6\u7801\u91CD\u7F6E\u90AE\u4EF6\u5DF2\u53D1\u9001!","User not found":"\u7528\u6237\u4E0D\u5B58\u5728","reset_password_title":"\u91CD\u7F6E\u60A8\u7684\u5BC6\u7801","error":"\u51FA\u9519\u4E86","ask_delete_message":"\u4F60\u786E\u5B9A\u8981\u5220\u9664\u6B64\u6D88\u606F\u5417?","cancel":"\u53D6\u6D88","just_now":"\u521A\u521A","none":"\u65E0","hourly":"\u6BCF\u5C0F\u65F6","daily":"\u6BCF\u5929","weekly":"\u6BCF\u5468","monthly":"\u6BCF\u6708","notification_emails_stopped":"\u5DF2\u505C\u7528\u90AE\u4EF6\u63D0\u9192!","public_link":"\u516C\u5171\u94FE\u63A5","default_group":"\u9ED8\u8BA4\u7FA4\u7EC4","destroy_account":"\u5220\u9664\u60A8\u7684\u8D26\u6237","are_you_sure":"\u60A8\u786E\u5B9A\u5417?","share_message":"\u5206\u4EAB\u6B64\u6D88\u606F","users":"\u7528\u6237","has_posted_in":"\u5DF2\u53D1\u5E03\u4E8E","has_commented_on":"\u8BC4\u8BBA\u4E8E","has_joined":"\u5DF2\u52A0\u5165","has_left":"\u5DF2\u9000\u51FA","the_message_from":"\u6D88\u606F\u6765\u81EA","in":"\u91CC","lang":"\u8BED\u8A00","reply":"\u56DE\u590D","remove_bookmark":"\u4E3A\u6D88\u606F\u79FB\u9664\u4E66\u7B7E","bookmarks":"\u4E66\u7B7E","api_key":"API\u5BC6\u94A5","reset_api_key":"\u91CD\u7F6EAPI\u5BC6\u94A5(\u60A8\u5C06\u4F1A\u65AD\u5F00\u8FDE\u63A5)","video_not_ready":"\u89C6\u9891\u5C1A\u672A\u51C6\u5907\u597D\u3002","bookmark_added":"\u6D88\u606F\u5DF2\u6DFB\u52A0\u5230\u4E66\u7B7E!","bookmark_removed":"\u6D88\u606F\u5DF2\u4ECE\u4E66\u7B7E\u4E2D\u79FB\u9664!","parent_message":"\u7236\u6D88\u606F","group_share_choice":"\u60A8\u60F3\u5C06\u6B64\u6D88\u606F\u53D1\u9001\u5230\u54EA\u4E2A\u7FA4\u7EC4?","audio_not_ready":"\u97F3\u9891\u5C1A\u672A\u51C6\u5907\u597D\u3002","upload_video":"\u6DFB\u52A0\u89C6\u9891","upload_audio":"\u6DFB\u52A0\u97F3\u9891\u6587\u4EF6\u3002"}');


const $a1c13afdb4e96f13$export$9a771d6906431624 = {
    possibleLang: {
        cs_CZ: "\u010De\u0161tina",
        de_DE: "Deutsch",
        en_US: "english",
        es_ES: "espa\xf1ol",
        fr_FR: "fran\xe7ais",
        hu_HU: "magyar nyelv",
        ko_KR: "\uD55C\uAD6D\uC5B4",
        nl_NL: "Nederlands",
        ru_RU: "\u0420\u0443\u0441\u0441\u043A\u0438\u0439",
        sk_SK: "Slovensk\xfd",
        zgh: "\u2D5C\u2D30\u2D4E\u2D30\u2D63\u2D49\u2D56\u2D5C",
        zh_Hans: "\u4E2D\u6587"
    },
    // possible dicts names to load
    getDefaultLang: ()=>(document.querySelector("meta[name='zusam:default-lang']") || {}).content || "en_US",
    getCurrentLang: ()=>(0, $c6f88c2c6ea3c4b1$export$2e2bcd8739ae039).lang || $a1c13afdb4e96f13$export$9a771d6906431624.getDefaultLang()
};
(0, $cb95bcae1947788f$export$2e2bcd8739ae039).use((0, $f4663bfcfe4ffd82$export$ae7e14d40d89f296)).init({
    resources: {
        cs_CZ: {
            translation: (0, (/*@__PURE__*/$parcel$interopDefault($f4e9a5159a153fa2$exports)))
        },
        de_DE: {
            translation: (0, (/*@__PURE__*/$parcel$interopDefault($d03e13a2cf004f69$exports)))
        },
        en: {
            translation: (0, (/*@__PURE__*/$parcel$interopDefault($fb625c47b8ebabfd$exports)))
        },
        // backwards compatibility, remove for 0.6
        en_US: {
            translation: (0, (/*@__PURE__*/$parcel$interopDefault($fb625c47b8ebabfd$exports)))
        },
        es_ES: {
            translation: (0, (/*@__PURE__*/$parcel$interopDefault($0d0d79d0d4f00eca$exports)))
        },
        es: {
            translation: (0, (/*@__PURE__*/$parcel$interopDefault($0d0d79d0d4f00eca$exports)))
        },
        // backwards compatibility, remove for 0.6
        fr_FR: {
            translation: (0, (/*@__PURE__*/$parcel$interopDefault($56575d19017aef25$exports)))
        },
        fr: {
            translation: (0, (/*@__PURE__*/$parcel$interopDefault($56575d19017aef25$exports)))
        },
        // backwards compatibility, remove for 0.6
        hu_HU: {
            translation: (0, (/*@__PURE__*/$parcel$interopDefault($99d33bf86d13fec0$exports)))
        },
        ko_KR: {
            translation: (0, (/*@__PURE__*/$parcel$interopDefault($c8ec0615535ae05c$exports)))
        },
        nl_NL: {
            translation: (0, (/*@__PURE__*/$parcel$interopDefault($6d1e59a43645a5df$exports)))
        },
        nl: {
            translation: (0, (/*@__PURE__*/$parcel$interopDefault($6d1e59a43645a5df$exports)))
        },
        // backwards compatibility, remove for 0.6
        ru_RU: {
            translation: (0, (/*@__PURE__*/$parcel$interopDefault($68505c5527d81c5f$exports)))
        },
        sk_SK: {
            translation: (0, (/*@__PURE__*/$parcel$interopDefault($ff7a0be7f7b1420f$exports)))
        },
        sk: {
            translation: (0, (/*@__PURE__*/$parcel$interopDefault($ff7a0be7f7b1420f$exports)))
        },
        // backwards compatibility, remove for 0.6
        zgh: {
            translation: (0, (/*@__PURE__*/$parcel$interopDefault($8fff5098bed66940$exports)))
        },
        zh_Hans: {
            translation: (0, (/*@__PURE__*/$parcel$interopDefault($0b8ec7cf8e82b81b$exports)))
        }
    },
    lng: $a1c13afdb4e96f13$export$9a771d6906431624.getCurrentLang(),
    // if you're using a language detector, do not define the lng option
    fallbackLng: $a1c13afdb4e96f13$export$9a771d6906431624.getDefaultLang(),
    interpolation: {
        escapeValue: false // react already safes from xss => https://www.i18next.com/translation-function/interpolation#unescape
    }
});


// Stateless utilities
// Should be agnostic of other components of zusam if possible
const $30ef6c271b4e9124$var$util = {
    // check if the input is a valid URL
    isValidUrl: (url)=>{
        try {
            new URL(url);
            return true;
        } catch (_) {
            return false;
        }
    },
    limitLength: (string, size = 20)=>{
        return [
            ...string.split("").slice(0, Math.floor(size / 2)),
            string.length > size ? "..." : "",
            ...string.split("").slice(Math.floor(size / 2)).slice(Math.floor(size / 2) * -1)
        ].join("");
    },
    escapeRegex: (string)=>{
        return string.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&");
    },
    getSubpath: ()=>new URL(document.baseURI).pathname.replace(/\/$/, ""),
    // toApp transforms an api url into an "app" url that the user can naviate to
    toApp: (url)=>{
        if (!url || typeof url != "string") return "";
        if ($30ef6c271b4e9124$var$util.isValidUrl(url)) return url;
        return location.origin + $30ef6c271b4e9124$var$util.getSubpath() + url;
    },
    // genId starts with a letter to be DOM friendly
    // seed can be used to order ids
    // TODO improve using ideas from ai/nanoid
    genId: (seed)=>`z${seed || ""}-${Date.now().toString().slice(-5)}${Math.random().toString().slice(-5)}`,
    // transform an id into int for the API (TODO: revisit this on 0.5)
    id2Int: (id)=>parseInt(id.replace(/[^\d]/g, ""), 10),
    urlRegExp: /(\([^()]*)?https?:\/\/[^[\]\n\r ]*[-A-Za-z0-9+&@#/%=~_()|]/i,
    getUrl: (txt)=>{
        if (!txt) return "";
        let url = txt.match($30ef6c271b4e9124$var$util.urlRegExp);
        if (url && url[0].startsWith("(")) {
            let link = url[0].match(/https?:\/\//i);
            url["index"] += link["index"];
            url[0] = url[0].slice(link["index"]);
            if (url[0].endsWith(")")) url[0] = url[0].slice(0, -1);
        }
        return url;
    },
    limitStrSize: (str, limit)=>str.length > limit ? `${str.slice(0, limit - 3)}...` : str,
    // full datetime as a string adapted to the users timezone
    humanFullDate: (timestamp)=>{
        if (!timestamp) return "";
        let d = new Date(timestamp * 1000);
        d = new Date(d.getTime() + d.getTimezoneOffset() * -60000);
        return d.toISOString().replace("T", " ").replace(/\..*$/, "");
    },
    // duration relative to event
    humanTime: (timestamp)=>{
        if (!timestamp) return null;
        const duration = Math.abs(Math.round((Date.now() / 1000 - timestamp) / 60));
        if (duration < 1) return (0, $cb95bcae1947788f$export$2e2bcd8739ae039).t("just_now");
        if (duration < 60) return (0, $cb95bcae1947788f$export$2e2bcd8739ae039).t("ago", {
            duration: `${duration}mn`
        });
        if (duration < 1440) return (0, $cb95bcae1947788f$export$2e2bcd8739ae039).t("ago", {
            duration: `${Math.floor(duration / 60)}h`
        });
        return $30ef6c271b4e9124$var$util.humanFullDate(timestamp).split(" ")[0];
    },
    // get the id of an object from an url
    getId: (e)=>{
        switch(typeof e){
            case "object":
                return e ? e.id : null;
            case "string":
                return e.split("/").pop().replace(/\?.*$/, "").replace(/\.\w+$/, "");
            default:
                console.error(e);
                throw "Could not extract id !";
        }
    },
    // get the url to a thubmnail
    thumbnail: (id, width, height = 99999)=>typeof id == "string" && !id.startsWith("z") ? $30ef6c271b4e9124$var$util.toApp(`/api/images/thumbnail/${width}/${height}/${id}`) : null,
    // same as http.thumbnail but for a crop
    crop: (id, width, height)=>typeof id == "string" && !id.startsWith("z") ? $30ef6c271b4e9124$var$util.toApp(`/api/images/crop/${width}/${height}/${id}`) : null,
    // default avatar in base64
    defaultAvatar: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAgAAAAIAAQMAAADOtka5AAAABlBMVEUAAAD///+l2Z/dAAAAAnRSTlMA/iyWEiMAAAMJSURBVHja7ZtBjpwwEEWxmIhFFmiURZZEyi6HCLkZHCXr2eQKHIUjoEiRSGRRiWB6klaDU/hDF4z+W6LuNz3+ZRvbkCSEEEIIIYQQQgghhBBCCCGEEEIIITvwGfy+kxoTpNJigkw6TJBLjwkK8ZiglMFYUInAAqwQRKRBBR0q8FhXEKwVR0GLCvxCjeo6oyzkoIxnEvj5661acPO3yvFqpxdcV+Pj88VeNZ7cGB4ul1QFkv399KT4KBIpmGEwF4i9oL6DIN/3FzToL2ju8AvsBeE2aNFfQMFJBCkF0/R+bkHyCgSVuaDcVaC5zyvMBTkqyHYVaBZDKSpw5oJgLcMC5doXFBSoIMNutjcQBHJULmlhQYUKlmNQbs9kqGC5P2o3FqBBOVjMWkEOdcZQKam3dyqkkgP/g35zxmEpLhbjir0ZFz2tXHgbPR5deI+EMPKmig/hhU/fIkOYL4iYDbIyqpCXajp2Zy4yhNuxqUfbMCaEIraQZ9swJgQBQ0jBQr6eYXrzQrYIYdtC9uaFbDKayJajyTkL+VijyWA+mnBajGpDeFrMzAu5BNvwKoQBDaFHQ+jQEBo0hBoMYUBD8GgIHRpCi44mcAiJRQhoITvzQs63LGQxL2SOJnEhiHUI296bwNOixb1JYr5kz8yX7Odf6XDfBC9kd6yVzq+np69QIY/8AEJ45kt0T4hIM0VONm5CiLlVhLflS+CwdTGEVa2AnfOFTogaVAAfcg1QivpqzLFHD4LnrR0q8FAhqlux3PPUu0EFLSrooL6kLeaQwKMCTY4OfUjVoY+IOvTxSFiw81NtnbmgRwXeXDAg08IxBPIKBPX5BQ0FBxC0+wtSCg4gcBT853nruwiqfQXNHQT/LDiGD9Old6sEL2umn3MtqxDks9NotVbwfaG+FDfL6fznsjV32365cTXrtqoPdJKYrbmreIDvT42DCMYoIUEu4FvIKSpwgr6JvYEAfJm8QgUl+j58gb6Rn4Nvcv/p0jUmcODr8IQQQgghhBBCCCGEEEIIIYQQQgghs/wGp6uYgtiKODIAAAAASUVORK5CYII=",
    hash: (str)=>str.split("").reduce((a, c)=>(a << 5) - a + c.charCodeAt() | 0),
    colorHash: (str)=>[
            "#000000",
            "#333366",
            "#333399",
            "#3333CC",
            "#339933",
            "#339999",
            "#33CC33",
            "#33CC99",
            "#663333",
            "#663366",
            "#666633",
            "#666699",
            "#66CC33",
            "#66CCCC",
            "#993333",
            "#993366",
            "#993399",
            "#996633",
            "#999966",
            "#CC3333",
            "#CC3366",
            "#CC3399",
            "#CC33CC",
            "#CC6633",
            "#CC9933",
            "#CC99CC",
            "#CCCC33"
        ][Math.abs($30ef6c271b4e9124$var$util.hash(str)) % 27],
    backgroundHash: (str)=>{
        if (!str) return "background-color: #aaa;";
        let c1 = $30ef6c271b4e9124$var$util.colorHash(str);
        let c2 = $30ef6c271b4e9124$var$util.colorHash(str.split("").reverse().join("."));
        let deg = 45 * (Math.abs($30ef6c271b4e9124$var$util.hash(str)) % 4);
        return `background-color:${c1};background-image:linear-gradient(${deg}deg, ${c2} 15%, transparent 15% 30%, ${c2} 30% 45%, transparent 45% 60%, ${c2} 60% 75%, transparent 75% 90%, ${c2} 90%);`;
    },
    // Accepts a keydown event and checks if it's enter. Compatibility between browsers
    // We do it the permissive way
    is_it_enter: (e)=>{
        return e.keyCode == 13 || e.keyCode == 10 || e.key == "Enter" || e.key == "\u21B5" || e.code == "Enter";
    },
    getVersion: ()=>(document.querySelector("meta[name='zusam:version']") || {}).content || "unknown",
    getWidthBreakpoint: ()=>{
        if (window.innerWidth > 1800) return 1800;
        if (window.innerWidth > 1400) return 1400;
        if (window.innerWidth > 992) return 992;
        if (window.innerWidth > 768) return 768;
        if (window.innerWidth > 576) return 576;
        return window.innerWidth;
    }
};
var $30ef6c271b4e9124$export$2e2bcd8739ae039 = $30ef6c271b4e9124$var$util;


const $dcc08ede0b85ca51$var$http = {
    sendFile: (formData, loadFn, progressFn = null, errorFn = null)=>{
        return (0, $a43f12068c4c782d$export$2e2bcd8739ae039).get("apiKey").then((apiKey)=>{
            let xhr = new XMLHttpRequest();
            xhr.open("POST", `${document.baseURI}api/files`, true);
            xhr.setRequestHeader("X-AUTH-TOKEN", apiKey);
            xhr.addEventListener("load", (e)=>{
                if (e.target.status > 199 && e.target.status < 300) loadFn(JSON.parse(e.target.response));
                else if (errorFn) errorFn(e.target.statusText);
                else console.error(e.target.statusText);
            });
            if (progressFn) xhr.upload.onprogress = (e)=>progressFn({
                    loaded: e.loaded,
                    total: e.total
                });
            if (errorFn) xhr.addEventListener("error", (e)=>errorFn(e));
            xhr.send(formData);
        }).catch((error)=>(0, $7e84e1a08353bb30$export$2e2bcd8739ae039).add(error, "alert-danger"));
    },
    get: (url, nocache = false, delay = 0)=>{
        return (0, $a43f12068c4c782d$export$2e2bcd8739ae039).get("apiKey").then((x)=>new Promise((resolve)=>setTimeout(()=>resolve(x), delay))).then((apiKey)=>{
            url = (0, $30ef6c271b4e9124$export$2e2bcd8739ae039).toApp(url);
            if (!url) return;
            let h = {};
            if (apiKey) h["X-AUTH-TOKEN"] = apiKey;
            if (nocache) h["X-NOCACHE"] = "nocache";
            return fetch(url, {
                method: "GET",
                headers: new Headers(h)
            }).then((res)=>res.ok && res.json()).catch((err)=>console.warn(`ERROR for ${url}`, err));
        }).catch((error)=>(0, $7e84e1a08353bb30$export$2e2bcd8739ae039).add(error, "alert-danger"));
    },
    post: (url, data, delay = 0, contentType = "application/json")=>$dcc08ede0b85ca51$var$http.request(url, data, "POST", delay, contentType),
    put: (url, data, delay = 0, contentType = "application/json")=>$dcc08ede0b85ca51$var$http.request(url, data, "PUT", delay, contentType),
    delete: (url, data, delay = 0, contentType = "application/json")=>$dcc08ede0b85ca51$var$http.request(url, null, "DELETE", delay, contentType),
    request: (url, data, method, delay = 0, contentType = "application/json")=>{
        return (0, $a43f12068c4c782d$export$2e2bcd8739ae039).get("apiKey").then((x)=>new Promise((resolve)=>setTimeout(()=>resolve(x), delay))).then((apiKey)=>{
            url = (0, $30ef6c271b4e9124$export$2e2bcd8739ae039).toApp(url);
            if (!url) return;
            let h = {};
            if (apiKey) h["X-AUTH-TOKEN"] = apiKey;
            if (contentType) h["Content-type"] = contentType;
            let fetchOptions = {
                method: method,
                headers: new Headers(h)
            };
            if (data) fetchOptions.body = typeof data == "object" && data.constructor.name == "Object" ? JSON.stringify(data) : data;
            return fetch(url, fetchOptions).then((res)=>{
                try {
                    if (method != "DELETE") return res.json();
                    return {};
                } catch (exception) {
                    console.warn(exception.message);
                    return Promise.reject(exception.message);
                }
            }).catch((err)=>console.warn(`ERROR for ${url}`, err));
        }).catch((error)=>(0, $7e84e1a08353bb30$export$2e2bcd8739ae039).add(error, "alert-danger"));
    }
};
var $dcc08ede0b85ca51$export$2e2bcd8739ae039 = $dcc08ede0b85ca51$var$http;



const $2d00f79f92830cb9$var$api = {
    get info () {
        return (0, $b7ae12cde431bd4b$export$2e2bcd8739ae039).get()?.api;
    },
    update: ()=>(0, $dcc08ede0b85ca51$export$2e2bcd8739ae039).get("/api/info", true).then((r)=>{
            if (!r) return;
            (0, $b7ae12cde431bd4b$export$2e2bcd8739ae039).dispatch("api/update", Object.assign({}, r));
            setTimeout(dispatchEvent(new CustomEvent("apiStateChange")));
            return r;
        })
};
var $2d00f79f92830cb9$export$2e2bcd8739ae039 = $2d00f79f92830cb9$var$api;







const $3f4f2fd808a213d2$var$notifications = {
    LIMIT: 20,
    get () {
        return (0, $b7ae12cde431bd4b$export$2e2bcd8739ae039).get()?.notifications || [];
    },
    update () {
        return (0, $dcc08ede0b85ca51$export$2e2bcd8739ae039).get(`/api/me/notifications/${$3f4f2fd808a213d2$var$notifications.LIMIT + 1}`).then((r)=>{
            (0, $b7ae12cde431bd4b$export$2e2bcd8739ae039).dispatch("notifications/update", r);
        });
    },
    isNew (id) {
        let state = (0, $b7ae12cde431bd4b$export$2e2bcd8739ae039).get();
        if (Array.isArray(state["notifications"])) return state.notifications.filter((n)=>!n.read).some((n)=>$3f4f2fd808a213d2$var$notifications.matchNotification(n, id) || n.type == "new_comment" && n.fromMessage.id === id);
        return false;
    },
    removeAllNotifications () {
        let state = (0, $b7ae12cde431bd4b$export$2e2bcd8739ae039).get();
        if (Array.isArray(state["notifications"])) state.notifications.forEach((n)=>{
            (0, $dcc08ede0b85ca51$export$2e2bcd8739ae039).delete(`/api/notifications/${n.id}`).then(()=>{
                (0, $b7ae12cde431bd4b$export$2e2bcd8739ae039).dispatch("notifications/remove", n);
            });
        });
    },
    markAllNotificationsAsRead () {
        let state = (0, $b7ae12cde431bd4b$export$2e2bcd8739ae039).get();
        if (Array.isArray(state["notifications"])) state.notifications.forEach((n)=>{
            (0, $dcc08ede0b85ca51$export$2e2bcd8739ae039).put(`/api/notifications/${n.id}`, {
                read: true
            }).then(()=>{
                (0, $b7ae12cde431bd4b$export$2e2bcd8739ae039).dispatch("notifications/read", n);
            });
        });
    },
    removeMatchingNotifications (id) {
        return Promise.all((0, $b7ae12cde431bd4b$export$2e2bcd8739ae039).get().notifications.filter((n)=>$3f4f2fd808a213d2$var$notifications.matchNotification(n, id)).map((n)=>{
            (0, $dcc08ede0b85ca51$export$2e2bcd8739ae039).delete(`/api/notifications/${n.id}`).then(()=>{
                (0, $b7ae12cde431bd4b$export$2e2bcd8739ae039).dispatch("notifications/remove", n);
            });
        }));
    },
    markAsRead (id) {
        return Promise.all((0, $b7ae12cde431bd4b$export$2e2bcd8739ae039).get().notifications.filter((n)=>$3f4f2fd808a213d2$var$notifications.matchNotification(n, id)).map((n)=>{
            (0, $dcc08ede0b85ca51$export$2e2bcd8739ae039).put(`/api/notifications/${n.id}`, {
                read: true
            }).then(()=>{
                (0, $b7ae12cde431bd4b$export$2e2bcd8739ae039).dispatch("notifications/read", n);
            });
        }));
    },
    matchNotification (notif, id) {
        if (notif.id === id) return true;
        if (notif.target === id) return true;
        return false;
    }
};
var $3f4f2fd808a213d2$export$2e2bcd8739ae039 = $3f4f2fd808a213d2$var$notifications;




const $df5f845658677a96$var$bookmarks_utils = {
    LIMIT: 1000,
    get () {
        return (0, $b7ae12cde431bd4b$export$2e2bcd8739ae039).get()?.bookmarks || [];
    },
    update () {
        return (0, $dcc08ede0b85ca51$export$2e2bcd8739ae039).get(`/api/me/bookmarks/${$df5f845658677a96$var$bookmarks_utils.LIMIT + 1}`).then((r)=>{
            (0, $b7ae12cde431bd4b$export$2e2bcd8739ae039).dispatch("bookmarks/update", r);
        });
    }
};
var $df5f845658677a96$export$2e2bcd8739ae039 = $df5f845658677a96$var$bookmarks_utils;





const $f85ec4af9c25b4e6$var$router = {
    get () {
        return (0, $b7ae12cde431bd4b$export$2e2bcd8739ae039).get();
    },
    get route () {
        try {
            return $f85ec4af9c25b4e6$var$router.removeSubpath(location.pathname).slice(1).split("/")[0];
        } catch  {
            return "";
        }
    },
    get id () {
        try {
            return $f85ec4af9c25b4e6$var$router.removeSubpath(location.pathname).slice(1).split("/")[1];
        } catch  {
            return "";
        }
    },
    get action () {
        try {
            return $f85ec4af9c25b4e6$var$router.removeSubpath(location.pathname).slice(1).split("/")[2];
        } catch  {
            return "";
        }
    },
    get backUrl () {
        console.err("don't use backUrl");
        return (0, $b7ae12cde431bd4b$export$2e2bcd8739ae039).get()?.backUrl;
    },
    get search () {
        return location.search.slice(1);
    },
    getEntity () {
        if ($f85ec4af9c25b4e6$var$router.isEntity($f85ec4af9c25b4e6$var$router.route)) return (0, $dcc08ede0b85ca51$export$2e2bcd8739ae039).get(`/api/${$f85ec4af9c25b4e6$var$router.route}/${$f85ec4af9c25b4e6$var$router.id}`);
        return Promise.resolve(null);
    },
    get entity () {
        console.err("don't use entity");
        return (0, $b7ae12cde431bd4b$export$2e2bcd8739ae039).get()?.entity;
    },
    removeSubpath: (path)=>path ? path.replace(new RegExp(`^${(0, $30ef6c271b4e9124$export$2e2bcd8739ae039).getSubpath()}`), "") : "",
    getParam: (param, searchParams = window.location.search.substring(1))=>{
        let res = searchParams.split("&").find((e)=>e.split("=")[0] === param);
        return res ? decodeURIComponent(res.split("=")[1]) : "";
    },
    getSegments: ()=>$f85ec4af9c25b4e6$var$router.removeSubpath(window.location.pathname).slice(1).split("?")[0].split("/"),
    // check if route is "outside": accessible to non connected user
    isOutside: ()=>[
            "login",
            "password-reset",
            "signup",
            "invitation",
            "stop-notification-emails",
            "public"
        ].includes($f85ec4af9c25b4e6$var$router.route || $f85ec4af9c25b4e6$var$router.getSegments()[0]),
    isEntity: ()=>[
            "messages",
            "groups",
            "users",
            "links",
            "files"
        ].includes($f85ec4af9c25b4e6$var$router.getSegments()[0]),
    getUrlComponents: (url)=>{
        let components = {};
        if (url) {
            components.url = new URL(url);
            components.path = components.url.pathname;
            components.search = components.url.search.slice(1);
            [components.route, components.id, components.action] = $f85ec4af9c25b4e6$var$router.removeSubpath(components.path).slice(1).split("/");
        }
        components.entityType = "";
        components.backUrl = "";
        return components;
    }
};
var $f85ec4af9c25b4e6$export$2e2bcd8739ae039 = $f85ec4af9c25b4e6$var$router;




const $cd2f6546c5cf5c32$export$5ea928c9faf85bd3 = (0, $7e84e1a08353bb30$export$2e2bcd8739ae039);
const $cd2f6546c5cf5c32$export$644d8ea042df96a6 = (0, $2d00f79f92830cb9$export$2e2bcd8739ae039);
const $cd2f6546c5cf5c32$export$7d6f1c8842f9f527 = (0, $dcc08ede0b85ca51$export$2e2bcd8739ae039);
const $cd2f6546c5cf5c32$export$9a771d6906431624 = (0, $a1c13afdb4e96f13$export$9a771d6906431624);
const $cd2f6546c5cf5c32$export$a7357cdd1f0b0168 = (0, $cb95bcae1947788f$export$2e2bcd8739ae039);
const $cd2f6546c5cf5c32$export$3e32638432616b6 = (0, $c6f88c2c6ea3c4b1$export$2e2bcd8739ae039);
const $cd2f6546c5cf5c32$export$6008d97729a90c74 = (0, $3f4f2fd808a213d2$export$2e2bcd8739ae039);
const $cd2f6546c5cf5c32$export$a4ea57bd994c1f0d = (0, $df5f845658677a96$export$2e2bcd8739ae039);
const $cd2f6546c5cf5c32$export$5375cda95f0b0eb4 = (0, $f85ec4af9c25b4e6$export$2e2bcd8739ae039);
const $cd2f6546c5cf5c32$export$ddcffe0146c8f882 = (0, $a43f12068c4c782d$export$2e2bcd8739ae039);
const $cd2f6546c5cf5c32$export$7debb50ef11d5e0b = (0, $30ef6c271b4e9124$export$2e2bcd8739ae039);






/**
 * React Router DOM v6.17.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
/**
 * React Router v6.17.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
/**
 * @remix-run/router v1.10.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $c846480b5114588d$var$_extends() {
    $c846480b5114588d$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $c846480b5114588d$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $c846480b5114588d$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($c846480b5114588d$export$e19cd5f9376f8cee || ($c846480b5114588d$export$e19cd5f9376f8cee = {}));
const $c846480b5114588d$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $c846480b5114588d$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $c846480b5114588d$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $c846480b5114588d$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $c846480b5114588d$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $c846480b5114588d$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $c846480b5114588d$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $c846480b5114588d$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $c846480b5114588d$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $c846480b5114588d$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $c846480b5114588d$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $c846480b5114588d$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $c846480b5114588d$export$fe53371bee54353d(to);
    }
    return $c846480b5114588d$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $c846480b5114588d$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $c846480b5114588d$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $c846480b5114588d$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $c846480b5114588d$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $c846480b5114588d$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $c846480b5114588d$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $c846480b5114588d$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $c846480b5114588d$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $c846480b5114588d$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $c846480b5114588d$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $c846480b5114588d$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $c846480b5114588d$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $c846480b5114588d$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $c846480b5114588d$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $c846480b5114588d$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $c846480b5114588d$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $c846480b5114588d$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $c846480b5114588d$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($c846480b5114588d$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $c846480b5114588d$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $c846480b5114588d$export$e19cd5f9376f8cee.Push;
        let location = $c846480b5114588d$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $c846480b5114588d$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $c846480b5114588d$export$e19cd5f9376f8cee.Replace;
        let location = $c846480b5114588d$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $c846480b5114588d$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $c846480b5114588d$export$fe53371bee54353d(to);
        $c846480b5114588d$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($c846480b5114588d$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($c846480b5114588d$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $c846480b5114588d$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($c846480b5114588d$var$ResultType || ($c846480b5114588d$var$ResultType = {}));
const $c846480b5114588d$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $c846480b5114588d$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $c846480b5114588d$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            index
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $c846480b5114588d$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $c846480b5114588d$export$3e9cee6b33872309(!manifest[id], 'Found a route id collision on id "' + id + '".  Route ' + "id's must be globally unique within Data Router usages");
        if ($c846480b5114588d$var$isIndexRoute(route)) {
            let indexRoute = $c846480b5114588d$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $c846480b5114588d$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $c846480b5114588d$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/utils/match-routes
 */ function $c846480b5114588d$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    let location = typeof locationArg === "string" ? $c846480b5114588d$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $c846480b5114588d$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $c846480b5114588d$var$flattenRoutes(routes);
    $c846480b5114588d$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i)matches = $c846480b5114588d$var$matchRouteBranch(branches[i], // Incoming pathnames are generally encoded from either window.location
    // or from router.navigate, but we want to match against the unencoded
    // paths in the route definitions.  Memory router locations won't be
    // encoded here but there also shouldn't be anything to decode so this
    // should be a safe operation.  This avoids needing matchRoutes to be
    // history-aware.
    $c846480b5114588d$var$safelyDecodeURI(pathname));
    return matches;
}
function $c846480b5114588d$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $c846480b5114588d$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $c846480b5114588d$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), 'Absolute route path "' + meta.relativePath + '" nested under path ' + ('"' + parentPath + '" is not valid. An absolute child route path ') + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $c846480b5114588d$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $c846480b5114588d$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ('all child routes from route path "' + path + '".'));
            $c846480b5114588d$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $c846480b5114588d$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $c846480b5114588d$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $c846480b5114588d$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $c846480b5114588d$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $c846480b5114588d$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $c846480b5114588d$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $c846480b5114588d$var$paramRe = /^:\w+$/;
const $c846480b5114588d$var$dynamicSegmentValue = 3;
const $c846480b5114588d$var$indexRouteValue = 2;
const $c846480b5114588d$var$emptySegmentValue = 1;
const $c846480b5114588d$var$staticSegmentValue = 10;
const $c846480b5114588d$var$splatPenalty = -2;
const $c846480b5114588d$var$isSplat = (s)=>s === "*";
function $c846480b5114588d$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($c846480b5114588d$var$isSplat)) initialScore += $c846480b5114588d$var$splatPenalty;
    if (index) initialScore += $c846480b5114588d$var$indexRouteValue;
    return segments.filter((s)=>!$c846480b5114588d$var$isSplat(s)).reduce((score, segment)=>score + ($c846480b5114588d$var$paramRe.test(segment) ? $c846480b5114588d$var$dynamicSegmentValue : segment === "" ? $c846480b5114588d$var$emptySegmentValue : $c846480b5114588d$var$staticSegmentValue), initialScore);
}
function $c846480b5114588d$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $c846480b5114588d$var$matchRouteBranch(branch, pathname) {
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $c846480b5114588d$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        let route = meta.route;
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $c846480b5114588d$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $c846480b5114588d$export$a5c6d149b50c1d86($c846480b5114588d$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $c846480b5114588d$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/utils/generate-path
 */ function $c846480b5114588d$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $c846480b5114588d$export$c0e02632e14916fd(false, 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:(\w+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $c846480b5114588d$export$3e9cee6b33872309(optional === "?" || param != null, 'Missing ":' + key + '" param');
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/utils/match-path
 */ function $c846480b5114588d$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, paramNames] = $c846480b5114588d$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = paramNames.reduce((memo, paramName, index)=>{
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        memo[paramName] = $c846480b5114588d$var$safelyDecodeURIComponent(captureGroups[index] || "", paramName);
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $c846480b5114588d$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $c846480b5114588d$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
    let paramNames = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^$?{}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:(\w+)/g, (_, paramName)=>{
        paramNames.push(paramName);
        return "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        paramNames.push("*");
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        paramNames
    ];
}
function $c846480b5114588d$var$safelyDecodeURI(value) {
    try {
        return decodeURI(value);
    } catch (error) {
        $c846480b5114588d$export$c0e02632e14916fd(false, 'The URL path "' + value + '" could not be decoded because it is is a ' + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
function $c846480b5114588d$var$safelyDecodeURIComponent(value, paramName) {
    try {
        return decodeURIComponent(value);
    } catch (error) {
        $c846480b5114588d$export$c0e02632e14916fd(false, 'The value for the URL param "' + paramName + '" will not be decoded because' + (' the string "' + value + '" is a malformed URL segment. This is probably') + (" due to a bad percent encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $c846480b5114588d$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/utils/resolve-path
 */ function $c846480b5114588d$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $c846480b5114588d$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $c846480b5114588d$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $c846480b5114588d$var$normalizeSearch(search),
        hash: $c846480b5114588d$var$normalizeHash(hash)
    };
}
function $c846480b5114588d$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $c846480b5114588d$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + 'a string in <Link to="..."> and the router will parse it for you.';
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $c846480b5114588d$export$90ba53ce1c7fdff2(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
/**
 * @private
 */ function $c846480b5114588d$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $c846480b5114588d$export$8ccf933b0513f8d0(toArg);
    else {
        to = $c846480b5114588d$var$_extends({}, toArg);
        $c846480b5114588d$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $c846480b5114588d$var$getInvalidPathError("?", "pathname", "search", to));
        $c846480b5114588d$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $c846480b5114588d$var$getInvalidPathError("#", "pathname", "hash", to));
        $c846480b5114588d$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $c846480b5114588d$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (isPathRelative || toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        if (toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            // Each leading .. segment means "go up one route" instead of "go up one
            // URL segment".  This is a key difference from how <a href> works and a
            // major reason we call this a "to" value instead of a "href".
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        // If there are more ".." segments than parent routes, resolve relative to
        // the root / URL.
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $c846480b5114588d$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $c846480b5114588d$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $c846480b5114588d$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $c846480b5114588d$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $c846480b5114588d$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $c846480b5114588d$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $c846480b5114588d$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 */ const $c846480b5114588d$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $c846480b5114588d$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $c846480b5114588d$export$42a99a7a4bc0e76a extends Error {
}
class $c846480b5114588d$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $c846480b5114588d$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $c846480b5114588d$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref)=>{
            let [key, value] = _ref;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $c846480b5114588d$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error('Deferred data for key "' + key + '" resolved/rejected with `undefined`, ' + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $c846480b5114588d$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: $c846480b5114588d$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $c846480b5114588d$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $c846480b5114588d$var$unwrapTrackedPromise(value) {
    if (!$c846480b5114588d$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
const $c846480b5114588d$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $c846480b5114588d$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $c846480b5114588d$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $c846480b5114588d$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $c846480b5114588d$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $c846480b5114588d$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $c846480b5114588d$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $c846480b5114588d$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $c846480b5114588d$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $c846480b5114588d$var$validMutationMethods = new Set($c846480b5114588d$var$validMutationMethodsArr);
const $c846480b5114588d$var$validRequestMethodsArr = [
    "get",
    ...$c846480b5114588d$var$validMutationMethodsArr
];
const $c846480b5114588d$var$validRequestMethods = new Set($c846480b5114588d$var$validRequestMethodsArr);
const $c846480b5114588d$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $c846480b5114588d$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $c846480b5114588d$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $c846480b5114588d$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $c846480b5114588d$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $c846480b5114588d$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $c846480b5114588d$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $c846480b5114588d$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $c846480b5114588d$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $c846480b5114588d$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $c846480b5114588d$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $c846480b5114588d$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    // Config driven behavior flags
    let future = $c846480b5114588d$var$_extends({
        v7_normalizeFormMethod: false,
        v7_prependBasename: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $c846480b5114588d$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialErrors = null;
    if (initialMatches == null) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $c846480b5114588d$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $c846480b5114588d$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    let initialized = // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    !initialMatches.some((m)=>m.route.lazy) && // And we have to either have no loaders or have been provided hydrationData
    (!initialMatches.some((m)=>m.route.loader) || init.hydrationData != null);
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $c846480b5114588d$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $c846480b5114588d$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = [];
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let ignoreNextHistoryUpdate = false;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (ignoreNextHistoryUpdate) {
                ignoreNextHistoryUpdate = false;
                return;
            }
            $c846480b5114588d$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                ignoreNextHistoryUpdate = true;
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked
                        init.history.go(delta);
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $c846480b5114588d$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $c846480b5114588d$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$c846480b5114588d$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($c846480b5114588d$export$e19cd5f9376f8cee.Pop, state.location);
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, viewTransitionOpts) {
        state = $c846480b5114588d$var$_extends({}, state, newState);
        subscribers.forEach((subscriber)=>subscriber(state, {
                unstable_viewTransitionOpts: viewTransitionOpts
            }));
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState) {
        var _location$state, _location$state2;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $c846480b5114588d$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $c846480b5114588d$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $c846480b5114588d$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $c846480b5114588d$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $c846480b5114588d$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $c846480b5114588d$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $c846480b5114588d$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $c846480b5114588d$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($c846480b5114588d$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $c846480b5114588d$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), viewTransitionOpts);
        // Reset stateful navigation vars
        pendingAction = $c846480b5114588d$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
        cancelledFetcherLoads = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $c846480b5114588d$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $c846480b5114588d$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $c846480b5114588d$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $c846480b5114588d$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $c846480b5114588d$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $c846480b5114588d$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $c846480b5114588d$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $c846480b5114588d$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $c846480b5114588d$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.unstable_viewTransition
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = $c846480b5114588d$export$2708184779ceb39d(routesToUse, location, basename);
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let error = $c846480b5114588d$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $c846480b5114588d$var$getShortCircuitMatches(routesToUse);
            // Cancel all pending deferred on 404s since we don't keep any routes
            cancelActiveDeferreds();
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            });
            return;
        }
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial load will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (state.initialized && !isRevalidationRequired && $c846480b5114588d$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $c846480b5114588d$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $c846480b5114588d$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionData;
        let pendingError;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingError = {
            [$c846480b5114588d$var$findNearestBoundary(matches).route.id]: opts.pendingError
        };
        else if (opts && opts.submission && $c846480b5114588d$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionOutput = await handleAction(request, location, opts.submission, matches, {
                replace: opts.replace
            });
            if (actionOutput.shortCircuited) return;
            pendingActionData = actionOutput.pendingActionData;
            pendingError = actionOutput.pendingActionError;
            loadingNavigation = $c846480b5114588d$var$getLoadingNavigation(location, opts.submission);
            // Create a GET request for the loaders
            request = new Request(request.url, {
                signal: request.signal
            });
        }
        // Call loaders
        let { shortCircuited: shortCircuited, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, pendingActionData, pendingError);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $c846480b5114588d$var$_extends({
            matches: matches
        }, pendingActionData ? {
            actionData: pendingActionData
        } : {}, {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $c846480b5114588d$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        });
        // Call our action and get the result
        let result;
        let actionMatch = $c846480b5114588d$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $c846480b5114588d$var$ResultType.error,
            error: $c846480b5114588d$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            result = await $c846480b5114588d$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename);
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($c846480b5114588d$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else // If the user didn't explicity indicate replace behavior, replace if
            // we redirected to the exact same location we're currently at to avoid
            // double back-buttons
            replace = result.location === state.location.pathname + state.location.search;
            await startRedirectNavigation(state, result, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($c846480b5114588d$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $c846480b5114588d$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions are REPLACE navigations, but if the
            // action threw an error that'll be rendered in an errorElement, we fall
            // back to PUSH so that the user can use the back button to get back to
            // the pre-submission form location to try again
            if ((opts && opts.replace) !== true) pendingAction = $c846480b5114588d$export$e19cd5f9376f8cee.Push;
            return {
                // Send back an empty object we can use to clear out any prior actionData
                pendingActionData: {},
                pendingActionError: {
                    [boundaryMatch.route.id]: result.error
                }
            };
        }
        if ($c846480b5114588d$var$isDeferredResult(result)) throw $c846480b5114588d$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        return {
            pendingActionData: {
                [actionMatch.route.id]: result.data
            }
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, overrideNavigation, submission, fetcherSubmission, replace, pendingActionData, pendingError) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $c846480b5114588d$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $c846480b5114588d$var$getSubmissionFromNavigation(loadingNavigation);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $c846480b5114588d$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionData, pendingError);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $c846480b5114588d$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingError || null
            }, pendingActionData ? {
                actionData: pendingActionData
            } : {}, updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}));
            return {
                shortCircuited: true
            };
        }
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        if (!isUninterruptedRevalidation) {
            revalidatingFetchers.forEach((rf)=>{
                let fetcher = state.fetchers.get(rf.key);
                let revalidatingFetcher = $c846480b5114588d$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
                state.fetchers.set(rf.key, revalidatingFetcher);
            });
            let actionData = pendingActionData || state.actionData;
            updateState($c846480b5114588d$var$_extends({
                navigation: loadingNavigation
            }, actionData ? Object.keys(actionData).length === 0 ? {
                actionData: null
            } : {
                actionData: actionData
            } : {}, revalidatingFetchers.length > 0 ? {
                fetchers: new Map(state.fetchers)
            } : {}));
        }
        revalidatingFetchers.forEach((rf)=>{
            if (fetchControllers.has(rf.key)) abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { results: results, loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $c846480b5114588d$var$findRedirect(results);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            await startRedirectNavigation(state, redirect.result, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $c846480b5114588d$var$processLoaderData(state, matches, matchesToLoad, loaderResults, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $c846480b5114588d$var$_extends({
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getFetcher(key) {
        return state.fetchers.get(key) || $c846480b5114588d$export$52eace9c284d3585;
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        if (fetchControllers.has(key)) abortFetcher(key);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $c846480b5114588d$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, routeId, opts == null ? void 0 : opts.relative);
        let matches = $c846480b5114588d$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        if (!matches) {
            setFetcherError(key, routeId, $c846480b5114588d$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }));
            return;
        }
        let { path: path, submission: submission, error: error } = $c846480b5114588d$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error);
            return;
        }
        let match = $c846480b5114588d$var$getTargetMatch(matches, path);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $c846480b5114588d$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        if (!match.route.action && !match.route.lazy) {
            let error = $c846480b5114588d$var$getInternalRouterError(405, {
                method: submission.formMethod,
                pathname: path,
                routeId: routeId
            });
            setFetcherError(key, routeId, error);
            return;
        }
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        let fetcher = $c846480b5114588d$var$getSubmittingFetcher(submission, existingFetcher);
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        });
        // Call the action for the fetcher
        let abortController = new AbortController();
        let fetchRequest = $c846480b5114588d$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResult = await $c846480b5114588d$var$callLoaderOrAction("action", fetchRequest, match, requestMatches, manifest, mapRouteProperties, basename);
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by ou our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        if ($c846480b5114588d$var$isRedirectResult(actionResult)) {
            fetchControllers.delete(key);
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our action started, so that
                // should take precedence over this redirect navigation.  We already
                // set isRevalidationRequired so all loaders for the new route should
                // fire unless opted out via shouldRevalidate
                let doneFetcher = $c846480b5114588d$var$getDoneFetcher(undefined);
                state.fetchers.set(key, doneFetcher);
                updateState({
                    fetchers: new Map(state.fetchers)
                });
                return;
            } else {
                fetchRedirectIds.add(key);
                let loadingFetcher = $c846480b5114588d$var$getLoadingFetcher(submission);
                state.fetchers.set(key, loadingFetcher);
                updateState({
                    fetchers: new Map(state.fetchers)
                });
                return startRedirectNavigation(state, actionResult, {
                    fetcherSubmission: submission
                });
            }
        }
        // Process any non-redirect errors thrown
        if ($c846480b5114588d$var$isErrorResult(actionResult)) {
            setFetcherError(key, routeId, actionResult.error);
            return;
        }
        if ($c846480b5114588d$var$isDeferredResult(actionResult)) throw $c846480b5114588d$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $c846480b5114588d$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $c846480b5114588d$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $c846480b5114588d$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $c846480b5114588d$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $c846480b5114588d$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, {
            [match.route.id]: actionResult.data
        }, undefined // No need to send through errors since we short circuit above
        );
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $c846480b5114588d$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            if (fetchControllers.has(staleKey)) abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { results: results, loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $c846480b5114588d$var$findRedirect(results);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            return startRedirectNavigation(state, redirect.result);
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $c846480b5114588d$var$processLoaderData(state, state.matches, matchesToLoad, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $c846480b5114588d$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        let didAbortFetchLoads = abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $c846480b5114588d$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState($c846480b5114588d$var$_extends({
                errors: errors,
                loaderData: $c846480b5114588d$var$mergeLoaderData(state.loaderData, loaderData, matches, errors)
            }, didAbortFetchLoads || revalidatingFetchers.length > 0 ? {
                fetchers: new Map(state.fetchers)
            } : {}));
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, submission) {
        let existingFetcher = state.fetchers.get(key);
        // Put this fetcher into it's loading state
        let loadingFetcher = $c846480b5114588d$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined);
        state.fetchers.set(key, loadingFetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        });
        // Call the loader for this fetcher route match
        let abortController = new AbortController();
        let fetchRequest = $c846480b5114588d$var$createClientSideRequest(init.history, path, abortController.signal);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let result = await $c846480b5114588d$var$callLoaderOrAction("loader", fetchRequest, match, matches, manifest, mapRouteProperties, basename);
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($c846480b5114588d$var$isDeferredResult(result)) result = await $c846480b5114588d$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($c846480b5114588d$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                let doneFetcher = $c846480b5114588d$var$getDoneFetcher(undefined);
                state.fetchers.set(key, doneFetcher);
                updateState({
                    fetchers: new Map(state.fetchers)
                });
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(state, result);
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($c846480b5114588d$var$isErrorResult(result)) {
            let boundaryMatch = $c846480b5114588d$var$findNearestBoundary(state.matches, routeId);
            state.fetchers.delete(key);
            // TODO: In remix, this would reset to IDLE_NAVIGATION if it was a catch -
            // do we need to behave any differently with our non-redirect errors?
            // What if it was a non-redirect Response?
            updateState({
                fetchers: new Map(state.fetchers),
                errors: {
                    [boundaryMatch.route.id]: result.error
                }
            });
            return;
        }
        $c846480b5114588d$export$3e9cee6b33872309(!$c846480b5114588d$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        let doneFetcher = $c846480b5114588d$var$getDoneFetcher(result.data);
        state.fetchers.set(key, doneFetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(state, redirect, _temp) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, replace: replace } = _temp === void 0 ? {} : _temp;
        if (redirect.revalidate) isRevalidationRequired = true;
        let redirectLocation = $c846480b5114588d$var$createLocation(state.location, redirect.location, {
            _isRedirect: true
        });
        $c846480b5114588d$export$3e9cee6b33872309(redirectLocation, "Expected a location on the redirect navigation");
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.reloadDocument) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($c846480b5114588d$var$ABSOLUTE_URL_REGEX.test(redirect.location)) {
                const url = init.history.createURL(redirect.location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $c846480b5114588d$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(redirect.location);
                else routerWindow.location.assign(redirect.location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true ? $c846480b5114588d$export$e19cd5f9376f8cee.Replace : $c846480b5114588d$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $c846480b5114588d$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($c846480b5114588d$var$redirectPreserveMethodStatusCodes.has(redirect.status) && activeSubmission && $c846480b5114588d$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $c846480b5114588d$var$_extends({}, activeSubmission, {
                formAction: redirect.location
            }),
            // Preserve this flag across redirects
            preventScrollReset: pendingPreventScrollReset
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $c846480b5114588d$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve this flag across redirects
                preventScrollReset: pendingPreventScrollReset
            });
        }
    }
    async function callLoadersAndMaybeResolveData(currentMatches, matches, matchesToLoad, fetchersToLoad, request) {
        // Call all navigation loaders and revalidating fetcher loaders in parallel,
        // then slice off the results into separate arrays so we can handle them
        // accordingly
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>$c846480b5114588d$var$callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename)),
            ...fetchersToLoad.map((f)=>{
                if (f.matches && f.match && f.controller) return $c846480b5114588d$var$callLoaderOrAction("loader", $c846480b5114588d$var$createClientSideRequest(init.history, f.path, f.controller.signal), f.match, f.matches, manifest, mapRouteProperties, basename);
                else {
                    let error = {
                        type: $c846480b5114588d$var$ResultType.error,
                        error: $c846480b5114588d$var$getInternalRouterError(404, {
                            pathname: f.path
                        })
                    };
                    return error;
                }
            })
        ]);
        let loaderResults = results.slice(0, matchesToLoad.length);
        let fetcherResults = results.slice(matchesToLoad.length);
        await Promise.all([
            $c846480b5114588d$var$resolveDeferredResults(currentMatches, matchesToLoad, loaderResults, loaderResults.map(()=>request.signal), false, state.loaderData),
            $c846480b5114588d$var$resolveDeferredResults(currentMatches, fetchersToLoad.map((f)=>f.match), fetcherResults, fetchersToLoad.map((f)=>f.controller ? f.controller.signal : null), true)
        ]);
        return {
            results: results,
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) {
                cancelledFetcherLoads.push(key);
                abortFetcher(key);
            }
        });
    }
    function setFetcherError(key, routeId, error) {
        let boundaryMatch = $c846480b5114588d$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        });
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        state.fetchers.delete(key);
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        $c846480b5114588d$export$3e9cee6b33872309(controller, "Expected fetch controller: " + key);
        controller.abort();
        fetchControllers.delete(key);
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $c846480b5114588d$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $c846480b5114588d$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $c846480b5114588d$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $c846480b5114588d$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $c846480b5114588d$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $c846480b5114588d$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $c846480b5114588d$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $c846480b5114588d$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$c846480b5114588d$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $c846480b5114588d$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    router = {
        get basename () {
            return basename;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcher,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $c846480b5114588d$export$4d0306f8f6a4585b = Symbol("deferred");
function $c846480b5114588d$export$3336b097a6fbc59a(routes, opts) {
    $c846480b5114588d$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $c846480b5114588d$var$defaultMapRouteProperties;
    let dataRoutes = $c846480b5114588d$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   */ async function query(request, _temp2) {
        let { requestContext: requestContext } = _temp2 === void 0 ? {} : _temp2;
        let url = new URL(request.url);
        let method = request.method;
        let location = $c846480b5114588d$var$createLocation("", $c846480b5114588d$export$fe53371bee54353d(url), null, "default");
        let matches = $c846480b5114588d$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$c846480b5114588d$var$isValidMethod(method) && method !== "HEAD") {
            let error = $c846480b5114588d$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $c846480b5114588d$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $c846480b5114588d$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $c846480b5114588d$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext);
        if ($c846480b5114588d$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $c846480b5114588d$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   */ async function queryRoute(request, _temp3) {
        let { routeId: routeId, requestContext: requestContext } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $c846480b5114588d$var$createLocation("", $c846480b5114588d$export$fe53371bee54353d(url), null, "default");
        let matches = $c846480b5114588d$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$c846480b5114588d$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $c846480b5114588d$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $c846480b5114588d$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $c846480b5114588d$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $c846480b5114588d$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $c846480b5114588d$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, match);
        if ($c846480b5114588d$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$c846480b5114588d$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, routeMatch) {
        $c846480b5114588d$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($c846480b5114588d$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $c846480b5114588d$var$getTargetMatch(matches, location), requestContext, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, routeMatch);
            return $c846480b5114588d$var$isResponse(result) ? result : $c846480b5114588d$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction, we throw
            // it to bail out and then return or throw here based on whether the user
            // returned or threw
            if ($c846480b5114588d$var$isQueryRouteResponse(e)) {
                if (e.type === $c846480b5114588d$var$ResultType.error) throw e.response;
                return e.response;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($c846480b5114588d$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $c846480b5114588d$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $c846480b5114588d$var$ResultType.error,
                error: error
            };
        } else {
            result = await $c846480b5114588d$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename, {
                isStaticRequest: true,
                isRouteRequest: isRouteRequest,
                requestContext: requestContext
            });
            if (request.signal.aborted) {
                let method = isRouteRequest ? "queryRoute" : "query";
                throw new Error(method + "() call aborted: " + request.method + " " + request.url);
            }
        }
        if ($c846480b5114588d$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.status,
            headers: {
                Location: result.location
            }
        });
        if ($c846480b5114588d$var$isDeferredResult(result)) {
            let error = $c846480b5114588d$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $c846480b5114588d$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($c846480b5114588d$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        if ($c846480b5114588d$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $c846480b5114588d$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(request, matches, requestContext, undefined, {
                [boundaryMatch.route.id]: result.error
            });
            // action status codes take precedence over loader status codes
            return $c846480b5114588d$var$_extends({}, context, {
                statusCode: $c846480b5114588d$export$972111febbeef05b(result.error) ? result.error.status : 500,
                actionData: null,
                actionHeaders: $c846480b5114588d$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        let context = await loadRouteData(loaderRequest, matches, requestContext);
        return $c846480b5114588d$var$_extends({}, context, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionData: {
                [actionMatch.route.id]: result.data
            },
            actionHeaders: $c846480b5114588d$var$_extends({}, result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {})
        });
    }
    async function loadRouteData(request, matches, requestContext, routeMatch, pendingActionError) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $c846480b5114588d$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : $c846480b5114588d$var$getLoaderMatchesUntilBoundary(matches, Object.keys(pendingActionError || {})[0]);
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionError || null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>$c846480b5114588d$var$callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename, {
                    isStaticRequest: true,
                    isRouteRequest: isRouteRequest,
                    requestContext: requestContext
                }))
        ]);
        if (request.signal.aborted) {
            let method = isRouteRequest ? "queryRoute" : "query";
            throw new Error(method + "() call aborted: " + request.method + " " + request.url);
        }
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $c846480b5114588d$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionError, activeDeferreds);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $c846480b5114588d$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $c846480b5114588d$export$fec11da027c70692(routes, context, error) {
    let newContext = $c846480b5114588d$var$_extends({}, context, {
        statusCode: 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $c846480b5114588d$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $c846480b5114588d$var$normalizeTo(location, matches, basename, prependBasename, to, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId != null && relative !== "path") {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route.  When using relative:path,
        // fromRouteId is ignored since that is always relative to the current
        // location path
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $c846480b5114588d$export$cae722b0cc860f13(to ? to : ".", $c846480b5114588d$export$90ba53ce1c7fdff2(contextualMatches).map((m)=>m.pathnameBase), $c846480b5114588d$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Add an ?index param for matched index routes if we don't already have one
    if ((to == null || to === "" || to === ".") && activeRouteMatch && activeRouteMatch.route.index && !$c846480b5114588d$var$hasNakedIndexQuery(path.search)) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $c846480b5114588d$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $c846480b5114588d$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $c846480b5114588d$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$c846480b5114588d$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$c846480b5114588d$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $c846480b5114588d$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $c846480b5114588d$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $c846480b5114588d$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$c846480b5114588d$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref3)=>{
                let [name, value] = _ref3;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$c846480b5114588d$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $c846480b5114588d$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $c846480b5114588d$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $c846480b5114588d$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $c846480b5114588d$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $c846480b5114588d$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($c846480b5114588d$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $c846480b5114588d$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $c846480b5114588d$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $c846480b5114588d$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes below any caught error as they aren't going to
// render so we don't need to load them
function $c846480b5114588d$var$getLoaderMatchesUntilBoundary(matches, boundaryId) {
    let boundaryMatches = matches;
    if (boundaryId) {
        let index = matches.findIndex((m)=>m.route.id === boundaryId);
        if (index >= 0) boundaryMatches = matches.slice(0, index);
    }
    return boundaryMatches;
}
function $c846480b5114588d$var$getMatchesToLoad(history, state, matches, submission, location, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionData, pendingError) {
    let actionResult = pendingError ? Object.values(pendingError)[0] : pendingActionData ? Object.values(pendingActionData)[0] : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryId = pendingError ? Object.keys(pendingError)[0] : undefined;
    let boundaryMatches = $c846480b5114588d$var$getLoaderMatchesUntilBoundary(matches, boundaryId);
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        if (match.route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (match.route.loader == null) return false;
        // Always call the loader on new route instances and pending defer cancellations
        if ($c846480b5114588d$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $c846480b5114588d$var$shouldRevalidateLoader(match, $c846480b5114588d$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || // Clicked the same link, resubmitted a GET form
            currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $c846480b5114588d$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate if fetcher won't be present in the subsequent render
        if (!matches.some((m)=>m.route.id === f.routeId)) return;
        let fetcherMatches = $c846480b5114588d$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $c846480b5114588d$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.includes(key)) // Always revalidate if the fetcher was cancelled
        shouldRevalidate = true;
        else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $c846480b5114588d$var$shouldRevalidateLoader(fetcherMatch, $c846480b5114588d$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $c846480b5114588d$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $c846480b5114588d$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $c846480b5114588d$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $c846480b5114588d$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $c846480b5114588d$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $c846480b5114588d$export$c0e02632e14916fd(!isPropertyStaticallyDefined, 'Route "' + routeToUpdate.id + '" has a static property "' + lazyRouteProperty + '" ' + "defined but its lazy function is also returning a value for this property. " + ('The lazy route property "' + lazyRouteProperty + '" will be ignored.'));
        if (!isPropertyStaticallyDefined && !$c846480b5114588d$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $c846480b5114588d$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
async function $c846480b5114588d$var$callLoaderOrAction(type, request, match, matches, manifest, mapRouteProperties, basename, opts) {
    if (opts === void 0) opts = {};
    let resultType;
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        return Promise.race([
            handler({
                request: request,
                params: match.params,
                context: opts.requestContext
            }),
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        if (match.route.lazy) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let values = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    $c846480b5114588d$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest)
                ]);
                if (handlerError) throw handlerError;
                result = values[0];
            } else {
                // Load lazy route module, then run any returned handler
                await $c846480b5114588d$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest);
                handler = match.route[type];
                if (handler) // Handler still run even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $c846480b5114588d$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $c846480b5114588d$var$ResultType.data,
                    data: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $c846480b5114588d$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $c846480b5114588d$export$3e9cee6b33872309(result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ('"' + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        resultType = $c846480b5114588d$var$ResultType.error;
        result = e;
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    if ($c846480b5114588d$var$isResponse(result)) {
        let status = result.status;
        // Process redirects
        if ($c846480b5114588d$var$redirectStatusCodes.has(status)) {
            let location = result.headers.get("Location");
            $c846480b5114588d$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
            // Support relative routing in internal redirects
            if (!$c846480b5114588d$var$ABSOLUTE_URL_REGEX.test(location)) location = $c846480b5114588d$var$normalizeTo(new URL(request.url), matches.slice(0, matches.indexOf(match) + 1), basename, true, location);
            else if (!opts.isStaticRequest) {
                // Strip off the protocol+origin for same-origin + same-basename absolute
                // redirects. If this is a static request, we can let it go back to the
                // browser as-is
                let currentUrl = new URL(request.url);
                let url = location.startsWith("//") ? new URL(currentUrl.protocol + location) : new URL(location);
                let isSameBasename = $c846480b5114588d$export$b69e3301ce081aa3(url.pathname, basename) != null;
                if (url.origin === currentUrl.origin && isSameBasename) location = url.pathname + url.search + url.hash;
            }
            // Don't process redirects in the router during static requests requests.
            // Instead, throw the Response and let the server handle it with an HTTP
            // redirect.  We also update the Location header in place in this flow so
            // basename and relative routing is taken into account
            if (opts.isStaticRequest) {
                result.headers.set("Location", location);
                throw result;
            }
            return {
                type: $c846480b5114588d$var$ResultType.redirect,
                status: status,
                location: location,
                revalidate: result.headers.get("X-Remix-Revalidate") !== null,
                reloadDocument: result.headers.get("X-Remix-Reload-Document") !== null
            };
        }
        // For SSR single-route requests, we want to hand Responses back directly
        // without unwrapping.  We do this with the QueryRouteResponse wrapper
        // interface so we can know whether it was returned or thrown
        if (opts.isRouteRequest) {
            let queryRouteResponse = {
                type: resultType === $c846480b5114588d$var$ResultType.error ? $c846480b5114588d$var$ResultType.error : $c846480b5114588d$var$ResultType.data,
                response: result
            };
            throw queryRouteResponse;
        }
        let data;
        let contentType = result.headers.get("Content-Type");
        // Check between word boundaries instead of startsWith() due to the last
        // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
        if (contentType && /\bapplication\/json\b/.test(contentType)) data = await result.json();
        else data = await result.text();
        if (resultType === $c846480b5114588d$var$ResultType.error) return {
            type: resultType,
            error: new $c846480b5114588d$export$6c6580e81da25755(status, result.statusText, data),
            headers: result.headers
        };
        return {
            type: $c846480b5114588d$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (resultType === $c846480b5114588d$var$ResultType.error) return {
        type: resultType,
        error: result
    };
    if ($c846480b5114588d$export$fbcedacb60443473(result)) {
        var _result$init, _result$init2;
        return {
            type: $c846480b5114588d$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
            headers: ((_result$init2 = result.init) == null ? void 0 : _result$init2.headers) && new Headers(result.init.headers)
        };
    }
    return {
        type: $c846480b5114588d$var$ResultType.data,
        data: result
    };
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $c846480b5114588d$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($c846480b5114588d$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $c846480b5114588d$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $c846480b5114588d$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $c846480b5114588d$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $c846480b5114588d$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $c846480b5114588d$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    // Process loader results into state.loaderData/state.errors
    results.forEach((result, index)=>{
        let id = matchesToLoad[index].route.id;
        $c846480b5114588d$export$3e9cee6b33872309(!$c846480b5114588d$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($c846480b5114588d$var$isErrorResult(result)) {
            // Look upwards from the matched route for the closest ancestor
            // error boundary, defaulting to the root match
            let boundaryMatch = $c846480b5114588d$var$findNearestBoundary(matches, id);
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError) {
                error = Object.values(pendingError)[0];
                pendingError = undefined;
            }
            errors = errors || {};
            // Prefer higher error values if lower errors bubble to the same boundary
            if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $c846480b5114588d$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            if ($c846480b5114588d$var$isDeferredResult(result)) {
                activeDeferreds.set(id, result.deferredData);
                loaderData[id] = result.deferredData.data;
            } else loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError) {
        errors = pendingError;
        loaderData[Object.keys(pendingError)[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $c846480b5114588d$var$processLoaderData(state, matches, matchesToLoad, results, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $c846480b5114588d$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds);
    // Process results from our revalidating fetchers
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, match: match, controller: controller } = revalidatingFetchers[index];
        $c846480b5114588d$export$3e9cee6b33872309(fetcherResults !== undefined && fetcherResults[index] !== undefined, "Did not find corresponding fetcher result");
        let result = fetcherResults[index];
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) continue;
        else if ($c846480b5114588d$var$isErrorResult(result)) {
            let boundaryMatch = $c846480b5114588d$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $c846480b5114588d$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($c846480b5114588d$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $c846480b5114588d$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($c846480b5114588d$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $c846480b5114588d$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $c846480b5114588d$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $c846480b5114588d$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $c846480b5114588d$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $c846480b5114588d$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $c846480b5114588d$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $c846480b5114588d$var$getInternalRouterError(status, _temp4) {
    let { pathname: pathname, routeId: routeId, method: method, type: type } = _temp4 === void 0 ? {} : _temp4;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + ' request to "' + pathname + '" but ' + ('did not provide a `loader` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = 'Route "' + routeId + '" does not match URL "' + pathname + '"';
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = 'No route matches URL "' + pathname + '"';
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + ' request to "' + pathname + '" but ' + ('did not provide an `action` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (method) errorMessage = 'Invalid request method "' + method.toUpperCase() + '"';
    }
    return new $c846480b5114588d$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $c846480b5114588d$var$findRedirect(results) {
    for(let i = results.length - 1; i >= 0; i--){
        let result = results[i];
        if ($c846480b5114588d$var$isRedirectResult(result)) return {
            result: result,
            idx: i
        };
    }
}
function $c846480b5114588d$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $c846480b5114588d$export$8ccf933b0513f8d0(path) : path;
    return $c846480b5114588d$export$fe53371bee54353d($c846480b5114588d$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $c846480b5114588d$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $c846480b5114588d$var$isDeferredResult(result) {
    return result.type === $c846480b5114588d$var$ResultType.deferred;
}
function $c846480b5114588d$var$isErrorResult(result) {
    return result.type === $c846480b5114588d$var$ResultType.error;
}
function $c846480b5114588d$var$isRedirectResult(result) {
    return (result && result.type) === $c846480b5114588d$var$ResultType.redirect;
}
function $c846480b5114588d$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $c846480b5114588d$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $c846480b5114588d$var$isRedirectResponse(result) {
    if (!$c846480b5114588d$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $c846480b5114588d$var$isQueryRouteResponse(obj) {
    return obj && $c846480b5114588d$var$isResponse(obj.response) && (obj.type === $c846480b5114588d$var$ResultType.data || obj.type === $c846480b5114588d$var$ResultType.error);
}
function $c846480b5114588d$var$isValidMethod(method) {
    return $c846480b5114588d$var$validRequestMethods.has(method.toLowerCase());
}
function $c846480b5114588d$var$isMutationMethod(method) {
    return $c846480b5114588d$var$validMutationMethods.has(method.toLowerCase());
}
async function $c846480b5114588d$var$resolveDeferredResults(currentMatches, matchesToLoad, results, signals, isFetcher, currentLoaderData) {
    for(let index = 0; index < results.length; index++){
        let result = results[index];
        let match = matchesToLoad[index];
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$c846480b5114588d$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($c846480b5114588d$var$isDeferredResult(result) && (isFetcher || isRevalidatingLoader)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            let signal = signals[index];
            $c846480b5114588d$export$3e9cee6b33872309(signal, "Expected an AbortSignal for revalidating fetcher deferred result");
            await $c846480b5114588d$var$resolveDeferredData(result, signal, isFetcher).then((result)=>{
                if (result) results[index] = result || results[index];
            });
        }
    }
}
async function $c846480b5114588d$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $c846480b5114588d$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $c846480b5114588d$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $c846480b5114588d$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $c846480b5114588d$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $c846480b5114588d$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $c846480b5114588d$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $c846480b5114588d$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $c846480b5114588d$export$90ba53ce1c7fdff2(matches);
    return pathMatches[pathMatches.length - 1];
}
function $c846480b5114588d$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $c846480b5114588d$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $c846480b5114588d$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $c846480b5114588d$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $c846480b5114588d$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $c846480b5114588d$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $c846480b5114588d$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($c846480b5114588d$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $c846480b5114588d$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($c846480b5114588d$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $c846480b5114588d$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}


function $2e634cb2b6e12a73$var$_extends() {
    $2e634cb2b6e12a73$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $2e634cb2b6e12a73$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $2e634cb2b6e12a73$export$3add0d5dce533e2e = /*#__PURE__*/ $d51ff6fbc6548743$exports.createContext(null);
const $2e634cb2b6e12a73$export$145dfa71566a64dc = /*#__PURE__*/ $d51ff6fbc6548743$exports.createContext(null);
const $2e634cb2b6e12a73$var$AwaitContext = /*#__PURE__*/ $d51ff6fbc6548743$exports.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $2e634cb2b6e12a73$export$26749e8557646306 = /*#__PURE__*/ $d51ff6fbc6548743$exports.createContext(null);
const $2e634cb2b6e12a73$export$c7914228fb69b0f5 = /*#__PURE__*/ $d51ff6fbc6548743$exports.createContext(null);
const $2e634cb2b6e12a73$export$9072aa6dd1f93057 = /*#__PURE__*/ $d51ff6fbc6548743$exports.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $2e634cb2b6e12a73$var$RouteErrorContext = /*#__PURE__*/ $d51ff6fbc6548743$exports.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/hooks/use-href
 */ function $2e634cb2b6e12a73$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$2e634cb2b6e12a73$export$9c954a9d03d32f4a() && (0, $c846480b5114588d$export$3e9cee6b33872309)(false);
    let { basename: basename, navigator: navigator } = $d51ff6fbc6548743$exports.useContext($2e634cb2b6e12a73$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $2e634cb2b6e12a73$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $c846480b5114588d$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/hooks/use-in-router-context
 */ function $2e634cb2b6e12a73$export$9c954a9d03d32f4a() {
    return $d51ff6fbc6548743$exports.useContext($2e634cb2b6e12a73$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/hooks/use-location
 */ function $2e634cb2b6e12a73$export$45d76561a5302f2b() {
    !$2e634cb2b6e12a73$export$9c954a9d03d32f4a() && (0, $c846480b5114588d$export$3e9cee6b33872309)(false);
    return $d51ff6fbc6548743$exports.useContext($2e634cb2b6e12a73$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/hooks/use-navigation-type
 */ function $2e634cb2b6e12a73$export$1b3f31771c5d07c() {
    return $d51ff6fbc6548743$exports.useContext($2e634cb2b6e12a73$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/hooks/use-match
 */ function $2e634cb2b6e12a73$export$6c330e8992e8a295(pattern) {
    !$2e634cb2b6e12a73$export$9c954a9d03d32f4a() && (0, $c846480b5114588d$export$3e9cee6b33872309)(false);
    let { pathname: pathname } = $2e634cb2b6e12a73$export$45d76561a5302f2b();
    return $d51ff6fbc6548743$exports.useMemo(()=>(0, $c846480b5114588d$export$81336c211d5ff295)(pattern, pathname), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $2e634cb2b6e12a73$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $2e634cb2b6e12a73$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $d51ff6fbc6548743$exports.useContext($2e634cb2b6e12a73$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $d51ff6fbc6548743$exports.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/hooks/use-navigate
 */ function $2e634cb2b6e12a73$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $d51ff6fbc6548743$exports.useContext($2e634cb2b6e12a73$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $2e634cb2b6e12a73$var$useNavigateStable() : $2e634cb2b6e12a73$var$useNavigateUnstable();
}
function $2e634cb2b6e12a73$var$useNavigateUnstable() {
    !$2e634cb2b6e12a73$export$9c954a9d03d32f4a() && (0, $c846480b5114588d$export$3e9cee6b33872309)(false);
    let dataRouterContext = $d51ff6fbc6548743$exports.useContext($2e634cb2b6e12a73$export$3add0d5dce533e2e);
    let { basename: basename, navigator: navigator } = $d51ff6fbc6548743$exports.useContext($2e634cb2b6e12a73$export$26749e8557646306);
    let { matches: matches } = $d51ff6fbc6548743$exports.useContext($2e634cb2b6e12a73$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $2e634cb2b6e12a73$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $c846480b5114588d$export$90ba53ce1c7fdff2)(matches).map((match)=>match.pathnameBase));
    let activeRef = $d51ff6fbc6548743$exports.useRef(false);
    $2e634cb2b6e12a73$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $d51ff6fbc6548743$exports.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $c846480b5114588d$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $c846480b5114588d$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $2e634cb2b6e12a73$var$OutletContext = /*#__PURE__*/ $d51ff6fbc6548743$exports.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/hooks/use-outlet-context
 */ function $2e634cb2b6e12a73$export$4138103a3ae699cc() {
    return $d51ff6fbc6548743$exports.useContext($2e634cb2b6e12a73$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/hooks/use-outlet
 */ function $2e634cb2b6e12a73$export$a3be3530d8e40d0b(context) {
    let outlet = $d51ff6fbc6548743$exports.useContext($2e634cb2b6e12a73$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $d51ff6fbc6548743$exports.createElement($2e634cb2b6e12a73$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/hooks/use-params
 */ function $2e634cb2b6e12a73$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $d51ff6fbc6548743$exports.useContext($2e634cb2b6e12a73$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/hooks/use-resolved-path
 */ function $2e634cb2b6e12a73$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { matches: matches } = $d51ff6fbc6548743$exports.useContext($2e634cb2b6e12a73$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $2e634cb2b6e12a73$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $c846480b5114588d$export$90ba53ce1c7fdff2)(matches).map((match)=>match.pathnameBase));
    return $d51ff6fbc6548743$exports.useMemo(()=>(0, $c846480b5114588d$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/hooks/use-routes
 */ function $2e634cb2b6e12a73$export$5d3fca4a98652595(routes, locationArg) {
    return $2e634cb2b6e12a73$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $2e634cb2b6e12a73$export$5fcee62552a12fbf(routes, locationArg, dataRouterState) {
    !$2e634cb2b6e12a73$export$9c954a9d03d32f4a() && (0, $c846480b5114588d$export$3e9cee6b33872309)(false);
    let { navigator: navigator } = $d51ff6fbc6548743$exports.useContext($2e634cb2b6e12a73$export$26749e8557646306);
    let { matches: parentMatches } = $d51ff6fbc6548743$exports.useContext($2e634cb2b6e12a73$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $2e634cb2b6e12a73$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $c846480b5114588d$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $c846480b5114588d$export$3e9cee6b33872309)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = parentPathnameBase === "/" ? pathname : pathname.slice(parentPathnameBase.length) || "/";
    let matches = (0, $c846480b5114588d$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $2e634cb2b6e12a73$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $c846480b5114588d$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $c846480b5114588d$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $d51ff6fbc6548743$exports.createElement($2e634cb2b6e12a73$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $2e634cb2b6e12a73$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $c846480b5114588d$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $2e634cb2b6e12a73$var$DefaultErrorComponent() {
    let error = $2e634cb2b6e12a73$export$ed527bf60f6e05f2();
    let message = (0, $c846480b5114588d$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $d51ff6fbc6548743$exports.createElement($d51ff6fbc6548743$exports.Fragment, null, /*#__PURE__*/ $d51ff6fbc6548743$exports.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $d51ff6fbc6548743$exports.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $d51ff6fbc6548743$exports.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $2e634cb2b6e12a73$var$defaultErrorElement = /*#__PURE__*/ $d51ff6fbc6548743$exports.createElement($2e634cb2b6e12a73$var$DefaultErrorComponent, null);
class $2e634cb2b6e12a73$var$RenderErrorBoundary extends $d51ff6fbc6548743$exports.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error || state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error ? /*#__PURE__*/ $d51ff6fbc6548743$exports.createElement($2e634cb2b6e12a73$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $d51ff6fbc6548743$exports.createElement($2e634cb2b6e12a73$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $2e634cb2b6e12a73$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $d51ff6fbc6548743$exports.useContext($2e634cb2b6e12a73$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $d51ff6fbc6548743$exports.createElement($2e634cb2b6e12a73$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $2e634cb2b6e12a73$var$_renderMatches(matches, parentMatches, dataRouterState) {
    var _dataRouterState2;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (matches == null) {
        var _dataRouterState;
        if ((_dataRouterState = dataRouterState) != null && _dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState2 = dataRouterState) == null ? void 0 : _dataRouterState2.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]));
        !(errorIndex >= 0) && (0, $c846480b5114588d$export$3e9cee6b33872309)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        let error = match.route.id ? errors == null ? void 0 : errors[match.route.id] : null;
        // Only data routers handle errors
        let errorElement = null;
        if (dataRouterState) errorElement = match.route.errorElement || $2e634cb2b6e12a73$var$defaultErrorElement;
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $d51ff6fbc6548743$exports.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $d51ff6fbc6548743$exports.createElement($2e634cb2b6e12a73$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $d51ff6fbc6548743$exports.createElement($2e634cb2b6e12a73$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $2e634cb2b6e12a73$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($2e634cb2b6e12a73$var$DataRouterHook || {});
var $2e634cb2b6e12a73$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($2e634cb2b6e12a73$var$DataRouterStateHook || {});
function $2e634cb2b6e12a73$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $2e634cb2b6e12a73$var$useDataRouterContext(hookName) {
    let ctx = $d51ff6fbc6548743$exports.useContext($2e634cb2b6e12a73$export$3add0d5dce533e2e);
    !ctx && (0, $c846480b5114588d$export$3e9cee6b33872309)(false);
    return ctx;
}
function $2e634cb2b6e12a73$var$useDataRouterState(hookName) {
    let state = $d51ff6fbc6548743$exports.useContext($2e634cb2b6e12a73$export$145dfa71566a64dc);
    !state && (0, $c846480b5114588d$export$3e9cee6b33872309)(false);
    return state;
}
function $2e634cb2b6e12a73$var$useRouteContext(hookName) {
    let route = $d51ff6fbc6548743$exports.useContext($2e634cb2b6e12a73$export$9072aa6dd1f93057);
    !route && (0, $c846480b5114588d$export$3e9cee6b33872309)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $2e634cb2b6e12a73$var$useCurrentRouteId(hookName) {
    let route = $2e634cb2b6e12a73$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $c846480b5114588d$export$3e9cee6b33872309)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $2e634cb2b6e12a73$export$5fc8298006ad9e58() {
    return $2e634cb2b6e12a73$var$useCurrentRouteId($2e634cb2b6e12a73$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $2e634cb2b6e12a73$export$d0fd4b7106de2769() {
    let state = $2e634cb2b6e12a73$var$useDataRouterState($2e634cb2b6e12a73$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $2e634cb2b6e12a73$export$600dc272ed516c15() {
    let dataRouterContext = $2e634cb2b6e12a73$var$useDataRouterContext($2e634cb2b6e12a73$var$DataRouterHook.UseRevalidator);
    let state = $2e634cb2b6e12a73$var$useDataRouterState($2e634cb2b6e12a73$var$DataRouterStateHook.UseRevalidator);
    return $d51ff6fbc6548743$exports.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $2e634cb2b6e12a73$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $2e634cb2b6e12a73$var$useDataRouterState($2e634cb2b6e12a73$var$DataRouterStateHook.UseMatches);
    return $d51ff6fbc6548743$exports.useMemo(()=>matches.map((m)=>(0, $c846480b5114588d$export$b3fac024fad9e8ff)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $2e634cb2b6e12a73$export$1448a5050d252c4d() {
    let state = $2e634cb2b6e12a73$var$useDataRouterState($2e634cb2b6e12a73$var$DataRouterStateHook.UseLoaderData);
    let routeId = $2e634cb2b6e12a73$var$useCurrentRouteId($2e634cb2b6e12a73$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $2e634cb2b6e12a73$export$fd5d37484eab868d(routeId) {
    let state = $2e634cb2b6e12a73$var$useDataRouterState($2e634cb2b6e12a73$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $2e634cb2b6e12a73$export$fdc00f3f26066d5e() {
    let state = $2e634cb2b6e12a73$var$useDataRouterState($2e634cb2b6e12a73$var$DataRouterStateHook.UseActionData);
    let route = $d51ff6fbc6548743$exports.useContext($2e634cb2b6e12a73$export$9072aa6dd1f93057);
    !route && (0, $c846480b5114588d$export$3e9cee6b33872309)(false);
    return Object.values((state == null ? void 0 : state.actionData) || {})[0];
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $2e634cb2b6e12a73$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $d51ff6fbc6548743$exports.useContext($2e634cb2b6e12a73$var$RouteErrorContext);
    let state = $2e634cb2b6e12a73$var$useDataRouterState($2e634cb2b6e12a73$var$DataRouterStateHook.UseRouteError);
    let routeId = $2e634cb2b6e12a73$var$useCurrentRouteId($2e634cb2b6e12a73$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $2e634cb2b6e12a73$export$78a72ddb39bdd145() {
    let value = $d51ff6fbc6548743$exports.useContext($2e634cb2b6e12a73$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $2e634cb2b6e12a73$export$17f53340677d5831() {
    let value = $d51ff6fbc6548743$exports.useContext($2e634cb2b6e12a73$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $2e634cb2b6e12a73$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $2e634cb2b6e12a73$export$2af03a1de5c0910(shouldBlock) {
    let { router: router, basename: basename } = $2e634cb2b6e12a73$var$useDataRouterContext($2e634cb2b6e12a73$var$DataRouterHook.UseBlocker);
    let state = $2e634cb2b6e12a73$var$useDataRouterState($2e634cb2b6e12a73$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $d51ff6fbc6548743$exports.useState("");
    let blockerFunction = $d51ff6fbc6548743$exports.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $2e634cb2b6e12a73$var$_extends({}, currentLocation, {
                pathname: (0, $c846480b5114588d$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $2e634cb2b6e12a73$var$_extends({}, nextLocation, {
                pathname: (0, $c846480b5114588d$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $d51ff6fbc6548743$exports.useEffect(()=>{
        let key = String(++$2e634cb2b6e12a73$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $d51ff6fbc6548743$exports.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $c846480b5114588d$export$386d57f03f0b2883);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $2e634cb2b6e12a73$var$useNavigateStable() {
    let { router: router } = $2e634cb2b6e12a73$var$useDataRouterContext($2e634cb2b6e12a73$var$DataRouterHook.UseNavigateStable);
    let id = $2e634cb2b6e12a73$var$useCurrentRouteId($2e634cb2b6e12a73$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $d51ff6fbc6548743$exports.useRef(false);
    $2e634cb2b6e12a73$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $d51ff6fbc6548743$exports.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $2e634cb2b6e12a73$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $2e634cb2b6e12a73$var$alreadyWarned = {};
function $2e634cb2b6e12a73$var$warningOnce(key, cond, message) {
    if (!cond && !$2e634cb2b6e12a73$var$alreadyWarned[key]) $2e634cb2b6e12a73$var$alreadyWarned[key] = true;
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $2e634cb2b6e12a73$var$START_TRANSITION = "startTransition";
const $2e634cb2b6e12a73$var$startTransitionImpl = $d51ff6fbc6548743$exports[$2e634cb2b6e12a73$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $2e634cb2b6e12a73$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $d51ff6fbc6548743$exports.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $d51ff6fbc6548743$exports.useCallback((newState)=>{
        if (v7_startTransition && $2e634cb2b6e12a73$var$startTransitionImpl) $2e634cb2b6e12a73$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $d51ff6fbc6548743$exports.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    let navigator = $d51ff6fbc6548743$exports.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $d51ff6fbc6548743$exports.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $d51ff6fbc6548743$exports.createElement($d51ff6fbc6548743$exports.Fragment, null, /*#__PURE__*/ $d51ff6fbc6548743$exports.createElement($2e634cb2b6e12a73$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $d51ff6fbc6548743$exports.createElement($2e634cb2b6e12a73$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $d51ff6fbc6548743$exports.createElement($2e634cb2b6e12a73$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator
    }, state.initialized ? /*#__PURE__*/ $d51ff6fbc6548743$exports.createElement($2e634cb2b6e12a73$var$DataRoutes, {
        routes: router.routes,
        state: state
    }) : fallbackElement))), null);
}
function $2e634cb2b6e12a73$var$DataRoutes(_ref2) {
    let { routes: routes, state: state } = _ref2;
    return $2e634cb2b6e12a73$export$5fcee62552a12fbf(routes, undefined, state);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/router-components/memory-router
 */ function $2e634cb2b6e12a73$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $d51ff6fbc6548743$exports.useRef();
    if (historyRef.current == null) historyRef.current = (0, $c846480b5114588d$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $d51ff6fbc6548743$exports.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $d51ff6fbc6548743$exports.useCallback((newState)=>{
        v7_startTransition && $2e634cb2b6e12a73$var$startTransitionImpl ? $2e634cb2b6e12a73$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $d51ff6fbc6548743$exports.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $d51ff6fbc6548743$exports.createElement($2e634cb2b6e12a73$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/components/navigate
 */ function $2e634cb2b6e12a73$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$2e634cb2b6e12a73$export$9c954a9d03d32f4a() && (0, $c846480b5114588d$export$3e9cee6b33872309)(false);
    let { matches: matches } = $d51ff6fbc6548743$exports.useContext($2e634cb2b6e12a73$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $2e634cb2b6e12a73$export$45d76561a5302f2b();
    let navigate = $2e634cb2b6e12a73$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $c846480b5114588d$export$cae722b0cc860f13)(to, (0, $c846480b5114588d$export$90ba53ce1c7fdff2)(matches).map((match)=>match.pathnameBase), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $d51ff6fbc6548743$exports.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/components/outlet
 */ function $2e634cb2b6e12a73$export$910ae8079b2c2852(props) {
    return $2e634cb2b6e12a73$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/components/route
 */ function $2e634cb2b6e12a73$export$e7b0ac011bb776c6(_props) {
    (0, $c846480b5114588d$export$3e9cee6b33872309)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/router-components/router
 */ function $2e634cb2b6e12a73$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $c846480b5114588d$export$e19cd5f9376f8cee).Pop, navigator: navigator, static: staticProp = false } = _ref5;
    !!$2e634cb2b6e12a73$export$9c954a9d03d32f4a() && (0, $c846480b5114588d$export$3e9cee6b33872309)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $d51ff6fbc6548743$exports.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp
        }), [
        basename,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $c846480b5114588d$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $d51ff6fbc6548743$exports.useMemo(()=>{
        let trailingPathname = (0, $c846480b5114588d$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $d51ff6fbc6548743$exports.createElement($2e634cb2b6e12a73$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $d51ff6fbc6548743$exports.createElement($2e634cb2b6e12a73$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/components/routes
 */ function $2e634cb2b6e12a73$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $2e634cb2b6e12a73$export$5d3fca4a98652595($2e634cb2b6e12a73$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $2e634cb2b6e12a73$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $d51ff6fbc6548743$exports.createElement($2e634cb2b6e12a73$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $d51ff6fbc6548743$exports.createElement($2e634cb2b6e12a73$var$ResolveAwait, null, children));
}
var $2e634cb2b6e12a73$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($2e634cb2b6e12a73$var$AwaitRenderStatus || {});
const $2e634cb2b6e12a73$var$neverSettledPromise = new Promise(()=>{});
class $2e634cb2b6e12a73$var$AwaitErrorBoundary extends $d51ff6fbc6548743$exports.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $2e634cb2b6e12a73$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $2e634cb2b6e12a73$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $2e634cb2b6e12a73$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = promise._error !== undefined ? $2e634cb2b6e12a73$var$AwaitRenderStatus.error : promise._data !== undefined ? $2e634cb2b6e12a73$var$AwaitRenderStatus.success : $2e634cb2b6e12a73$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $2e634cb2b6e12a73$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $2e634cb2b6e12a73$var$AwaitRenderStatus.error && promise._error instanceof (0, $c846480b5114588d$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
        throw $2e634cb2b6e12a73$var$neverSettledPromise;
        if (status === $2e634cb2b6e12a73$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $2e634cb2b6e12a73$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $d51ff6fbc6548743$exports.createElement($2e634cb2b6e12a73$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $2e634cb2b6e12a73$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $d51ff6fbc6548743$exports.createElement($2e634cb2b6e12a73$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $2e634cb2b6e12a73$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $2e634cb2b6e12a73$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $d51ff6fbc6548743$exports.createElement($d51ff6fbc6548743$exports.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/utils/create-routes-from-children
 */ function $2e634cb2b6e12a73$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $d51ff6fbc6548743$exports.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $d51ff6fbc6548743$exports.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $d51ff6fbc6548743$exports.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $2e634cb2b6e12a73$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $2e634cb2b6e12a73$export$e7b0ac011bb776c6) && (0, $c846480b5114588d$export$3e9cee6b33872309)(false);
        !(!element.props.index || !element.props.children) && (0, $c846480b5114588d$export$3e9cee6b33872309)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $2e634cb2b6e12a73$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $2e634cb2b6e12a73$export$daf73786167a7f72(matches) {
    return $2e634cb2b6e12a73$var$_renderMatches(matches);
}
function $2e634cb2b6e12a73$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $d51ff6fbc6548743$exports.createElement(route.Component),
        Component: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $d51ff6fbc6548743$exports.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $2e634cb2b6e12a73$export$f30f7e456d254e83(routes, opts) {
    return (0, $c846480b5114588d$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $2e634cb2b6e12a73$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $c846480b5114588d$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $2e634cb2b6e12a73$export$52b333d321859367
    }).initialize();
}



function $34f84368c0c9d98a$var$_extends() {
    $34f84368c0c9d98a$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $34f84368c0c9d98a$var$_extends.apply(this, arguments);
}
function $34f84368c0c9d98a$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $34f84368c0c9d98a$var$defaultMethod = "get";
const $34f84368c0c9d98a$var$defaultEncType = "application/x-www-form-urlencoded";
function $34f84368c0c9d98a$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $34f84368c0c9d98a$var$isButtonElement(object) {
    return $34f84368c0c9d98a$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $34f84368c0c9d98a$var$isFormElement(object) {
    return $34f84368c0c9d98a$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $34f84368c0c9d98a$var$isInputElement(object) {
    return $34f84368c0c9d98a$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $34f84368c0c9d98a$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $34f84368c0c9d98a$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$34f84368c0c9d98a$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $34f84368c0c9d98a$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $34f84368c0c9d98a$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $34f84368c0c9d98a$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $34f84368c0c9d98a$var$_formDataSupportsSubmitter = null;
function $34f84368c0c9d98a$var$isFormDataSubmitterSupported() {
    if ($34f84368c0c9d98a$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $34f84368c0c9d98a$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $34f84368c0c9d98a$var$_formDataSupportsSubmitter = true;
    }
    return $34f84368c0c9d98a$var$_formDataSupportsSubmitter;
}
const $34f84368c0c9d98a$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $34f84368c0c9d98a$var$getFormEncType(encType) {
    if (encType != null && !$34f84368c0c9d98a$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $34f84368c0c9d98a$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($34f84368c0c9d98a$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $c846480b5114588d$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || $34f84368c0c9d98a$var$defaultMethod;
        encType = $34f84368c0c9d98a$var$getFormEncType(target.getAttribute("enctype")) || $34f84368c0c9d98a$var$defaultEncType;
        formData = new FormData(target);
    } else if ($34f84368c0c9d98a$var$isButtonElement(target) || $34f84368c0c9d98a$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error('Cannot submit a <button> or <input type="submit"> without a <form>');
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $c846480b5114588d$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $34f84368c0c9d98a$var$defaultMethod;
        encType = $34f84368c0c9d98a$var$getFormEncType(target.getAttribute("formenctype")) || $34f84368c0c9d98a$var$getFormEncType(form.getAttribute("enctype")) || $34f84368c0c9d98a$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$34f84368c0c9d98a$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($34f84368c0c9d98a$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $34f84368c0c9d98a$var$defaultMethod;
        action = null;
        encType = $34f84368c0c9d98a$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $34f84368c0c9d98a$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "unstable_viewTransition"
], $34f84368c0c9d98a$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "unstable_viewTransition",
    "children"
], $34f84368c0c9d98a$var$_excluded3 = [
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "submit",
    "relative",
    "preventScrollReset",
    "unstable_viewTransition"
];
function $34f84368c0c9d98a$export$1f3f55432a00e06d(routes, opts) {
    return (0, $c846480b5114588d$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $34f84368c0c9d98a$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $c846480b5114588d$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $34f84368c0c9d98a$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $2e634cb2b6e12a73$export$52b333d321859367),
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $34f84368c0c9d98a$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $c846480b5114588d$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $34f84368c0c9d98a$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $c846480b5114588d$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $34f84368c0c9d98a$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $2e634cb2b6e12a73$export$52b333d321859367),
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $34f84368c0c9d98a$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $34f84368c0c9d98a$var$_extends({}, state, {
        errors: $34f84368c0c9d98a$var$deserializeErrors(state.errors)
    });
    return state;
}
function $34f84368c0c9d98a$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $c846480b5114588d$export$6c6580e81da25755)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $34f84368c0c9d98a$export$7ad602f0e94e62d1 = /*#__PURE__*/ $d51ff6fbc6548743$exports.createContext({
    isTransitioning: false
});
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $34f84368c0c9d98a$var$START_TRANSITION = "startTransition";
const $34f84368c0c9d98a$var$startTransitionImpl = $d51ff6fbc6548743$exports[$34f84368c0c9d98a$var$START_TRANSITION];
function $34f84368c0c9d98a$var$startTransitionSafe(cb) {
    if ($34f84368c0c9d98a$var$startTransitionImpl) $34f84368c0c9d98a$var$startTransitionImpl(cb);
    else cb();
}
class $34f84368c0c9d98a$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $34f84368c0c9d98a$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $d51ff6fbc6548743$exports.useState(router.state);
    let [pendingState, setPendingState] = $d51ff6fbc6548743$exports.useState();
    let [vtContext, setVtContext] = $d51ff6fbc6548743$exports.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $d51ff6fbc6548743$exports.useState();
    let [transition, setTransition] = $d51ff6fbc6548743$exports.useState();
    let [interruption, setInterruption] = $d51ff6fbc6548743$exports.useState();
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $d51ff6fbc6548743$exports.useCallback((cb)=>{
        if (v7_startTransition) $34f84368c0c9d98a$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $d51ff6fbc6548743$exports.useCallback((newState, _ref2)=>{
        let { unstable_viewTransitionOpts: viewTransitionOpts } = _ref2;
        if (!viewTransitionOpts || router.window == null || typeof router.window.document.startViewTransition !== "function") // Mid-navigation state update, or startViewTransition isn't available
        optInStartTransition(()=>setStateImpl(newState));
        else if (transition && renderDfd) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        optInStartTransition,
        transition,
        renderDfd,
        router.window
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $d51ff6fbc6548743$exports.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $d51ff6fbc6548743$exports.useEffect(()=>{
        if (vtContext.isTransitioning) setRenderDfd(new $34f84368c0c9d98a$var$Deferred());
    }, [
        vtContext.isTransitioning
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $d51ff6fbc6548743$exports.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $d51ff6fbc6548743$exports.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $d51ff6fbc6548743$exports.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    let navigator = $d51ff6fbc6548743$exports.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $d51ff6fbc6548743$exports.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $d51ff6fbc6548743$exports.createElement($d51ff6fbc6548743$exports.Fragment, null, /*#__PURE__*/ $d51ff6fbc6548743$exports.createElement((0, $2e634cb2b6e12a73$export$3add0d5dce533e2e).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $d51ff6fbc6548743$exports.createElement((0, $2e634cb2b6e12a73$export$145dfa71566a64dc).Provider, {
        value: state
    }, /*#__PURE__*/ $d51ff6fbc6548743$exports.createElement($34f84368c0c9d98a$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $d51ff6fbc6548743$exports.createElement((0, $2e634cb2b6e12a73$export$55185c17a0fcbe46), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator
    }, state.initialized ? /*#__PURE__*/ $d51ff6fbc6548743$exports.createElement($34f84368c0c9d98a$var$DataRoutes, {
        routes: router.routes,
        state: state
    }) : fallbackElement)))), null);
}
function $34f84368c0c9d98a$var$DataRoutes(_ref3) {
    let { routes: routes, state: state } = _ref3;
    return (0, $2e634cb2b6e12a73$export$5fcee62552a12fbf)(routes, undefined, state);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $34f84368c0c9d98a$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $d51ff6fbc6548743$exports.useRef();
    if (historyRef.current == null) historyRef.current = (0, $c846480b5114588d$export$719fc203c4e16dee)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $d51ff6fbc6548743$exports.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $d51ff6fbc6548743$exports.useCallback((newState)=>{
        v7_startTransition && $34f84368c0c9d98a$var$startTransitionImpl ? $34f84368c0c9d98a$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $d51ff6fbc6548743$exports.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $d51ff6fbc6548743$exports.createElement((0, $2e634cb2b6e12a73$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $34f84368c0c9d98a$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $d51ff6fbc6548743$exports.useRef();
    if (historyRef.current == null) historyRef.current = (0, $c846480b5114588d$export$b71fdd3798280242)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $d51ff6fbc6548743$exports.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $d51ff6fbc6548743$exports.useCallback((newState)=>{
        v7_startTransition && $34f84368c0c9d98a$var$startTransitionImpl ? $34f84368c0c9d98a$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $d51ff6fbc6548743$exports.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $d51ff6fbc6548743$exports.createElement((0, $2e634cb2b6e12a73$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $34f84368c0c9d98a$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $d51ff6fbc6548743$exports.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $d51ff6fbc6548743$exports.useCallback((newState)=>{
        v7_startTransition && $34f84368c0c9d98a$var$startTransitionImpl ? $34f84368c0c9d98a$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $d51ff6fbc6548743$exports.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $d51ff6fbc6548743$exports.createElement((0, $2e634cb2b6e12a73$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
const $34f84368c0c9d98a$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $34f84368c0c9d98a$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $34f84368c0c9d98a$export$a6c7ac8248d6e38a = /*#__PURE__*/ $d51ff6fbc6548743$exports.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, unstable_viewTransition: unstable_viewTransition } = _ref7, rest = $34f84368c0c9d98a$var$_objectWithoutPropertiesLoose(_ref7, $34f84368c0c9d98a$var$_excluded);
    let { basename: basename } = $d51ff6fbc6548743$exports.useContext((0, $2e634cb2b6e12a73$export$26749e8557646306));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $34f84368c0c9d98a$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($34f84368c0c9d98a$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $c846480b5114588d$export$b69e3301ce081aa3)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $2e634cb2b6e12a73$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    let internalOnClick = $34f84368c0c9d98a$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        unstable_viewTransition: unstable_viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $d51ff6fbc6548743$exports.createElement("a", $34f84368c0c9d98a$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $34f84368c0c9d98a$export$b0d92dbee9b5b60d = /*#__PURE__*/ $d51ff6fbc6548743$exports.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, unstable_viewTransition: unstable_viewTransition, children: children } = _ref8, rest = $34f84368c0c9d98a$var$_objectWithoutPropertiesLoose(_ref8, $34f84368c0c9d98a$var$_excluded2);
    let path = (0, $2e634cb2b6e12a73$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    let location = (0, $2e634cb2b6e12a73$export$45d76561a5302f2b)();
    let routerState = $d51ff6fbc6548743$exports.useContext((0, $2e634cb2b6e12a73$export$145dfa71566a64dc));
    let { navigator: navigator } = $d51ff6fbc6548743$exports.useContext((0, $2e634cb2b6e12a73$export$26749e8557646306));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $34f84368c0c9d98a$export$328fe15191788e7f(path) && unstable_viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(toPathname.length) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $d51ff6fbc6548743$exports.createElement($34f84368c0c9d98a$export$a6c7ac8248d6e38a, $34f84368c0c9d98a$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        unstable_viewTransition: unstable_viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $34f84368c0c9d98a$export$a7fed597f4b8afd8 = /*#__PURE__*/ $d51ff6fbc6548743$exports.forwardRef((props, ref)=>{
    let submit = $34f84368c0c9d98a$export$47c85c6e3a081d3();
    return /*#__PURE__*/ $d51ff6fbc6548743$exports.createElement($34f84368c0c9d98a$var$FormImpl, $34f84368c0c9d98a$var$_extends({}, props, {
        submit: submit,
        ref: ref
    }));
});
const $34f84368c0c9d98a$var$FormImpl = /*#__PURE__*/ $d51ff6fbc6548743$exports.forwardRef((_ref9, forwardedRef)=>{
    let { reloadDocument: reloadDocument, replace: replace, state: state, method: method = $34f84368c0c9d98a$var$defaultMethod, action: action, onSubmit: onSubmit, submit: submit, relative: relative, preventScrollReset: preventScrollReset, unstable_viewTransition: unstable_viewTransition } = _ref9, props = $34f84368c0c9d98a$var$_objectWithoutPropertiesLoose(_ref9, $34f84368c0c9d98a$var$_excluded3);
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let formAction = $34f84368c0c9d98a$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            method: submitMethod,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            unstable_viewTransition: unstable_viewTransition
        });
    };
    return /*#__PURE__*/ $d51ff6fbc6548743$exports.createElement("form", $34f84368c0c9d98a$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $34f84368c0c9d98a$export$11aac1aab828f1fa(_ref10) {
    let { getKey: getKey, storageKey: storageKey } = _ref10;
    $34f84368c0c9d98a$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $34f84368c0c9d98a$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($34f84368c0c9d98a$var$DataRouterHook || ($34f84368c0c9d98a$var$DataRouterHook = {}));
var $34f84368c0c9d98a$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($34f84368c0c9d98a$var$DataRouterStateHook || ($34f84368c0c9d98a$var$DataRouterStateHook = {}));
function $34f84368c0c9d98a$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $34f84368c0c9d98a$var$useDataRouterContext(hookName) {
    let ctx = $d51ff6fbc6548743$exports.useContext((0, $2e634cb2b6e12a73$export$3add0d5dce533e2e));
    !ctx && (0, $c846480b5114588d$export$3e9cee6b33872309)(false);
    return ctx;
}
function $34f84368c0c9d98a$var$useDataRouterState(hookName) {
    let state = $d51ff6fbc6548743$exports.useContext((0, $2e634cb2b6e12a73$export$145dfa71566a64dc));
    !state && (0, $c846480b5114588d$export$3e9cee6b33872309)(false);
    return state;
}
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $34f84368c0c9d98a$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, unstable_viewTransition: unstable_viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $2e634cb2b6e12a73$export$9770f232ac06a008)();
    let location = (0, $2e634cb2b6e12a73$export$45d76561a5302f2b)();
    let path = (0, $2e634cb2b6e12a73$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $d51ff6fbc6548743$exports.useCallback((event)=>{
        if ($34f84368c0c9d98a$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $c846480b5114588d$export$fe53371bee54353d)(location) === (0, $c846480b5114588d$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                unstable_viewTransition: unstable_viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        unstable_viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $34f84368c0c9d98a$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $d51ff6fbc6548743$exports.useRef($34f84368c0c9d98a$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $d51ff6fbc6548743$exports.useRef(false);
    let location = (0, $2e634cb2b6e12a73$export$45d76561a5302f2b)();
    let searchParams = $d51ff6fbc6548743$exports.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $34f84368c0c9d98a$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $2e634cb2b6e12a73$export$9770f232ac06a008)();
    let setSearchParams = $d51ff6fbc6548743$exports.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $34f84368c0c9d98a$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $34f84368c0c9d98a$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $34f84368c0c9d98a$export$47c85c6e3a081d3() {
    let { router: router } = $34f84368c0c9d98a$var$useDataRouterContext($34f84368c0c9d98a$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $d51ff6fbc6548743$exports.useContext((0, $2e634cb2b6e12a73$export$26749e8557646306));
    let currentRouteId = (0, $2e634cb2b6e12a73$export$5fc8298006ad9e58)();
    return $d51ff6fbc6548743$exports.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $34f84368c0c9d98a$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $34f84368c0c9d98a$var$getFormSubmissionInfo(target, basename);
        router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            unstable_viewTransition: options.unstable_viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
/**
 * Returns the implementation for fetcher.submit
 */ function $34f84368c0c9d98a$var$useSubmitFetcher(fetcherKey, fetcherRouteId) {
    let { router: router } = $34f84368c0c9d98a$var$useDataRouterContext($34f84368c0c9d98a$var$DataRouterHook.UseSubmitFetcher);
    let { basename: basename } = $d51ff6fbc6548743$exports.useContext((0, $2e634cb2b6e12a73$export$26749e8557646306));
    return $d51ff6fbc6548743$exports.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $34f84368c0c9d98a$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $34f84368c0c9d98a$var$getFormSubmissionInfo(target, basename);
        !(fetcherRouteId != null) && (0, $c846480b5114588d$export$3e9cee6b33872309)(false);
        router.fetch(fetcherKey, fetcherRouteId, options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType
        });
    }, [
        router,
        basename,
        fetcherKey,
        fetcherRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $34f84368c0c9d98a$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $d51ff6fbc6548743$exports.useContext((0, $2e634cb2b6e12a73$export$26749e8557646306));
    let routeContext = $d51ff6fbc6548743$exports.useContext((0, $2e634cb2b6e12a73$export$9072aa6dd1f93057));
    !routeContext && (0, $c846480b5114588d$export$3e9cee6b33872309)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $34f84368c0c9d98a$var$_extends({}, (0, $2e634cb2b6e12a73$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    }));
    // Previously we set the default action to ".". The problem with this is that
    // `useResolvedPath(".")` excludes search params of the resolved URL. This is
    // the intended behavior of when "." is specifically provided as
    // the form action, but inconsistent w/ browsers when the action is omitted.
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $2e634cb2b6e12a73$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove the automatically
        // inserted ?index param so we match the useResolvedPath search behavior
        // which would not include ?index
        if (match.route.index) {
            let params = new URLSearchParams(path.search);
            params.delete("index");
            path.search = params.toString() ? "?" + params.toString() : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $c846480b5114588d$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $c846480b5114588d$export$fe53371bee54353d)(path);
}
function $34f84368c0c9d98a$var$createFetcherForm(fetcherKey, routeId) {
    let FetcherForm = /*#__PURE__*/ $d51ff6fbc6548743$exports.forwardRef((props, ref)=>{
        let submit = $34f84368c0c9d98a$var$useSubmitFetcher(fetcherKey, routeId);
        return /*#__PURE__*/ $d51ff6fbc6548743$exports.createElement($34f84368c0c9d98a$var$FormImpl, $34f84368c0c9d98a$var$_extends({}, props, {
            ref: ref,
            submit: submit
        }));
    });
    return FetcherForm;
}
let $34f84368c0c9d98a$var$fetcherId = 0;
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $34f84368c0c9d98a$export$5b0d2d9a9921565a() {
    var _route$matches;
    let { router: router } = $34f84368c0c9d98a$var$useDataRouterContext($34f84368c0c9d98a$var$DataRouterHook.UseFetcher);
    let route = $d51ff6fbc6548743$exports.useContext((0, $2e634cb2b6e12a73$export$9072aa6dd1f93057));
    !route && (0, $c846480b5114588d$export$3e9cee6b33872309)(false);
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !(routeId != null) && (0, $c846480b5114588d$export$3e9cee6b33872309)(false);
    let [fetcherKey] = $d51ff6fbc6548743$exports.useState(()=>String(++$34f84368c0c9d98a$var$fetcherId));
    let [Form] = $d51ff6fbc6548743$exports.useState(()=>{
        !routeId && (0, $c846480b5114588d$export$3e9cee6b33872309)(false);
        return $34f84368c0c9d98a$var$createFetcherForm(fetcherKey, routeId);
    });
    let [load] = $d51ff6fbc6548743$exports.useState(()=>(href)=>{
            !router && (0, $c846480b5114588d$export$3e9cee6b33872309)(false);
            !routeId && (0, $c846480b5114588d$export$3e9cee6b33872309)(false);
            router.fetch(fetcherKey, routeId, href);
        });
    let submit = $34f84368c0c9d98a$var$useSubmitFetcher(fetcherKey, routeId);
    let fetcher = router.getFetcher(fetcherKey);
    let fetcherWithComponents = $d51ff6fbc6548743$exports.useMemo(()=>$34f84368c0c9d98a$var$_extends({
            Form: Form,
            submit: submit,
            load: load
        }, fetcher), [
        fetcher,
        Form,
        submit,
        load
    ]);
    $d51ff6fbc6548743$exports.useEffect(()=>{
        // Is this busted when the React team gets real weird and calls effects
        // twice on mount?  We really just need to garbage collect here when this
        // fetcher is no longer around.
        return ()=>{
            if (!router) {
                console.warn("No router available to clean up from useFetcher()");
                return;
            }
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $34f84368c0c9d98a$export$fa996778a3a31087() {
    let state = $34f84368c0c9d98a$var$useDataRouterState($34f84368c0c9d98a$var$DataRouterStateHook.UseFetchers);
    return [
        ...state.fetchers.values()
    ];
}
const $34f84368c0c9d98a$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $34f84368c0c9d98a$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $34f84368c0c9d98a$export$25057cfe5591e3e9(_temp3) {
    let { getKey: getKey, storageKey: storageKey } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $34f84368c0c9d98a$var$useDataRouterContext($34f84368c0c9d98a$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $34f84368c0c9d98a$var$useDataRouterState($34f84368c0c9d98a$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $d51ff6fbc6548743$exports.useContext((0, $2e634cb2b6e12a73$export$26749e8557646306));
    let location = (0, $2e634cb2b6e12a73$export$45d76561a5302f2b)();
    let matches = (0, $2e634cb2b6e12a73$export$2378eb7f5ff86053)();
    let navigation = (0, $2e634cb2b6e12a73$export$d0fd4b7106de2769)();
    // Trigger manual scroll restoration while we're active
    $d51ff6fbc6548743$exports.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $34f84368c0c9d98a$var$usePageHide($d51ff6fbc6548743$exports.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $34f84368c0c9d98a$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $34f84368c0c9d98a$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($34f84368c0c9d98a$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $d51ff6fbc6548743$exports.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $34f84368c0c9d98a$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $34f84368c0c9d98a$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $d51ff6fbc6548743$exports.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($34f84368c0c9d98a$var$_extends({}, location, {
                    pathname: (0, $c846480b5114588d$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($34f84368c0c9d98a$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $d51ff6fbc6548743$exports.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $34f84368c0c9d98a$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $d51ff6fbc6548743$exports.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $34f84368c0c9d98a$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $d51ff6fbc6548743$exports.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $34f84368c0c9d98a$export$39f4eb3dbd812741(_ref11) {
    let { when: when, message: message } = _ref11;
    let blocker = (0, $2e634cb2b6e12a73$export$2af03a1de5c0910)(when);
    $d51ff6fbc6548743$exports.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $d51ff6fbc6548743$exports.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $34f84368c0c9d98a$export$328fe15191788e7f(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $d51ff6fbc6548743$exports.useContext($34f84368c0c9d98a$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $c846480b5114588d$export$3e9cee6b33872309)(false);
    let { basename: basename } = $34f84368c0c9d98a$var$useDataRouterContext($34f84368c0c9d98a$var$DataRouterHook.useViewTransitionState);
    let path = (0, $2e634cb2b6e12a73$export$e75d2a2d1b3c245b)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $c846480b5114588d$export$b69e3301ce081aa3)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $c846480b5114588d$export$b69e3301ce081aa3)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" unstable_viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" unstable_viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $c846480b5114588d$export$81336c211d5ff295)(path.pathname, nextPath) != null || (0, $c846480b5114588d$export$81336c211d5ff295)(path.pathname, currentPath) != null;
}


var $686605276d736576$exports = {};
$686605276d736576$exports = new URL("zusam_logo.1eebfd28.svg", import.meta.url).toString();


function $53140ff71bd6800b$export$2e2bcd8739ae039() {
    const [sending, setSending] = (0, $88a9540d1aad6464$export$60241385465d0a34)(false);
    const [showResetPassword, setShowResetPassword] = (0, $88a9540d1aad6464$export$60241385465d0a34)(false);
    const navigate = (0, $2e634cb2b6e12a73$export$9770f232ac06a008)();
    const { t: t } = (0, $23287d5819478a30$export$9fc83ad70ead8663)();
    (0, $88a9540d1aad6464$export$6d9c69b0de29b591)(()=>{
        // reroute if already logged in
        (0, $cd2f6546c5cf5c32$export$ddcffe0146c8f882).get("apiKey").then((apiKey)=>apiKey && navigate("/"));
        (0, $cd2f6546c5cf5c32$export$ddcffe0146c8f882).reset();
    }, []);
    const sendPasswordReset = (e)=>{
        e.preventDefault();
        let login = document.getElementById("login").value || "";
        login.toLowerCase();
        setSending(true);
        (0, $cd2f6546c5cf5c32$export$7d6f1c8842f9f527).post("/api/password-reset-mail", {
            mail: login
        }).then((res)=>{
            setSending(false);
            if (res && !res.message) (0, $cd2f6546c5cf5c32$export$5ea928c9faf85bd3).add(t("password_reset_mail_sent"));
            else (0, $cd2f6546c5cf5c32$export$5ea928c9faf85bd3).add(t(res.message), "alert-danger");
        });
    };
    const sendLoginForm = (e)=>{
        e.preventDefault();
        setSending(true);
        let login = document.getElementById("login").value || "";
        login.toLowerCase();
        const password = document.getElementById("password").value;
        (0, $cd2f6546c5cf5c32$export$7d6f1c8842f9f527).post("/api/login", {
            login: login,
            password: password
        }).then((res)=>{
            setSending(false);
            if (res && res.api_key) (0, $cd2f6546c5cf5c32$export$ddcffe0146c8f882).set("apiKey", res.api_key).then(()=>{
                (0, $cd2f6546c5cf5c32$export$3e32638432616b6).update().then((user)=>{
                    let redirect = "/create-group";
                    if (user.data?.default_group) redirect = `/groups/${user?.data["default_group"]}`;
                    else if (user?.groups[0]) redirect = `/groups/${user?.groups[0].id}`;
                    navigate(redirect);
                });
            });
            else if (res && res.message) (0, $cd2f6546c5cf5c32$export$5ea928c9faf85bd3).add(t(res.message), "alert-danger");
            else (0, $cd2f6546c5cf5c32$export$5ea928c9faf85bd3).add(t("error"), "alert-danger");
        });
    };
    return (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
        class: "login"
    }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
        class: "login-form"
    }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("img", {
        src: new URL($686605276d736576$exports)
    }), !showResetPassword && (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("form", null, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
        class: "form-group mb-3"
    }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("input", {
        type: "email",
        class: "form-control",
        required: true,
        id: "login",
        placeholder: t("login_placeholder")
    })), (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
        class: "form-group"
    }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("input", {
        type: "password",
        class: "form-control",
        required: true,
        id: "password",
        placeholder: t("password_placeholder")
    })), (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
        class: "forgot-password"
    }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("span", {
        onClick: ()=>setShowResetPassword(true)
    }, t("forgot_password"))), (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("button", {
        type: "submit",
        class: "btn btn-light",
        onClick: (e)=>sendLoginForm(e),
        disabled: sending
    }, t("connect"))), !!showResetPassword && (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("form", null, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
        class: "form-group mb-3"
    }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("input", {
        type: "email",
        class: "form-control",
        required: true,
        id: "login",
        placeholder: t("login_placeholder")
    })), (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("button", {
        type: "submit",
        class: "btn btn-light",
        onClick: (e)=>sendPasswordReset(e),
        disabled: sending
    }, t("submit")))));
}






function $245fbd49526c814f$export$2e2bcd8739ae039() {
    const { t: t } = (0, $23287d5819478a30$export$9fc83ad70ead8663)();
    const navigate = (0, $2e634cb2b6e12a73$export$9770f232ac06a008)();
    const sendNewPassword = (e)=>{
        e.preventDefault();
        (0, $cd2f6546c5cf5c32$export$ddcffe0146c8f882).set("apiKey", "");
        const password = document.getElementById("password").value || "";
        const passwordConfirmation = document.getElementById("password_confirmation").value || "";
        const mail = (0, $cd2f6546c5cf5c32$export$5375cda95f0b0eb4).getParam("mail");
        const key = (0, $cd2f6546c5cf5c32$export$5375cda95f0b0eb4).getParam("key");
        if (mail && password) {
            if (password != passwordConfirmation) {
                (0, $cd2f6546c5cf5c32$export$5ea928c9faf85bd3).add(t("passwords_dont_match"));
                return;
            }
            (0, $cd2f6546c5cf5c32$export$7d6f1c8842f9f527).post("/api/new-password", {
                mail: mail,
                key: key,
                password: password
            }).then((res)=>{
                if (res.api_key) {
                    (0, $cd2f6546c5cf5c32$export$ddcffe0146c8f882).set("apiKey", res.api_key);
                    setTimeout(()=>navigate("/"), 100);
                } else (0, $cd2f6546c5cf5c32$export$5ea928c9faf85bd3).add(t(res.message));
            }).catch((res)=>console.warn(res));
        }
    };
    return (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
        class: "login"
    }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
        class: "login-form"
    }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("h2", {
        class: "title"
    }, t("reset_password_title")), (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("form", null, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
        class: "form-group"
    }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("input", {
        type: "password",
        class: "form-control",
        required: true,
        id: "password",
        placeholder: t("new_password_placeholder")
    })), (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
        class: "form-group"
    }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("input", {
        type: "password",
        class: "form-control",
        required: true,
        id: "password_confirmation",
        placeholder: t("confirm_password_placeholder")
    })), (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("button", {
        type: "submit",
        class: "btn btn-light",
        onClick: (e)=>sendNewPassword(e)
    }, t("submit")))));
}







function $7cecaa63b21a4acb$export$2e2bcd8739ae039() {
    const navigate = (0, $2e634cb2b6e12a73$export$9770f232ac06a008)();
    const { t: t } = (0, $23287d5819478a30$export$9fc83ad70ead8663)();
    const sendSignupForm = (e)=>{
        e.preventDefault();
        let login = document.getElementById("login").value || "";
        login.toLowerCase();
        const password = document.getElementById("password").value;
        (0, $cd2f6546c5cf5c32$export$ddcffe0146c8f882).set("apiKey", "");
        (0, $cd2f6546c5cf5c32$export$7d6f1c8842f9f527).post("/api/signup", {
            login: login,
            password: password,
            invite_key: (0, $cd2f6546c5cf5c32$export$5375cda95f0b0eb4).getParam("inviteKey")
        }).then((res)=>{
            if (res && !res.message) {
                (0, $cd2f6546c5cf5c32$export$ddcffe0146c8f882).set("apiKey", res.api_key);
                setTimeout(()=>navigate("/"), 100);
            } else (0, $cd2f6546c5cf5c32$export$5ea928c9faf85bd3).add(t(res.message));
        });
    };
    return (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
        class: "signup"
    }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
        class: "signup-form"
    }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("img", {
        src: new URL($686605276d736576$exports)
    }), (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
        class: "welcome lead"
    }, t("invitation_welcome")), (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("form", null, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
        class: "form-group"
    }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("input", {
        type: "email",
        class: "form-control",
        required: true,
        id: "login",
        placeholder: t("login_placeholder")
    })), (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
        class: "form-group"
    }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("input", {
        type: "password",
        class: "form-control",
        required: true,
        id: "password",
        placeholder: t("password_placeholder")
    })), (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("button", {
        type: "submit",
        class: "btn btn-light",
        onClick: (e)=>sendSignupForm(e)
    }, t("signup")))));
}





class $10fcb144e46b2198$var$StopNotificationEmails extends (0, $73048c6b859c8a02$export$16fa2f45be04daa8) {
    constructor(){
        super();
        (0, $cd2f6546c5cf5c32$export$7d6f1c8842f9f527).get(`/api${window.location.pathname}`).then(()=>{
            this.setState({
                message: this.props.t("notification_emails_stopped")
            });
        }).catch((err)=>{
            console.warn(err);
            this.setState({
                message: this.props.t("error")
            });
        });
    }
    render() {
        return (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", null, this.state.message || "");
    }
}
var $10fcb144e46b2198$export$2e2bcd8739ae039 = (0, $ee5bb531210bb8d0$export$2dcb0053efd21124)()($10fcb144e46b2198$var$StopNotificationEmails);









function $6e64521ddde455b6$export$2e2bcd8739ae039(props) {
    return (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)((0, $48e0eac2816dd5e6$export$2e2bcd8739ae039), {
        id: props.id,
        isChild: true
    });
}




function $02bd391920972de4$export$2e2bcd8739ae039(props) {
    const { t: t } = (0, $23287d5819478a30$export$9fc83ad70ead8663)();
    const [firstDisplayedChild, setFirstDisplayedChild] = (0, $88a9540d1aad6464$export$60241385465d0a34)(0);
    const [lastDisplayedChild, setLastDisplayedChild] = (0, $88a9540d1aad6464$export$60241385465d0a34)(0);
    const onNewChild = (event)=>{
        const newMsg = event.detail;
        if (newMsg.parent && (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).getId(newMsg.parent) == props.id) // a big number to display all children until the new one. This is not elegant...
        // The issue is that we can't simply increment lastDisplayedChild as it is not defined here
        // Another issue is that a user could load a comment in the middle of the list and create a new one...
        // The real answer is to make a paginated list but that is for another time
        setLastDisplayedChild(1024);
    };
    const displayPreviousChildren = ()=>{
        setFirstDisplayedChild(Math.max(0, firstDisplayedChild - 10));
    };
    const displayNextChildren = ()=>{
        setLastDisplayedChild(Math.min(props.childMessages.length, lastDisplayedChild + 10));
    };
    (0, $88a9540d1aad6464$export$6d9c69b0de29b591)(()=>{
        window.addEventListener("newChild", onNewChild);
        let firstDisplayedChild = 0;
        let lastDisplayedChild = 0;
        if (props.childMessages.length) {
            let msgIndex = (0, $cd2f6546c5cf5c32$export$5375cda95f0b0eb4).action ? props.childMessages.findIndex((e)=>e && e.id === (0, $cd2f6546c5cf5c32$export$5375cda95f0b0eb4).action) : -1;
            if (msgIndex != -1) {
                firstDisplayedChild = Math.max(0, msgIndex - 1);
                lastDisplayedChild = Math.min(props.childMessages.length, msgIndex + 1);
            } else {
                firstDisplayedChild = props.childMessages && props.childMessages.length - 5; // display the last 5 children
                lastDisplayedChild = props.childMessages && props.childMessages.length;
            }
        }
        setFirstDisplayedChild(firstDisplayedChild);
        setLastDisplayedChild(lastDisplayedChild);
    }, []);
    if (lastDisplayedChild - firstDisplayedChild < 1 || !props.childMessages) return null;
    return (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
        class: "children"
    }, firstDisplayedChild > 0 && (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
        class: "d-flex"
    }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("a", {
        class: "more-coms unselectable",
        onClick: ()=>displayPreviousChildren()
    }, t("previous_coms"))), props.childMessages.map((e, i)=>{
        if (i < firstDisplayedChild || i > lastDisplayedChild) return null;
        return (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)((0, $6e64521ddde455b6$export$2e2bcd8739ae039), {
            id: e.id,
            key: e.id
        });
    }), lastDisplayedChild + 1 < props.childMessages.length && (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
        class: "d-flex"
    }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("span", {
        class: "more-coms unselectable",
        onClick: ()=>displayNextChildren()
    }, t("next_coms"))));
}




function $d385cb0a744355a5$export$2e2bcd8739ae039(props) {
    return (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
        class: "message-head d-flex"
    }, !props.isPublic && (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", null, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("img", {
        className: `rounded-circle material-shadow avatar${props.author && props.author.name ? "" : " removed-user"}`,
        style: (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).backgroundHash(props.author && props.author.name ? props.author && props.author.id : ""),
        src: props.author && props.author.avatar ? (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).crop(props.author.avatar.id, 100, 100) : (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).defaultAvatar,
        title: props.author && props.author.name ? props.author.name : ""
    })), !props.isChild && !props.isPublic && (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
        class: "infos"
    }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("span", {
        class: "capitalize author"
    }, props.author && props.author.name ? props.author.name : "")));
}






// Fontawesome icons taken from https://raw.githubusercontent.com/FortAwesome/Font-Awesome/master/js/all.js
function $3e9f5419b3244add$var$FaIcon() {
    const icons = {
        regular: {
            comment: [
                512,
                512,
                [],
                "f075",
                "M256 32C114.6 32 0 125.1 0 240c0 47.6 19.9 91.2 52.9 126.3C38 405.7 7 439.1 6.5 439.5c-6.6 7-8.4 17.2-4.6 26S14.4 480 24 480c61.5 0 110-25.7 139.1-46.3C192 442.8 223.2 448 256 448c141.4 0 256-93.1 256-208S397.4 32 256 32zm0 368c-26.7 0-53.1-4.1-78.4-12.1l-22.7-7.2-19.5 13.8c-14.3 10.1-33.9 21.4-57.5 29 7.3-12.1 14.4-25.7 19.9-40.2l10.6-28.1-20.6-21.8C69.7 314.1 48 282.2 48 240c0-88.2 93.3-160 208-160s208 71.8 208 160-93.3 160-208 160z"
            ],
            bookmark: [
                384,
                512,
                [],
                "f02e",
                "M336 0H48C21.49 0 0 21.49 0 48v464l192-112 192 112V48c0-26.51-21.49-48-48-48zm0 428.43l-144-84-144 84V54a6 6 0 0 1 6-6h276c3.314 0 6 2.683 6 5.996V428.43z"
            ],
            images: [
                576,
                512,
                [],
                "f302",
                "M480 416v16c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V176c0-26.51 21.49-48 48-48h16v48H54a6 6 0 0 0-6 6v244a6 6 0 0 0 6 6h372a6 6 0 0 0 6-6v-10h48zm42-336H150a6 6 0 0 0-6 6v244a6 6 0 0 0 6 6h372a6 6 0 0 0 6-6V86a6 6 0 0 0-6-6zm6-48c26.51 0 48 21.49 48 48v256c0 26.51-21.49 48-48 48H144c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h384zM264 144c0 22.091-17.909 40-40 40s-40-17.909-40-40 17.909-40 40-40 40 17.909 40 40zm-72 96l39.515-39.515c4.686-4.686 12.284-4.686 16.971 0L288 240l103.515-103.515c4.686-4.686 12.284-4.686 16.971 0L480 208v80H192v-48z"
            ],
            "check-circle": [
                512,
                512,
                [],
                "f058",
                "M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0 48c110.532 0 200 89.451 200 200 0 110.532-89.451 200-200 200-110.532 0-200-89.451-200-200 0-110.532 89.451-200 200-200m140.204 130.267l-22.536-22.718c-4.667-4.705-12.265-4.736-16.97-.068L215.346 303.697l-59.792-60.277c-4.667-4.705-12.265-4.736-16.97-.069l-22.719 22.536c-4.705 4.667-4.736 12.265-.068 16.971l90.781 91.516c4.667 4.705 12.265 4.736 16.97.068l172.589-171.204c4.704-4.668 4.734-12.266.067-16.971z"
            ],
            "file-pdf": [
                384,
                512,
                [],
                "f1c1",
                "M369.9 97.9L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zM332.1 128H256V51.9l76.1 76.1zM48 464V48h160v104c0 13.3 10.7 24 24 24h104v288H48zm250.2-143.7c-12.2-12-47-8.7-64.4-6.5-17.2-10.5-28.7-25-36.8-46.3 3.9-16.1 10.1-40.6 5.4-56-4.2-26.2-37.8-23.6-42.6-5.9-4.4 16.1-.4 38.5 7 67.1-10 23.9-24.9 56-35.4 74.4-20 10.3-47 26.2-51 46.2-3.3 15.8 26 55.2 76.1-31.2 22.4-7.4 46.8-16.5 68.4-20.1 18.9 10.2 41 17 55.8 17 25.5 0 28-28.2 17.5-38.7zm-198.1 77.8c5.1-13.7 24.5-29.5 30.4-35-19 30.3-30.4 35.7-30.4 35zm81.6-190.6c7.4 0 6.7 32.1 1.8 40.8-4.4-13.9-4.3-40.8-1.8-40.8zm-24.4 136.6c9.7-16.9 18-37 24.7-54.7 8.3 15.1 18.9 27.2 30.1 35.5-20.8 4.3-38.9 13.1-54.8 19.2zm131.6-5s-5 6-37.3-7.8c35.1-2.6 40.9 5.4 37.3 7.8z"
            ],
            bell: [
                448,
                512,
                [],
                "f0f3",
                "M439.39 362.29c-19.32-20.76-55.47-51.99-55.47-154.29 0-77.7-54.48-139.9-127.94-155.16V32c0-17.67-14.32-32-31.98-32s-31.98 14.33-31.98 32v20.84C118.56 68.1 64.08 130.3 64.08 208c0 102.3-36.15 133.53-55.47 154.29-6 6.45-8.66 14.16-8.61 21.71.11 16.4 12.98 32 32.1 32h383.8c19.12 0 32-15.6 32.1-32 .05-7.55-2.61-15.27-8.61-21.71zM67.53 368c21.22-27.97 44.42-74.33 44.53-159.42 0-.2-.06-.38-.06-.58 0-61.86 50.14-112 112-112s112 50.14 112 112c0 .2-.06.38-.06.58.11 85.1 23.31 131.46 44.53 159.42H67.53zM224 512c35.32 0 63.97-28.65 63.97-64H160.03c0 35.35 28.65 64 63.97 64z"
            ],
            "level-down-alt": [
                320,
                512,
                [],
                "f3be",
                "M313.553 392.331L209.587 504.334c-9.485 10.214-25.676 10.229-35.174 0L70.438 392.331C56.232 377.031 67.062 352 88.025 352H152V80H68.024a11.996 11.996 0 0 1-8.485-3.515l-56-56C-4.021 12.926 1.333 0 12.024 0H208c13.255 0 24 10.745 24 24v328h63.966c20.878 0 31.851 24.969 17.587 40.331z"
            ]
        },
        solid: {
            bookmark: [
                384,
                512,
                [],
                "f02e",
                "M0 512V48C0 21.49 21.49 0 48 0h288c26.51 0 48 21.49 48 48v464L192 400 0 512z"
            ],
            comment: [
                512,
                512,
                [],
                "f075",
                "M256 32C114.6 32 0 125.1 0 240c0 49.6 21.4 95 57 130.7C44.5 421.1 2.7 466 2.2 466.5c-2.2 2.3-2.8 5.7-1.5 8.7S4.8 480 8 480c66.3 0 116-31.8 140.6-51.4 32.7 12.3 69 19.4 107.4 19.4 141.4 0 256-93.1 256-208S397.4 32 256 32z"
            ],
            "pencil-alt": [
                512,
                512,
                [],
                "f303",
                "M497.9 142.1l-46.1 46.1c-4.7 4.7-12.3 4.7-17 0l-111-111c-4.7-4.7-4.7-12.3 0-17l46.1-46.1c18.7-18.7 49.1-18.7 67.9 0l60.1 60.1c18.8 18.7 18.8 49.1 0 67.9zM284.2 99.8L21.6 362.4.4 483.9c-2.9 16.4 11.4 30.6 27.8 27.8l121.5-21.3 262.6-262.6c4.7-4.7 4.7-12.3 0-17l-111-111c-4.8-4.7-12.4-4.7-17.1 0zM124.1 339.9c-5.5-5.5-5.5-14.3 0-19.8l154-154c5.5-5.5 14.3-5.5 19.8 0s5.5 14.3 0 19.8l-154 154c-5.5 5.5-14.3 5.5-19.8 0zM88 424h48v36.3l-64.5 11.3-31.1-31.1L51.7 376H88v48z"
            ],
            "arrow-left": [
                448,
                512,
                [],
                "f060",
                "M257.5 445.1l-22.2 22.2c-9.4 9.4-24.6 9.4-33.9 0L7 273c-9.4-9.4-9.4-24.6 0-33.9L201.4 44.7c9.4-9.4 24.6-9.4 33.9 0l22.2 22.2c9.5 9.5 9.3 25-.4 34.3L136.6 216H424c13.3 0 24 10.7 24 24v32c0 13.3-10.7 24-24 24H136.6l120.5 114.8c9.8 9.3 10 24.8.4 34.3z"
            ],
            "caret-down": [
                320,
                512,
                [],
                "f0d7",
                "M31.3 192h257.3c17.8 0 26.7 21.5 14.1 34.1L174.1 354.8c-7.8 7.8-20.5 7.8-28.3 0L17.2 226.1C4.6 213.5 13.5 192 31.3 192z"
            ],
            film: [
                512,
                512,
                [],
                "f008",
                "M488 64h-8v20c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12V64H96v20c0 6.6-5.4 12-12 12H44c-6.6 0-12-5.4-12-12V64h-8C10.7 64 0 74.7 0 88v336c0 13.3 10.7 24 24 24h8v-20c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v20h320v-20c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v20h8c13.3 0 24-10.7 24-24V88c0-13.3-10.7-24-24-24zM96 372c0 6.6-5.4 12-12 12H44c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-96c0 6.6-5.4 12-12 12H44c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-96c0 6.6-5.4 12-12 12H44c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm272 208c0 6.6-5.4 12-12 12H156c-6.6 0-12-5.4-12-12v-96c0-6.6 5.4-12 12-12h200c6.6 0 12 5.4 12 12v96zm0-168c0 6.6-5.4 12-12 12H156c-6.6 0-12-5.4-12-12v-96c0-6.6 5.4-12 12-12h200c6.6 0 12 5.4 12 12v96zm112 152c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-96c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-96c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40z"
            ],
            times: [
                352,
                512,
                [],
                "f00d",
                "M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"
            ],
            bell: [
                448,
                512,
                [],
                "f0f3",
                "M224 512c35.32 0 63.97-28.65 63.97-64H160.03c0 35.35 28.65 64 63.97 64zm215.39-149.71c-19.32-20.76-55.47-51.99-55.47-154.29 0-77.7-54.48-139.9-127.94-155.16V32c0-17.67-14.32-32-31.98-32s-31.98 14.33-31.98 32v20.84C118.56 68.1 64.08 130.3 64.08 208c0 102.3-36.15 133.53-55.47 154.29-6 6.45-8.66 14.16-8.61 21.71.11 16.4 12.98 32 32.1 32h383.8c19.12 0 32-15.6 32.1-32 .05-7.55-2.61-15.27-8.61-21.71z"
            ],
            "ellipsis-h": [
                512,
                512,
                [],
                "f141",
                "M328 256c0 39.8-32.2 72-72 72s-72-32.2-72-72 32.2-72 72-72 72 32.2 72 72zm104-72c-39.8 0-72 32.2-72 72s32.2 72 72 72 72-32.2 72-72-32.2-72-72-72zm-352 0c-39.8 0-72 32.2-72 72s32.2 72 72 72 72-32.2 72-72-32.2-72-72-72z"
            ],
            search: [
                512,
                512,
                [],
                "f002",
                "M505 442.7L405.3 343c-4.5-4.5-10.6-7-17-7H372c27.6-35.3 44-79.7 44-128C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c48.3 0 92.7-16.4 128-44v16.3c0 6.4 2.5 12.5 7 17l99.7 99.7c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.6.1-34zM208 336c-70.7 0-128-57.2-128-128 0-70.7 57.2-128 128-128 70.7 0 128 57.2 128 128 0 70.7-57.2 128-128 128z"
            ]
        }
    };
    const icon = icons[this.props.family][this.props.icon];
    if (icon) return (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("svg", {
        style: this.props.rotation ? `transform: rotate(${this.props.rotation})` : null,
        className: `fa-icon ${this.props.family} ${this.props.icon}`,
        viewBox: `0 0 ${icon[0]} ${icon[1]}`
    }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("path", {
        fill: "currentColor",
        d: icon[4]
    }));
}
var $3e9f5419b3244add$export$2e2bcd8739ae039 = $3e9f5419b3244add$var$FaIcon;


const $607f51540ffcd426$export$8b29a4b6778bf7f = (0, $3e9f5419b3244add$export$2e2bcd8739ae039);










function $1d71a8627c3cc4ca$export$2e2bcd8739ae039(props) {
    const { t: t } = (0, $23287d5819478a30$export$9fc83ad70ead8663)();
    const groupId = (0, $88a9540d1aad6464$export$60241385465d0a34)(props.id);
    const [loaded, setLoaded] = (0, $88a9540d1aad6464$export$60241385465d0a34)(false);
    const [search, setSearch] = (0, $88a9540d1aad6464$export$60241385465d0a34)("");
    const [hashtags, setHashtags] = (0, $88a9540d1aad6464$export$60241385465d0a34)("");
    const [messages, setMessages] = (0, $88a9540d1aad6464$export$60241385465d0a34)([]);
    const loadMessages = ()=>{
        const search = (0, $cd2f6546c5cf5c32$export$5375cda95f0b0eb4).getParam("q");
        const hashtags = (0, $cd2f6546c5cf5c32$export$5375cda95f0b0eb4).getParam("hashtags");
        setSearch(search);
        setHashtags(hashtags);
        setLoaded(false);
        setMessages([]);
        (0, $cd2f6546c5cf5c32$export$7d6f1c8842f9f527).post("/api/messages/search", {
            group: groupId,
            search: search,
            hashtags: hashtags
        }).then((res)=>{
            if (res && Array.isArray(res["messages"])) {
                setSearch(search);
                setMessages(res["messages"]);
                setLoaded(true);
            }
        });
    };
    (0, $88a9540d1aad6464$export$6d9c69b0de29b591)(()=>{
        loadMessages();
        window.addEventListener("groupSearch", loadMessages);
        return ()=>{
            window.removeEventListener("groupSearch", loadMessages);
        };
    }, []);
    if (!Array.isArray(messages)) return;
    return (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", null, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("article", {
        id: "group",
        class: "justify-content-center d-flex"
    }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
        class: "search-results-container container-fluid d-flex justify-content-center flex-wrap"
    }, messages.length == 0 && !loaded && (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("p", null, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
        class: "mt-5 spinner orange-spinner"
    }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", null), (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", null), (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", null), (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", null), (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", null))), messages.length == 0 && loaded && (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("p", null, t("search_without_result")), messages.map((msg, i)=>{
        return (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)((0, $6a345a2434031edc$export$423dfe6469a8e0dd), {
            tabindex: i + 1,
            key: msg.id,
            message: msg,
            groupId: groupId,
            search: search,
            hashtags: hashtags
        });
    }))));
}





function $86c0079f7dba3fbc$export$2e2bcd8739ae039() {
    let params = (0, $2e634cb2b6e12a73$export$99eaa27ddbbb95ef)();
    return (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("main", null, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)((0, $520fa8871428281e$export$42cfbb80f7861e77), null), (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
        class: "content"
    }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("article", {
        class: "mb-3"
    }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
        class: "container pb-3"
    }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)((0, $520fa8871428281e$export$8eb86eb08c0b5c12), {
        key: params.id,
        id: params.id
    })))));
}






function $bdb02e7be54f3bf7$export$2e2bcd8739ae039() {
    const { t: t } = (0, $23287d5819478a30$export$9fc83ad70ead8663)();
    return (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)((0, $73048c6b859c8a02$export$ffb0004e005737fa), null, this.props.groups && (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
        class: "nav-link dropdown groups unselectable",
        tabindex: "-1",
        onClick: (e)=>e.currentTarget.classList.toggle("active")
    }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
        class: "unselectable pr-1"
    }, t("groups"), " ", (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)((0, $607f51540ffcd426$export$8b29a4b6778bf7f), {
        family: "solid",
        icon: "caret-down"
    })), (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
        class: "dropdown-menu dropdown-left"
    }, this.props.groups.filter((e)=>!!e).map((e)=>(0, $73048c6b859c8a02$export$c8a8987d4410bf2d)((0, $34f84368c0c9d98a$export$a6c7ac8248d6e38a), {
            key: e.id,
            to: `/groups/${e.id}`,
            class: "d-block seamless-link unselectable"
        }, e.name)), (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)((0, $34f84368c0c9d98a$export$a6c7ac8248d6e38a), {
        to: "/create-group",
        class: "seamless-link unselectable"
    }, `+ ${t("create_a_group")}`))));
}










let $5fa7d79990e2bc5d$export$554ccc96b126a426 = (0, $73048c6b859c8a02$export$fd42f52fd3ae1109)();
let $5fa7d79990e2bc5d$var$useIsomorphicLayoutEffect = typeof window !== "undefined" ? (0, $88a9540d1aad6464$export$e5c5a5f917a5871c) : (0, $88a9540d1aad6464$export$6d9c69b0de29b591);
let $5fa7d79990e2bc5d$export$b5d7ee322abba39e = (context)=>(...keys)=>{
        let store = (0, $88a9540d1aad6464$export$fae74005e78b1a27)(context);
        let rerender = (0, $88a9540d1aad6464$export$60241385465d0a34)({});
        $5fa7d79990e2bc5d$var$useIsomorphicLayoutEffect(()=>{
            return store.on("@changed", (_, changed)=>{
                let changesInKeys = keys.some((key)=>key in changed);
                if (changesInKeys) rerender[1]({});
            });
        }, []);
        return (0, $88a9540d1aad6464$export$1538c33de8887b59)(()=>{
            let state = store.get();
            let data = {};
            keys.forEach((key)=>{
                data[key] = state[key];
            });
            data.dispatch = store.dispatch;
            return data;
        }, [
            rerender[0]
        ]);
    };
let $5fa7d79990e2bc5d$export$11aeef812f154e9e = $5fa7d79990e2bc5d$export$b5d7ee322abba39e($5fa7d79990e2bc5d$export$554ccc96b126a426);
let $5fa7d79990e2bc5d$export$c8172487361f669f = (...keys)=>{
    let Component = keys.pop();
    return (0, $d51ff6fbc6548743$export$257a8862b851cb5b)((originProps, ref)=>{
        let props = {
            ...originProps,
            ...$5fa7d79990e2bc5d$export$11aeef812f154e9e(...keys),
            ref: ref
        };
        return (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)(Component, props);
    });
};



function $a069a14e59ed06ba$export$2e2bcd8739ae039() {
    const { t: t } = (0, $23287d5819478a30$export$9fc83ad70ead8663)();
    const { bookmarks: bookmarks } = (0, $5fa7d79990e2bc5d$export$11aeef812f154e9e)("bookmarks");
    const { me: me } = (0, $5fa7d79990e2bc5d$export$11aeef812f154e9e)("me");
    return (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
        class: "main-nav nav align-items-center z-index-100"
    }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
        class: "navbar-block"
    }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
        class: "menu dropdown cursor-pointer",
        tabindex: "-1",
        onClick: (e)=>e.currentTarget.classList.toggle("active")
    }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
        class: "rounded-circle avatar unselectable"
    }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("img", {
        class: "rounded-circle",
        style: (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).backgroundHash(me.id),
        src: me.avatar ? (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).crop(me.avatar["id"], 80, 80) : (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).defaultAvatar,
        onError: (e)=>e.currentTarget.src = (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).defaultAvatar
    })), (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
        class: "dropdown-menu dropdown-right"
    }, bookmarks?.length > 0 && (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)((0, $34f84368c0c9d98a$export$a6c7ac8248d6e38a), {
        class: "d-block seamless-link capitalize",
        to: "/bookmarks"
    }, t("bookmarks")), (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)((0, $34f84368c0c9d98a$export$a6c7ac8248d6e38a), {
        class: "d-block seamless-link capitalize",
        to: `/users/${me.id}/settings`
    }, t("settings")), (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)((0, $34f84368c0c9d98a$export$a6c7ac8248d6e38a), {
        class: "d-block seamless-link capitalize",
        to: "/logout"
    }, t("logout")))), (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)((0, $520fa8871428281e$export$2d8ae0bb40c793f6), null)), [
        "messages",
        "groups"
    ].includes((0, $cd2f6546c5cf5c32$export$5375cda95f0b0eb4).route) && (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)((0, $be03c4de42ac64ff$export$4b85d3515bd863a5), null), (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
        class: "navbar-block"
    }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)((0, $520fa8871428281e$export$ffe0a8eecde78dfa), {
        groups: me.groups
    })));
}








function $664ade9a4f66382d$var$_extends() {
    $664ade9a4f66382d$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $664ade9a4f66382d$var$_extends.apply(this, arguments);
}
function $664ade9a4f66382d$export$2e2bcd8739ae039() {
    const { t: t } = (0, $23287d5819478a30$export$9fc83ad70ead8663)();
    const { notifications: notifications } = (0, $5fa7d79990e2bc5d$export$11aeef812f154e9e)("notifications");
    if (!notifications) return null;
    return (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
        className: `menu dropdown${notifications.length ? " cursor-pointer" : ""}`,
        title: t("notifications"),
        tabindex: "-1",
        onClick: (e)=>notifications.length && e.currentTarget.classList.toggle("active")
    }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
        class: "unselectable button-with-count"
    }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)((0, $607f51540ffcd426$export$8b29a4b6778bf7f), {
        family: notifications.length ? "solid" : "regular",
        icon: "bell"
    }), !!notifications.filter((n)=>!n.read).length && (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
        class: "unread-badge"
    })), (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
        class: "dropdown-menu dropdown-right notifications-menu"
    }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
        class: "notification-header"
    }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("strong", {
        class: "capitalize"
    }, t("notifications")), (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
        class: "action capitalize",
        onClick: ()=>{
            (0, $cd2f6546c5cf5c32$export$6008d97729a90c74).markAllNotificationsAsRead();
        }
    }, t("mark_all_as_read"))), notifications?.length && notifications.sort((a, b)=>b.createdAt - a.createdAt).slice(0, (0, $cd2f6546c5cf5c32$export$6008d97729a90c74).LIMIT).map((e)=>(0, $73048c6b859c8a02$export$c8a8987d4410bf2d)((0, $be03c4de42ac64ff$export$14834abbfce3b8cd), $664ade9a4f66382d$var$_extends({
            key: e.id + e.read
        }, e)))));
}


const $520fa8871428281e$export$8eb86eb08c0b5c12 = (0, $1d71a8627c3cc4ca$export$2e2bcd8739ae039);
const $520fa8871428281e$export$5cc34a6155e65c0e = (0, $86c0079f7dba3fbc$export$2e2bcd8739ae039);
const $520fa8871428281e$export$ffe0a8eecde78dfa = (0, $bdb02e7be54f3bf7$export$2e2bcd8739ae039);
const $520fa8871428281e$export$42cfbb80f7861e77 = (0, $a069a14e59ed06ba$export$2e2bcd8739ae039);
const $520fa8871428281e$export$2d8ae0bb40c793f6 = (0, $664ade9a4f66382d$export$2e2bcd8739ae039);



function $6f8b52f4496f3b9a$export$2e2bcd8739ae039() {
    const { bookmarks: bookmarks } = (0, $5fa7d79990e2bc5d$export$11aeef812f154e9e)("bookmarks");
    if (!bookmarks) return null;
    if (!Array.isArray(bookmarks) || bookmarks.length < 1) return;
    return (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("main", null, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)((0, $520fa8871428281e$export$42cfbb80f7861e77), null), (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
        class: "content"
    }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("article", {
        id: "group",
        class: "justify-content-center d-flex"
    }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
        class: "message-container container-fluid d-flex justify-content-center flex-wrap"
    }, bookmarks.map((b, i)=>{
        return (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)((0, $6a345a2434031edc$export$84c965ec8b6b0f92), {
            tabindex: i + 1,
            key: b.message.id,
            id: b.message.id
        });
    })))));
}






class $dd2a1b0379ca9bf9$var$CreateGroup extends (0, $73048c6b859c8a02$export$16fa2f45be04daa8) {
    constructor(){
        super();
        this.postNewGroup = this.postNewGroup.bind(this);
    }
    postNewGroup(event) {
        event.preventDefault();
        const name = document.querySelector("#create_group_form input[name='name']").value;
        let group = {};
        if (name) group.name = name;
        else return false;
        group.createdAt = Math.floor(Date.now() / 1000);
        (0, $cd2f6546c5cf5c32$export$7d6f1c8842f9f527).post("/api/groups", group).then((res)=>{
            (0, $cd2f6546c5cf5c32$export$7d6f1c8842f9f527).post(`/api/groups/invitation/${res.secretKey}`, {}).then((res)=>{
                window.location = (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).toApp(`/groups/${res.id}`);
            });
        });
    }
    render() {
        return (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("main", null, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)((0, $520fa8871428281e$export$42cfbb80f7861e77), null), (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
            class: "content"
        }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
            class: "container mt-2"
        }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
            class: "group-settings"
        }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
            class: "card"
        }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
            class: "card-body"
        }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
            class: "container-fluid p-1"
        }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
            class: "row"
        }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
            class: "col-12 col-md-10"
        }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("form", {
            id: "create_group_form",
            class: "mb-1"
        }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
            class: "form-group"
        }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("label", {
            for: "name"
        }, this.props.t("name"), ": "), (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("input", {
            type: "text",
            name: "name",
            minlength: "1",
            maxlength: "128",
            placeholder: this.props.t("name_input"),
            class: "form-control",
            required: true
        })), (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("button", {
            onClick: (e)=>this.postNewGroup(e),
            class: "btn btn-primary"
        }, this.props.t("create_the_group"))))))))))));
    }
}
var $dd2a1b0379ca9bf9$export$2e2bcd8739ae039 = (0, $ee5bb531210bb8d0$export$2dcb0053efd21124)()($dd2a1b0379ca9bf9$var$CreateGroup);







function $4016a5cf4497ca7a$export$2e2bcd8739ae039() {
    let params = (0, $2e634cb2b6e12a73$export$99eaa27ddbbb95ef)();
    return (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("main", null, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)((0, $520fa8871428281e$export$42cfbb80f7861e77), null), (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
        class: "content"
    }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", null, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", null, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("article", {
        id: "group",
        class: "justify-content-center d-flex"
    }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
        class: "message-container container-fluid d-flex justify-content-center flex-wrap"
    }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)((0, $6a345a2434031edc$export$89085c7857c3f940), {
        key: params.id,
        id: params.id
    })))), (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)((0, $34f84368c0c9d98a$export$a6c7ac8248d6e38a), {
        class: "write-button material-shadow seamless-link",
        to: `/groups/${params.id}/write`
    }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)((0, $607f51540ffcd426$export$8b29a4b6778bf7f), {
        family: "solid",
        icon: "pencil-alt"
    })))));
}





function $aed7e74f78402a69$export$2e2bcd8739ae039(props) {
    const { t: t } = (0, $23287d5819478a30$export$9fc83ad70ead8663)();
    // duration relative to event
    const humanTime = (timestamp)=>{
        if (!timestamp) return null;
        const duration = Math.abs(Math.round((Date.now() / 1000 - timestamp) / 60));
        if (duration < 1) return t("just_now");
        if (duration < 60) return t("ago", {
            duration: `${duration}mn`
        });
        if (duration < 1440) return t("ago", {
            duration: `${Math.floor(duration / 60)}h`
        });
        return (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).humanFullDate(timestamp).split(" ")[0];
    };
    return (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)((0, $73048c6b859c8a02$export$ffb0004e005737fa), null, humanTime(props.timestamp));
}








function $73f3a1fb1b71c71a$export$2e2bcd8739ae039(props) {
    const { t: t } = (0, $23287d5819478a30$export$9fc83ad70ead8663)();
    const [target, setTarget] = (0, $88a9540d1aad6464$export$60241385465d0a34)(null);
    const [action, setAction] = (0, $88a9540d1aad6464$export$60241385465d0a34)(null);
    const [title, setTitle] = (0, $88a9540d1aad6464$export$60241385465d0a34)(null);
    const [author, setAuthor] = (0, $88a9540d1aad6464$export$60241385465d0a34)(null);
    const [notification, setNotification] = (0, $88a9540d1aad6464$export$60241385465d0a34)(null);
    const getMiniature = (notification)=>{
        let imgSrc = (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).defaultAvatar;
        if (notification?.miniature && notification.type != "global_notification") imgSrc = (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).crop(notification?.miniature?.id, 80, 80);
        return (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("img", {
            style: (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).backgroundHash(notification?.fromUser?.id),
            src: imgSrc,
            onError: (e)=>setMiniatureOnError(e)
        });
    };
    const setMiniatureOnError = (event)=>{
        event.currentTarget.src = (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).defaultAvatar;
    };
    const getAction = (notification)=>{
        switch(notification?.type){
            case "new_message":
                return t("has_posted_in");
            case "new_comment":
                return t("has_commented_on");
            case "user_joined_group":
                return t("has_joined");
            case "user_left_group":
                return t("has_left");
            case "group_name_change":
                return t("changed_group_name");
            default:
                return "";
        }
    };
    const getObject = (notification)=>{
        switch(notification?.type){
            case "new_message":
                return (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)((0, $73048c6b859c8a02$export$ffb0004e005737fa), null, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("strong", null, notification?.fromGroup.name), title && (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)((0, $73048c6b859c8a02$export$ffb0004e005737fa), null, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("br", null), (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("small", null, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("em", null, (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).limitStrSize(title, 50)))));
            case "new_comment":
                return (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("span", null, `${t("the_message_from")} `, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("strong", null, notification?.parentAuthorName), title && (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)((0, $73048c6b859c8a02$export$ffb0004e005737fa), null, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("br", null), (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("small", null, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("em", null, (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).limitStrSize(title, 50)))));
            case "user_joined_group":
            case "user_left_group":
                return (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("strong", null, notification?.fromGroup.name);
            case "group_name_change":
                return (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("span", null, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("strong", null, notification.data["previousGroupName"]), ` ${t("to")} `, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("strong", null, notification.data["newGroupName"]));
            case "global_notification":
                return notification.data["text"];
            default:
                return "";
        }
    };
    const getTarget = (notification, message_id)=>{
        switch(notification?.type){
            case "user_joined_group":
            case "user_left_group":
            case "group_name_change":
                return `/groups/${notification.fromGroup.id}`;
            case "new_message":
                return `/messages/${notification.target}`;
            case "new_comment":
                return `/messages/${message_id}/${notification.target}`;
            case "global_notification":
                return notification.target;
            default:
                return "";
        }
    };
    (0, $88a9540d1aad6464$export$6d9c69b0de29b591)(()=>{
        (0, $cd2f6546c5cf5c32$export$7d6f1c8842f9f527).get(`/api/notifications/${props.id}`, false, 100).then((n)=>{
            if (n) {
                setTarget(getTarget(n, n.fromMessage?.id));
                setAction(getAction(n));
                setTitle(n.title);
                if (n?.fromUser?.id) (0, $cd2f6546c5cf5c32$export$7d6f1c8842f9f527).get(`/api/users/${n.fromUser.id}`).then((u)=>{
                    setAuthor(u);
                });
                setNotification(n);
            }
        });
    }, []);
    if (!notification) return null;
    return (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)((0, $34f84368c0c9d98a$export$a6c7ac8248d6e38a), {
        key: props.id,
        class: `notification seamless-link unselectable ${!notification.read ? "unread" : ""}`,
        to: target,
        title: title
    }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
        class: "miniature unselectable"
    }, getMiniature(notification)), (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
        class: "infos"
    }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
        class: "description"
    }, notification.type != "global_notification" && (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)((0, $73048c6b859c8a02$export$ffb0004e005737fa), null, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("strong", null, author?.name || "--"), (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("span", null, ` ${action} `)), getObject(notification)), (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
        class: "date"
    }, (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).humanTime(notification.createdAt))), (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
        class: "options dropdown",
        onClick: (e)=>{
            e.stopPropagation();
            e.preventDefault();
            e?.target?.closest(".dropdown")?.classList.toggle("active");
        }
    }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
        class: "none-if-follows-empty"
    }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)((0, $607f51540ffcd426$export$8b29a4b6778bf7f), {
        family: "solid",
        icon: "ellipsis-h"
    })), (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
        class: "dropdown-menu dropdown-options"
    }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("a", {
        class: "seamless-link capitalize",
        onClick: ()=>(0, $cd2f6546c5cf5c32$export$6008d97729a90c74).removeMatchingNotifications(notification.id)
    }, t("delete")))));
}






function $2ed7e499aaac665f$export$2e2bcd8739ae039() {
    const params = (0, $2e634cb2b6e12a73$export$99eaa27ddbbb95ef)();
    const [message, setMessage] = (0, $88a9540d1aad6464$export$60241385465d0a34)(null);
    (0, $88a9540d1aad6464$export$6d9c69b0de29b591)(()=>{
        (0, $cd2f6546c5cf5c32$export$7d6f1c8842f9f527).get(`/api/groups/${params.id}/random`).then((m)=>{
            setMessage(m);
        });
    }, []);
    if (message) return (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)((0, $2e634cb2b6e12a73$export$444b3ab0cb9aec40), {
        to: `/messages/${message.id}`,
        replace: true
    });
}







function $a06567713ad1b415$export$2e2bcd8739ae039() {
    const { t: t } = (0, $23287d5819478a30$export$9fc83ad70ead8663)();
    const navigate = (0, $2e634cb2b6e12a73$export$9770f232ac06a008)();
    function search(evt) {
        evt.preventDefault();
        (0, $cd2f6546c5cf5c32$export$5375cda95f0b0eb4).getEntity().then((entity)=>{
            let group_id = null;
            switch(entity.entityType){
                case "group":
                    group_id = entity.id;
                    break;
                case "message":
                    group_id = entity.group.id;
                    break;
                default:
            }
            // https://stackoverflow.com/a/37511463
            let searchTerms = document.getElementById("search").value.normalize("NFD").replace(/[\u0300-\u036f]/g, "").split(" ");
            navigate(`/groups/${group_id}/search?q=${searchTerms.join("+")}`);
            window.dispatchEvent(new CustomEvent("groupSearch"));
        });
    }
    return (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("form", {
        class: "navbar-block search-block",
        onSubmit: (e)=>search(e)
    }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
        class: "input-group"
    }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("input", {
        class: "form-control",
        type: "text",
        id: "search",
        placeholder: t("search_in_group"),
        value: (0, $cd2f6546c5cf5c32$export$5375cda95f0b0eb4).getParam("q").replace(/\+/g, " ")
    }), (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
        class: "input-group-append"
    }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("button", {
        class: "btn btn-secondary",
        type: "submit"
    }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)((0, $607f51540ffcd426$export$8b29a4b6778bf7f), {
        family: "solid",
        icon: "search"
    })))));
}








function $37e28339f35f2974$export$2e2bcd8739ae039() {
    let params = (0, $2e634cb2b6e12a73$export$99eaa27ddbbb95ef)();
    return (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("main", null, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)((0, $520fa8871428281e$export$42cfbb80f7861e77), null), (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
        class: "content"
    }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("article", {
        class: "mb-3"
    }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
        class: "container pb-3"
    }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)((0, $b0c42e92c84db02f$export$d7a960146e1a269e), {
        focus: true,
        group: params.id
    })))));
}








// trick from https://stackoverflow.com/a/53837442
function $fe5a7484fb575b8e$var$useForceUpdate() {
    const setValue = (0, $88a9540d1aad6464$export$60241385465d0a34)(0)[1]; // integer state
    return ()=>setValue((value)=>value + 1); // update state to force render
}
function $fe5a7484fb575b8e$export$2e2bcd8739ae039(props) {
    const { t: t } = (0, $23287d5819478a30$export$9fc83ad70ead8663)();
    const navigate = (0, $2e634cb2b6e12a73$export$9770f232ac06a008)();
    const [files, setFiles] = (0, $88a9540d1aad6464$export$60241385465d0a34)(props?.files || []);
    const [sending, setSending] = (0, $88a9540d1aad6464$export$60241385465d0a34)(false);
    const [uploading, setUploading] = (0, $88a9540d1aad6464$export$60241385465d0a34)(false);
    const forceUpdate = $fe5a7484fb575b8e$var$useForceUpdate();
    const writerId = (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).genId();
    // This allows to have the latest state of files in callbacks
    // https://stackoverflow.com/a/60643670
    const currentFiles = (0, $88a9540d1aad6464$export$b8f5890fc79d6aca)();
    currentFiles.current = files;
    const setForm = (writerForm, files = [], title = "", text = "")=>{
        setFiles(files);
        Array.from(writerForm.current.getElementsByClassName("title-input")).map((e)=>e.value = title);
        Array.from(writerForm.current.getElementsByClassName("text-input")).map((e)=>e.value = text);
    };
    const updateFile = (id, file)=>{
        setFiles(currentFiles.current.map((f)=>f.id === id ? Object.assign(f, file) : f));
    };
    const invertFiles = (id_a, id_b)=>{
        const index_a = files.findIndex((e)=>e.id === id_a);
        const index_b = files.findIndex((e)=>e.id === id_b);
        [files[index_a], files[index_b]] = [
            files[index_b],
            files[index_a]
        ];
        setFiles(files);
        forceUpdate();
    };
    const removeFile = (id)=>{
        setFiles(files.filter((f)=>f.id != id));
    };
    const uploadFile = (fileId)=>{
        const formData = new FormData();
        let file = files.find((e)=>e.id == fileId);
        if (!file || !file.inputFile) {
            // TODO handle this properly
            console.error(files, file, fileId);
            throw "error";
        }
        formData.append("file", file.inputFile);
        updateFile(fileId, Object.assign(file, {
            status: "uploading"
        }));
        setUploading(true);
        (0, $cd2f6546c5cf5c32$export$7d6f1c8842f9f527).sendFile(formData, (file)=>{
            setUploading(false);
            updateFile(fileId, Object.assign({
                status: "ready"
            }, file));
        }, (e)=>{
            updateFile(fileId, {
                status: "uploading",
                progress: Math.floor(e.loaded / e.total * 100)
            });
        }, (e)=>{
            setUploading(false);
            console.warn(e);
            (0, $cd2f6546c5cf5c32$export$5ea928c9faf85bd3).add(t("error_upload"), "alert-danger");
            removeFile(fileId);
        });
    };
    const putMessage = (msg, writerForm)=>{
        (0, $cd2f6546c5cf5c32$export$7d6f1c8842f9f527).put(`/api/messages/${props.messageId}`, msg).then((res)=>{
            setForm(writerForm, [], "", "");
            setSending(false);
            if (!res) {
                (0, $cd2f6546c5cf5c32$export$5ea928c9faf85bd3).add(t("error_new_message"), "alert-danger");
                return;
            }
            window.dispatchEvent(new CustomEvent("editMessage", {
                detail: res
            }));
        });
        setSending(true);
    };
    const postMessage = (msg, writerForm)=>{
        msg = Object.assign(msg, {
            createdAt: Math.floor(Date.now() / 1000),
            author: (0, $cd2f6546c5cf5c32$export$3e32638432616b6).id,
            group: (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).getId(props.group),
            children: [],
            lastActivityDate: Math.floor(Date.now() / 1000)
        });
        if (props.parent) msg.parent = (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).getId(props.parent);
        // don't post if there is nothing to post
        if (!msg.files.length && !msg.data.text && !msg.data.title) {
            (0, $cd2f6546c5cf5c32$export$5ea928c9faf85bd3).add(t("empty_message"), "alert-danger");
            return;
        }
        (0, $cd2f6546c5cf5c32$export$7d6f1c8842f9f527).post("/api/messages", msg).then((res)=>{
            if (!res) {
                setSending(false);
                (0, $cd2f6546c5cf5c32$export$5ea928c9faf85bd3).add(t("error_new_message"), "alert-danger");
                return;
            }
            if (props.isChild) {
                setSending(false);
                window.dispatchEvent(new CustomEvent("newChild", {
                    detail: res
                }));
            } else navigate(`/messages/${res.id}`);
            setForm(writerForm, [], "", "");
        });
        setSending(true);
    };
    const sendMessage = (writerForm, data)=>{
        let msg = {
            files: files.filter((e)=>!e?.removed).filter((e)=>[
                    "ready",
                    "raw"
                ].includes(e?.status)).map((e)=>e?.id).filter((e)=>!!e),
            data: {
                title: data?.title,
                text: data?.text
            }
        };
        if (props.messageId) putMessage(msg, writerForm);
        else postMessage(msg, writerForm);
    };
    // toggle state (removed or not) of a file
    const toggleFile = (id)=>{
        setFiles(files.map((f)=>{
            if (f.id == id) f.removed = !f.removed;
            return f;
        }));
    };
    const addFiles = (mimetype, input_files)=>{
        let list = Array.from(input_files).map((e)=>({
                inputFile: e,
                type: mimetype,
                id: (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).genId(),
                progress: 0,
                status: "initial"
            }));
        setFiles([
            ...files,
            ...list
        ]);
    };
    const inputFile = (mimetype, multiple = false)=>{
        const input = document.createElement("input");
        document.body.appendChild(input);
        input.style.display = "none";
        input.type = "file";
        input.accept = mimetype;
        if (multiple) input.multiple = "multiple";
        input.addEventListener("change", (event)=>{
            addFiles(mimetype, event.target.files);
        });
        input.click();
    };
    (0, $88a9540d1aad6464$export$6d9c69b0de29b591)(()=>{
        if (files.filter((e)=>e.status === "uploading").length < 2) {
            for(let i = 0; i < files.length; i++)if (files[i].status == "initial" && !!files[i].inputFile) {
                uploadFile(files[i].id);
                break;
            }
        }
    }, [
        files
    ]);
    return (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)((0, $b0c42e92c84db02f$export$29beae8571dce55f), {
        id: writerId,
        sending: sending,
        uploading: uploading,
        inputFile: inputFile,
        sendMessage: sendMessage,
        cancel: props.cancel,
        files: files,
        toggleFile: toggleFile,
        invertFiles: invertFiles,
        addFiles: addFiles,
        group: props.group,
        isChild: props.isChild,
        text: props.text,
        title: props.title
    });
}









class $471cd1c649eea7ba$export$2e2bcd8739ae039 extends (0, $73048c6b859c8a02$export$16fa2f45be04daa8) {
    render() {
        const embedUrl = `${this.props.url}/size=large/bgcol=f5f5f5/linkcol=0687f5/minimal=true/tracklist=false/`;
        if (this.state.revealed) return (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
            class: "bandcamp-embed embed-responsive embed-responsive-1by1"
        }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("iframe", {
            class: "embed-responsive-item",
            src: embedUrl
        }));
        return (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
            class: "embed-preview",
            onClick: ()=>this.setState({
                    revealed: true
                })
        }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
            class: "bandcamp"
        }), (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("img", {
            src: this.props.preview
        }));
    }
}



class $1dd5e274a4fb4aa6$export$2e2bcd8739ae039 extends (0, $73048c6b859c8a02$export$16fa2f45be04daa8) {
    render() {
        if (this.state.revealed) return (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
            class: "embed-responsive embed-responsive-16by9"
        }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("iframe", {
            allowfullscreen: true,
            class: "embed-responsive-item",
            src: this.props.url
        }));
        return (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
            class: "embed-preview",
            onClick: ()=>this.setState({
                    revealed: true
                })
        }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
            className: this.props.playBtnClass
        }), (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("img", {
            src: this.props.preview
        }));
    }
}


var $42107f3179039eb0$exports = {};
!function(e, t) {
    $42107f3179039eb0$exports = t();
}($42107f3179039eb0$exports, function() {
    "use strict";
    function e(t) {
        return (e = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
            return typeof e;
        } : function(e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
        })(t);
    }
    function t(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }
    function i(e, t) {
        for(var i = 0; i < t.length; i++){
            var n = t[i];
            n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
        }
    }
    function n(e, t, n) {
        return t && i(e.prototype, t), n && i(e, n), e;
    }
    var s = Date.now();
    function l() {
        var e = {}, t = !0, i = 0, n = arguments.length;
        "[object Boolean]" === Object.prototype.toString.call(arguments[0]) && (t = arguments[0], i++);
        for(var s = function(i) {
            for(var n in i)Object.prototype.hasOwnProperty.call(i, n) && (t && "[object Object]" === Object.prototype.toString.call(i[n]) ? e[n] = l(!0, e[n], i[n]) : e[n] = i[n]);
        }; i < n; i++){
            var o = arguments[i];
            s(o);
        }
        return e;
    }
    function o(e, t) {
        if ((k(e) || e === window || e === document) && (e = [
            e
        ]), A(e) || L(e) || (e = [
            e
        ]), 0 != P(e)) {
            if (A(e) && !L(e)) for(var i = e.length, n = 0; n < i && !1 !== t.call(e[n], e[n], n, e); n++);
            else if (L(e)) {
                for(var s in e)if (O(e, s) && !1 === t.call(e[s], e[s], s, e)) break;
            }
        }
    }
    function r(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null, i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null, n = e[s] = e[s] || [], l = {
            all: n,
            evt: null,
            found: null
        };
        return t && i && P(n) > 0 && o(n, function(e, n) {
            if (e.eventName == t && e.fn.toString() == i.toString()) return l.found = !0, l.evt = n, !1;
        }), l;
    }
    function a(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, i = t.onElement, n = t.withCallback, s = t.avoidDuplicate, l = void 0 === s || s, a = t.once, h = void 0 !== a && a, d = t.useCapture, c = void 0 !== d && d, u = arguments.length > 2 ? arguments[2] : void 0, g = i || [];
        function v(e) {
            T(n) && n.call(u, e, this), h && v.destroy();
        }
        return C(g) && (g = document.querySelectorAll(g)), v.destroy = function() {
            o(g, function(t) {
                var i = r(t, e, v);
                i.found && i.all.splice(i.evt, 1), t.removeEventListener && t.removeEventListener(e, v, c);
            });
        }, o(g, function(t) {
            var i = r(t, e, v);
            (t.addEventListener && l && !i.found || !l) && (t.addEventListener(e, v, c), i.all.push({
                eventName: e,
                fn: v
            }));
        }), v;
    }
    function h(e, t) {
        o(t.split(" "), function(t) {
            return e.classList.add(t);
        });
    }
    function d(e, t) {
        o(t.split(" "), function(t) {
            return e.classList.remove(t);
        });
    }
    function c(e, t) {
        return e.classList.contains(t);
    }
    function u(e, t) {
        for(; e !== document.body;){
            if (!(e = e.parentElement)) return !1;
            if ("function" == typeof e.matches ? e.matches(t) : e.msMatchesSelector(t)) return e;
        }
    }
    function g(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "", i = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
        if (!e || "" === t) return !1;
        if ("none" === t) return T(i) && i(), !1;
        var n = x(), s = t.split(" ");
        o(s, function(t) {
            h(e, "g" + t);
        }), a(n, {
            onElement: e,
            avoidDuplicate: !1,
            once: !0,
            withCallback: function(e, t) {
                o(s, function(e) {
                    d(t, "g" + e);
                }), T(i) && i();
            }
        });
    }
    function v(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "";
        if ("" === t) return e.style.webkitTransform = "", e.style.MozTransform = "", e.style.msTransform = "", e.style.OTransform = "", e.style.transform = "", !1;
        e.style.webkitTransform = t, e.style.MozTransform = t, e.style.msTransform = t, e.style.OTransform = t, e.style.transform = t;
    }
    function f(e) {
        e.style.display = "block";
    }
    function p(e) {
        e.style.display = "none";
    }
    function m(e) {
        var t = document.createDocumentFragment(), i = document.createElement("div");
        for(i.innerHTML = e; i.firstChild;)t.appendChild(i.firstChild);
        return t;
    }
    function y() {
        return {
            width: window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth,
            height: window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight
        };
    }
    function x() {
        var e, t = document.createElement("fakeelement"), i = {
            animation: "animationend",
            OAnimation: "oAnimationEnd",
            MozAnimation: "animationend",
            WebkitAnimation: "webkitAnimationEnd"
        };
        for(e in i)if (void 0 !== t.style[e]) return i[e];
    }
    function b(e, t, i, n) {
        if (e()) t();
        else {
            var s;
            i || (i = 100);
            var l = setInterval(function() {
                e() && (clearInterval(l), s && clearTimeout(s), t());
            }, i);
            n && (s = setTimeout(function() {
                clearInterval(l);
            }, n));
        }
    }
    function S(e, t, i) {
        if (I(e)) console.error("Inject assets error");
        else if (T(t) && (i = t, t = !1), C(t) && t in window) T(i) && i();
        else {
            var n;
            if (-1 !== e.indexOf(".css")) {
                if ((n = document.querySelectorAll('link[href="' + e + '"]')) && n.length > 0) return void (T(i) && i());
                var s = document.getElementsByTagName("head")[0], l = s.querySelectorAll('link[rel="stylesheet"]'), o = document.createElement("link");
                return o.rel = "stylesheet", o.type = "text/css", o.href = e, o.media = "all", l ? s.insertBefore(o, l[0]) : s.appendChild(o), void (T(i) && i());
            }
            if ((n = document.querySelectorAll('script[src="' + e + '"]')) && n.length > 0) {
                if (T(i)) {
                    if (C(t)) return b(function() {
                        return void 0 !== window[t];
                    }, function() {
                        i();
                    }), !1;
                    i();
                }
            } else {
                var r = document.createElement("script");
                r.type = "text/javascript", r.src = e, r.onload = function() {
                    if (T(i)) {
                        if (C(t)) return b(function() {
                            return void 0 !== window[t];
                        }, function() {
                            i();
                        }), !1;
                        i();
                    }
                }, document.body.appendChild(r);
            }
        }
    }
    function w() {
        return "navigator" in window && window.navigator.userAgent.match(/(iPad)|(iPhone)|(iPod)|(Android)|(PlayBook)|(BB10)|(BlackBerry)|(Opera Mini)|(IEMobile)|(webOS)|(MeeGo)/i);
    }
    function T(e) {
        return "function" == typeof e;
    }
    function C(e) {
        return "string" == typeof e;
    }
    function k(e) {
        return !(!e || !e.nodeType || 1 != e.nodeType);
    }
    function E(e) {
        return Array.isArray(e);
    }
    function A(e) {
        return e && e.length && isFinite(e.length);
    }
    function L(t) {
        return "object" === e(t) && null != t && !T(t) && !E(t);
    }
    function I(e) {
        return null == e;
    }
    function O(e, t) {
        return null !== e && hasOwnProperty.call(e, t);
    }
    function P(e) {
        if (L(e)) {
            if (e.keys) return e.keys().length;
            var t = 0;
            for(var i in e)O(e, i) && t++;
            return t;
        }
        return e.length;
    }
    function M(e) {
        return !isNaN(parseFloat(e)) && isFinite(e);
    }
    function z() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : -1, t = document.querySelectorAll(".gbtn[data-taborder]:not(.disabled)");
        if (!t.length) return !1;
        if (1 == t.length) return t[0];
        "string" == typeof e && (e = parseInt(e));
        var i = [];
        o(t, function(e) {
            i.push(e.getAttribute("data-taborder"));
        });
        var n = Math.max.apply(Math, i.map(function(e) {
            return parseInt(e);
        })), s = e < 0 ? 1 : e + 1;
        s > n && (s = "1");
        var l = i.filter(function(e) {
            return e >= parseInt(s);
        }), r = l.sort()[0];
        return document.querySelector('.gbtn[data-taborder="'.concat(r, '"]'));
    }
    function X(e) {
        if (e.events.hasOwnProperty("keyboard")) return !1;
        e.events.keyboard = a("keydown", {
            onElement: window,
            withCallback: function(t, i) {
                var n = (t = t || window.event).keyCode;
                if (9 == n) {
                    var s = document.querySelector(".gbtn.focused");
                    if (!s) {
                        var l = !(!document.activeElement || !document.activeElement.nodeName) && document.activeElement.nodeName.toLocaleLowerCase();
                        if ("input" == l || "textarea" == l || "button" == l) return;
                    }
                    t.preventDefault();
                    var o = document.querySelectorAll(".gbtn[data-taborder]");
                    if (!o || o.length <= 0) return;
                    if (!s) {
                        var r = z();
                        return void (r && (r.focus(), h(r, "focused")));
                    }
                    var a = z(s.getAttribute("data-taborder"));
                    d(s, "focused"), a && (a.focus(), h(a, "focused"));
                }
                39 == n && e.nextSlide(), 37 == n && e.prevSlide(), 27 == n && e.close();
            }
        });
    }
    function Y(e) {
        return Math.sqrt(e.x * e.x + e.y * e.y);
    }
    function q(e, t) {
        var i = function(e, t) {
            var i = Y(e) * Y(t);
            if (0 === i) return 0;
            var n = function(e, t) {
                return e.x * t.x + e.y * t.y;
            }(e, t) / i;
            return n > 1 && (n = 1), Math.acos(n);
        }(e, t);
        return function(e, t) {
            return e.x * t.y - t.x * e.y;
        }(e, t) > 0 && (i *= -1), 180 * i / Math.PI;
    }
    var N = function() {
        function e(i) {
            t(this, e), this.handlers = [], this.el = i;
        }
        return n(e, [
            {
                key: "add",
                value: function(e) {
                    this.handlers.push(e);
                }
            },
            {
                key: "del",
                value: function(e) {
                    e || (this.handlers = []);
                    for(var t = this.handlers.length; t >= 0; t--)this.handlers[t] === e && this.handlers.splice(t, 1);
                }
            },
            {
                key: "dispatch",
                value: function() {
                    for(var e = 0, t = this.handlers.length; e < t; e++){
                        var i = this.handlers[e];
                        "function" == typeof i && i.apply(this.el, arguments);
                    }
                }
            }
        ]), e;
    }();
    function D(e, t) {
        var i = new N(e);
        return i.add(t), i;
    }
    var _ = function() {
        function e(i, n) {
            t(this, e), this.element = "string" == typeof i ? document.querySelector(i) : i, this.start = this.start.bind(this), this.move = this.move.bind(this), this.end = this.end.bind(this), this.cancel = this.cancel.bind(this), this.element.addEventListener("touchstart", this.start, !1), this.element.addEventListener("touchmove", this.move, !1), this.element.addEventListener("touchend", this.end, !1), this.element.addEventListener("touchcancel", this.cancel, !1), this.preV = {
                x: null,
                y: null
            }, this.pinchStartLen = null, this.zoom = 1, this.isDoubleTap = !1;
            var s = function() {};
            this.rotate = D(this.element, n.rotate || s), this.touchStart = D(this.element, n.touchStart || s), this.multipointStart = D(this.element, n.multipointStart || s), this.multipointEnd = D(this.element, n.multipointEnd || s), this.pinch = D(this.element, n.pinch || s), this.swipe = D(this.element, n.swipe || s), this.tap = D(this.element, n.tap || s), this.doubleTap = D(this.element, n.doubleTap || s), this.longTap = D(this.element, n.longTap || s), this.singleTap = D(this.element, n.singleTap || s), this.pressMove = D(this.element, n.pressMove || s), this.twoFingerPressMove = D(this.element, n.twoFingerPressMove || s), this.touchMove = D(this.element, n.touchMove || s), this.touchEnd = D(this.element, n.touchEnd || s), this.touchCancel = D(this.element, n.touchCancel || s), this.translateContainer = this.element, this._cancelAllHandler = this.cancelAll.bind(this), window.addEventListener("scroll", this._cancelAllHandler), this.delta = null, this.last = null, this.now = null, this.tapTimeout = null, this.singleTapTimeout = null, this.longTapTimeout = null, this.swipeTimeout = null, this.x1 = this.x2 = this.y1 = this.y2 = null, this.preTapPosition = {
                x: null,
                y: null
            };
        }
        return n(e, [
            {
                key: "start",
                value: function(e) {
                    if (e.touches) {
                        if (e.target && e.target.nodeName && [
                            "a",
                            "button",
                            "input"
                        ].indexOf(e.target.nodeName.toLowerCase()) >= 0) console.log("ignore drag for this touched element", e.target.nodeName.toLowerCase());
                        else {
                            this.now = Date.now(), this.x1 = e.touches[0].pageX, this.y1 = e.touches[0].pageY, this.delta = this.now - (this.last || this.now), this.touchStart.dispatch(e, this.element), null !== this.preTapPosition.x && (this.isDoubleTap = this.delta > 0 && this.delta <= 250 && Math.abs(this.preTapPosition.x - this.x1) < 30 && Math.abs(this.preTapPosition.y - this.y1) < 30, this.isDoubleTap && clearTimeout(this.singleTapTimeout)), this.preTapPosition.x = this.x1, this.preTapPosition.y = this.y1, this.last = this.now;
                            var t = this.preV;
                            if (e.touches.length > 1) {
                                this._cancelLongTap(), this._cancelSingleTap();
                                var i = {
                                    x: e.touches[1].pageX - this.x1,
                                    y: e.touches[1].pageY - this.y1
                                };
                                t.x = i.x, t.y = i.y, this.pinchStartLen = Y(t), this.multipointStart.dispatch(e, this.element);
                            }
                            this._preventTap = !1, this.longTapTimeout = setTimeout((function() {
                                this.longTap.dispatch(e, this.element), this._preventTap = !0;
                            }).bind(this), 750);
                        }
                    }
                }
            },
            {
                key: "move",
                value: function(e) {
                    if (e.touches) {
                        var t = this.preV, i = e.touches.length, n = e.touches[0].pageX, s = e.touches[0].pageY;
                        if (this.isDoubleTap = !1, i > 1) {
                            var l = e.touches[1].pageX, o = e.touches[1].pageY, r = {
                                x: e.touches[1].pageX - n,
                                y: e.touches[1].pageY - s
                            };
                            null !== t.x && (this.pinchStartLen > 0 && (e.zoom = Y(r) / this.pinchStartLen, this.pinch.dispatch(e, this.element)), e.angle = q(r, t), this.rotate.dispatch(e, this.element)), t.x = r.x, t.y = r.y, null !== this.x2 && null !== this.sx2 ? (e.deltaX = (n - this.x2 + l - this.sx2) / 2, e.deltaY = (s - this.y2 + o - this.sy2) / 2) : (e.deltaX = 0, e.deltaY = 0), this.twoFingerPressMove.dispatch(e, this.element), this.sx2 = l, this.sy2 = o;
                        } else {
                            if (null !== this.x2) {
                                e.deltaX = n - this.x2, e.deltaY = s - this.y2;
                                var a = Math.abs(this.x1 - this.x2), h = Math.abs(this.y1 - this.y2);
                                (a > 10 || h > 10) && (this._preventTap = !0);
                            } else e.deltaX = 0, e.deltaY = 0;
                            this.pressMove.dispatch(e, this.element);
                        }
                        this.touchMove.dispatch(e, this.element), this._cancelLongTap(), this.x2 = n, this.y2 = s, i > 1 && e.preventDefault();
                    }
                }
            },
            {
                key: "end",
                value: function(e) {
                    if (e.changedTouches) {
                        this._cancelLongTap();
                        var t = this;
                        e.touches.length < 2 && (this.multipointEnd.dispatch(e, this.element), this.sx2 = this.sy2 = null), this.x2 && Math.abs(this.x1 - this.x2) > 30 || this.y2 && Math.abs(this.y1 - this.y2) > 30 ? (e.direction = this._swipeDirection(this.x1, this.x2, this.y1, this.y2), this.swipeTimeout = setTimeout(function() {
                            t.swipe.dispatch(e, t.element);
                        }, 0)) : (this.tapTimeout = setTimeout(function() {
                            t._preventTap || t.tap.dispatch(e, t.element), t.isDoubleTap && (t.doubleTap.dispatch(e, t.element), t.isDoubleTap = !1);
                        }, 0), t.isDoubleTap || (t.singleTapTimeout = setTimeout(function() {
                            t.singleTap.dispatch(e, t.element);
                        }, 250))), this.touchEnd.dispatch(e, this.element), this.preV.x = 0, this.preV.y = 0, this.zoom = 1, this.pinchStartLen = null, this.x1 = this.x2 = this.y1 = this.y2 = null;
                    }
                }
            },
            {
                key: "cancelAll",
                value: function() {
                    this._preventTap = !0, clearTimeout(this.singleTapTimeout), clearTimeout(this.tapTimeout), clearTimeout(this.longTapTimeout), clearTimeout(this.swipeTimeout);
                }
            },
            {
                key: "cancel",
                value: function(e) {
                    this.cancelAll(), this.touchCancel.dispatch(e, this.element);
                }
            },
            {
                key: "_cancelLongTap",
                value: function() {
                    clearTimeout(this.longTapTimeout);
                }
            },
            {
                key: "_cancelSingleTap",
                value: function() {
                    clearTimeout(this.singleTapTimeout);
                }
            },
            {
                key: "_swipeDirection",
                value: function(e, t, i, n) {
                    return Math.abs(e - t) >= Math.abs(i - n) ? e - t > 0 ? "Left" : "Right" : i - n > 0 ? "Up" : "Down";
                }
            },
            {
                key: "on",
                value: function(e, t) {
                    this[e] && this[e].add(t);
                }
            },
            {
                key: "off",
                value: function(e, t) {
                    this[e] && this[e].del(t);
                }
            },
            {
                key: "destroy",
                value: function() {
                    return this.singleTapTimeout && clearTimeout(this.singleTapTimeout), this.tapTimeout && clearTimeout(this.tapTimeout), this.longTapTimeout && clearTimeout(this.longTapTimeout), this.swipeTimeout && clearTimeout(this.swipeTimeout), this.element.removeEventListener("touchstart", this.start), this.element.removeEventListener("touchmove", this.move), this.element.removeEventListener("touchend", this.end), this.element.removeEventListener("touchcancel", this.cancel), this.rotate.del(), this.touchStart.del(), this.multipointStart.del(), this.multipointEnd.del(), this.pinch.del(), this.swipe.del(), this.tap.del(), this.doubleTap.del(), this.longTap.del(), this.singleTap.del(), this.pressMove.del(), this.twoFingerPressMove.del(), this.touchMove.del(), this.touchEnd.del(), this.touchCancel.del(), this.preV = this.pinchStartLen = this.zoom = this.isDoubleTap = this.delta = this.last = this.now = this.tapTimeout = this.singleTapTimeout = this.longTapTimeout = this.swipeTimeout = this.x1 = this.x2 = this.y1 = this.y2 = this.preTapPosition = this.rotate = this.touchStart = this.multipointStart = this.multipointEnd = this.pinch = this.swipe = this.tap = this.doubleTap = this.longTap = this.singleTap = this.pressMove = this.touchMove = this.touchEnd = this.touchCancel = this.twoFingerPressMove = null, window.removeEventListener("scroll", this._cancelAllHandler), null;
                }
            }
        ]), e;
    }();
    function W(e) {
        var t = function() {
            var e, t = document.createElement("fakeelement"), i = {
                transition: "transitionend",
                OTransition: "oTransitionEnd",
                MozTransition: "transitionend",
                WebkitTransition: "webkitTransitionEnd"
            };
            for(e in i)if (void 0 !== t.style[e]) return i[e];
        }(), i = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth, n = c(e, "gslide-media") ? e : e.querySelector(".gslide-media"), s = u(n, ".ginner-container"), l = e.querySelector(".gslide-description");
        i > 769 && (n = s), h(n, "greset"), v(n, "translate3d(0, 0, 0)"), a(t, {
            onElement: n,
            once: !0,
            withCallback: function(e, t) {
                d(n, "greset");
            }
        }), n.style.opacity = "", l && (l.style.opacity = "");
    }
    function B(e) {
        if (e.events.hasOwnProperty("touch")) return !1;
        var t, i, n, s = y(), l = s.width, o = s.height, r = !1, a = null, g = null, f = null, p = !1, m = 1, x = 1, b = !1, S = !1, w = null, T = null, C = null, k = null, E = 0, A = 0, L = !1, I = !1, O = {}, P = {}, M = 0, z = 0, X = document.getElementById("glightbox-slider"), Y = document.querySelector(".goverlay"), q = new _(X, {
            touchStart: function(t) {
                if (r = !0, (c(t.targetTouches[0].target, "ginner-container") || u(t.targetTouches[0].target, ".gslide-desc") || "a" == t.targetTouches[0].target.nodeName.toLowerCase()) && (r = !1), u(t.targetTouches[0].target, ".gslide-inline") && !c(t.targetTouches[0].target.parentNode, "gslide-inline") && (r = !1), r) {
                    if (P = t.targetTouches[0], O.pageX = t.targetTouches[0].pageX, O.pageY = t.targetTouches[0].pageY, M = t.targetTouches[0].clientX, z = t.targetTouches[0].clientY, a = e.activeSlide, g = a.querySelector(".gslide-media"), n = a.querySelector(".gslide-inline"), f = null, c(g, "gslide-image") && (f = g.querySelector("img")), (window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth) > 769 && (g = a.querySelector(".ginner-container")), d(Y, "greset"), t.pageX > 20 && t.pageX < window.innerWidth - 20) return;
                    t.preventDefault();
                }
            },
            touchMove: function(s) {
                if (r && (P = s.targetTouches[0], !b && !S)) {
                    if (n && n.offsetHeight > o) {
                        var a = O.pageX - P.pageX;
                        if (Math.abs(a) <= 13) return !1;
                    }
                    p = !0;
                    var h, d = s.targetTouches[0].clientX, c = s.targetTouches[0].clientY, u = M - d, m = z - c;
                    if (Math.abs(u) > Math.abs(m) ? (L = !1, I = !0) : (I = !1, L = !0), t = P.pageX - O.pageX, E = 100 * t / l, i = P.pageY - O.pageY, A = 100 * i / o, L && f && (h = 1 - Math.abs(i) / o, Y.style.opacity = h, e.settings.touchFollowAxis && (E = 0)), I && (h = 1 - Math.abs(t) / l, g.style.opacity = h, e.settings.touchFollowAxis && (A = 0)), !f) return v(g, "translate3d(".concat(E, "%, 0, 0)"));
                    v(g, "translate3d(".concat(E, "%, ").concat(A, "%, 0)"));
                }
            },
            touchEnd: function() {
                if (r) {
                    if (p = !1, S || b) return C = w, void (k = T);
                    var t = Math.abs(parseInt(A)), i = Math.abs(parseInt(E));
                    if (!(t > 29 && f)) return t < 29 && i < 25 ? (h(Y, "greset"), Y.style.opacity = 1, W(g)) : void 0;
                    e.close();
                }
            },
            multipointEnd: function() {
                setTimeout(function() {
                    b = !1;
                }, 50);
            },
            multipointStart: function() {
                b = !0, m = x || 1;
            },
            pinch: function(e) {
                if (!f || p) return !1;
                b = !0, f.scaleX = f.scaleY = m * e.zoom;
                var t = m * e.zoom;
                if (S = !0, t <= 1) return S = !1, t = 1, k = null, C = null, w = null, T = null, void f.setAttribute("style", "");
                t > 4.5 && (t = 4.5), f.style.transform = "scale3d(".concat(t, ", ").concat(t, ", 1)"), x = t;
            },
            pressMove: function(e) {
                if (S && !b) {
                    var t = P.pageX - O.pageX, i = P.pageY - O.pageY;
                    C && (t += C), k && (i += k), w = t, T = i;
                    var n = "translate3d(".concat(t, "px, ").concat(i, "px, 0)");
                    x && (n += " scale3d(".concat(x, ", ").concat(x, ", 1)")), v(f, n);
                }
            },
            swipe: function(t) {
                if (!S) {
                    if (b) b = !1;
                    else {
                        if ("Left" == t.direction) {
                            if (e.index == e.elements.length - 1) return W(g);
                            e.nextSlide();
                        }
                        if ("Right" == t.direction) {
                            if (0 == e.index) return W(g);
                            e.prevSlide();
                        }
                    }
                }
            }
        });
        e.events.touch = q;
    }
    var H = function() {
        function e(i, n) {
            var s = this, l = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null;
            if (t(this, e), this.img = i, this.slide = n, this.onclose = l, this.img.setZoomEvents) return !1;
            this.active = !1, this.zoomedIn = !1, this.dragging = !1, this.currentX = null, this.currentY = null, this.initialX = null, this.initialY = null, this.xOffset = 0, this.yOffset = 0, this.img.addEventListener("mousedown", function(e) {
                return s.dragStart(e);
            }, !1), this.img.addEventListener("mouseup", function(e) {
                return s.dragEnd(e);
            }, !1), this.img.addEventListener("mousemove", function(e) {
                return s.drag(e);
            }, !1), this.img.addEventListener("click", function(e) {
                return s.slide.classList.contains("dragging-nav") ? (s.zoomOut(), !1) : s.zoomedIn ? void (s.zoomedIn && !s.dragging && s.zoomOut()) : s.zoomIn();
            }, !1), this.img.setZoomEvents = !0;
        }
        return n(e, [
            {
                key: "zoomIn",
                value: function() {
                    var e = this.widowWidth();
                    if (!(this.zoomedIn || e <= 768)) {
                        var t = this.img;
                        if (t.setAttribute("data-style", t.getAttribute("style")), t.style.maxWidth = t.naturalWidth + "px", t.style.maxHeight = t.naturalHeight + "px", t.naturalWidth > e) {
                            var i = e / 2 - t.naturalWidth / 2;
                            this.setTranslate(this.img.parentNode, i, 0);
                        }
                        this.slide.classList.add("zoomed"), this.zoomedIn = !0;
                    }
                }
            },
            {
                key: "zoomOut",
                value: function() {
                    this.img.parentNode.setAttribute("style", ""), this.img.setAttribute("style", this.img.getAttribute("data-style")), this.slide.classList.remove("zoomed"), this.zoomedIn = !1, this.currentX = null, this.currentY = null, this.initialX = null, this.initialY = null, this.xOffset = 0, this.yOffset = 0, this.onclose && "function" == typeof this.onclose && this.onclose();
                }
            },
            {
                key: "dragStart",
                value: function(e) {
                    e.preventDefault(), this.zoomedIn ? ("touchstart" === e.type ? (this.initialX = e.touches[0].clientX - this.xOffset, this.initialY = e.touches[0].clientY - this.yOffset) : (this.initialX = e.clientX - this.xOffset, this.initialY = e.clientY - this.yOffset), e.target === this.img && (this.active = !0, this.img.classList.add("dragging"))) : this.active = !1;
                }
            },
            {
                key: "dragEnd",
                value: function(e) {
                    var t = this;
                    e.preventDefault(), this.initialX = this.currentX, this.initialY = this.currentY, this.active = !1, setTimeout(function() {
                        t.dragging = !1, t.img.isDragging = !1, t.img.classList.remove("dragging");
                    }, 100);
                }
            },
            {
                key: "drag",
                value: function(e) {
                    this.active && (e.preventDefault(), "touchmove" === e.type ? (this.currentX = e.touches[0].clientX - this.initialX, this.currentY = e.touches[0].clientY - this.initialY) : (this.currentX = e.clientX - this.initialX, this.currentY = e.clientY - this.initialY), this.xOffset = this.currentX, this.yOffset = this.currentY, this.img.isDragging = !0, this.dragging = !0, this.setTranslate(this.img, this.currentX, this.currentY));
                }
            },
            {
                key: "onMove",
                value: function(e) {
                    if (this.zoomedIn) {
                        var t = e.clientX - this.img.naturalWidth / 2, i = e.clientY - this.img.naturalHeight / 2;
                        this.setTranslate(this.img, t, i);
                    }
                }
            },
            {
                key: "setTranslate",
                value: function(e, t, i) {
                    e.style.transform = "translate3d(" + t + "px, " + i + "px, 0)";
                }
            },
            {
                key: "widowWidth",
                value: function() {
                    return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
                }
            }
        ]), e;
    }(), V = function() {
        function e() {
            var i = this, n = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            t(this, e);
            var s = n.dragEl, l = n.toleranceX, o = void 0 === l ? 40 : l, r = n.toleranceY, a = void 0 === r ? 65 : r, h = n.slide, d = void 0 === h ? null : h, c = n.instance, u = void 0 === c ? null : c;
            this.el = s, this.active = !1, this.dragging = !1, this.currentX = null, this.currentY = null, this.initialX = null, this.initialY = null, this.xOffset = 0, this.yOffset = 0, this.direction = null, this.lastDirection = null, this.toleranceX = o, this.toleranceY = a, this.toleranceReached = !1, this.dragContainer = this.el, this.slide = d, this.instance = u, this.el.addEventListener("mousedown", function(e) {
                return i.dragStart(e);
            }, !1), this.el.addEventListener("mouseup", function(e) {
                return i.dragEnd(e);
            }, !1), this.el.addEventListener("mousemove", function(e) {
                return i.drag(e);
            }, !1);
        }
        return n(e, [
            {
                key: "dragStart",
                value: function(e) {
                    if (this.slide.classList.contains("zoomed")) this.active = !1;
                    else {
                        "touchstart" === e.type ? (this.initialX = e.touches[0].clientX - this.xOffset, this.initialY = e.touches[0].clientY - this.yOffset) : (this.initialX = e.clientX - this.xOffset, this.initialY = e.clientY - this.yOffset);
                        var t = e.target.nodeName.toLowerCase();
                        e.target.classList.contains("nodrag") || u(e.target, ".nodrag") || -1 !== [
                            "input",
                            "select",
                            "textarea",
                            "button",
                            "a"
                        ].indexOf(t) ? this.active = !1 : (e.preventDefault(), (e.target === this.el || "img" !== t && u(e.target, ".gslide-inline")) && (this.active = !0, this.el.classList.add("dragging"), this.dragContainer = u(e.target, ".ginner-container")));
                    }
                }
            },
            {
                key: "dragEnd",
                value: function(e) {
                    var t = this;
                    e && e.preventDefault(), this.initialX = 0, this.initialY = 0, this.currentX = null, this.currentY = null, this.initialX = null, this.initialY = null, this.xOffset = 0, this.yOffset = 0, this.active = !1, this.doSlideChange && (this.instance.preventOutsideClick = !0, "right" == this.doSlideChange && this.instance.prevSlide(), "left" == this.doSlideChange && this.instance.nextSlide()), this.doSlideClose && this.instance.close(), this.toleranceReached || this.setTranslate(this.dragContainer, 0, 0, !0), setTimeout(function() {
                        t.instance.preventOutsideClick = !1, t.toleranceReached = !1, t.lastDirection = null, t.dragging = !1, t.el.isDragging = !1, t.el.classList.remove("dragging"), t.slide.classList.remove("dragging-nav"), t.dragContainer.style.transform = "", t.dragContainer.style.transition = "";
                    }, 100);
                }
            },
            {
                key: "drag",
                value: function(e) {
                    if (this.active) {
                        e.preventDefault(), this.slide.classList.add("dragging-nav"), "touchmove" === e.type ? (this.currentX = e.touches[0].clientX - this.initialX, this.currentY = e.touches[0].clientY - this.initialY) : (this.currentX = e.clientX - this.initialX, this.currentY = e.clientY - this.initialY), this.xOffset = this.currentX, this.yOffset = this.currentY, this.el.isDragging = !0, this.dragging = !0, this.doSlideChange = !1, this.doSlideClose = !1;
                        var t = Math.abs(this.currentX), i = Math.abs(this.currentY);
                        if (t > 0 && t >= Math.abs(this.currentY) && (!this.lastDirection || "x" == this.lastDirection)) {
                            this.yOffset = 0, this.lastDirection = "x", this.setTranslate(this.dragContainer, this.currentX, 0);
                            var n = this.shouldChange();
                            if (!this.instance.settings.dragAutoSnap && n && (this.doSlideChange = n), this.instance.settings.dragAutoSnap && n) return this.instance.preventOutsideClick = !0, this.toleranceReached = !0, this.active = !1, this.instance.preventOutsideClick = !0, this.dragEnd(null), "right" == n && this.instance.prevSlide(), void ("left" == n && this.instance.nextSlide());
                        }
                        if (this.toleranceY > 0 && i > 0 && i >= t && (!this.lastDirection || "y" == this.lastDirection)) {
                            this.xOffset = 0, this.lastDirection = "y", this.setTranslate(this.dragContainer, 0, this.currentY);
                            var s = this.shouldClose();
                            return !this.instance.settings.dragAutoSnap && s && (this.doSlideClose = !0), void (this.instance.settings.dragAutoSnap && s && this.instance.close());
                        }
                    }
                }
            },
            {
                key: "shouldChange",
                value: function() {
                    var e = !1;
                    if (Math.abs(this.currentX) >= this.toleranceX) {
                        var t = this.currentX > 0 ? "right" : "left";
                        ("left" == t && this.slide !== this.slide.parentNode.lastChild || "right" == t && this.slide !== this.slide.parentNode.firstChild) && (e = t);
                    }
                    return e;
                }
            },
            {
                key: "shouldClose",
                value: function() {
                    var e = !1;
                    return Math.abs(this.currentY) >= this.toleranceY && (e = !0), e;
                }
            },
            {
                key: "setTranslate",
                value: function(e, t, i) {
                    var n = arguments.length > 3 && void 0 !== arguments[3] && arguments[3];
                    e.style.transition = n ? "all .2s ease" : "", e.style.transform = "translate3d(".concat(t, "px, ").concat(i, "px, 0)");
                }
            }
        ]), e;
    }();
    function j(e, t, i, n) {
        var s = e.querySelector(".gslide-media"), l = new Image, o = "gSlideTitle_" + i, r = "gSlideDesc_" + i;
        l.addEventListener("load", function() {
            T(n) && n();
        }, !1), l.src = t.href, "" != t.sizes && "" != t.srcset && (l.sizes = t.sizes, l.srcset = t.srcset), l.alt = "", I(t.alt) || "" === t.alt || (l.alt = t.alt), "" !== t.title && l.setAttribute("aria-labelledby", o), "" !== t.description && l.setAttribute("aria-describedby", r), t.hasOwnProperty("_hasCustomWidth") && t._hasCustomWidth && (l.style.width = t.width), t.hasOwnProperty("_hasCustomHeight") && t._hasCustomHeight && (l.style.height = t.height), s.insertBefore(l, s.firstChild);
    }
    function F(e, t, i, n) {
        var s = this, l = e.querySelector(".ginner-container"), o = "gvideo" + i, r = e.querySelector(".gslide-media"), a = this.getAllPlayers();
        h(l, "gvideo-container"), r.insertBefore(m('<div class="gvideo-wrapper"></div>'), r.firstChild);
        var d = e.querySelector(".gvideo-wrapper");
        S(this.settings.plyr.css, "Plyr");
        var c = t.href, u = null == t ? void 0 : t.videoProvider, g = !1;
        r.style.maxWidth = t.width, S(this.settings.plyr.js, "Plyr", function() {
            if (!u && c.match(/vimeo\.com\/([0-9]*)/) && (u = "vimeo"), !u && (c.match(/(youtube\.com|youtube-nocookie\.com)\/watch\?v=([a-zA-Z0-9\-_]+)/) || c.match(/youtu\.be\/([a-zA-Z0-9\-_]+)/) || c.match(/(youtube\.com|youtube-nocookie\.com)\/embed\/([a-zA-Z0-9\-_]+)/)) && (u = "youtube"), "local" === u || !u) {
                u = "local";
                var l = '<video id="' + o + '" ';
                l += 'style="background:#000; max-width: '.concat(t.width, ';" '), l += 'preload="metadata" ', l += 'x-webkit-airplay="allow" ', l += "playsinline ", l += "controls ", l += 'class="gvideo-local">', l += '<source src="'.concat(c, '">'), g = m(l += "</video>");
            }
            var r = g || m('<div id="'.concat(o, '" data-plyr-provider="').concat(u, '" data-plyr-embed-id="').concat(c, '"></div>'));
            h(d, "".concat(u, "-video gvideo")), d.appendChild(r), d.setAttribute("data-id", o), d.setAttribute("data-index", i);
            var v = O(s.settings.plyr, "config") ? s.settings.plyr.config : {}, f = new Plyr("#" + o, v);
            f.on("ready", function(e) {
                a[o] = e.detail.plyr, T(n) && n();
            }), b(function() {
                return e.querySelector("iframe") && "true" == e.querySelector("iframe").dataset.ready;
            }, function() {
                s.resize(e);
            }), f.on("enterfullscreen", R), f.on("exitfullscreen", R);
        });
    }
    function R(e) {
        var t = u(e.target, ".gslide-media");
        "enterfullscreen" === e.type && h(t, "fullscreen"), "exitfullscreen" === e.type && d(t, "fullscreen");
    }
    function G(e, t, i, n) {
        var s, l = this, o = e.querySelector(".gslide-media"), r = !(!O(t, "href") || !t.href) && t.href.split("#").pop().trim(), d = !(!O(t, "content") || !t.content) && t.content;
        if (d && (C(d) && (s = m('<div class="ginlined-content">'.concat(d, "</div>"))), k(d))) {
            "none" == d.style.display && (d.style.display = "block");
            var c = document.createElement("div");
            c.className = "ginlined-content", c.appendChild(d), s = c;
        }
        if (r) {
            var u = document.getElementById(r);
            if (!u) return !1;
            var g = u.cloneNode(!0);
            g.style.height = t.height, g.style.maxWidth = t.width, h(g, "ginlined-content"), s = g;
        }
        if (!s) return console.error("Unable to append inline slide content", t), !1;
        o.style.height = t.height, o.style.width = t.width, o.appendChild(s), this.events["inlineclose" + r] = a("click", {
            onElement: o.querySelectorAll(".gtrigger-close"),
            withCallback: function(e) {
                e.preventDefault(), l.close();
            }
        }), T(n) && n();
    }
    function Z(e, t, i, n) {
        var s = e.querySelector(".gslide-media"), l = function(e) {
            var t = e.url, i = e.allow, n = e.callback, s = e.appendTo, l = document.createElement("iframe");
            return l.className = "vimeo-video gvideo", l.src = t, l.style.width = "100%", l.style.height = "100%", i && l.setAttribute("allow", i), l.onload = function() {
                l.onload = null, h(l, "node-ready"), T(n) && n();
            }, s && s.appendChild(l), l;
        }({
            url: t.href,
            callback: n
        });
        s.parentNode.style.maxWidth = t.width, s.parentNode.style.height = t.height, s.appendChild(l);
    }
    var U = function() {
        function e() {
            var i = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            t(this, e), this.defaults = {
                href: "",
                sizes: "",
                srcset: "",
                title: "",
                type: "",
                videoProvider: "",
                description: "",
                alt: "",
                descPosition: "bottom",
                effect: "",
                width: "",
                height: "",
                content: !1,
                zoomable: !0,
                draggable: !0
            }, L(i) && (this.defaults = l(this.defaults, i));
        }
        return n(e, [
            {
                key: "sourceType",
                value: function(e) {
                    var t = e;
                    if (null !== (e = e.toLowerCase()).match(/\.(jpeg|jpg|jpe|gif|png|apn|webp|avif|svg)/)) return "image";
                    if (e.match(/(youtube\.com|youtube-nocookie\.com)\/watch\?v=([a-zA-Z0-9\-_]+)/) || e.match(/youtu\.be\/([a-zA-Z0-9\-_]+)/) || e.match(/(youtube\.com|youtube-nocookie\.com)\/embed\/([a-zA-Z0-9\-_]+)/)) return "video";
                    if (e.match(/vimeo\.com\/([0-9]*)/)) return "video";
                    if (null !== e.match(/\.(mp4|ogg|webm|mov)/)) return "video";
                    if (null !== e.match(/\.(mp3|wav|wma|aac|ogg)/)) return "audio";
                    if (e.indexOf("#") > -1 && "" !== t.split("#").pop().trim()) return "inline";
                    return e.indexOf("goajax=true") > -1 ? "ajax" : "external";
                }
            },
            {
                key: "parseConfig",
                value: function(e, t) {
                    var i = this, n = l({
                        descPosition: t.descPosition
                    }, this.defaults);
                    if (L(e) && !k(e)) {
                        O(e, "type") || (O(e, "content") && e.content ? e.type = "inline" : O(e, "href") && (e.type = this.sourceType(e.href)));
                        var s = l(n, e);
                        return this.setSize(s, t), s;
                    }
                    var r = "", a = e.getAttribute("data-glightbox"), h = e.nodeName.toLowerCase();
                    if ("a" === h && (r = e.href), "img" === h && (r = e.src, n.alt = e.alt), n.href = r, o(n, function(s, l) {
                        O(t, l) && "width" !== l && (n[l] = t[l]);
                        var o = e.dataset[l];
                        I(o) || (n[l] = i.sanitizeValue(o));
                    }), n.content && (n.type = "inline"), !n.type && r && (n.type = this.sourceType(r)), I(a)) {
                        if (!n.title && "a" == h) {
                            var d = e.title;
                            I(d) || "" === d || (n.title = d);
                        }
                        if (!n.title && "img" == h) {
                            var c = e.alt;
                            I(c) || "" === c || (n.title = c);
                        }
                    } else {
                        var u = [];
                        o(n, function(e, t) {
                            u.push(";\\s?" + t);
                        }), u = u.join("\\s?:|"), "" !== a.trim() && o(n, function(e, t) {
                            var s = a, l = new RegExp("s?" + t + "s?:s?(.*?)(" + u + "s?:|$)"), o = s.match(l);
                            if (o && o.length && o[1]) {
                                var r = o[1].trim().replace(/;\s*$/, "");
                                n[t] = i.sanitizeValue(r);
                            }
                        });
                    }
                    if (n.description && "." === n.description.substring(0, 1)) {
                        var g;
                        try {
                            g = document.querySelector(n.description).innerHTML;
                        } catch (e) {
                            if (!(e instanceof DOMException)) throw e;
                        }
                        g && (n.description = g);
                    }
                    if (!n.description) {
                        var v = e.querySelector(".glightbox-desc");
                        v && (n.description = v.innerHTML);
                    }
                    return this.setSize(n, t, e), this.slideConfig = n, n;
                }
            },
            {
                key: "setSize",
                value: function(e, t) {
                    var i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null, n = "video" == e.type ? this.checkSize(t.videosWidth) : this.checkSize(t.width), s = this.checkSize(t.height);
                    return e.width = O(e, "width") && "" !== e.width ? this.checkSize(e.width) : n, e.height = O(e, "height") && "" !== e.height ? this.checkSize(e.height) : s, i && "image" == e.type && (e._hasCustomWidth = !!i.dataset.width, e._hasCustomHeight = !!i.dataset.height), e;
                }
            },
            {
                key: "checkSize",
                value: function(e) {
                    return M(e) ? "".concat(e, "px") : e;
                }
            },
            {
                key: "sanitizeValue",
                value: function(e) {
                    return "true" !== e && "false" !== e ? e : "true" === e;
                }
            }
        ]), e;
    }(), $ = function() {
        function e(i, n, s) {
            t(this, e), this.element = i, this.instance = n, this.index = s;
        }
        return n(e, [
            {
                key: "setContent",
                value: function() {
                    var e = this, t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null, i = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                    if (c(t, "loaded")) return !1;
                    var n = this.instance.settings, s = this.slideConfig, l = w();
                    T(n.beforeSlideLoad) && n.beforeSlideLoad({
                        index: this.index,
                        slide: t,
                        player: !1
                    });
                    var o = s.type, r = s.descPosition, a = t.querySelector(".gslide-media"), d = t.querySelector(".gslide-title"), u = t.querySelector(".gslide-desc"), g = t.querySelector(".gdesc-inner"), v = i, f = "gSlideTitle_" + this.index, p = "gSlideDesc_" + this.index;
                    if (T(n.afterSlideLoad) && (v = function() {
                        T(i) && i(), n.afterSlideLoad({
                            index: e.index,
                            slide: t,
                            player: e.instance.getSlidePlayerInstance(e.index)
                        });
                    }), "" == s.title && "" == s.description ? g && g.parentNode.parentNode.removeChild(g.parentNode) : (d && "" !== s.title ? (d.id = f, d.innerHTML = s.title) : d.parentNode.removeChild(d), u && "" !== s.description ? (u.id = p, l && n.moreLength > 0 ? (s.smallDescription = this.slideShortDesc(s.description, n.moreLength, n.moreText), u.innerHTML = s.smallDescription, this.descriptionEvents(u, s)) : u.innerHTML = s.description) : u.parentNode.removeChild(u), h(a.parentNode, "desc-".concat(r)), h(g.parentNode, "description-".concat(r))), h(a, "gslide-".concat(o)), h(t, "loaded"), "video" !== o) {
                        if ("external" !== o) return "inline" === o ? (G.apply(this.instance, [
                            t,
                            s,
                            this.index,
                            v
                        ]), void (s.draggable && new V({
                            dragEl: t.querySelector(".gslide-inline"),
                            toleranceX: n.dragToleranceX,
                            toleranceY: n.dragToleranceY,
                            slide: t,
                            instance: this.instance
                        }))) : void ("image" !== o ? T(v) && v() : j(t, s, this.index, function() {
                            var i = t.querySelector("img");
                            s.draggable && new V({
                                dragEl: i,
                                toleranceX: n.dragToleranceX,
                                toleranceY: n.dragToleranceY,
                                slide: t,
                                instance: e.instance
                            }), s.zoomable && i.naturalWidth > i.offsetWidth && (h(i, "zoomable"), new H(i, t, function() {
                                e.instance.resize();
                            })), T(v) && v();
                        }));
                        Z.apply(this, [
                            t,
                            s,
                            this.index,
                            v
                        ]);
                    } else F.apply(this.instance, [
                        t,
                        s,
                        this.index,
                        v
                    ]);
                }
            },
            {
                key: "slideShortDesc",
                value: function(e) {
                    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 50, i = arguments.length > 2 && void 0 !== arguments[2] && arguments[2], n = document.createElement("div");
                    n.innerHTML = e;
                    var s = n.innerText, l = i;
                    if ((e = s.trim()).length <= t) return e;
                    var o = e.substr(0, t - 1);
                    return l ? (n = null, o + '... <a href="#" class="desc-more">' + i + "</a>") : o;
                }
            },
            {
                key: "descriptionEvents",
                value: function(e, t) {
                    var i = this, n = e.querySelector(".desc-more");
                    if (!n) return !1;
                    a("click", {
                        onElement: n,
                        withCallback: function(e, n) {
                            e.preventDefault();
                            var s = document.body, l = u(n, ".gslide-desc");
                            if (!l) return !1;
                            l.innerHTML = t.description, h(s, "gdesc-open");
                            var o = a("click", {
                                onElement: [
                                    s,
                                    u(l, ".gslide-description")
                                ],
                                withCallback: function(e, n) {
                                    "a" !== e.target.nodeName.toLowerCase() && (d(s, "gdesc-open"), h(s, "gdesc-closed"), l.innerHTML = t.smallDescription, i.descriptionEvents(l, t), setTimeout(function() {
                                        d(s, "gdesc-closed");
                                    }, 400), o.destroy());
                                }
                            });
                        }
                    });
                }
            },
            {
                key: "create",
                value: function() {
                    return m(this.instance.settings.slideHTML);
                }
            },
            {
                key: "getConfig",
                value: function() {
                    k(this.element) || this.element.hasOwnProperty("draggable") || (this.element.draggable = this.instance.settings.draggable);
                    var e = new U(this.instance.settings.slideExtraAttributes);
                    return this.slideConfig = e.parseConfig(this.element, this.instance.settings), this.slideConfig;
                }
            }
        ]), e;
    }(), J = w(), K = null !== w() || void 0 !== document.createTouch || "ontouchstart" in window || "onmsgesturechange" in window || navigator.msMaxTouchPoints, Q = document.getElementsByTagName("html")[0], ee = {
        selector: ".glightbox",
        elements: null,
        skin: "clean",
        theme: "clean",
        closeButton: !0,
        startAt: null,
        autoplayVideos: !0,
        autofocusVideos: !0,
        descPosition: "bottom",
        width: "900px",
        height: "506px",
        videosWidth: "960px",
        beforeSlideChange: null,
        afterSlideChange: null,
        beforeSlideLoad: null,
        afterSlideLoad: null,
        slideInserted: null,
        slideRemoved: null,
        slideExtraAttributes: null,
        onOpen: null,
        onClose: null,
        loop: !1,
        zoomable: !0,
        draggable: !0,
        dragAutoSnap: !1,
        dragToleranceX: 40,
        dragToleranceY: 65,
        preload: !0,
        oneSlidePerOpen: !1,
        touchNavigation: !0,
        touchFollowAxis: !0,
        keyboardNavigation: !0,
        closeOnOutsideClick: !0,
        plugins: !1,
        plyr: {
            css: "https://cdn.plyr.io/3.6.12/plyr.css",
            js: "https://cdn.plyr.io/3.6.12/plyr.js",
            config: {
                ratio: "16:9",
                fullscreen: {
                    enabled: !0,
                    iosNative: !0
                },
                youtube: {
                    noCookie: !0,
                    rel: 0,
                    showinfo: 0,
                    iv_load_policy: 3
                },
                vimeo: {
                    byline: !1,
                    portrait: !1,
                    title: !1,
                    transparent: !1
                }
            }
        },
        openEffect: "zoom",
        closeEffect: "zoom",
        slideEffect: "slide",
        moreText: "See more",
        moreLength: 60,
        cssEfects: {
            fade: {
                in: "fadeIn",
                out: "fadeOut"
            },
            zoom: {
                in: "zoomIn",
                out: "zoomOut"
            },
            slide: {
                in: "slideInRight",
                out: "slideOutLeft"
            },
            slideBack: {
                in: "slideInLeft",
                out: "slideOutRight"
            },
            none: {
                in: "none",
                out: "none"
            }
        },
        svg: {
            close: '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" xml:space="preserve"><g><g><path d="M505.943,6.058c-8.077-8.077-21.172-8.077-29.249,0L6.058,476.693c-8.077,8.077-8.077,21.172,0,29.249C10.096,509.982,15.39,512,20.683,512c5.293,0,10.586-2.019,14.625-6.059L505.943,35.306C514.019,27.23,514.019,14.135,505.943,6.058z"/></g></g><g><g><path d="M505.942,476.694L35.306,6.059c-8.076-8.077-21.172-8.077-29.248,0c-8.077,8.076-8.077,21.171,0,29.248l470.636,470.636c4.038,4.039,9.332,6.058,14.625,6.058c5.293,0,10.587-2.019,14.624-6.057C514.018,497.866,514.018,484.771,505.942,476.694z"/></g></g></svg>',
            next: '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 477.175 477.175" xml:space="preserve"> <g><path d="M360.731,229.075l-225.1-225.1c-5.3-5.3-13.8-5.3-19.1,0s-5.3,13.8,0,19.1l215.5,215.5l-215.5,215.5c-5.3,5.3-5.3,13.8,0,19.1c2.6,2.6,6.1,4,9.5,4c3.4,0,6.9-1.3,9.5-4l225.1-225.1C365.931,242.875,365.931,234.275,360.731,229.075z"/></g></svg>',
            prev: '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 477.175 477.175" xml:space="preserve"><g><path d="M145.188,238.575l215.5-215.5c5.3-5.3,5.3-13.8,0-19.1s-13.8-5.3-19.1,0l-225.1,225.1c-5.3,5.3-5.3,13.8,0,19.1l225.1,225c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4c5.3-5.3,5.3-13.8,0-19.1L145.188,238.575z"/></g></svg>'
        },
        slideHTML: '<div class="gslide">\n    <div class="gslide-inner-content">\n        <div class="ginner-container">\n            <div class="gslide-media">\n            </div>\n            <div class="gslide-description">\n                <div class="gdesc-inner">\n                    <h4 class="gslide-title"></h4>\n                    <div class="gslide-desc"></div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>',
        lightboxHTML: '<div id="glightbox-body" class="glightbox-container" tabindex="-1" role="dialog" aria-hidden="false">\n    <div class="gloader visible"></div>\n    <div class="goverlay"></div>\n    <div class="gcontainer">\n    <div id="glightbox-slider" class="gslider"></div>\n    <button class="gclose gbtn" aria-label="Close" data-taborder="3">{closeSVG}</button>\n    <button class="gprev gbtn" aria-label="Previous" data-taborder="2">{prevSVG}</button>\n    <button class="gnext gbtn" aria-label="Next" data-taborder="1">{nextSVG}</button>\n</div>\n</div>'
    }, te = function() {
        function e() {
            var i = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            t(this, e), this.customOptions = i, this.settings = l(ee, i), this.effectsClasses = this.getAnimationClasses(), this.videoPlayers = {}, this.apiEvents = [], this.fullElementsList = !1;
        }
        return n(e, [
            {
                key: "init",
                value: function() {
                    var e = this, t = this.getSelector();
                    t && (this.baseEvents = a("click", {
                        onElement: t,
                        withCallback: function(t, i) {
                            t.preventDefault(), e.open(i);
                        }
                    })), this.elements = this.getElements();
                }
            },
            {
                key: "open",
                value: function() {
                    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null;
                    if (0 === this.elements.length) return !1;
                    this.activeSlide = null, this.prevActiveSlideIndex = null, this.prevActiveSlide = null;
                    var i = M(t) ? t : this.settings.startAt;
                    if (k(e)) {
                        var n = e.getAttribute("data-gallery");
                        n && (this.fullElementsList = this.elements, this.elements = this.getGalleryElements(this.elements, n)), I(i) && (i = this.getElementIndex(e)) < 0 && (i = 0);
                    }
                    M(i) || (i = 0), this.build(), g(this.overlay, "none" === this.settings.openEffect ? "none" : this.settings.cssEfects.fade.in);
                    var s = document.body, l = window.innerWidth - document.documentElement.clientWidth;
                    if (l > 0) {
                        var o = document.createElement("style");
                        o.type = "text/css", o.className = "gcss-styles", o.innerText = ".gscrollbar-fixer {margin-right: ".concat(l, "px}"), document.head.appendChild(o), h(s, "gscrollbar-fixer");
                    }
                    h(s, "glightbox-open"), h(Q, "glightbox-open"), J && (h(document.body, "glightbox-mobile"), this.settings.slideEffect = "slide"), this.showSlide(i, !0), 1 === this.elements.length ? (h(this.prevButton, "glightbox-button-hidden"), h(this.nextButton, "glightbox-button-hidden")) : (d(this.prevButton, "glightbox-button-hidden"), d(this.nextButton, "glightbox-button-hidden")), this.lightboxOpen = !0, this.trigger("open"), T(this.settings.onOpen) && this.settings.onOpen(), K && this.settings.touchNavigation && B(this), this.settings.keyboardNavigation && X(this);
                }
            },
            {
                key: "openAt",
                value: function() {
                    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0;
                    this.open(null, e);
                }
            },
            {
                key: "showSlide",
                value: function() {
                    var e = this, t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0, i = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                    f(this.loader), this.index = parseInt(t);
                    var n = this.slidesContainer.querySelector(".current");
                    n && d(n, "current"), this.slideAnimateOut();
                    var s = this.slidesContainer.querySelectorAll(".gslide")[t];
                    if (c(s, "loaded")) this.slideAnimateIn(s, i), p(this.loader);
                    else {
                        f(this.loader);
                        var l = this.elements[t], o = {
                            index: this.index,
                            slide: s,
                            slideNode: s,
                            slideConfig: l.slideConfig,
                            slideIndex: this.index,
                            trigger: l.node,
                            player: null
                        };
                        this.trigger("slide_before_load", o), l.instance.setContent(s, function() {
                            p(e.loader), e.resize(), e.slideAnimateIn(s, i), e.trigger("slide_after_load", o);
                        });
                    }
                    this.slideDescription = s.querySelector(".gslide-description"), this.slideDescriptionContained = this.slideDescription && c(this.slideDescription.parentNode, "gslide-media"), this.settings.preload && (this.preloadSlide(t + 1), this.preloadSlide(t - 1)), this.updateNavigationClasses(), this.activeSlide = s;
                }
            },
            {
                key: "preloadSlide",
                value: function(e) {
                    var t = this;
                    if (e < 0 || e > this.elements.length - 1) return !1;
                    if (I(this.elements[e])) return !1;
                    var i = this.slidesContainer.querySelectorAll(".gslide")[e];
                    if (c(i, "loaded")) return !1;
                    var n = this.elements[e], s = n.type, l = {
                        index: e,
                        slide: i,
                        slideNode: i,
                        slideConfig: n.slideConfig,
                        slideIndex: e,
                        trigger: n.node,
                        player: null
                    };
                    this.trigger("slide_before_load", l), "video" === s || "external" === s ? setTimeout(function() {
                        n.instance.setContent(i, function() {
                            t.trigger("slide_after_load", l);
                        });
                    }, 200) : n.instance.setContent(i, function() {
                        t.trigger("slide_after_load", l);
                    });
                }
            },
            {
                key: "prevSlide",
                value: function() {
                    this.goToSlide(this.index - 1);
                }
            },
            {
                key: "nextSlide",
                value: function() {
                    this.goToSlide(this.index + 1);
                }
            },
            {
                key: "goToSlide",
                value: function() {
                    var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
                    if (this.prevActiveSlide = this.activeSlide, this.prevActiveSlideIndex = this.index, !this.loop() && (e < 0 || e > this.elements.length - 1)) return !1;
                    e < 0 ? e = this.elements.length - 1 : e >= this.elements.length && (e = 0), this.showSlide(e);
                }
            },
            {
                key: "insertSlide",
                value: function() {
                    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : -1;
                    t < 0 && (t = this.elements.length);
                    var i = new $(e, this, t), n = i.getConfig(), s = l({}, n), o = i.create(), r = this.elements.length - 1;
                    s.index = t, s.node = !1, s.instance = i, s.slideConfig = n, this.elements.splice(t, 0, s);
                    var a = null, h = null;
                    if (this.slidesContainer) {
                        if (t > r) this.slidesContainer.appendChild(o);
                        else {
                            var d = this.slidesContainer.querySelectorAll(".gslide")[t];
                            this.slidesContainer.insertBefore(o, d);
                        }
                        (this.settings.preload && 0 == this.index && 0 == t || this.index - 1 == t || this.index + 1 == t) && this.preloadSlide(t), 0 === this.index && 0 === t && (this.index = 1), this.updateNavigationClasses(), a = this.slidesContainer.querySelectorAll(".gslide")[t], h = this.getSlidePlayerInstance(t), s.slideNode = a;
                    }
                    this.trigger("slide_inserted", {
                        index: t,
                        slide: a,
                        slideNode: a,
                        slideConfig: n,
                        slideIndex: t,
                        trigger: null,
                        player: h
                    }), T(this.settings.slideInserted) && this.settings.slideInserted({
                        index: t,
                        slide: a,
                        player: h
                    });
                }
            },
            {
                key: "removeSlide",
                value: function() {
                    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : -1;
                    if (e < 0 || e > this.elements.length - 1) return !1;
                    var t = this.slidesContainer && this.slidesContainer.querySelectorAll(".gslide")[e];
                    t && (this.getActiveSlideIndex() == e && (e == this.elements.length - 1 ? this.prevSlide() : this.nextSlide()), t.parentNode.removeChild(t)), this.elements.splice(e, 1), this.trigger("slide_removed", e), T(this.settings.slideRemoved) && this.settings.slideRemoved(e);
                }
            },
            {
                key: "slideAnimateIn",
                value: function(e, t) {
                    var i = this, n = e.querySelector(".gslide-media"), s = e.querySelector(".gslide-description"), l = {
                        index: this.prevActiveSlideIndex,
                        slide: this.prevActiveSlide,
                        slideNode: this.prevActiveSlide,
                        slideIndex: this.prevActiveSlide,
                        slideConfig: I(this.prevActiveSlideIndex) ? null : this.elements[this.prevActiveSlideIndex].slideConfig,
                        trigger: I(this.prevActiveSlideIndex) ? null : this.elements[this.prevActiveSlideIndex].node,
                        player: this.getSlidePlayerInstance(this.prevActiveSlideIndex)
                    }, o = {
                        index: this.index,
                        slide: this.activeSlide,
                        slideNode: this.activeSlide,
                        slideConfig: this.elements[this.index].slideConfig,
                        slideIndex: this.index,
                        trigger: this.elements[this.index].node,
                        player: this.getSlidePlayerInstance(this.index)
                    };
                    if (n.offsetWidth > 0 && s && (p(s), s.style.display = ""), d(e, this.effectsClasses), t) g(e, this.settings.cssEfects[this.settings.openEffect].in, function() {
                        i.settings.autoplayVideos && i.slidePlayerPlay(e), i.trigger("slide_changed", {
                            prev: l,
                            current: o
                        }), T(i.settings.afterSlideChange) && i.settings.afterSlideChange.apply(i, [
                            l,
                            o
                        ]);
                    });
                    else {
                        var r = this.settings.slideEffect, a = "none" !== r ? this.settings.cssEfects[r].in : r;
                        this.prevActiveSlideIndex > this.index && "slide" == this.settings.slideEffect && (a = this.settings.cssEfects.slideBack.in), g(e, a, function() {
                            i.settings.autoplayVideos && i.slidePlayerPlay(e), i.trigger("slide_changed", {
                                prev: l,
                                current: o
                            }), T(i.settings.afterSlideChange) && i.settings.afterSlideChange.apply(i, [
                                l,
                                o
                            ]);
                        });
                    }
                    setTimeout(function() {
                        i.resize(e);
                    }, 100), h(e, "current");
                }
            },
            {
                key: "slideAnimateOut",
                value: function() {
                    if (!this.prevActiveSlide) return !1;
                    var e = this.prevActiveSlide;
                    d(e, this.effectsClasses), h(e, "prev");
                    var t = this.settings.slideEffect, i = "none" !== t ? this.settings.cssEfects[t].out : t;
                    this.slidePlayerPause(e), this.trigger("slide_before_change", {
                        prev: {
                            index: this.prevActiveSlideIndex,
                            slide: this.prevActiveSlide,
                            slideNode: this.prevActiveSlide,
                            slideIndex: this.prevActiveSlideIndex,
                            slideConfig: I(this.prevActiveSlideIndex) ? null : this.elements[this.prevActiveSlideIndex].slideConfig,
                            trigger: I(this.prevActiveSlideIndex) ? null : this.elements[this.prevActiveSlideIndex].node,
                            player: this.getSlidePlayerInstance(this.prevActiveSlideIndex)
                        },
                        current: {
                            index: this.index,
                            slide: this.activeSlide,
                            slideNode: this.activeSlide,
                            slideIndex: this.index,
                            slideConfig: this.elements[this.index].slideConfig,
                            trigger: this.elements[this.index].node,
                            player: this.getSlidePlayerInstance(this.index)
                        }
                    }), T(this.settings.beforeSlideChange) && this.settings.beforeSlideChange.apply(this, [
                        {
                            index: this.prevActiveSlideIndex,
                            slide: this.prevActiveSlide,
                            player: this.getSlidePlayerInstance(this.prevActiveSlideIndex)
                        },
                        {
                            index: this.index,
                            slide: this.activeSlide,
                            player: this.getSlidePlayerInstance(this.index)
                        }
                    ]), this.prevActiveSlideIndex > this.index && "slide" == this.settings.slideEffect && (i = this.settings.cssEfects.slideBack.out), g(e, i, function() {
                        var t = e.querySelector(".ginner-container"), i = e.querySelector(".gslide-media"), n = e.querySelector(".gslide-description");
                        t.style.transform = "", i.style.transform = "", d(i, "greset"), i.style.opacity = "", n && (n.style.opacity = ""), d(e, "prev");
                    });
                }
            },
            {
                key: "getAllPlayers",
                value: function() {
                    return this.videoPlayers;
                }
            },
            {
                key: "getSlidePlayerInstance",
                value: function(e) {
                    var t = "gvideo" + e, i = this.getAllPlayers();
                    return !(!O(i, t) || !i[t]) && i[t];
                }
            },
            {
                key: "stopSlideVideo",
                value: function(e) {
                    if (k(e)) {
                        var t = e.querySelector(".gvideo-wrapper");
                        t && (e = t.getAttribute("data-index"));
                    }
                    console.log("stopSlideVideo is deprecated, use slidePlayerPause");
                    var i = this.getSlidePlayerInstance(e);
                    i && i.playing && i.pause();
                }
            },
            {
                key: "slidePlayerPause",
                value: function(e) {
                    if (k(e)) {
                        var t = e.querySelector(".gvideo-wrapper");
                        t && (e = t.getAttribute("data-index"));
                    }
                    var i = this.getSlidePlayerInstance(e);
                    i && i.playing && i.pause();
                }
            },
            {
                key: "playSlideVideo",
                value: function(e) {
                    if (k(e)) {
                        var t = e.querySelector(".gvideo-wrapper");
                        t && (e = t.getAttribute("data-index"));
                    }
                    console.log("playSlideVideo is deprecated, use slidePlayerPlay");
                    var i = this.getSlidePlayerInstance(e);
                    i && !i.playing && i.play();
                }
            },
            {
                key: "slidePlayerPlay",
                value: function(e) {
                    var t;
                    if (!J || null !== (t = this.settings.plyr.config) && void 0 !== t && t.muted) {
                        if (k(e)) {
                            var i = e.querySelector(".gvideo-wrapper");
                            i && (e = i.getAttribute("data-index"));
                        }
                        var n = this.getSlidePlayerInstance(e);
                        n && !n.playing && (n.play(), this.settings.autofocusVideos && n.elements.container.focus());
                    }
                }
            },
            {
                key: "setElements",
                value: function(e) {
                    var t = this;
                    this.settings.elements = !1;
                    var i = [];
                    e && e.length && o(e, function(e, n) {
                        var s = new $(e, t, n), o = s.getConfig(), r = l({}, o);
                        r.slideConfig = o, r.instance = s, r.index = n, i.push(r);
                    }), this.elements = i, this.lightboxOpen && (this.slidesContainer.innerHTML = "", this.elements.length && (o(this.elements, function() {
                        var e = m(t.settings.slideHTML);
                        t.slidesContainer.appendChild(e);
                    }), this.showSlide(0, !0)));
                }
            },
            {
                key: "getElementIndex",
                value: function(e) {
                    var t = !1;
                    return o(this.elements, function(i, n) {
                        if (O(i, "node") && i.node == e) return t = n, !0;
                    }), t;
                }
            },
            {
                key: "getElements",
                value: function() {
                    var e = this, t = [];
                    this.elements = this.elements ? this.elements : [], !I(this.settings.elements) && E(this.settings.elements) && this.settings.elements.length && o(this.settings.elements, function(i, n) {
                        var s = new $(i, e, n), o = s.getConfig(), r = l({}, o);
                        r.node = !1, r.index = n, r.instance = s, r.slideConfig = o, t.push(r);
                    });
                    var i = !1;
                    return this.getSelector() && (i = document.querySelectorAll(this.getSelector())), i ? (o(i, function(i, n) {
                        var s = new $(i, e, n), o = s.getConfig(), r = l({}, o);
                        r.node = i, r.index = n, r.instance = s, r.slideConfig = o, r.gallery = i.getAttribute("data-gallery"), t.push(r);
                    }), t) : t;
                }
            },
            {
                key: "getGalleryElements",
                value: function(e, t) {
                    return e.filter(function(e) {
                        return e.gallery == t;
                    });
                }
            },
            {
                key: "getSelector",
                value: function() {
                    return !this.settings.elements && (this.settings.selector && "data-" == this.settings.selector.substring(0, 5) ? "*[".concat(this.settings.selector, "]") : this.settings.selector);
                }
            },
            {
                key: "getActiveSlide",
                value: function() {
                    return this.slidesContainer.querySelectorAll(".gslide")[this.index];
                }
            },
            {
                key: "getActiveSlideIndex",
                value: function() {
                    return this.index;
                }
            },
            {
                key: "getAnimationClasses",
                value: function() {
                    var e = [];
                    for(var t in this.settings.cssEfects)if (this.settings.cssEfects.hasOwnProperty(t)) {
                        var i = this.settings.cssEfects[t];
                        e.push("g".concat(i.in)), e.push("g".concat(i.out));
                    }
                    return e.join(" ");
                }
            },
            {
                key: "build",
                value: function() {
                    var e = this;
                    if (this.built) return !1;
                    var t = document.body.childNodes, i = [];
                    o(t, function(e) {
                        e.parentNode == document.body && "#" !== e.nodeName.charAt(0) && e.hasAttribute && !e.hasAttribute("aria-hidden") && (i.push(e), e.setAttribute("aria-hidden", "true"));
                    });
                    var n = O(this.settings.svg, "next") ? this.settings.svg.next : "", s = O(this.settings.svg, "prev") ? this.settings.svg.prev : "", l = O(this.settings.svg, "close") ? this.settings.svg.close : "", r = this.settings.lightboxHTML;
                    r = m(r = (r = (r = r.replace(/{nextSVG}/g, n)).replace(/{prevSVG}/g, s)).replace(/{closeSVG}/g, l)), document.body.appendChild(r);
                    var d = document.getElementById("glightbox-body");
                    this.modal = d;
                    var g = d.querySelector(".gclose");
                    this.prevButton = d.querySelector(".gprev"), this.nextButton = d.querySelector(".gnext"), this.overlay = d.querySelector(".goverlay"), this.loader = d.querySelector(".gloader"), this.slidesContainer = document.getElementById("glightbox-slider"), this.bodyHiddenChildElms = i, this.events = {}, h(this.modal, "glightbox-" + this.settings.skin), this.settings.closeButton && g && (this.events.close = a("click", {
                        onElement: g,
                        withCallback: function(t, i) {
                            t.preventDefault(), e.close();
                        }
                    })), g && !this.settings.closeButton && g.parentNode.removeChild(g), this.nextButton && (this.events.next = a("click", {
                        onElement: this.nextButton,
                        withCallback: function(t, i) {
                            t.preventDefault(), e.nextSlide();
                        }
                    })), this.prevButton && (this.events.prev = a("click", {
                        onElement: this.prevButton,
                        withCallback: function(t, i) {
                            t.preventDefault(), e.prevSlide();
                        }
                    })), this.settings.closeOnOutsideClick && (this.events.outClose = a("click", {
                        onElement: d,
                        withCallback: function(t, i) {
                            e.preventOutsideClick || c(document.body, "glightbox-mobile") || u(t.target, ".ginner-container") || u(t.target, ".gbtn") || c(t.target, "gnext") || c(t.target, "gprev") || e.close();
                        }
                    })), o(this.elements, function(t, i) {
                        e.slidesContainer.appendChild(t.instance.create()), t.slideNode = e.slidesContainer.querySelectorAll(".gslide")[i];
                    }), K && h(document.body, "glightbox-touch"), this.events.resize = a("resize", {
                        onElement: window,
                        withCallback: function() {
                            e.resize();
                        }
                    }), this.built = !0;
                }
            },
            {
                key: "resize",
                value: function() {
                    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null;
                    if ((e = e || this.activeSlide) && !c(e, "zoomed")) {
                        var t = y(), i = e.querySelector(".gvideo-wrapper"), n = e.querySelector(".gslide-image"), s = this.slideDescription, l = t.width, o = t.height;
                        if (l <= 768 ? h(document.body, "glightbox-mobile") : d(document.body, "glightbox-mobile"), i || n) {
                            var r = !1;
                            if (s && (c(s, "description-bottom") || c(s, "description-top")) && !c(s, "gabsolute") && (r = !0), n) {
                                if (l <= 768) n.querySelector("img");
                                else if (r) {
                                    var a = s.offsetHeight, u = n.querySelector("img");
                                    u.setAttribute("style", "max-height: calc(100vh - ".concat(a, "px)")), s.setAttribute("style", "max-width: ".concat(u.offsetWidth, "px;"));
                                }
                            }
                            if (i) {
                                var g = O(this.settings.plyr.config, "ratio") ? this.settings.plyr.config.ratio : "";
                                if (!g) {
                                    var v = i.clientWidth, f = i.clientHeight, p = v / f;
                                    g = "".concat(v / p, ":").concat(f / p);
                                }
                                var m = g.split(":"), x = this.settings.videosWidth, b = this.settings.videosWidth, S = (b = M(x) || -1 !== x.indexOf("px") ? parseInt(x) : -1 !== x.indexOf("vw") ? l * parseInt(x) / 100 : -1 !== x.indexOf("vh") ? o * parseInt(x) / 100 : -1 !== x.indexOf("%") ? l * parseInt(x) / 100 : parseInt(i.clientWidth)) / (parseInt(m[0]) / parseInt(m[1]));
                                if (S = Math.floor(S), r && (o -= s.offsetHeight), b > l || S > o || o < S && l > b) {
                                    var w = i.offsetWidth, T = i.offsetHeight, C = o / T, k = {
                                        width: w * C,
                                        height: T * C
                                    };
                                    i.parentNode.setAttribute("style", "max-width: ".concat(k.width, "px")), r && s.setAttribute("style", "max-width: ".concat(k.width, "px;"));
                                } else i.parentNode.style.maxWidth = "".concat(x), r && s.setAttribute("style", "max-width: ".concat(x, ";"));
                            }
                        }
                    }
                }
            },
            {
                key: "reload",
                value: function() {
                    this.init();
                }
            },
            {
                key: "updateNavigationClasses",
                value: function() {
                    var e = this.loop();
                    d(this.nextButton, "disabled"), d(this.prevButton, "disabled"), 0 == this.index && this.elements.length - 1 == 0 ? (h(this.prevButton, "disabled"), h(this.nextButton, "disabled")) : 0 !== this.index || e ? this.index !== this.elements.length - 1 || e || h(this.nextButton, "disabled") : h(this.prevButton, "disabled");
                }
            },
            {
                key: "loop",
                value: function() {
                    var e = O(this.settings, "loopAtEnd") ? this.settings.loopAtEnd : null;
                    return e = O(this.settings, "loop") ? this.settings.loop : e, e;
                }
            },
            {
                key: "close",
                value: function() {
                    var e = this;
                    if (!this.lightboxOpen) {
                        if (this.events) {
                            for(var t in this.events)this.events.hasOwnProperty(t) && this.events[t].destroy();
                            this.events = null;
                        }
                        return !1;
                    }
                    if (this.closing) return !1;
                    this.closing = !0, this.slidePlayerPause(this.activeSlide), this.fullElementsList && (this.elements = this.fullElementsList), this.bodyHiddenChildElms.length && o(this.bodyHiddenChildElms, function(e) {
                        e.removeAttribute("aria-hidden");
                    }), h(this.modal, "glightbox-closing"), g(this.overlay, "none" == this.settings.openEffect ? "none" : this.settings.cssEfects.fade.out), g(this.activeSlide, this.settings.cssEfects[this.settings.closeEffect].out, function() {
                        if (e.activeSlide = null, e.prevActiveSlideIndex = null, e.prevActiveSlide = null, e.built = !1, e.events) {
                            for(var t in e.events)e.events.hasOwnProperty(t) && e.events[t].destroy();
                            e.events = null;
                        }
                        var i = document.body;
                        d(Q, "glightbox-open"), d(i, "glightbox-open touching gdesc-open glightbox-touch glightbox-mobile gscrollbar-fixer"), e.modal.parentNode.removeChild(e.modal), e.trigger("close"), T(e.settings.onClose) && e.settings.onClose();
                        var n = document.querySelector(".gcss-styles");
                        n && n.parentNode.removeChild(n), e.lightboxOpen = !1, e.closing = null;
                    });
                }
            },
            {
                key: "destroy",
                value: function() {
                    this.close(), this.clearAllEvents(), this.baseEvents && this.baseEvents.destroy();
                }
            },
            {
                key: "on",
                value: function(e, t) {
                    var i = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
                    if (!e || !T(t)) throw new TypeError("Event name and callback must be defined");
                    this.apiEvents.push({
                        evt: e,
                        once: i,
                        callback: t
                    });
                }
            },
            {
                key: "once",
                value: function(e, t) {
                    this.on(e, t, !0);
                }
            },
            {
                key: "trigger",
                value: function(e) {
                    var t = this, i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null, n = [];
                    o(this.apiEvents, function(t, s) {
                        var l = t.evt, o = t.once, r = t.callback;
                        l == e && (r(i), o && n.push(s));
                    }), n.length && o(n, function(e) {
                        return t.apiEvents.splice(e, 1);
                    });
                }
            },
            {
                key: "clearAllEvents",
                value: function() {
                    this.apiEvents.splice(0, this.apiEvents.length);
                }
            },
            {
                key: "version",
                value: function() {
                    return "3.1.0";
                }
            }
        ]), e;
    }();
    return function() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, t = new te(e);
        return t.init(), t;
    };
});


function $9745ce6cd249f9c5$export$2e2bcd8739ae039(props) {
    const [lightbox, setLightbox] = (0, $88a9540d1aad6464$export$60241385465d0a34)(null);
    (0, $88a9540d1aad6464$export$6d9c69b0de29b591)(()=>{
        setLightbox((0, (/*@__PURE__*/$parcel$interopDefault($42107f3179039eb0$exports)))({
            autoplayVideos: false,
            draggable: true,
            loop: false,
            touchNavigation: true,
            zoomable: true,
            elements: []
        }));
    }, []);
    const openLightbox = (evt)=>{
        evt.preventDefault();
        evt.stopPropagation();
        if (lightbox != null && Array.from(document.getElementsByClassName("glightbox")).length > 0) {
            const elements = Array.from(document.getElementsByClassName("glightbox")).map((e)=>{
                const r = {
                    href: e.href
                };
                if (e?.dataset?.width) r.width = e?.dataset?.width;
                if (e?.dataset?.height) r.height = e?.dataset?.height;
                if (e?.dataset?.type) r.type = e?.dataset?.type;
                if (e?.dataset?.srcset) r.srcset = e?.dataset?.srcset;
                if (e?.dataset?.sizes) r.sizes = e?.dataset?.sizes;
                return r;
            });
            lightbox.setElements(elements);
            lightbox.open(null, elements.findIndex((e)=>e.href === evt.target.closest(".glightbox").href));
        }
    };
    const getPreview = ()=>{
        if (props?.data?.exception) console.warn(props.data);
        if (props.data["providerName"]) {
            if ("peertube" == props.data["providerName"].toLowerCase()) {
                // default embed code
                if (props.data["code"]) return (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
                    class: "embed-container",
                    dangerouslySetInnerHTML: {
                        __html: props.data["code"]
                    }
                });
            }
            if ("soundcloud" == props.data["providerName"].toLowerCase()) {
                if (props.data["code"]) return (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)((0, $1dd5e274a4fb4aa6$export$2e2bcd8739ae039), {
                    preview: (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).crop(props.preview.id, 1024, 270),
                    url: `${props.data["code"].match(/https:\/\/[^"\s]+/)[0]}&auto_play=true`,
                    playBtnClass: "soundcloud"
                });
            }
            if ("bandcamp" == props.data["providerName"].toLowerCase()) {
                if (props.data["code"]) {
                    let id = props.data["code"].match(/https:\/\/.*album=\d+/);
                    if (!id) id = props.data["code"].match(/https:\/\/.*track=\d+/);
                    if (id) return (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)((0, $471cd1c649eea7ba$export$2e2bcd8739ae039), {
                        preview: (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).crop(props.preview.id, 1024, 270),
                        url: id[0]
                    });
                }
            }
            if ("lichess.org" == props.data["providerName"].toLowerCase()) {
                let url = props?.data?.url && typeof props?.data.url == "string" ? props.data?.url : props.url;
                if ((0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).isValidUrl(url) && !url.match(/embed/) && !url.match(/study/) && !url.match(/blog/)) {
                    url = new URL(url.replace("lichess.org/", "lichess.org/embed/"));
                    let id;
                    try {
                        id = url.pathname.split("/").slice(-1)[0];
                    } catch (e) {
                        id = "";
                    }
                    url = new URL(url.href.replace(id, id.slice(0, 8)));
                    if (id) return (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)((0, $1dd5e274a4fb4aa6$export$2e2bcd8739ae039), {
                        preview: (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).crop(props.preview.id, 270, 270),
                        url: url,
                        playBtnClass: "lichess"
                    });
                }
            }
            if ("youtube" == props.data["providerName"].toLowerCase()) {
                let url = props.url;
                if (props?.preview?.id && url) {
                    url = new URL(url);
                    let video_id;
                    let playlist_id;
                    if (url.host == "www.youtube.com" || url.host == "m.youtube.com" || url.host == "youtube.com" || url.host == "music.youtube.com") {
                        if (url.pathname.match(/shorts/)) {
                            video_id = [
                                `v=${url.pathname.split("/").slice(-1)[0]}`
                            ];
                            playlist_id = [];
                        } else if (url.pathname.match(/embed/)) {
                            video_id = [
                                `v=${url.pathname.split("/").slice(-1)[0]}`
                            ];
                            playlist_id = [];
                        } else {
                            video_id = url.search.substring(1).split("&").filter((e)=>e.match(/^v=/));
                            playlist_id = url.search.substring(1).split("&").filter((e)=>e.match(/^list=/));
                        }
                    }
                    if (url.host == "youtu.be") {
                        video_id = [
                            `v=${url.pathname.slice(1)}`
                        ];
                        playlist_id = [];
                    }
                    let timecode = (0, $cd2f6546c5cf5c32$export$5375cda95f0b0eb4).getParam("t", url.search.substring(1));
                    if (playlist_id.length && video_id.length) return (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)((0, $1dd5e274a4fb4aa6$export$2e2bcd8739ae039), {
                        preview: (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).crop(props.preview.id, 1024, 270),
                        url: `https://youtube.com/embed/${video_id[0].split("=")[1]}?autoplay=1&controls=2&wmode=opaque&list=${playlist_id[0].split("=")[1]}${timecode ? `&start=${timecode}` : ""}`,
                        playBtnClass: "youtube"
                    });
                    if (playlist_id.length) return (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)((0, $1dd5e274a4fb4aa6$export$2e2bcd8739ae039), {
                        preview: (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).crop(props.preview.id, 1024, 270),
                        url: `https://youtube.com/embed/videoseries?list=${playlist_id[0].split("=")[1]}&autoplay=1&controls=2&wmode=opaque${timecode ? `&start=${timecode}` : ""}`,
                        playBtnClass: "youtube"
                    });
                    if (video_id.length) return (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)((0, $1dd5e274a4fb4aa6$export$2e2bcd8739ae039), {
                        preview: (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).crop(props.preview.id, 1024, 270),
                        url: `https://youtube.com/embed/${video_id[0].split("=")[1]}?autoplay=1&controls=2&wmode=opaque${timecode ? `&start=${timecode}` : ""}`,
                        playBtnClass: "youtube"
                    });
                }
            }
        }
        if (props.data["content-type"] == "image/gif") return (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
            class: "container d-flex justify-content-center flex-wrap align-items-center"
        }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("img", {
            href: (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).toApp(props.url),
            class: "img-fluid",
            "data-origin": props.url,
            "data-src": props.url,
            src: props.url
        }));
        if (/image/.test(props.data["content-type"])) return (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
            class: "container d-flex justify-content-center flex-wrap align-items-center"
        }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("a", {
            href: (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).toApp(props.url),
            class: "glightbox",
            "data-type": "image",
            "data-srcset": `${(0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).thumbnail(props.preview.id, 720)} 720w, ${(0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).thumbnail(props.preview.id, 1366)} 1366w, ${(0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).thumbnail(props.preview.id, 2048)} 2048w`,
            "data-sizes": "(max-width: 992px) 720px, (max-width: 1400px) 1366px, 2048px",
            onClick: (e)=>openLightbox(e)
        }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("img", {
            href: (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).toApp(props.url),
            class: "img-fluid cursor-pointer",
            "data-origin": props.url,
            "data-src": (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).thumbnail(props.preview.id, 1366),
            src: (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).thumbnail(props.preview.id, 2048)
        })));
        // application/ogg: https://developer.mozilla.org/en-US/docs/Web/HTTP/Configuring_servers_for_Ogg_media
        if (/video/.test(props.data["content-type"]) || props.data["content-type"] == "application/ogg") return (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
            class: "container d-flex justify-content-center flex-wrap align-items-center"
        }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("video", {
            class: "img-fluid",
            controls: true,
            src: props.url
        }));
        if (/audio/.test(props.data["content-type"])) return (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
            class: "container d-flex justify-content-center flex-wrap align-items-center"
        }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("audio", {
            class: "w-100",
            controls: true
        }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("source", {
            src: props.url
        })));
        if (props.data["title"] && (props.preview || props.data["description"])) return (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("a", {
            class: "preview-card seamless-link d-inline-block",
            target: "_blank",
            rel: "noreferrer",
            href: (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).toApp(props.url)
        }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
            class: "card",
            style: "max-width: 480px"
        }, props.preview && (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("img", {
            class: "card-img-top",
            src: (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).crop(props.preview.id, 320, 180)
        }), (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
            class: "card-body p-1"
        }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("h5", null, props.data["title"]), props.data["description"] && (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("p", null, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("small", null, props.data["description"].slice(0, 500))))));
        return null;
    };
    if (!props.url || !props.data) return null;
    let preview = getPreview();
    if (preview) return (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("p", {
        class: "text-center card-text"
    }, preview);
    return null;
}




function $b7ceefe51d9ca40b$export$2e2bcd8739ae039(props) {
    const toggleFile = (evt)=>{
        evt.stopPropagation();
        evt.preventDefault();
        if (typeof props.toggleFile == "function") props.toggleFile(evt.target.closest(".file-embed").id);
    };
    if (!props.files || props.files.length === 0) return null;
    if (props.files && props.files.length > 3) return (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
        class: "file-grid"
    }, props.files.map((e)=>(0, $73048c6b859c8a02$export$c8a8987d4410bf2d)((0, $c72cf4b6b78e8f8e$export$40e4fb50d87564f1), {
            key: e.id,
            invertFiles: props.invertFiles,
            toggleFile: toggleFile,
            file: e,
            inWriter: props.inWriter
        })));
    return (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
        class: "d-flex justify-content-center flex-wrap"
    }, props.files.map((e)=>(0, $73048c6b859c8a02$export$c8a8987d4410bf2d)((0, $c72cf4b6b78e8f8e$export$48621228a997a4e0), {
            key: e.id,
            toggleFile: toggleFile,
            invertFiles: props.invertFiles,
            file: e,
            inWriter: props.inWriter
        })));
}








function $374de5a37ad6a81a$export$2e2bcd8739ae039(props) {
    const [lightbox, setLightbox] = (0, $88a9540d1aad6464$export$60241385465d0a34)(null);
    const { t: t } = (0, $23287d5819478a30$export$9fc83ad70ead8663)();
    const filePath = props.file.contentUrl ? `/files/${props.file.contentUrl}` : null;
    let url = filePath;
    (0, $88a9540d1aad6464$export$6d9c69b0de29b591)(()=>{
        setLightbox((0, (/*@__PURE__*/$parcel$interopDefault($42107f3179039eb0$exports)))({
            autoplayVideos: false,
            draggable: true,
            loop: false,
            touchNavigation: true,
            zoomable: true,
            elements: []
        }));
    }, []);
    const openLightbox = (evt)=>{
        if (!props.inWriter) {
            evt.preventDefault();
            evt.stopPropagation();
            if (lightbox != null && Array.from(document.getElementsByClassName("glightbox")).length > 0) {
                const elements = Array.from(document.getElementsByClassName("glightbox")).map((e)=>{
                    const r = {
                        href: e.href
                    };
                    if (e?.dataset?.width) r.width = e?.dataset?.width;
                    if (e?.dataset?.height) r.height = e?.dataset?.height;
                    if (e?.dataset?.type) r.type = e?.dataset?.type;
                    if (e?.dataset?.srcset) r.srcset = e?.dataset?.srcset;
                    if (e?.dataset?.sizes) r.sizes = e?.dataset?.sizes;
                    return r;
                });
                lightbox.setElements(elements);
                lightbox.open(null, elements.findIndex((e)=>e.href === evt.target.closest(".glightbox").href));
            }
        }
    };
    if (props.file.contentUrl) {
        if (/video/.test(props.file.type)) {
            if (props.file.status == "ready") return (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("video", {
                draggable: "false",
                poster: (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).thumbnail(props.file.id, 1280, 720),
                class: "file-embed img-fluid contained-height video",
                controls: "true",
                src: url,
                id: props.file.id
            });
            return (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("a", {
                class: "file-embed file-loading image video-uploaded",
                id: props.file.id
            }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("img", {
                class: "img-fluid video-raw",
                src: (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).crop(props.file.id, 320, 180)
            }), (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
                class: "video-not-ready"
            }, t("video_not_ready")));
        }
        if (/pdf/.test(props.file.type)) return (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("a", {
            "data-origin": (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).toApp(filePath),
            draggable: "false",
            href: !props.inWriter ? (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).toApp(url) : undefined,
            className: `glightbox file-embed pdf-outline image${props.file.removed ? " removed" : ""}`,
            id: props.file.id,
            "data-width": "calc(90vw - 10px)",
            "data-height": "100vh",
            onClick: (e)=>openLightbox(e)
        }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("img", {
            class: "img-fluid",
            src: (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).thumbnail(props.file.id, 420, 994)
        }), (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
            class: "remove-button",
            style: props.file.removed ? "color:red" : "",
            onClick: (e)=>props.toggleFile(e)
        }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)((0, $607f51540ffcd426$export$8b29a4b6778bf7f), {
            family: "solid",
            icon: "times"
        })));
        if (/image/.test(props.file.type)) {
            if (props.file.type == "image/gif") return (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("a", {
                "data-origin": (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).toApp(filePath),
                draggable: "false",
                href: !props.inWriter ? (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).toApp(filePath) : undefined,
                className: `glightbox file-embed image${props.file.removed ? " removed" : ""}`,
                id: props.file.id,
                "data-type": "image",
                onClick: (e)=>openLightbox(e)
            }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("img", {
                class: "img-fluid",
                src: (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).toApp(filePath)
            }), (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
                class: "remove-button",
                style: props.file.removed ? "color:red" : "",
                onClick: (e)=>props.toggleFile(e)
            }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)((0, $607f51540ffcd426$export$8b29a4b6778bf7f), {
                family: "solid",
                icon: "times"
            })));
            return (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("a", {
                "data-origin": (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).toApp(filePath),
                draggable: "false",
                "data-type": "image",
                "data-srcset": `${(0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).thumbnail(props.file.id, 720)} 720w, ${(0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).thumbnail(props.file.id, 1366)} 1366w, ${(0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).thumbnail(props.file.id, 2048)} 2048w`,
                "data-sizes": "(max-width: 992px) 720px, (max-width: 1400px) 1366px, 2048px",
                href: !props.inWriter ? (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).toApp(filePath) : undefined,
                className: `glightbox file-embed image${props.file.removed ? " removed" : ""}`,
                id: props.file.id,
                onClick: (e)=>openLightbox(e)
            }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("img", {
                class: "img-fluid",
                src: (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).thumbnail(props.file.id, 720)
            }), (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
                class: "remove-button",
                style: props.file.removed ? "color:red" : "",
                onClick: (e)=>props.toggleFile(e)
            }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)((0, $607f51540ffcd426$export$8b29a4b6778bf7f), {
                family: "solid",
                icon: "times"
            })));
        }
    }
    if (props.file.status == "loading") return (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
        class: "file-embed file-placeholder",
        id: props.file.id
    });
    return (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
        class: "file-embed file-placeholder",
        id: props.file.id
    }, props.file["error"] ? (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
        class: "orange-error"
    }, "\xd7") : (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
        class: "spinner orange-spinner"
    }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", null), (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", null), (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", null), (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", null), (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", null)), (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
        class: "progress-bar"
    }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
        style: {
            width: `${props.file.progress}%`
        }
    })));
}






var $a64402709a5ef811$exports = {};
/*! mobile-drag-drop 3.0.0-rc.0 | Copyright (c) 2022 Tim Ruffles | MIT License */ !function(t, i) {
    i($a64402709a5ef811$exports);
}($a64402709a5ef811$exports, function(t) {
    "use strict";
    var c = "dnd-poly-", s = [
        "none",
        "copy",
        "copyLink",
        "copyMove",
        "link",
        "linkMove",
        "move",
        "all"
    ], f = [
        "none",
        "copy",
        "move",
        "link"
    ];
    function i() {
        var t = !1;
        try {
            var i = Object.defineProperty({}, "passive", {
                get: function() {
                    t = !0;
                }
            });
            window.addEventListener("test", null, i);
        } catch (t) {}
        return t;
    }
    var e = i();
    function l(t) {
        return t && t.tagName;
    }
    function h(t, i, s) {
        void 0 === s && (s = !0), document.addEventListener(t, i, !!e && {
            passive: s
        });
    }
    function n(t, i) {
        document.removeEventListener(t, i);
    }
    function u(t, i, s, n) {
        void 0 === n && (n = !1);
        var h = e ? {
            passive: !0,
            capture: n
        } : n;
        return t.addEventListener(i, s, h), {
            off: function() {
                t.removeEventListener(i, s, h);
            }
        };
    }
    function o(t) {
        return 0 === t.length ? 0 : t.reduce(function(t, i) {
            return i + t;
        }, 0) / t.length;
    }
    function r(t, i) {
        for(var s = 0; s < t.changedTouches.length; s++)if (t.changedTouches[s].identifier === i) return !0;
        return !1;
    }
    function a(t, i, s) {
        for(var n = [], h = [], e = 0; e < i.touches.length; e++){
            var r = i.touches[e];
            n.push(r[t + "X"]), h.push(r[t + "Y"]);
        }
        s.x = o(n), s.y = o(h);
    }
    var d = [
        "",
        "-webkit-"
    ];
    function v(t, i, s, n, h) {
        var e = i.x, i = i.y;
        n && (e += n.x, i += n.y), (h = void 0 === h || h) && (e -= parseInt(t.offsetWidth, 10) / 2, i -= parseInt(t.offsetHeight, 10) / 2);
        for(var r = "translate3d(" + e + "px," + i + "px, 0)", o = 0; o < d.length; o++){
            var u = d[o] + "transform";
            t.style[u] = r + " " + s[o];
        }
    }
    var p = (Object.defineProperty(g.prototype, "dropEffect", {
        get: function() {
            return this.t;
        },
        set: function(t) {
            0 !== this.i.mode && -1 < s.indexOf(t) && (this.t = t);
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(g.prototype, "types", {
        get: function() {
            if (0 !== this.i.mode) return Object.freeze(this.i.types);
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(g.prototype, "effectAllowed", {
        get: function() {
            return this.i.effectAllowed;
        },
        set: function(t) {
            2 === this.i.mode && -1 < s.indexOf(t) && (this.i.effectAllowed = t);
        },
        enumerable: !1,
        configurable: !0
    }), g.prototype.setData = function(t, i) {
        if (2 === this.i.mode) {
            if (-1 < t.indexOf(" ")) throw new Error("illegal arg: type contains space");
            this.i.data[t] = i, -1 === this.i.types.indexOf(t) && this.i.types.push(t);
        }
    }, g.prototype.getData = function(t) {
        if (1 === this.i.mode || 2 === this.i.mode) return this.i.data[t] || "";
    }, g.prototype.clearData = function(t) {
        2 === this.i.mode && (t && this.i.data[t] ? (delete this.i.data[t], -1 < (t = this.i.types.indexOf(t)) && this.i.types.splice(t, 1)) : (this.i.data = {}, this.i.types = []));
    }, g.prototype.setDragImage = function(t, i, s) {
        2 === this.i.mode && this.h(t, i, s);
    }, g);
    function g(t, i) {
        this.i = t, this.h = i, this.t = f[0];
    }
    function m(t, i) {
        return t ? t === s[0] ? f[0] : 0 === t.indexOf(s[1]) || t === s[7] ? f[1] : 0 === t.indexOf(s[4]) ? f[3] : t === s[6] ? f[2] : f[1] : 3 === i.nodeType && "A" === i.tagName ? f[3] : f[1];
    }
    function y(u, t, a, i, s, n, c) {
        void 0 === c && (c = null);
        s = function(t, i, s, n, h, e, r) {
            void 0 === c && (r = null);
            var o = a.changedTouches[0], n = new Event(u, {
                bubbles: !0,
                cancelable: n
            });
            n.dataTransfer = e, n.relatedTarget = r, n.screenX = o.screenX, n.screenY = o.screenY, n.clientX = o.clientX, n.clientY = o.clientY, n.pageX = o.pageX, n.pageY = o.pageY;
            t = t.getBoundingClientRect();
            return n.offsetX = n.clientX - t.left, n.offsetY = n.clientY - t.top, n;
        }(t, 0, 0, n = void 0 === n || n, document.defaultView, s, c), s = !t.dispatchEvent(s);
        return i.mode = 0, s;
    }
    function b(t, i) {
        if (!t || t === s[7]) return i;
        if (i === f[1]) {
            if (0 === t.indexOf(f[1])) return f[1];
        } else if (i === f[3]) {
            if (0 === t.indexOf(f[3]) || -1 < t.indexOf("Link")) return f[3];
        } else if (i === f[2] && (0 === t.indexOf(f[2]) || -1 < t.indexOf("Move"))) return f[2];
        return f[0];
    }
    var w = (x.prototype.o = function() {
        var n = this;
        this.u = 1, this.l = f[0], this.v = {
            data: {},
            effectAllowed: void 0,
            mode: 3,
            types: []
        }, this.p = {
            x: null,
            y: null
        }, this.g = {
            x: null,
            y: null
        };
        var h = this.m;
        if (this.I = new p(this.v, function(t, i, s) {
            h = t, "number" != typeof i && "number" != typeof s || (n.j = {
                x: i || 0,
                y: s || 0
            });
        }), this.v.mode = 2, this.I.dropEffect = f[0], y("dragstart", this.m, this.k, this.v, this.I)) return this.u = 3, this.C(), !1;
        a("page", this.k, this.g);
        var i, t, s = this.S.dragImageSetup(h);
        return this.A = (i = s, d.map(function(t) {
            t = i.style[t + "transform"];
            return t && "none" !== t ? t.replace(/translate\(\D*\d+[^,]*,\D*\d+[^,]*\)\s*/g, "") : "";
        })), s.style.position = "absolute", s.style.left = "0px", s.style.top = "0px", s.style.zIndex = "999999", s.classList.add("dnd-poly-drag-image"), s.classList.add("dnd-poly-icon"), this.O = s, this.j || (this.S.dragImageOffset ? this.j = {
            x: this.S.dragImageOffset.x,
            y: this.S.dragImageOffset.y
        } : this.S.dragImageCenterOnTouch ? (t = getComputedStyle(h), this.j = {
            x: 0 - parseInt(t.marginLeft, 10),
            y: 0 - parseInt(t.marginTop, 10)
        }) : (s = h.getBoundingClientRect(), t = getComputedStyle(h), this.j = {
            x: s.left - this.M.clientX - parseInt(t.marginLeft, 10) + s.width / 2,
            y: s.top - this.M.clientY - parseInt(t.marginTop, 10) + s.height / 2
        })), v(this.O, this.g, this.A, this.j, this.S.dragImageCenterOnTouch), document.body.appendChild(this.O), this.D = window.setInterval(function() {
            n.F || (n.F = !0, n.N(), n.F = !1);
        }, this.S.iterationInterval), !0;
    }, x.prototype.C = function() {
        this.D && (clearInterval(this.D), this.D = null), n("touchmove", this.P), n("touchend", this.T), n("touchcancel", this.T), this.O && (this.O.parentNode.removeChild(this.O), this.O = null), this.L(this.S, this.k, this.u);
    }, x.prototype._ = function(t) {
        var s = this;
        if (!1 !== r(t, this.M.identifier)) {
            if (this.k = t, 0 === this.u) {
                var i = void 0;
                if (this.S.dragStartConditionOverride) try {
                    i = this.S.dragStartConditionOverride(t);
                } catch (t) {
                    i = !1;
                }
                else i = 1 === t.touches.length;
                return i ? void (!0 === this.o() && (this.H.preventDefault(), t.preventDefault())) : void this.C();
            }
            if (t.preventDefault(), a("client", t, this.p), a("page", t, this.g), this.S.dragImageTranslateOverride) try {
                var n = !1;
                if (this.S.dragImageTranslateOverride(t, {
                    x: this.p.x,
                    y: this.p.y
                }, this.V, function(t, i) {
                    s.O && (n = !0, s.p.x += t, s.p.y += i, s.g.x += t, s.g.y += i, v(s.O, s.g, s.A, s.j, s.S.dragImageCenterOnTouch));
                }), n) return;
            } catch (t) {}
            v(this.O, this.g, this.A, this.j, this.S.dragImageCenterOnTouch);
        }
    }, x.prototype.X = function(t) {
        if (!1 !== r(t, this.M.identifier)) {
            if (this.S.dragImageTranslateOverride) try {
                this.S.dragImageTranslateOverride(void 0, void 0, void 0, function() {});
            } catch (t) {}
            0 !== this.u ? (t.preventDefault(), this.u = "touchcancel" === t.type ? 3 : 2) : this.C();
        }
    }, x.prototype.N = function() {
        var t = this, i = this.l;
        this.v.mode = 3, this.I.dropEffect = f[0];
        var s, n, h, e, r, o = y("drag", this.m, this.k, this.v, this.I);
        if (o && (this.l = f[0]), o || 2 === this.u || 3 === this.u) return this.Y(this.u) ? (e = this.m, s = this.O, n = this.A, a = function() {
            t.q();
        }, void ("hidden" !== (r = getComputedStyle(e)).visibility && "none" !== r.display ? (s.classList.add("dnd-poly-snapback"), h = getComputedStyle(s), o = parseFloat(h.transitionDuration), isNaN(o) || 0 === o ? a() : ((e = {
            x: (u = e.getBoundingClientRect()).left,
            y: u.top
        }).x += document.body.scrollLeft || document.documentElement.scrollLeft, e.y += document.body.scrollTop || document.documentElement.scrollTop, e.x -= parseInt(r.marginLeft, 10), e.y -= parseInt(r.marginTop, 10), u = parseFloat(h.transitionDelay), u = Math.round(1e3 * (o + u)), v(s, e, n, void 0, !1), setTimeout(a, u))) : a())) : void this.q();
        var u = this.S.elementFromPoint(this.p.x, this.p.y), a = this.B;
        u !== this.V && u !== this.B && (this.V = u, null !== this.B && (this.v.mode = 3, this.I.dropEffect = f[0], y("dragexit", this.B, this.k, this.v, this.I, !1)), null === this.V ? this.B = this.V : (this.v.mode = 3, this.I.dropEffect = m(this.v.effectAllowed, this.m), y("dragenter", this.V, this.k, this.v, this.I) ? (this.B = this.V, this.l = b(this.I.effectAllowed, this.I.dropEffect)) : this.V !== document.body && (this.B = document.body))), a !== this.B && l(a) && (this.v.mode = 3, this.I.dropEffect = f[0], y("dragleave", a, this.k, this.v, this.I, !1, this.B)), l(this.B) && (this.v.mode = 3, this.I.dropEffect = m(this.v.effectAllowed, this.m), !1 === y("dragover", this.B, this.k, this.v, this.I) ? this.l = f[0] : this.l = b(this.I.effectAllowed, this.I.dropEffect)), i !== this.l && this.O.classList.remove(c + i);
        i = c + this.l;
        this.O.classList.add(i);
    }, x.prototype.Y = function(t) {
        t = this.l === f[0] || null === this.B || 3 === t;
        return t ? l(this.B) && (this.v.mode = 3, this.I.dropEffect = f[0], y("dragleave", this.B, this.k, this.v, this.I, !1)) : l(this.B) && (this.v.mode = 1, this.I.dropEffect = this.l, !0 === y("drop", this.B, this.k, this.v, this.I) ? this.l = this.I.dropEffect : this.l = f[0]), t;
    }, x.prototype.q = function() {
        this.v.mode = 3, this.I.dropEffect = this.l, y("dragend", this.m, this.k, this.v, this.I, !1), this.u = 2, this.C();
    }, x);
    function x(t, i, s, n) {
        this.H = t, this.S = i, this.m = s, this.L = n, this.u = 0, this.V = null, this.B = null, this.k = t, this.M = t.changedTouches[0], this.P = this._.bind(this), this.T = this.X.bind(this), h("touchmove", this.P, !1), h("touchend", this.T, !1), h("touchcancel", this.T, !1);
    }
    var I, j = {
        iterationInterval: 150,
        tryFindDraggableTarget: function(t) {
            for(var i = 0, s = t.composedPath(); i < s.length; i++){
                var n = s[i];
                do if (!1 !== n.draggable) {
                    if (!0 === n.draggable) return n;
                    if (n.getAttribute && "true" === n.getAttribute("draggable")) return n;
                }
                while ((n = n.parentNode) && n !== document.body);
            }
        },
        dragImageSetup: function(t) {
            var i = t.cloneNode(!0);
            return function t(i, s) {
                if (1 === i.nodeType) {
                    for(var n, h, e = getComputedStyle(i), r = 0; r < e.length; r++){
                        var o = e[r];
                        s.style.setProperty(o, e.getPropertyValue(o), e.getPropertyPriority(o));
                    }
                    s.style.pointerEvents = "none", s.removeAttribute("id"), s.removeAttribute("class"), s.removeAttribute("draggable"), "CANVAS" === s.nodeName && (n = s, h = (h = i).getContext("2d").getImageData(0, 0, h.width, h.height), n.getContext("2d").putImageData(h, 0, 0));
                }
                if (i.hasChildNodes()) for(r = 0; r < i.childNodes.length; r++)t(i.childNodes[r], s.childNodes[r]);
                !function t(i) {
                    if (i instanceof HTMLElement && (i.style.pointerEvents = "none"), i.children && i.children.length) for(var s = 0; s < i.children.length; s++)t(i.children[s]);
                    if (i.shadowRoot && i.shadowRoot.children.length) for(s = 0; s < i.shadowRoot.children.length; s++)t(i.shadowRoot.children[s]);
                }(s);
            }(t, i), i;
        },
        elementFromPoint: function(t, i) {
            var s = document.elementFromPoint(t, i);
            if (s) {
                for(; s.shadowRoot;){
                    var n = s.shadowRoot.elementFromPoint(t, i);
                    if (null === n || n === s) break;
                    s = n;
                }
                return s;
            }
        }
    };
    function k(i) {
        if (!I) {
            var t = j.tryFindDraggableTarget(i);
            if (t) try {
                I = new w(i, j, t, S);
            } catch (t) {
                throw S(j, i, 3), t;
            }
        }
    }
    function C(t) {
        function i(t) {
            h.off(), e.off(), r.off(), o.off(), s && s.dispatchEvent(new CustomEvent("dnd-poly-dragstart-cancel", {
                bubbles: !0,
                cancelable: !0
            })), clearTimeout(n);
        }
        var s = t.target;
        s && s.dispatchEvent(new CustomEvent("dnd-poly-dragstart-pending", {
            bubbles: !0,
            cancelable: !0
        }));
        var n = window.setTimeout(function() {
            h.off(), e.off(), r.off(), o.off(), k(t);
        }, j.holdToDrag), h = u(s, "touchend", i), e = u(s, "touchcancel", i), r = u(s, "touchmove", i), o = u(window, "scroll", i, !0);
    }
    function S(t, i, s) {
        if (0 === s && t.defaultActionOverride) try {
            t.defaultActionOverride(i), i.defaultPrevented;
        } catch (t) {}
        I = null;
    }
    t.polyfill = function(i) {
        if (i && Object.keys(i).forEach(function(t) {
            j[t] = i[t];
        }), !j.forceApply) {
            t = (t = !!window.chrome || /chrome/i.test(navigator.userAgent), {
                dragEvents: "ondragstart" in document.documentElement,
                draggable: "draggable" in document.documentElement,
                userAgentSupportingNativeDnD: !(/iPad|iPhone|iPod|Android/.test(navigator.userAgent) || t && "ontouchstart" in document.documentElement)
            });
            if (t.userAgentSupportingNativeDnD && t.draggable && t.dragEvents) return !1;
        }
        var t;
        return j.holdToDrag ? h("touchstart", C, !1) : h("touchstart", k, !1), !0;
    }, t.supportsPassiveEventListener = i, Object.defineProperty(t, "G", {
        value: !0
    });
});



function $469480f865369d3d$export$2e2bcd8739ae039(props) {
    const [lightbox, setLightbox] = (0, $88a9540d1aad6464$export$60241385465d0a34)(null);
    const filePath = props.file.contentUrl ? `/files/${props.file.contentUrl}` : null;
    let url = filePath;
    const innerRef = (0, $88a9540d1aad6464$export$b8f5890fc79d6aca)(null);
    (0, $a64402709a5ef811$exports.polyfill)({
        tryFindDraggableTarget: (e)=>{
            if (!props.inWriter) return undefined;
            const cp = e.composedPath();
            for (const o of cp){
                let el = o;
                do {
                    if (el.draggable === false) continue;
                    if (el.draggable === true) return el;
                    if (el.getAttribute && el.getAttribute("draggable") === "true") return el;
                }while ((el = el.parentNode) && el !== document.body);
            }
        }
    });
    (0, $88a9540d1aad6464$export$6d9c69b0de29b591)(()=>{
        setLightbox((0, (/*@__PURE__*/$parcel$interopDefault($42107f3179039eb0$exports)))({
            autoplayVideos: false,
            draggable: true,
            loop: false,
            touchNavigation: true,
            zoomable: true,
            elements: []
        }));
    }, []);
    const openLightbox = (evt)=>{
        if (!props.inWriter) {
            evt.preventDefault();
            evt.stopPropagation();
            if (lightbox != null && Array.from(document.getElementsByClassName("glightbox")).length > 0) {
                const elements = Array.from(document.getElementsByClassName("glightbox")).map((e)=>{
                    const r = {
                        href: e.href
                    };
                    if (e?.dataset?.width) r.width = e?.dataset?.width;
                    if (e?.dataset?.height) r.height = e?.dataset?.height;
                    if (e?.dataset?.type) r.type = e?.dataset?.type;
                    if (e?.dataset?.srcset) r.srcset = e?.dataset?.srcset;
                    if (e?.dataset?.sizes) r.sizes = e?.dataset?.sizes;
                    return r;
                });
                lightbox.setElements(elements);
                lightbox.open(null, elements.findIndex((e)=>e.href === evt.target.closest(".glightbox").href));
            }
        }
    };
    const fileDragStart = (e)=>{
        e.target.style.opacity = "0.4";
        e.dataTransfer.effectAllowed = "move";
        e.dataTransfer.setData("id", props.file.id);
        document.querySelectorAll(".remove-button").forEach((e)=>e.style.display = "none");
    };
    const fileDragEnd = (e)=>{
        e.target.style.opacity = "1";
        document.querySelectorAll(".remove-button").forEach((e)=>e.style.display = "block");
        document.querySelectorAll(".drag-over").forEach((e)=>e.classList.remove("drag-over"));
    };
    const fileDragEnter = (e)=>{
        e.preventDefault();
        innerRef.current.classList.add("drag-over");
        return false;
    };
    const fileDragLeave = (e)=>{
        e.preventDefault();
        innerRef.current.classList.remove("drag-over");
        return false;
    };
    // necessary to declare a drop target
    const fileDragOver = (e)=>{
        e.preventDefault();
        return false;
    };
    const fileDrop = (e)=>{
        // stops the browser from redirecting.
        e.preventDefault();
        props.invertFiles(e.dataTransfer.getData("id"), props.file.id);
        return false;
    };
    (0, $88a9540d1aad6464$export$6d9c69b0de29b591)(()=>{
        if (props.inWriter && props.file.status == "ready" && innerRef && innerRef.current) {
            innerRef.current.addEventListener("dragstart", fileDragStart);
            innerRef.current.addEventListener("dragend", fileDragEnd);
            innerRef.current.addEventListener("dragover", fileDragOver);
            innerRef.current.addEventListener("dragenter", fileDragEnter);
            innerRef.current.addEventListener("dragleave", fileDragLeave);
            innerRef.current.addEventListener("drop", fileDrop);
            return ()=>{
                innerRef.current.removeEventListener("dragstart", fileDragStart);
                innerRef.current.removeEventListener("dragend", fileDragEnd);
                innerRef.current.removeEventListener("dragover", fileDragOver);
                innerRef.current.removeEventListener("dragenter", fileDragEnter);
                innerRef.current.removeEventListener("dragleave", fileDragLeave);
                innerRef.current.removeEventListener("drop", fileDrop);
            };
        }
    }, []);
    switch(props.file.status){
        case "raw":
            return (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("a", {
                class: "file-embed file-loading rounded",
                id: props.file.id
            }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
                class: "miniature"
            }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)((0, $607f51540ffcd426$export$8b29a4b6778bf7f), {
                family: "regular",
                icon: "check-circle"
            })));
        case "loading":
            return (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("a", {
                class: "file-embed file-loading rounded",
                id: props.file.id
            }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
                class: "miniature"
            }));
        case "uploading":
        case "initial":
            return (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("a", {
                class: "file-embed file-loading rounded",
                id: props.file.id
            }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
                class: "miniature video-raw",
                style: `background-image:url("${(0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).crop(props.file.id, 160, 160)}")`
            }), (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
                class: "spinner orange-spinner"
            }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", null), (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", null), (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", null), (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", null), (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", null)), props.file && props.file.progress > 0 && (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
                class: "progress-bar"
            }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
                style: {
                    width: `${props.file.progress}%`
                }
            })));
        case "ready":
        default:
            if (/pdf/.test(props.file.type) || /video/.test(props.file.type)) return (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("a", {
                ref: innerRef,
                draggable: !!props.inWriter,
                "data-origin": (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).toApp(filePath),
                href: !props.inWriter ? (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).toApp(url) : undefined,
                className: `${!props.inWriter ? "glightbox " : ""}file-embed rounded ${props.file.removed ? " removed" : ""}`,
                id: props.file.id,
                "data-width": "calc(90vw - 10px)",
                "data-height": "100vh",
                onClick: (e)=>openLightbox(e)
            }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
                className: `miniature${props.file.removed ? " removed" : ""}`,
                style: `background-image:url("${(0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).crop(props.file.id, 160, 160)}")`
            }), (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
                class: "remove-button",
                style: props.file.removed ? "color:red" : "",
                onClick: (e)=>props.toggleFile(e)
            }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)((0, $607f51540ffcd426$export$8b29a4b6778bf7f), {
                family: "solid",
                icon: "times"
            })));
            if (props.file.type == "image/gif") return (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("a", {
                ref: innerRef,
                draggable: !!props.inWriter,
                "data-origin": (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).toApp(filePath),
                href: !props.inWriter ? (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).toApp(filePath) : undefined,
                class: `${!props.inWriter ? "glightbox " : ""}file-embed rounded`,
                id: props.file.id,
                "data-type": "image",
                onClick: (e)=>openLightbox(e)
            }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
                className: `miniature${props.file.removed ? " removed" : ""}`,
                style: `background-image:url("${(0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).crop(props.file.id, 160, 160)}")`
            }), (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
                class: "remove-button",
                style: props.file.removed ? "color:red" : "",
                onClick: (e)=>props.toggleFile(e)
            }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)((0, $607f51540ffcd426$export$8b29a4b6778bf7f), {
                family: "solid",
                icon: "times"
            })));
            if (/image/.test(props.file.type)) return (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("a", {
                ref: innerRef,
                draggable: !!props.inWriter,
                "data-origin": (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).toApp(filePath),
                "data-type": "image",
                "data-srcset": `${(0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).thumbnail(props.file.id, 720)} 720w, ${(0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).thumbnail(props.file.id, 1366)} 1366w, ${(0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).thumbnail(props.file.id, 2048)} 2048w`,
                "data-sizes": "(max-width: 992px) 720px, (max-width: 1400px) 1366px, 2048px",
                href: !props.inWriter ? (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).toApp(filePath) : undefined,
                class: `${!props.inWriter ? "glightbox " : ""}file-embed rounded`,
                id: props.file.id,
                onClick: (e)=>openLightbox(e)
            }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
                className: `miniature${props.file.removed ? " removed" : ""}`,
                style: `background-image:url("${(0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).crop(props.file.id, 160, 160)}")`
            }), (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
                class: "remove-button",
                style: props.file.removed ? "color:red" : "",
                onClick: (e)=>props.toggleFile(e)
            }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)((0, $607f51540ffcd426$export$8b29a4b6778bf7f), {
                family: "solid",
                icon: "times"
            })));
    }
}


const $c72cf4b6b78e8f8e$export$330d558700ffa676 = (0, $9745ce6cd249f9c5$export$2e2bcd8739ae039);
const $c72cf4b6b78e8f8e$export$ca445ff2f74d7dc4 = (0, $b7ceefe51d9ca40b$export$2e2bcd8739ae039);
const $c72cf4b6b78e8f8e$export$48621228a997a4e0 = (0, $374de5a37ad6a81a$export$2e2bcd8739ae039);
const $c72cf4b6b78e8f8e$export$40e4fb50d87564f1 = (0, $469480f865369d3d$export$2e2bcd8739ae039);




function $bd90da8fd697beab$var$_extends() {
    $bd90da8fd697beab$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $bd90da8fd697beab$var$_extends.apply(this, arguments);
}
function $bd90da8fd697beab$export$2e2bcd8739ae039(props) {
    const [preview, setPreview] = (0, $88a9540d1aad6464$export$60241385465d0a34)(null);
    const [link, setLink] = (0, $88a9540d1aad6464$export$60241385465d0a34)("");
    const [text, setText] = (0, $88a9540d1aad6464$export$60241385465d0a34)(props.text || "");
    const [title, setTitle] = (0, $88a9540d1aad6464$export$60241385465d0a34)(props.title || "");
    const { t: t } = (0, $23287d5819478a30$export$9fc83ad70ead8663)();
    const writerForm = (0, $88a9540d1aad6464$export$b8f5890fc79d6aca)(null);
    const cleanForm = ()=>{
        setPreview(null);
        setLink(null);
        setText("");
        setTitle("");
    };
    const sendMessage = (writerForm)=>{
        props.sendMessage(writerForm, {
            // we get the raw value here because onChange() does not capture all possible inputs
            // and then the values of text/title could not be up to date
            title: writerForm?.current?.querySelector(".title-input")?.value,
            text: writerForm?.current?.querySelector(".text-input")?.value
        });
        cleanForm();
    };
    const genPreview = (t)=>{
        if (!t) return;
        t.style.height = "1px";
        t.style.height = `${25 + t.scrollHeight}px`;
        // waiting for the dom to be updated
        setTimeout(()=>{
            const text = t.value;
            let links = text.match(/(https?:\/\/[^\s]+)/gi);
            if (links && links[0] != link) (0, $cd2f6546c5cf5c32$export$7d6f1c8842f9f527).get(`/api/links/by_url?url=${encodeURIComponent(links[0])}`).then((r)=>{
                if (r && t.value.indexOf(links[0]) >= 0) {
                    setLink(links[0]);
                    setPreview(r);
                }
            });
        }, 0);
    };
    const onKeyPress = (event, doGenPreview = false)=>{
        if (event.ctrlKey && (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).is_it_enter(event)) {
            sendMessage(writerForm);
            return;
        }
        if (![
            " ",
            "Enter",
            "v"
        ].includes(event.key)) return;
        if (doGenPreview) genPreview(event.currentTarget);
    };
    const onPaste = (event)=>{
        props.addFiles("image/jpeg", event.clipboardData.files);
    };
    (0, $88a9540d1aad6464$export$6d9c69b0de29b591)(()=>{
        genPreview(document?.getElementById(props.id)?.querySelector(".text-input"));
    }, []);
    if (props.sending) return (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
        class: "message-placeholder"
    }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
        class: "spinner orange-spinner"
    }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", null), (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", null), (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", null), (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", null), (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", null)));
    return (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
        id: props.id,
        class: "writer",
        ref: writerForm
    }, !props.isChild && (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("input", {
        type: "text",
        class: "title-input",
        onKeyPress: (e)=>onKeyPress(e),
        placeholder: t("title_placeholder"),
        value: title,
        onChange: (e)=>setTitle(e.target.value)
    }), (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("textarea", {
        onKeyPress: (e)=>onKeyPress(e, true),
        onPaste: (e)=>onPaste(e),
        class: "text-input",
        rows: "5",
        autocomplete: "off",
        autofocus: props.focus,
        placeholder: t("text_placeholder"),
        maxlength: "50000",
        value: text,
        onChange: (e)=>setText(e.target.value)
    }), !!preview && (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)((0, $c72cf4b6b78e8f8e$export$330d558700ffa676), $bd90da8fd697beab$var$_extends({
        inWriter: true
    }, preview)), !!props.files.length && (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)((0, $c72cf4b6b78e8f8e$export$ca445ff2f74d7dc4), {
        files: props.files,
        toggleFile: props.toggleFile,
        invertFiles: props.invertFiles,
        inWriter: true
    }), (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
        class: "options"
    }, (0, $cd2f6546c5cf5c32$export$644d8ea042df96a6)?.info?.upload?.image && (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("button", {
        class: "option",
        onClick: ()=>props.inputFile("image/*", true),
        title: t("upload_image")
    }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)((0, $607f51540ffcd426$export$8b29a4b6778bf7f), {
        family: "regular",
        icon: "images"
    })), (0, $cd2f6546c5cf5c32$export$644d8ea042df96a6)?.info?.upload?.video && (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("button", {
        class: "option",
        onClick: ()=>props.inputFile("video/*"),
        title: t("upload_video")
    }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)((0, $607f51540ffcd426$export$8b29a4b6778bf7f), {
        family: "solid",
        icon: "film"
    })), (0, $cd2f6546c5cf5c32$export$644d8ea042df96a6)?.info?.upload?.pdf && (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("button", {
        class: "option",
        onClick: ()=>props.inputFile("application/pdf"),
        title: t("upload_pdf")
    }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)((0, $607f51540ffcd426$export$8b29a4b6778bf7f), {
        family: "regular",
        icon: "file-pdf"
    })), (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
        class: "actions"
    }, !!props.cancel && (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("button", {
        class: "cancel",
        onClick: (e)=>props.cancel(e)
    }, t("cancel")), (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("button", {
        disabled: !props.group || props.uploading,
        type: "submit",
        class: "submit",
        onClick: ()=>sendMessage(writerForm)
    }, t("submit")))));
}


const $b0c42e92c84db02f$export$29913b8f065577b2 = (0, $37e28339f35f2974$export$2e2bcd8739ae039);
const $b0c42e92c84db02f$export$d7a960146e1a269e = (0, $fe5a7484fb575b8e$export$2e2bcd8739ae039);
const $b0c42e92c84db02f$export$29beae8571dce55f = (0, $bd90da8fd697beab$export$2e2bcd8739ae039);







function $2f916fd353a9e499$export$2e2bcd8739ae039() {
    const { t: t } = (0, $23287d5819478a30$export$9fc83ad70ead8663)();
    const { me: me } = (0, $5fa7d79990e2bc5d$export$11aeef812f154e9e)("me");
    const location = (0, $2e634cb2b6e12a73$export$45d76561a5302f2b)();
    const searchParams = new URLSearchParams(location.search);
    const [loaded, setLoaded] = (0, $88a9540d1aad6464$export$60241385465d0a34)(false);
    const [title, setTitle] = (0, $88a9540d1aad6464$export$60241385465d0a34)(searchParams.get("title") || "");
    const [text, setText] = (0, $88a9540d1aad6464$export$60241385465d0a34)(searchParams.get("text") || "");
    const [url, setUrl] = (0, $88a9540d1aad6464$export$60241385465d0a34)(searchParams.get("url") || "");
    const parent = searchParams.get("parent") || "";
    const [files, setFiles] = (0, $88a9540d1aad6464$export$60241385465d0a34)([]);
    const [group, setGroup] = (0, $88a9540d1aad6464$export$60241385465d0a34)("");
    (0, $88a9540d1aad6464$export$6d9c69b0de29b591)(()=>{
        setTimeout(()=>{
            (0, $cd2f6546c5cf5c32$export$3e32638432616b6).fetch().then((user)=>{
                if (user.data["default_group"]) setGroup(user.data["default_group"]);
                else if (user.groups.length == 1) setGroup(user.groups[0]["id"]);
                if (searchParams.get("message")) (0, $cd2f6546c5cf5c32$export$7d6f1c8842f9f527).get(`/api/messages/${searchParams.get("message")}`).then((m)=>{
                    if (m?.files?.length) Promise.all(m.files.map((f)=>(0, $cd2f6546c5cf5c32$export$7d6f1c8842f9f527).get(`/api/files/${f.id}`).then((f)=>f))).then((files)=>{
                        setFiles(files);
                        setTitle(m?.data?.title || "");
                        setText(m?.data?.text || "");
                        setUrl("");
                        setLoaded(true);
                    });
                    else {
                        setTitle(m?.data?.title || "");
                        setText(m?.data?.text || "");
                        setUrl("");
                        setLoaded(true);
                    }
                });
                else setLoaded(true);
            });
        }, 100);
    }, []);
    if (!loaded) return;
    return (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("main", null, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)((0, $520fa8871428281e$export$42cfbb80f7861e77), null), (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
        class: "content"
    }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("article", {
        class: "mt-2"
    }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
        class: "container"
    }, !parent && me?.groups?.length > 1 && (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
        class: "mb-1"
    }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("label", {
        class: "px-1",
        for: "group_share_choice"
    }, t("group_share_choice")), (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("select", {
        value: group,
        class: "form-select",
        name: "group_share_choice",
        onChange: (e)=>setGroup(e.target.value),
        required: true
    }, me?.groups.map((e)=>(0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("option", {
            key: e["id"],
            value: e["id"]
        }, e.name)))), !!parent && (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
        class: "form-group"
    }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("label", {
        for: "apiKey"
    }, t("parent_message"), ":", " "), (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("input", {
        type: "text",
        name: "parent_message",
        value: parent,
        class: "form-control font-size-80",
        readonly: "readonly"
    })), (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)((0, $b0c42e92c84db02f$export$d7a960146e1a269e), {
        focus: true,
        group: group,
        title: title,
        parent: parent,
        text: text || url ? `${text}\n${url}` : "",
        files: files
    })))));
}


const $be03c4de42ac64ff$export$9c257beea3dbd13a = (0, $6f8b52f4496f3b9a$export$2e2bcd8739ae039);
const $be03c4de42ac64ff$export$1a13290ec7702c7 = (0, $dd2a1b0379ca9bf9$export$2e2bcd8739ae039);
const $be03c4de42ac64ff$export$959a4441e74dcd2b = (0, $4016a5cf4497ca7a$export$2e2bcd8739ae039);
const $be03c4de42ac64ff$export$35f3ae0a16fef81 = (0, $aed7e74f78402a69$export$2e2bcd8739ae039);
const $be03c4de42ac64ff$export$14834abbfce3b8cd = (0, $73f3a1fb1b71c71a$export$2e2bcd8739ae039);
const $be03c4de42ac64ff$export$4b31f5af7c5f8dee = (0, $2ed7e499aaac665f$export$2e2bcd8739ae039);
const $be03c4de42ac64ff$export$4b85d3515bd863a5 = (0, $a06567713ad1b415$export$2e2bcd8739ae039);
const $be03c4de42ac64ff$export$c9915453de10000b = (0, $2f916fd353a9e499$export$2e2bcd8739ae039);




function $d0274a88e468a969$export$2e2bcd8739ae039(props) {
    const { t: t } = (0, $23287d5819478a30$export$9fc83ad70ead8663)();
    const { bookmarks: bookmarks } = (0, $5fa7d79990e2bc5d$export$11aeef812f154e9e)("bookmarks");
    return (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
        class: "message-footer"
    }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
        class: "infos"
    }, !props?.isPublic && props?.author && props?.author?.id === (0, $cd2f6546c5cf5c32$export$3e32638432616b6).id && (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)((0, $73048c6b859c8a02$export$ffb0004e005737fa), null, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("a", {
        class: "action seamless-link font-size-90 capitalize d-none d-sm-block",
        onClick: (e)=>props.editMessage(e)
    }, t("edit")), (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
        class: "dot d-none d-sm-block"
    }, "\u2022")), !props?.isPublic && props?.isChild && props?.message && (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)((0, $73048c6b859c8a02$export$ffb0004e005737fa), null, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)((0, $34f84368c0c9d98a$export$a6c7ac8248d6e38a), {
        class: "action seamless-link font-size-90 capitalize",
        to: `/messages/${props?.message.id}${props?.message?.children.length ? "" : "?focus=reply"}`
    }, props?.message?.children.length ? props.message.children.some((e)=>(0, $cd2f6546c5cf5c32$export$6008d97729a90c74).isNew(e.id)) ? (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("b", null, t("replies", {
        count: props.message.children.length
    })) : t("replies", {
        count: props.message.children.length
    }) : t("reply")), (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
        class: "dot"
    }, "\u2022")), (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
        class: "date font-size-90",
        title: (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).humanFullDate(props?.message.createdAt)
    }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)((0, $be03c4de42ac64ff$export$35f3ae0a16fef81), {
        timestamp: props?.message.createdAt
    })), (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)((0, $73048c6b859c8a02$export$ffb0004e005737fa), null, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
        class: "dot"
    }, "\u2022"), (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
        class: "font-size-90"
    }, props?.author && props?.author?.name ? props.author.name : "--"))), (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", null, !props?.isPublic && (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
        class: "options dropdown",
        onClick: (e)=>e?.target?.closest(".dropdown")?.classList.toggle("active")
    }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
        class: "none-if-follows-empty"
    }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)((0, $607f51540ffcd426$export$8b29a4b6778bf7f), {
        family: "solid",
        icon: "ellipsis-h"
    })), (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
        class: "dropdown-menu dropdown-options"
    }, props?.author && props?.author?.id === (0, $cd2f6546c5cf5c32$export$3e32638432616b6).id && (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("a", {
        class: "seamless-link capitalize",
        onClick: (e)=>props.deleteMessage(e)
    }, t("delete")), (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("a", {
        class: "seamless-link capitalize",
        onClick: (e)=>props.openPublicLink(e)
    }, t("public_link")), (0, $cd2f6546c5cf5c32$export$3e32638432616b6).groups?.length > 1 && (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("a", {
        class: "seamless-link capitalize",
        onClick: (e)=>props.shareMessage(e)
    }, t("share_message")), !props?.message?.isInFront && props?.author && props?.author.id == (0, $cd2f6546c5cf5c32$export$3e32638432616b6).id && (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("a", {
        class: "seamless-link capitalize",
        onClick: (e)=>props.publishInGroup(e)
    }, t("publish_in_group")), !bookmarks.some((b)=>b.message.id === props?.message.id) && (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("a", {
        class: "seamless-link capitalize",
        onClick: ()=>{
            (0, $cd2f6546c5cf5c32$export$5ea928c9faf85bd3).add(t("bookmark_added"));
            (0, $b7ae12cde431bd4b$export$2e2bcd8739ae039).dispatch("bookmark/add", props.message.id);
        }
    }, t("add_bookmark")), bookmarks.some((b)=>b.message.id === props?.message.id) && (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("a", {
        class: "seamless-link capitalize",
        onClick: ()=>{
            (0, $cd2f6546c5cf5c32$export$5ea928c9faf85bd3).add(t("bookmark_removed"));
            (0, $b7ae12cde431bd4b$export$2e2bcd8739ae039).dispatch("bookmark/remove", bookmarks.find((b)=>b.message.id === props.message.id));
        }
    }, t("remove_bookmark")), props?.author?.id == (0, $cd2f6546c5cf5c32$export$3e32638432616b6).id && (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("a", {
        class: "seamless-link capitalize",
        onClick: (e)=>props.editMessage(e)
    }, t("edit"))))));
}






function $5345fa5f2538b9ef$export$2e2bcd8739ae039(props) {
    const [preview, setPreview] = (0, $88a9540d1aad6464$export$60241385465d0a34)(null);
    const displayMessageText = ()=>{
        if (!props.message.data) return "";
        // escape html a little (just enough to avoid xss I hope)
        let txt = props.message.data["text"].replace(/</g, "&lt;").replace(/>/g, "&gt;").trim();
        // replace url by real links
        let shift = 0;
        let match = null;
        while(match = (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).getUrl(txt.slice(shift))){
            let url = match[0];
            if (url.length >= 50) url = `${url.slice(0, 25)}...${url.slice(-24)}`;
            let link = `<a href="${match[0]}" target="_blank">${url}</a>`;
            txt = txt.slice(0, match["index"] + shift) + link + txt.slice(match["index"] + shift + match[0].length);
            shift += match["index"] + link.length;
        }
        // replace line returns
        txt = txt.replace(/\n/g, "<br/>");
        return {
            __html: txt
        };
    };
    (0, $88a9540d1aad6464$export$6d9c69b0de29b591)(()=>{
        if (!preview && props.message) {
            if (props.message.data) {
                let previewUrl = (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).getUrl(props.message.data["text"]);
                if (previewUrl) (0, $cd2f6546c5cf5c32$export$7d6f1c8842f9f527).get(`/api/links/by_url?url=${encodeURIComponent(previewUrl[0])}`).then((r)=>setPreview(r));
            }
        }
    });
    return (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
        class: "message-body"
    }, props.message.data && props.message.data.title && (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
        class: "title"
    }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("span", null, props.message.data.title)), props.message.data && props.message.data.text && props.message.data.text.trim() && (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("p", {
        class: "card-text",
        dangerouslySetInnerHTML: displayMessageText()
    }), preview && (!props.message.data || !props.message.data["no_embed"]) && (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)((0, $c72cf4b6b78e8f8e$export$330d558700ffa676), {
        key: preview.url,
        url: preview.url,
        preview: preview.preview,
        data: preview.data
    }), props.files && (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)((0, $c72cf4b6b78e8f8e$export$ca445ff2f74d7dc4), {
        files: props.files
    }));
}






function $7cd04194507a3338$export$2e2bcd8739ae039(props) {
    const stack = [
        props.message.id,
        ...props.message.lineage
    ].reverse();
    const [breadcrumbs, setBreadcrumbs] = (0, $88a9540d1aad6464$export$60241385465d0a34)([]);
    const [group, setGroup] = (0, $88a9540d1aad6464$export$60241385465d0a34)(null);
    const getTitle = (message, previewLink)=>{
        if (message) {
            if (message["data"] && message["data"]["title"]) return message["data"]["title"];
            if (previewLink && previewLink["data"]) return previewLink["data"]["title"];
            if (message["data"] && message["data"]["text"]) {
                let url = (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).getUrl(message["data"]["text"]);
                if (url && url.length > 0) url = url[0];
                if (url) return url;
                return message["data"]["text"];
            }
        }
        // When all else fails, just say who and when
        return `${message?.author?.name}, ${(0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).humanTime(message.createdAt)}`;
    };
    const loadBreadcrumbs = (ids)=>{
        let breadcrumbs = [];
        Promise.all(ids.map((id)=>(0, $cd2f6546c5cf5c32$export$7d6f1c8842f9f527).get(`/api/messages/${id}`))).then((messages)=>{
            Promise.all(messages.map((message)=>{
                let previewUrl = (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).getUrl(message?.data?.text);
                if (previewUrl) return (0, $cd2f6546c5cf5c32$export$7d6f1c8842f9f527).get(`/api/links/by_url?url=${encodeURIComponent(previewUrl[0])}`);
                return Promise.resolve(null);
            })).then((links)=>{
                for(let i = 0; i < ids.length; i++)breadcrumbs[i] = getTitle(messages[i], links[i]);
                setBreadcrumbs(breadcrumbs);
            });
        });
    };
    (0, $88a9540d1aad6464$export$6d9c69b0de29b591)(()=>{
        loadBreadcrumbs(stack);
        (0, $cd2f6546c5cf5c32$export$7d6f1c8842f9f527).get(`/api/groups/${props.message.group.id}`).then((group)=>{
            setGroup(group);
        });
    }, []);
    if (stack.length > 0) {
        const stack_truncated = [
            stack[0],
            ...stack.slice(Math.min(3, stack.length) * -1).slice(1)
        ];
        const breadcrumbs_truncated = [
            breadcrumbs[0],
            ...breadcrumbs.slice(Math.min(3, breadcrumbs.length) * -1).slice(1)
        ];
        return (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
            class: "message-breadcrumbs"
        }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("nav", {
            style: "--bs-breadcrumb-divider: '>';"
        }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("ol", {
            class: "breadcrumb"
        }, group && (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("li", {
            class: "breadcrumb-item"
        }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)((0, $34f84368c0c9d98a$export$a6c7ac8248d6e38a), {
            key: group.id,
            to: `/groups/${group.id}`,
            class: "no-decoration"
        }, (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).limitLength(group.name || group.id.slice(0, 8), 30))), stack_truncated.map((e, i)=>(0, $73048c6b859c8a02$export$c8a8987d4410bf2d)((0, $73048c6b859c8a02$export$ffb0004e005737fa), {
                key: e
            }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)((0, $73048c6b859c8a02$export$ffb0004e005737fa), null, i == 1 && stack.length > 3 && (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("li", {
                class: "breadcrumb-item"
            }, "...")), (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("li", {
                class: "breadcrumb-item"
            }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)((0, $34f84368c0c9d98a$export$a6c7ac8248d6e38a), {
                key: e,
                to: `/messages/${e}`,
                class: "no-decoration"
            }, (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).limitLength(breadcrumbs_truncated[i] || e.slice(0, 8), 30))))))));
    }
}







function $48e0eac2816dd5e6$export$2e2bcd8739ae039(props) {
    const navigate = (0, $2e634cb2b6e12a73$export$9770f232ac06a008)();
    const { t: t } = (0, $23287d5819478a30$export$9fc83ad70ead8663)();
    const { me: me } = (0, $5fa7d79990e2bc5d$export$11aeef812f154e9e)("me");
    const [author, setAuthor] = (0, $88a9540d1aad6464$export$60241385465d0a34)(null);
    const [parent, setParent] = (0, $88a9540d1aad6464$export$60241385465d0a34)(null);
    const [files, setFiles] = (0, $88a9540d1aad6464$export$60241385465d0a34)(null);
    const [isRemoved, setIsRemoved] = (0, $88a9540d1aad6464$export$60241385465d0a34)(false);
    const [edit, setEdit] = (0, $88a9540d1aad6464$export$60241385465d0a34)(false);
    const [message, setMessage] = (0, $88a9540d1aad6464$export$60241385465d0a34)(null);
    const messageRef = (0, $88a9540d1aad6464$export$b8f5890fc79d6aca)(message);
    const setMessageRef = (message)=>{
        messageRef.current = message;
        setMessage(message);
    };
    const [, forceUpdate] = (0, $88a9540d1aad6464$export$13e3392192263954)((x)=>x + 1, 0);
    (0, $88a9540d1aad6464$export$6d9c69b0de29b591)(()=>{
        window.addEventListener("newChild", onNewChild);
        window.addEventListener("editMessage", onEditMessage);
        loadMessage();
        (0, $cd2f6546c5cf5c32$export$6008d97729a90c74).markAsRead(props.id);
        if (!props.isChild) setTimeout(()=>window.scrollTo(0, 0));
        setTimeout(()=>{
            if (props.id == (0, $cd2f6546c5cf5c32$export$5375cda95f0b0eb4).action) {
                const msgElement = document.getElementById(props.id);
                if (msgElement) {
                    msgElement.scrollIntoView({
                        block: "start",
                        behavior: "smooth"
                    });
                    setTimeout(()=>msgElement.classList.remove("highlight"), 1000);
                }
            }
        }, 1000);
    }, []);
    const hydrateMessage = (m)=>{
        setMessageRef(m);
        if (m?.author?.id) (0, $cd2f6546c5cf5c32$export$7d6f1c8842f9f527).get(`/api/users/${m.author.id}`).then((u)=>{
            setAuthor(u);
        });
        if (m?.parent?.id) (0, $cd2f6546c5cf5c32$export$7d6f1c8842f9f527).get(`/api/messages/${m.parent.id}`).then((p)=>{
            setParent(p);
        });
        // delay loading of files a little bit
        setTimeout(()=>{
            if (m?.files?.length) Promise.all(m.files.map((f)=>(0, $cd2f6546c5cf5c32$export$7d6f1c8842f9f527).get(`/api/files/${f.id}`).then((f)=>f))).then((files)=>setFiles(files));
        }, 100);
    };
    const loadMessage = ()=>{
        if (props?.message) {
            if (props?.files?.length) setFiles(props?.message?.files.map((f)=>({
                    id: f.id,
                    status: "loading"
                })));
            hydrateMessage(props.message);
        } else if (props?.token) (0, $cd2f6546c5cf5c32$export$7d6f1c8842f9f527).get(`/api/public/${props.token}`).then((m)=>{
            if (m?.files?.length) setFiles(m?.files.map((f)=>({
                    id: f.id,
                    status: "loading"
                })));
            hydrateMessage(m);
        });
        else (0, $cd2f6546c5cf5c32$export$7d6f1c8842f9f527).get(`/api/messages/${props.id}`).then((m)=>{
            if (m?.files?.length) setFiles(m?.files.map((f)=>({
                    id: f.id,
                    status: "loading"
                })));
            hydrateMessage(m);
        });
    };
    const onNewChild = (event)=>{
        if (!messageRef.current?.id) return;
        const newMsg = event.detail;
        if (newMsg?.parent && (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).getId(newMsg?.parent) == props.id) {
            newMsg.author = me;
            let newChildren = messageRef?.current?.children ? [
                ...messageRef.current.children,
                newMsg
            ] : [
                newMsg
            ];
            let newRef = Object.assign(messageRef.current, {
                children: newChildren
            });
            setMessageRef(newRef);
            forceUpdate();
        }
    };
    const openPublicLink = async (event)=>{
        event.preventDefault();
        let newTab = window.open("about:blank", "_blank");
        const res = await (0, $cd2f6546c5cf5c32$export$7d6f1c8842f9f527).get(`/api/messages/${props.id}/get-public-link`);
        newTab.location = `${document.baseURI}public/${res.token}`;
    };
    const onEditMessage = (event)=>{
        if (event.detail.id == props.id) {
            setEdit(false);
            hydrateMessage(event.detail);
            props.key = +Date.now();
        }
    };
    const getComponentClass = ()=>{
        let cn = "message";
        if (props.isChild) cn += " child";
        if (props.id == (0, $cd2f6546c5cf5c32$export$5375cda95f0b0eb4).action) cn += " highlight";
        return cn;
    };
    const deleteMessage = (event)=>{
        event.preventDefault();
        if (confirm(t("ask_delete_message"))) (0, $cd2f6546c5cf5c32$export$7d6f1c8842f9f527).delete(`/api/messages/${props.id}`).then(()=>{
            if (props.isChild) setIsRemoved(true);
            else navigate(`/groups/${message.group.id}`);
        });
    };
    const shareMessage = (event)=>{
        event.preventDefault();
        navigate(`/share?message=${props.id}`);
    };
    const editMessage = (event)=>{
        event.preventDefault();
        setEdit(true);
    };
    const publishInGroup = ()=>{
        (0, $cd2f6546c5cf5c32$export$7d6f1c8842f9f527).put(`/api/messages/${props.id}`, {
            lastActivityDate: Math.floor(Date.now() / 1000),
            isInFront: true
        }).then((res)=>{
            if (!res) {
                alert.add(t("error"), "alert-danger");
                return;
            }
            navigate(`/groups/${message.group.id}`);
        });
    };
    const cancelEdit = (event)=>{
        event.preventDefault();
        setEdit(false);
    };
    const displayWriter = (isChild, focus)=>{
        return (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)((0, $b0c42e92c84db02f$export$d7a960146e1a269e), {
            cancel: edit ? cancelEdit : null,
            files: edit ? files : [],
            focus: focus || !!edit,
            group: message.group,
            messageId: edit ? props.id : null,
            parent: edit ? parent?.id : props.id,
            text: edit ? message.data["text"] : "",
            title: edit ? message.data["title"] : "",
            isChild: isChild
        });
    };
    if (isRemoved || !message) // placeholder (to be able to target it)
    return (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
        id: props.id,
        className: "message"
    });
    return (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)((0, $73048c6b859c8a02$export$ffb0004e005737fa), null, !props?.isChild && !props?.isPublic && (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)((0, $7cd04194507a3338$export$2e2bcd8739ae039), {
        key: message?.id,
        message: message
    }), (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
        id: props.id,
        className: getComponentClass()
    }, edit && displayWriter(props?.isChild), !edit && (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)((0, $73048c6b859c8a02$export$ffb0004e005737fa), null, props.isChild && !props.isPublic && edit && (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
        class: "message-head d-none d-md-block"
    }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("img", {
        class: "rounded-circle w-3 material-shadow avatar",
        style: (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).backgroundHash(me.id),
        src: me.avatar ? (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).crop(me.avatar?.id, 100, 100) : (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).defaultAvatar
    })), (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)((0, $d385cb0a744355a5$export$2e2bcd8739ae039), {
        author: author,
        message: message,
        isPublic: props?.isPublic,
        isChild: props?.isChild
    }), (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
        class: "main"
    }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)((0, $5345fa5f2538b9ef$export$2e2bcd8739ae039), {
        message: message,
        files: files || [],
        isPublic: props?.isPublic,
        isChild: props?.isChild
    }), (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)((0, $d0274a88e468a969$export$2e2bcd8739ae039), {
        author: author,
        message: message,
        editMessage: editMessage,
        deleteMessage: deleteMessage,
        shareMessage: shareMessage,
        publishInGroup: publishInGroup,
        openPublicLink: openPublicLink,
        isPublic: props?.isPublic,
        isChild: props?.isChild
    })))), props?.postMessageComponent, !props?.isChild && !props?.isPublic && (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)((0, $02bd391920972de4$export$2e2bcd8739ae039), {
        childMessages: message?.children,
        key: props.id,
        id: props.id
    }), !edit && !props?.isPublic && !props?.isChild && (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
        class: "message child mt-2"
    }, me?.id && (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
        class: "message-head d-none d-md-block"
    }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("img", {
        class: "rounded-circle w-3 material-shadow avatar",
        style: (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).backgroundHash(me.id),
        src: me?.avatar ? (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).crop(me.avatar["id"], 100, 100) : (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).defaultAvatar
    })), displayWriter(true, props.focus)));
}











class $2b42a26c55ba553a$export$2e2bcd8739ae039 extends (0, $73048c6b859c8a02$export$16fa2f45be04daa8) {
    constructor(props){
        super(props);
        let loaded = 1 + Math.floor(window.screen.width * window.screen.height / 68800);
        this.state = {
            loaded: loaded,
            messages: [],
            scrollTop: 0,
            totalMessages: 0,
            pageYOffset: 0,
            page: 0
        };
        this.scroll_cooldown = Date.now();
        this.onScroll = this.onScroll.bind(this);
        this.loadMessages = this.loadMessages.bind(this);
        this.onNewParent = this.onNewParent.bind(this);
        window.addEventListener("newParent", this.onNewParent);
    }
    onNewParent() {
        this.loadMessages(0);
    }
    componentDidMount() {
        this.loadMessages(0);
        window.addEventListener("scroll", this.onScroll);
    }
    componentWillUnmount() {
        window.removeEventListener("scroll", this.onScroll);
    }
    loadMessages(page) {
        (0, $cd2f6546c5cf5c32$export$7d6f1c8842f9f527).get(`/api/groups/${this.props.id}`).then((res)=>{
            this.setState({
                group: res
            });
        });
        (0, $cd2f6546c5cf5c32$export$7d6f1c8842f9f527).get(`/api/groups/${this.props.id}/page/${page}`).then((res)=>{
            if (res && Array.isArray(res["messages"])) {
                let new_loaded = Math.max(this.state.loaded, page * 30);
                let msgList = this.state.messages;
                // don't add already added messages
                res["messages"].map((mid)=>!msgList.find((msg)=>msg.id == mid) && msgList.push({
                        id: mid
                    }));
                this.setState({
                    messages: msgList,
                    totalMessages: res["totalItems"],
                    page: page,
                    loaded: new_loaded
                });
                if ((page + 1) * 30 < new_loaded) setTimeout(()=>this.loadMessages(page + 1));
            }
        });
    }
    onScroll() {
        // prevent loading messages if we are in a post
        if (window.getComputedStyle(document.getElementById("group").parentNode).display == "none") return;
        // don't load if on cooldown
        if (this.scroll_cooldown + 100 < Date.now()) {
            this.scroll_cooldown = Date.now();
            this.setState({
                pageYOffset: window.pageYOffset
            });
            // don't load if unecessary
            if (Array.isArray(this.state.messages) && document.body.scrollHeight - window.screen.height - 500 < window.pageYOffset && this.state.loaded < this.state.totalMessages) {
                this.setState((prevState)=>({
                        loaded: prevState.loaded + 10
                    }));
                if (this.state.loaded + 30 > this.state.messages.length) {
                    this.loadMessages(this.state.page + 1);
                    // update page count right away
                    this.setState((prevState)=>({
                            page: prevState.page + 1
                        }));
                }
            }
        }
    }
    render() {
        if (!this.props.id) return;
        return (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)((0, $73048c6b859c8a02$export$ffb0004e005737fa), null, Array.isArray(this.state.messages) && this.state.messages.slice(0, this.state.loaded).map((msg, i)=>{
            return (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)((0, $6a345a2434031edc$export$84c965ec8b6b0f92), {
                tabindex: i + 1,
                key: msg.id,
                id: msg.id
            });
        }));
    }
}







function $0336d0c72cfa625f$export$2e2bcd8739ae039(props) {
    let params = (0, $2e634cb2b6e12a73$export$99eaa27ddbbb95ef)();
    return (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("main", null, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)((0, $520fa8871428281e$export$42cfbb80f7861e77), null), (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
        class: "content"
    }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("article", {
        class: "mb-3 justify-content-center d-flex"
    }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
        class: "container pb-3"
    }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)((0, $48e0eac2816dd5e6$export$2e2bcd8739ae039), {
        focus: !!(0, $cd2f6546c5cf5c32$export$5375cda95f0b0eb4).getParam("focus", (0, $cd2f6546c5cf5c32$export$5375cda95f0b0eb4).search),
        isPublic: false,
        isChild: false,
        message: props?.message,
        id: params.id,
        key: params.id
    })))));
}








function $2ff1bd810ea4c925$export$2e2bcd8739ae039(props) {
    const [author, setAuthor] = (0, $88a9540d1aad6464$export$60241385465d0a34)(null);
    const [preview, setPreview] = (0, $88a9540d1aad6464$export$60241385465d0a34)(null);
    const [id, setId] = (0, $88a9540d1aad6464$export$60241385465d0a34)(null);
    const [data, setData] = (0, $88a9540d1aad6464$export$60241385465d0a34)(null);
    const [lastActivityDate, setLastActivityDate] = (0, $88a9540d1aad6464$export$60241385465d0a34)(null);
    const [children, setChildren] = (0, $88a9540d1aad6464$export$60241385465d0a34)(0);
    const [loaded, setLoaded] = (0, $88a9540d1aad6464$export$60241385465d0a34)(false);
    const getAvatar = (user)=>{
        return (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("img", {
            title: user ? user.name : "--",
            className: `avatar material-shadow${user ? "" : " removed-user"}`,
            style: (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).backgroundHash(user ? user.id : ""),
            src: user?.avatar ? (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).crop(user.avatar["id"], 100, 100) : (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).defaultAvatar,
            onError: (e)=>e.currentTarget.src = (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).defaultAvatar
        });
    };
    const setDefaultMiniature = (e)=>{
        e.currentTarget.src = (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).defaultAvatar;
        e.currentTarget.style.height = "180px";
        e.currentTarget.style.width = "auto";
        e.currentTarget.style.position = "absolute";
        e.currentTarget.style.left = "50%";
        e.currentTarget.style.transform = "translate(-50%, 0%)";
    };
    (0, $88a9540d1aad6464$export$6d9c69b0de29b591)(()=>{
        (0, $cd2f6546c5cf5c32$export$7d6f1c8842f9f527).get(`/api/messages/${props.id}/preview`).then((p)=>{
            if (p?.author?.id) (0, $cd2f6546c5cf5c32$export$7d6f1c8842f9f527).get(`/api/users/${p.author.id}`).then((u)=>{
                setAuthor(u);
            });
            setPreview(p?.preview);
            setId(p?.id);
            setChildren(p?.children);
            setLoaded(true);
            setLastActivityDate(p?.lastActivityDate);
            setData(p?.data);
        });
    }, []);
    if (!props?.id || !data) return null;
    return (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)((0, $34f84368c0c9d98a$export$a6c7ac8248d6e38a), {
        to: `/messages/${id}`,
        class: "d-inline-block seamless-link message-preview unselectable",
        title: data?.title
    }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
        tabindex: props?.tabindex,
        class: "card material-shadow-with-hover"
    }, getAvatar(author), (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
        class: "card-miniature-loading"
    }, loaded && (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)((0, $73048c6b859c8a02$export$ffb0004e005737fa), null, preview ? (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
        class: "card-miniature"
    }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("img", {
        width: "320",
        height: "180",
        src: (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).crop((0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).getId(preview), 320, 180),
        onError: (e)=>setDefaultMiniature(e)
    })) : (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
        class: "text-preview"
    }, data?.text))), (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
        class: "card-body border-top d-flex justify-content-between"
    }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("span", {
        class: "left-buffer"
    }), (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("span", {
        class: "title",
        title: data?.title || (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).humanFullDate(lastActivityDate)
    }, data?.title || (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)((0, $be03c4de42ac64ff$export$35f3ae0a16fef81), {
        timestamp: lastActivityDate
    })), (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("span", {
        class: "children"
    }, children > 0 && (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("span", null, `${children} `, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)((0, $607f51540ffcd426$export$8b29a4b6778bf7f), {
        family: (0, $cd2f6546c5cf5c32$export$6008d97729a90c74).isNew(id) ? "solid" : "regular",
        icon: "comment"
    }))))));
}







function $a241afa5477ddabe$export$2e2bcd8739ae039(props) {
    const [author, setAuthor] = (0, $88a9540d1aad6464$export$60241385465d0a34)(props?.message?.author || null);
    (0, $88a9540d1aad6464$export$6d9c69b0de29b591)(()=>{
        if (props?.message?.author) (0, $cd2f6546c5cf5c32$export$7d6f1c8842f9f527).get(`/api/users/${props.message.author}`).then((author)=>author && setAuthor(author));
    }, []);
    const displayAuthorName = ()=>{
        if (!author?.name) return {
            __html: "--"
        };
        let authorName = author.name;
        // make the search terms stand out
        let words = authorName.split(" ");
        for(let j = 0; j < words.length; j++)if (!words[j].match((0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).urlRegExp)) {
            let searchTerms = props.search.split(" ");
            for(let k = 0; k < searchTerms.length; k++)words[j] = words[j].replace(new RegExp((0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).escapeRegex(searchTerms[k]), "gi"), "<b>$&</b>");
        }
        authorName = words.join(" ");
        return {
            __html: authorName
        };
    };
    const displayMessageTitle = ()=>{
        if (!props?.message?.data?.title) return {
            __html: (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).humanTime(props?.message?.lastActivityDate)
        };
        // escape html a little (just enough to avoid xss I hope)
        let title = props?.message?.data?.title.replace(/</g, "&lt;").replace(/>/g, "&gt;").trim();
        // make the search terms stand out
        let words = title.split(" ");
        let searchTerms = props?.search.split(" ") || [];
        for(let j = 0; j < words.length; j++){
            if (!words[j].match((0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).urlRegExp)) for(let k = 0; k < searchTerms.length; k++)words[j] = words[j].replace(new RegExp((0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).escapeRegex(searchTerms[k]), "gi"), "<b>$&</b>");
        }
        title = words.join(" ");
        return {
            __html: title
        };
    };
    const displayMessageText = ()=>{
        if (!props?.message?.data?.text) return "";
        // escape html a little (just enough to avoid xss I hope)
        let txt = props?.message?.data?.text.replace(/</g, "&lt;").replace(/>/g, "&gt;").trim();
        // make the search terms stand out for not url words
        let lines = txt.split("\n");
        for(let i = 0; i < lines.length; i++){
            let words = lines[i].split(" ");
            for(let j = 0; j < words.length; j++)if (!words[j].match((0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).urlRegExp)) {
                let searchTerms = props.search.split(" ");
                for(let k = 0; k < searchTerms.length; k++){
                    if (!searchTerms[k]) continue;
                    words[j] = words[j].replace(new RegExp((0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).escapeRegex(searchTerms[k]), "gi"), "<b>$&</b>");
                }
                let hashtags = props?.hashtags.split(" ") || [];
                for(let k = 0; k < hashtags.length; k++){
                    if (!hashtags[k]) continue;
                    words[j] = words[j].replace(new RegExp(`#${hashtags[k]}`, "gi"), "<b>$&</b>");
                }
            }
            lines[i] = words.join(" ");
        }
        txt = lines.join("\n");
        // replace url by real links
        let shift = 0;
        let match = null;
        while(match = (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).getUrl(txt.slice(shift))){
            let url = match[0];
            if (url.length >= 50) url = `${url.slice(0, 25)}...${url.slice(-24)}`;
            let searchTerms = props?.search.split(" ") || [];
            for(let i = 0; i < searchTerms.length; i++)url = url.replace(new RegExp((0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).escapeRegex(searchTerms[i]), "gi"), "<b>$&</b>");
            let link = `<a href="${match[0]}" target="_blank">${url}</a>`;
            txt = txt.slice(0, match["index"] + shift) + link + txt.slice(match["index"] + shift + match[0].length);
            shift += match["index"] + link.length;
        }
        // replace line returns
        txt = txt.replace(/\n/g, "<br/>");
        return {
            __html: txt
        };
    };
    const getMiniature = ()=>{
        if (props?.preview) return (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
            class: "card-miniature",
            style: `background-image: url('${(0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).crop(props?.preview, 100, 100)}')`
        });
        let avatar = (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).defaultAvatar;
        if (author?.avatar?.id) avatar = (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).crop(author.avatar["id"], 100, 100);
        return (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
            class: "card-miniature",
            style: `background-image: url('${avatar}')`
        });
    };
    const getLink = ()=>{
        if (props.message.parent && props.message.children == 0) return `/messages/${props.message.parent}/${props.message.id}`;
        return `/messages/${props.message.id}`;
    };
    return (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)((0, $34f84368c0c9d98a$export$a6c7ac8248d6e38a), {
        class: "d-inline-block seamless-link message-preview unselectable",
        to: getLink(),
        title: props?.title
    }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
        tabindex: props.tabindex,
        class: "card material-shadow-with-hover"
    }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
        class: "card-body border-top"
    }, getMiniature(), (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
        class: "infos"
    }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
        class: "title",
        dangerouslySetInnerHTML: displayAuthorName()
    }), (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
        class: "dot"
    }, "\u2022"), (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
        class: "title",
        title: props?.title || (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).humanFullDate(props.message.lastActivityDate),
        dangerouslySetInnerHTML: displayMessageTitle()
    })), (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
        class: "text"
    }, props?.message?.data?.text.trim() && (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("p", {
        class: "card-text",
        dangerouslySetInnerHTML: displayMessageText()
    })), (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
        class: "children"
    }, !!props.message.children && (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("span", null, `${props.message.children} `, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)((0, $607f51540ffcd426$export$8b29a4b6778bf7f), {
        family: (0, $cd2f6546c5cf5c32$export$6008d97729a90c74).isNew(props.message.id) ? "solid" : "regular",
        icon: "comment"
    }))))));
}


const $6a345a2434031edc$export$f69c19e57285b83a = (0, $48e0eac2816dd5e6$export$2e2bcd8739ae039);
const $6a345a2434031edc$export$36e783c4ff07cd7c = (0, $5345fa5f2538b9ef$export$2e2bcd8739ae039);
const $6a345a2434031edc$export$ff4023171d74287f = (0, $7cd04194507a3338$export$2e2bcd8739ae039);
const $6a345a2434031edc$export$34692698b50bc55e = (0, $6e64521ddde455b6$export$2e2bcd8739ae039);
const $6a345a2434031edc$export$e4f91797a78e658f = (0, $02bd391920972de4$export$2e2bcd8739ae039);
const $6a345a2434031edc$export$448e87951e58f7a8 = (0, $d0274a88e468a969$export$2e2bcd8739ae039);
const $6a345a2434031edc$export$14933f4fded8a04f = (0, $d385cb0a744355a5$export$2e2bcd8739ae039);
const $6a345a2434031edc$export$89085c7857c3f940 = (0, $2b42a26c55ba553a$export$2e2bcd8739ae039);
const $6a345a2434031edc$export$4025c8e17986f775 = (0, $0336d0c72cfa625f$export$2e2bcd8739ae039);
const $6a345a2434031edc$export$84c965ec8b6b0f92 = (0, $2ff1bd810ea4c925$export$2e2bcd8739ae039);
const $6a345a2434031edc$export$423dfe6469a8e0dd = (0, $a241afa5477ddabe$export$2e2bcd8739ae039);



function $ac6c208c16ca16e8$export$2e2bcd8739ae039() {
    let params = (0, $2e634cb2b6e12a73$export$99eaa27ddbbb95ef)();
    return (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("article", {
        class: "justify-content-center d-flex mt-2"
    }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
        class: "container"
    }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("main", null, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
        class: "content"
    }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("article", {
        class: "mb-3 justify-content-center d-flex"
    }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
        class: "container pb-3"
    }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)((0, $6a345a2434031edc$export$f69c19e57285b83a), {
        focus: false,
        isPublic: true,
        isChild: false,
        token: params.token
    })))))));
}


const $f367d32ad26358d9$export$21a94553ffa41578 = (0, $53140ff71bd6800b$export$2e2bcd8739ae039);
const $f367d32ad26358d9$export$b44239f84c8f0268 = (0, $245fbd49526c814f$export$2e2bcd8739ae039);
const $f367d32ad26358d9$export$89200835fb4edfb9 = (0, $7cecaa63b21a4acb$export$2e2bcd8739ae039);
const $f367d32ad26358d9$export$e9e03eeea26d4dee = (0, $10fcb144e46b2198$export$2e2bcd8739ae039);
const $f367d32ad26358d9$export$68b4491d6924a6d1 = (0, $ac6c208c16ca16e8$export$2e2bcd8739ae039);











function $69115444f08d0dc6$export$2e2bcd8739ae039() {
    const params = (0, $2e634cb2b6e12a73$export$99eaa27ddbbb95ef)();
    const { t: t } = (0, $23287d5819478a30$export$9fc83ad70ead8663)();
    const { me: me, dispatch: dispatch } = (0, $5fa7d79990e2bc5d$export$11aeef812f154e9e)("me");
    const navigate = (0, $2e634cb2b6e12a73$export$9770f232ac06a008)();
    const [secretKey, setSecretKey] = (0, $88a9540d1aad6464$export$60241385465d0a34)("");
    const [users, setUsers] = (0, $88a9540d1aad6464$export$60241385465d0a34)([]);
    const [group, setGroup] = (0, $88a9540d1aad6464$export$60241385465d0a34)({});
    const [alertMessage, setAlertMessage] = (0, $88a9540d1aad6464$export$60241385465d0a34)("");
    (0, $88a9540d1aad6464$export$6d9c69b0de29b591)(()=>{
        (0, $cd2f6546c5cf5c32$export$7d6f1c8842f9f527).get(`/api/groups/${params.id}`).then((group)=>{
            setGroup(group);
            setSecretKey(group.secretKey);
            Promise.all(group.users.map((u)=>(0, $cd2f6546c5cf5c32$export$7d6f1c8842f9f527).get(`/api/users/${u.id}`).then((u)=>u))).then((users)=>setUsers(users));
        });
        setAlertMessage(t((0, $cd2f6546c5cf5c32$export$5375cda95f0b0eb4).getParam("alert")));
    }, []);
    const resetSecretKey = (event)=>{
        event.preventDefault();
        (0, $cd2f6546c5cf5c32$export$7d6f1c8842f9f527).post(`/api/groups/${group.id}/reset-invite-key`, {}).then((res)=>{
            (0, $cd2f6546c5cf5c32$export$5ea928c9faf85bd3).add(t("group_updated"));
            setSecretKey(res["inviteKey"]);
        });
    };
    const updateSettings = (event)=>{
        event.preventDefault();
        const name = document.querySelector("#settings_form input[name='name']").value;
        if (name) group.name = name;
        setGroup(Object.assign({}, group));
        (0, $cd2f6546c5cf5c32$export$7d6f1c8842f9f527).put(`/api/groups/${group.id}`, group).then((res)=>{
            setGroup(res);
            setAlertMessage(t("group_updated"));
            navigate(`${location.pathname}?alert=group_updated`);
        });
    };
    const leaveGroup = (event)=>{
        event.preventDefault();
        if (me.data?.default_group == group.id) {
            let user = {};
            user.data = {
                default_group: me.groups[0].id
            };
            (0, $cd2f6546c5cf5c32$export$7d6f1c8842f9f527).put(`/api/users/${me.id}`, user).then(()=>{
                dispatch("me/fetch");
                leave();
            });
        } else leave();
    };
    const leave = ()=>{
        (0, $cd2f6546c5cf5c32$export$7d6f1c8842f9f527).post(`/api/groups/${group.id}/leave`, {}).then((res)=>{
            if (!res || !res["entityType"]) (0, $cd2f6546c5cf5c32$export$5ea928c9faf85bd3).add(t("error"), "alert-danger");
            else {
                dispatch("me/fetch");
                (0, $cd2f6546c5cf5c32$export$5ea928c9faf85bd3).add(t("group_left"));
                navigate("/");
            }
        });
    };
    return (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", null, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
        class: "group-settings mb-3"
    }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
        class: "card"
    }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
        class: "card-body"
    }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
        class: "container-fluid p-1"
    }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
        class: "row"
    }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
        class: "col-12 col-md-10"
    }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("form", {
        id: "settings_form",
        class: "mb-1 border-bottom pb-1"
    }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
        class: "form-group"
    }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("label", {
        for: "name"
    }, t("name"), ": "), (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("input", {
        type: "text",
        name: "name",
        minlength: "1",
        maxlength: "128",
        placeholder: t("name_input"),
        value: group.name,
        class: "form-control",
        required: true
    })), (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("button", {
        onClick: updateSettings,
        class: "btn btn-outline-secondary"
    }, t("save_changes"))), (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("form", {
        class: "mb-1 border-bottom pb-1"
    }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
        class: "form-group"
    }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("label", {
        for: "inviteKey"
    }, t("invitation_link"), ":", " "), (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("input", {
        type: "text",
        name: "inviteKey",
        value: `${window.location.protocol}//${window.location.host}/invitation/${secretKey}`,
        class: "form-control font-size-80",
        readonly: "readonly"
    })), (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("button", {
        class: "btn btn-outline-secondary",
        onClick: resetSecretKey
    }, t("reset_invitation_link"))), (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("form", null, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("button", {
        onClick: (e)=>leaveGroup(e),
        class: "btn btn-outline-danger"
    }, t("quit_group"))))))))), (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
        class: "user-list mb-3"
    }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("h3", null, t("users")), users.map((user)=>user && (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
            class: "user-card",
            key: user.id
        }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("img", {
            class: "avatar material-shadow-with-hover",
            style: (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).backgroundHash(user.id),
            src: user.avatar ? (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).crop(user.avatar["id"], 200, 200) : (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).defaultAvatar,
            onError: (e)=>e.currentTarget.src = (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).defaultAvatar
        }), (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("span", null, user["name"])))), alertMessage && (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
        class: "global-alert alert alert-success"
    }, alertMessage));
}









function $eee779cb2410b301$export$2e2bcd8739ae039() {
    const { t: t } = (0, $23287d5819478a30$export$9fc83ad70ead8663)();
    const { me: me } = (0, $5fa7d79990e2bc5d$export$11aeef812f154e9e)("me");
    const navigate = (0, $2e634cb2b6e12a73$export$9770f232ac06a008)();
    const location = (0, $2e634cb2b6e12a73$export$45d76561a5302f2b)();
    const [apiKey, setApiKey] = (0, $88a9540d1aad6464$export$60241385465d0a34)(null);
    const [alertMessage, setAlertMessage] = (0, $88a9540d1aad6464$export$60241385465d0a34)("");
    (0, $88a9540d1aad6464$export$6d9c69b0de29b591)(()=>{
        (0, $cd2f6546c5cf5c32$export$ddcffe0146c8f882).get("apiKey").then((apiKey)=>setApiKey(apiKey));
        setAlertMessage(t((0, $cd2f6546c5cf5c32$export$5375cda95f0b0eb4).getParam("alert")));
    }, []);
    const resetApiKey = (event)=>{
        event.preventDefault();
        (0, $cd2f6546c5cf5c32$export$7d6f1c8842f9f527).post(`/api/users/${me.id}/reset-api-key`, {}).then(()=>(0, $cd2f6546c5cf5c32$export$5375cda95f0b0eb4).logout());
    };
    const inputAvatar = ()=>{
        const input = document.createElement("input");
        input.type = "file";
        input.accept = "image/*";
        input.addEventListener("change", (event)=>{
            const formData = new FormData();
            formData.append("file", event.target.files[0]);
            (0, $cd2f6546c5cf5c32$export$7d6f1c8842f9f527).sendFile(formData, (file)=>{
                (0, $cd2f6546c5cf5c32$export$7d6f1c8842f9f527).put(`/api/users/${me.id}`, {
                    avatar: file["id"]
                }).then(()=>{
                    setAlertMessage(t("settings_updated"));
                    navigate(`${location.pathname}?alert=settings_updated`);
                });
            });
        });
        input.click();
    };
    const destroyAccount = (event)=>{
        event.preventDefault();
        let confirmDeletion = confirm(t("are_you_sure"));
        if (confirmDeletion) (0, $cd2f6546c5cf5c32$export$7d6f1c8842f9f527).delete(`/api/users/${me.id}`).then(()=>{
            navigate("/logout");
        });
    };
    const updateSettings = (event)=>{
        event.preventDefault();
        const name = document.querySelector("#settings_form input[name='name']").value;
        const login = document.querySelector("#settings_form input[name='email']").value;
        const password = document.querySelector("#settings_form input[name='password']").value;
        const notification_emails = document.querySelector("#settings_form select[name='notification_emails']").value;
        const default_group = document.querySelector("#settings_form select[name='default_group']").value;
        const lang = document.querySelector("#settings_form select[name='lang']").value;
        let user = {};
        if (name) user.name = name;
        if (login) user.login = login;
        if (password) user.password = password;
        user["data"] = {
            notification_emails: notification_emails,
            default_group: default_group,
            lang: lang
        };
        (0, $cd2f6546c5cf5c32$export$7d6f1c8842f9f527).put(`/api/users/${me.id}`, user).then((res)=>{
            if (res["error"]) (0, $cd2f6546c5cf5c32$export$5ea928c9faf85bd3).add(res["error"], "alert-danger");
            else {
                setAlertMessage(t("settings_updated"));
                navigate(`${location.pathname}?alert=settings_updated`);
            }
        });
    };
    if (me && me?.data) return (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
        class: "user-settings"
    }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
        class: "card"
    }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
        class: "identite card-body"
    }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
        class: "container-fluid p-1"
    }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
        class: "row"
    }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
        class: "col-12 col-md-2"
    }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("img", {
        class: "img-fluid rounded-circle material-shadow avatar",
        src: me.avatar ? (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).crop(me.avatar["id"], 100, 100) : (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).defaultAvatar,
        style: (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).backgroundHash(me.id || ""),
        onError: (e)=>e.currentTarget.src = (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).defaultAvatar,
        onClick: (e)=>inputAvatar(e)
    })), (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
        class: "col-12 col-md-10"
    }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("form", {
        id: "settings_form",
        class: "mb-3"
    }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
        class: "form-group"
    }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("label", {
        for: "name"
    }, t("name"), ": "), (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("input", {
        type: "text",
        name: "name",
        minlength: "1",
        maxlength: "128",
        placeholder: t("name_input"),
        value: me.name,
        class: "form-control"
    })), (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
        class: "form-group"
    }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("label", {
        for: "email"
    }, t("email"), ": "), (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("input", {
        type: "email",
        name: "email",
        placeholder: t("email_input"),
        value: me.login,
        class: "form-control"
    })), (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
        class: "form-group"
    }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("label", {
        for: "password"
    }, t("password"), ": "), (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("input", {
        type: "password",
        name: "password",
        autocomplete: "off",
        minlength: "8",
        maxlength: "128",
        placeholder: t("password_input"),
        class: "form-control"
    })), (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
        class: "form-group"
    }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("label", {
        for: "notification_emails"
    }, t("notification_emails"), ":"), (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("select", {
        name: "notification_emails",
        class: "form-control",
        value: me?.data["notification_emails"]
    }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("option", {
        value: "none"
    }, t("none")), (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("option", {
        value: "hourly"
    }, t("hourly")), (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("option", {
        value: "daily"
    }, t("daily")), (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("option", {
        value: "weekly"
    }, t("weekly")), (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("option", {
        value: "monthly"
    }, t("monthly")))), (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
        class: "form-group"
    }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("label", {
        for: "default_group"
    }, t("default_group"), ":"), (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("select", {
        name: "default_group",
        class: "form-control",
        value: me?.data["default_group"]
    }, me.groups?.map((e)=>(0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("option", {
            key: e.id,
            value: e.id
        }, e.name)))), (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
        class: "form-group"
    }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("label", {
        class: "capitalize",
        for: "lang"
    }, t("lang"), ":"), (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("select", {
        name: "lang",
        class: "form-control",
        value: (0, $cd2f6546c5cf5c32$export$9a771d6906431624).getCurrentLang()
    }, Object.keys((0, $cd2f6546c5cf5c32$export$9a771d6906431624).possibleLang).map((k)=>(0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("option", {
            key: k,
            value: k
        }, (0, $cd2f6546c5cf5c32$export$9a771d6906431624).possibleLang[k])))), (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("button", {
        onClick: (e)=>updateSettings(e),
        class: "btn btn-primary"
    }, t("save_changes"))), (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("form", {
        id: "api_key_form"
    }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
        class: "form-group"
    }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("label", {
        for: "apiKey"
    }, t("api_key"), ":", " "), (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("input", {
        type: "text",
        name: "apiKey",
        value: apiKey,
        class: "form-control font-size-80",
        readonly: "readonly"
    })), (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("button", {
        class: "btn btn-outline-secondary",
        onClick: resetApiKey
    }, t("reset_api_key"))), (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("form", {
        id: "destroy_form"
    }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("label", {
        class: "d-block",
        for: "destroy_account"
    }, t("destroy_account_explain")), (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("button", {
        onClick: (e)=>destroyAccount(e),
        name: "destroy_account",
        class: "btn btn-danger"
    }, t("destroy_account")))))))), alertMessage && (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
        class: "global-alert alert alert-success"
    }, alertMessage));
}







function $2e4039a8780c9af0$export$2e2bcd8739ae039() {
    const params = (0, $2e634cb2b6e12a73$export$99eaa27ddbbb95ef)();
    const { t: t } = (0, $23287d5819478a30$export$9fc83ad70ead8663)();
    const { me: me } = (0, $5fa7d79990e2bc5d$export$11aeef812f154e9e)("me");
    return (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("main", null, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)((0, $520fa8871428281e$export$42cfbb80f7861e77), null), (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
        class: "content"
    }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("article", {
        class: "mt-2 justify-content-center d-flex"
    }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
        class: "container pb-3"
    }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
        class: "settings"
    }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("ul", {
        class: "nav nav-tabs"
    }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("li", {
        class: "nav-item"
    }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)((0, $34f84368c0c9d98a$export$a6c7ac8248d6e38a), {
        class: `nav-link${params.type == "users" ? " active" : ""}`,
        to: `/users/${me.id}/settings`
    }, t("account"))), me.groups?.length > 0 && (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("li", {
        class: "nav-item dropdown group-list",
        tabindex: "-1",
        onClick: (e)=>e.currentTarget.classList.toggle("active")
    }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
        class: `nav-link${params.type == "groups" ? " active" : ""}`
    }, t("groups")), (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)("div", {
        class: "dropdown-menu"
    }, me.groups?.map((e)=>(0, $73048c6b859c8a02$export$c8a8987d4410bf2d)((0, $34f84368c0c9d98a$export$a6c7ac8248d6e38a), {
            key: `/groups/${e.id}/settings`,
            class: "seamless-link",
            to: `/groups/${e.id}/settings`
        }, e.name))))), params.type === "users" && (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)((0, $eee779cb2410b301$export$2e2bcd8739ae039), {
        id: params.id,
        key: params.id
    }), params.type === "groups" && (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)((0, $69115444f08d0dc6$export$2e2bcd8739ae039), {
        id: params.id,
        key: params.id
    }))))));
}



const $1180cc40af8fd7c1$export$7756bc8dbeb9ec70 = (0, $69115444f08d0dc6$export$2e2bcd8739ae039);
const $1180cc40af8fd7c1$export$c72f6eaae7b9adff = (0, $2e4039a8780c9af0$export$2e2bcd8739ae039);
const $1180cc40af8fd7c1$export$6587c76ebf15601c = (0, $eee779cb2410b301$export$2e2bcd8739ae039);





function $63a436771d8fc45d$var$App() {
    const navigate = (0, $2e634cb2b6e12a73$export$9770f232ac06a008)();
    const location = (0, $2e634cb2b6e12a73$export$45d76561a5302f2b)();
    const toggleDropdowns = (e)=>{
        if (!e.target.closest(".dropdown")) // close dropdowns if we are clicking on something else
        document.querySelectorAll(".dropdown").forEach((n)=>n.classList.remove("active"));
        else // close dropdowns that are not clicked on
        document.querySelectorAll(".dropdown").forEach((n)=>{
            if (n != e.target.closest(".dropdown")) n.classList.remove("active");
        });
    };
    // initial load
    (0, $88a9540d1aad6464$export$6d9c69b0de29b591)(()=>{
        // this test is here to ensure that 'api' gets loaded before
        // this may come from a transpilation issue with parceljs
        if ((0, $cd2f6546c5cf5c32$export$644d8ea042df96a6) && typeof (0, $cd2f6546c5cf5c32$export$644d8ea042df96a6).update === "function") (0, $cd2f6546c5cf5c32$export$644d8ea042df96a6).update();
        else console.error("Could not use api.update()");
        (0, $cd2f6546c5cf5c32$export$6008d97729a90c74).update();
        (0, $cd2f6546c5cf5c32$export$a4ea57bd994c1f0d).update();
        // manage dropdowns
        window.addEventListener("click", (e)=>toggleDropdowns(e));
        return ()=>{
            window.removeEventListener("click", (e)=>toggleDropdowns(e));
        };
    });
    (0, $cd2f6546c5cf5c32$export$3e32638432616b6).fetch().then((user)=>{
        if (location.pathname == "/") {
            let redirect = "/login";
            if (user) {
                redirect = "/create-group";
                if (user.data?.default_group) redirect = `/groups/${user?.data["default_group"]}`;
                else if (user?.groups[0]) redirect = `/groups/${user?.groups[0].id}`;
            }
            navigate(redirect);
        }
        if (location.pathname.match(/^\/invitation/)) {
            if (user) (0, $cd2f6546c5cf5c32$export$7d6f1c8842f9f527).post(`/api/groups/invitation/${(0, $cd2f6546c5cf5c32$export$5375cda95f0b0eb4).id}`, {}).then(()=>{
                navigate("/");
            });
            else navigate(`/signup?inviteKey=${(0, $cd2f6546c5cf5c32$export$5375cda95f0b0eb4).id}`);
        }
        if (!(0, $cd2f6546c5cf5c32$export$5375cda95f0b0eb4).isOutside() && !user) navigate("/login");
    });
    return (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)((0, $2e634cb2b6e12a73$export$3565eb3d00ca5a74), null, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)((0, $2e634cb2b6e12a73$export$e7b0ac011bb776c6), {
        path: "/password-reset",
        element: (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)((0, $f367d32ad26358d9$export$b44239f84c8f0268), null)
    }), (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)((0, $2e634cb2b6e12a73$export$e7b0ac011bb776c6), {
        path: "/public/:token",
        element: (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)((0, $f367d32ad26358d9$export$68b4491d6924a6d1), null)
    }), (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)((0, $2e634cb2b6e12a73$export$e7b0ac011bb776c6), {
        path: "/share",
        element: (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)((0, $be03c4de42ac64ff$export$c9915453de10000b), null)
    }), (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)((0, $2e634cb2b6e12a73$export$e7b0ac011bb776c6), {
        path: "/signup",
        element: (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)((0, $f367d32ad26358d9$export$89200835fb4edfb9), null)
    }), (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)((0, $2e634cb2b6e12a73$export$e7b0ac011bb776c6), {
        path: "/stop-notification-emails",
        element: (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)((0, $f367d32ad26358d9$export$e9e03eeea26d4dee), null)
    }), (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)((0, $2e634cb2b6e12a73$export$e7b0ac011bb776c6), {
        path: "/login",
        element: (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)((0, $f367d32ad26358d9$export$21a94553ffa41578), null)
    }), (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)((0, $2e634cb2b6e12a73$export$e7b0ac011bb776c6), {
        path: "/logout",
        element: (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)((0, $2e634cb2b6e12a73$export$444b3ab0cb9aec40), {
            replace: true,
            to: "/login"
        })
    }), (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)((0, $2e634cb2b6e12a73$export$e7b0ac011bb776c6), {
        path: "/:type/:id/settings",
        element: (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)((0, $1180cc40af8fd7c1$export$c72f6eaae7b9adff), null)
    }), (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)((0, $2e634cb2b6e12a73$export$e7b0ac011bb776c6), {
        path: "/bookmarks",
        element: (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)((0, $be03c4de42ac64ff$export$9c257beea3dbd13a), null)
    }), (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)((0, $2e634cb2b6e12a73$export$e7b0ac011bb776c6), {
        path: "/create-group",
        element: (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)((0, $be03c4de42ac64ff$export$1a13290ec7702c7), null)
    }), (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)((0, $2e634cb2b6e12a73$export$e7b0ac011bb776c6), {
        path: "/groups/:id",
        element: (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)((0, $be03c4de42ac64ff$export$959a4441e74dcd2b), null)
    }), (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)((0, $2e634cb2b6e12a73$export$e7b0ac011bb776c6), {
        path: "/groups/:id/random",
        element: (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)((0, $be03c4de42ac64ff$export$4b31f5af7c5f8dee), null)
    }), (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)((0, $2e634cb2b6e12a73$export$e7b0ac011bb776c6), {
        path: "/groups/:id/search",
        element: (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)((0, $520fa8871428281e$export$5cc34a6155e65c0e), null)
    }), (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)((0, $2e634cb2b6e12a73$export$e7b0ac011bb776c6), {
        path: "/groups/:id/write",
        element: (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)((0, $b0c42e92c84db02f$export$29913b8f065577b2), null)
    }), (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)((0, $2e634cb2b6e12a73$export$e7b0ac011bb776c6), {
        path: "/messages/:id",
        element: (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)((0, $6a345a2434031edc$export$4025c8e17986f775), null)
    }), (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)((0, $2e634cb2b6e12a73$export$e7b0ac011bb776c6), {
        path: "/messages/:id/:child_id",
        element: (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)((0, $6a345a2434031edc$export$4025c8e17986f775), null)
    }));
}
var $63a436771d8fc45d$export$2e2bcd8739ae039 = $63a436771d8fc45d$var$App;





const $2b67dd6f65354df9$var$router = (0, $34f84368c0c9d98a$export$1f3f55432a00e06d)([
    {
        path: "*",
        Component: (0, $63a436771d8fc45d$export$2e2bcd8739ae039)
    }
], {
    basename: `/${document.baseURI.split("/")[3]}`
});
function $2b67dd6f65354df9$var$Index() {
    return (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)((0, $5fa7d79990e2bc5d$export$554ccc96b126a426).Provider, {
        value: (0, $b7ae12cde431bd4b$export$2e2bcd8739ae039)
    }, (0, $73048c6b859c8a02$export$c8a8987d4410bf2d)((0, $34f84368c0c9d98a$export$323e4fc2fa4753fb), {
        router: $2b67dd6f65354df9$var$router
    }));
}
(0, $73048c6b859c8a02$export$b3890eb0ae9dca99)((0, $73048c6b859c8a02$export$c8a8987d4410bf2d)($2b67dd6f65354df9$var$Index, null), document.body);


//# sourceMappingURL=index.0942891d.js.map
